const quotes=[
  {
    "author": "Oscar Wilde",
    "quote": "Be yourself; everyone else is already taken."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I'm selfish, impatient and a little insecure. I make mistakes, I am out of control and at times hard to handle. But if you can't handle me at my worst, then you sure as hell don't deserve me at my best."
  },
  {
    "author": "Albert Einstein",
    "quote": "Two things are infinite: the universe and human stupidity; and I'm not sure about the universe."
  },
  {
    "author": "Frank Zappa",
    "quote": "So many books, so little time."
  },
  {
    "author": "Marcus Tullius Cicero",
    "quote": "A room without books is like a body without a soul."
  },
  {
    "author": "Bernard M. Baruch",
    "quote": "Be who you are and say what you feel, because those who mind don't matter, and those who matter don't mind."
  },
  {
    "author": "William W. Purkey",
    "quote": "You've gotta dance like there's nobody watching,"
  },
  {
    "author": "Dr. Seuss",
    "quote": "You know you're in love when you can't fall asleep because reality is finally better than your dreams."
  },
  {
    "author": "Mae West",
    "quote": "You only live once, but if you do it right, once is enough."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Be the change that you wish to see in the world."
  },
  {
    "author": "Robert Frost",
    "quote": "In three words I can sum up everything I've learned about life: it goes on."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "If you want to know what a man's like, take a good look at how he treats his inferiors, not his equals."
  },
  {
    "author": "Albert Camus",
    "quote": "Don’t walk in front of me… I may not follow"
  },
  {
    "author": "Mark Twain",
    "quote": "If you tell the truth, you don't have to remember anything."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "Friendship ... is born at the moment when one man says to another What! You too? I thought that no one but myself . . ."
  },
  {
    "author": "Maya Angelou",
    "quote": "I've learned that people will forget what you said, people will forget what you did, but people will never forget how you made them feel."
  },
  {
    "author": "Elbert Hubbard",
    "quote": "A friend is someone who knows all about you and still loves you."
  },
  {
    "author": "Oscar Wilde",
    "quote": "To live is the rarest thing in the world. Most people exist, that is all."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Always forgive your enemies; nothing annoys them so much."
  },
  {
    "author": "Martin Luther King Jr.,",
    "quote": "Darkness cannot drive out darkness: only light can do that. Hate cannot drive out hate: only love can do that."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Live as if you were to die tomorrow. Learn as if you were to live forever."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "We accept the love we think we deserve."
  },
  {
    "author": "Friedrich Nietzsche,",
    "quote": "Without music, life would be a mistake."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "I am so clever that sometimes I don't understand a single word of what I am saying."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "To be yourself in a world that is constantly trying to make you something else is the greatest accomplishment."
  },
  {
    "author": "Steve Jobs",
    "quote": "Here's to the crazy ones. The misfits. The rebels. The troublemakers. The round pegs in the square holes. The ones who see things differently. They're not fond of rules. And they have no respect for the status quo. You can quote them, disagree with them, glorify or vilify them. About the only thing you can't do is ignore them. Because they change things. They push the human race forward. And while some may see them as the crazy ones, we see genius. Because the people who are crazy enough to think they can change the world, are the ones who do."
  },
  {
    "author": "Narcotics Anonymous",
    "quote": "Insanity is doing the same thing, over and over again, but expecting different results."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I believe that everything happens for a reason. People change so that you can learn to let go, things go wrong so that you appreciate them when they're right, you believe lies so you eventually learn to trust no one but yourself, and sometimes good things fall apart so better things can fall together."
  },
  {
    "author": "Andre Gide,",
    "quote": "It is better to be hated for what you are than to be loved for what you are not."
  },
  {
    "author": "H. Jackson Brown Jr.,",
    "quote": "Twenty years from now you will be more disappointed by the things that you didn't do than by the ones you did do. So throw off the bowlines. Sail away from the safe harbor. Catch the trade winds in your sails. Explore. Dream. Discover."
  },
  {
    "author": "Bob Marley",
    "quote": "Only once in your life, I truly believe, you find someone who can completely turn your world around. You tell them things that you’ve never shared with another soul and they absorb everything you say and actually want to hear more. You share hopes for the future, dreams that will never come true, goals that were never achieved and the many disappointments life has thrown at you. When something wonderful happens, you can’t wait to tell them about it, knowing they will share in your excitement. They are not embarrassed to cry with you when you are hurting or laugh with you when you make a fool of yourself. Never do they hurt your feelings or make you feel like you are not good enough, but rather they build you up and show you the things about yourself that make you special and even beautiful. There is never any pressure, jealousy or competition but only a quiet calmness when they are around. You can be yourself and not worry about what they will think of you because they love you for who you are. The things that seem insignificant to most people such as a note, song or walk become invaluable treasures kept safe in your heart to cherish forever. Memories of your childhood come back and are so clear and vivid it’s like being young again. Colours seem brighter and more brilliant. Laughter seems part of daily life where before it was infrequent or didn’t exist at all. A phone call or two during the day helps to get you through a long day’s work and always brings a smile to your face. In their presence, there’s no need for continuous conversation, but you find you’re quite content in just having them nearby. Things that never interested you before become fascinating because you know they are important to this person who is so special to you. You think of this person on every occasion and in everything you do. Simple things bring them to mind like a pale blue sky, gentle wind or even a storm cloud on the horizon. You open your heart knowing that there’s a chance it may be broken one day and in opening your heart, you experience a love and joy that you never dreamed possible. You find that being vulnerable is the only way to allow your heart to feel true pleasure that’s so real it scares you. You find strength in knowing you have a true friend and possibly a soul mate who will remain loyal to the end. Life seems completely different, exciting and worthwhile. Your only hope and security is in knowing that they are a part of your life."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "All that is gold does not glitter,"
  },
  {
    "author": "Jane Austen,",
    "quote": "The person, be it gentleman or lady, who has not pleasure in a good novel, must be intolerably stupid."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It is our choices, Harry, that show what we truly are, far more than our abilities."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Imperfection is beauty, madness is genius and it's better to be absolutely ridiculous than absolutely boring."
  },
  {
    "author": "Albert Einstein",
    "quote": "There are only two ways to live your life. One is as though nothing is a miracle. The other is as though everything is a miracle."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It does not do to dwell on dreams and forget to live."
  },
  {
    "author": "Mark Twain",
    "quote": "Good friends, good books, and a sleepy conscience: this is the ideal life."
  },
  {
    "author": "John Green,",
    "quote": "As he read, I fell in love the way you fall asleep: slowly, and then all at once."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "We are all in the gutter, but some of us are looking at the stars."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Fairy tales are more than true: not because they tell us that dragons exist, but because they tell us that dragons can be beaten."
  },
  {
    "author": "William Shakespeare,",
    "quote": "The fool doth think he is wise, but the wise man knows himself to be a fool."
  },
  {
    "author": "Maurice Switzer,",
    "quote": "It is better to remain silent at the risk of being thought a fool, than to talk and remove all doubt of it."
  },
  {
    "author": "Mark Twain",
    "quote": "Whenever you find yourself on the side of the majority, it is time to reform (or pause and reflect)."
  },
  {
    "author": "Allen Saunders",
    "quote": "Life is what happens to us while we are making other plans."
  },
  {
    "author": "Bill Keane",
    "quote": "Yesterday is history, tomorrow is a mystery, today is a gift of God, which is why we call it the present."
  },
  {
    "author": "Thomas A. Edison",
    "quote": "I have not failed. I've just found 10,000 ways that won't work."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "It is not a lack of love, but a lack of friendship that makes unhappy marriages."
  },
  {
    "author": "Elie Wiesel",
    "quote": "The opposite of love is not hate, it's indifference. The opposite of art is not ugliness, it's indifference. The opposite of faith is not heresy, it's indifference. And the opposite of life is not death, it's indifference."
  },
  {
    "author": "Eleanor Roosevelt",
    "quote": "A woman is like a tea bag; you never know how strong it is until it's in hot water."
  },
  {
    "author": "Mark Twain",
    "quote": "The man who does not read has no advantage over the man who cannot read."
  },
  {
    "author": "Pablo Neruda,",
    "quote": "I love you without knowing how, or when, or from where. I love you simply, without problems or pride: I love you in this way because I do not know any other way of loving but this, in which there is no I or you, so intimate that your hand upon my chest is my hand, so intimate that when I fall asleep your eyes close."
  },
  {
    "author": "douglas adams,",
    "quote": "I may not have gone where I intended to go, but I think I have ended up where I needed to be."
  },
  {
    "author": "Gordon A. Eadie",
    "quote": "If you don't stand for something you will fall for anything."
  },
  {
    "author": "Groucho Marx,",
    "quote": "Outside of a dog, a book is man's best friend. Inside of a dog it's too dark to read."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "I solemnly swear that I am up to no good."
  },
  {
    "author": "Albert Einstein",
    "quote": "I am enough of an artist to draw freely upon my imagination. Imagination is more important than knowledge. Knowledge is limited. Imagination encircles the world."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Love all, trust a few,"
  },
  {
    "author": "Dr. Seuss",
    "quote": "I like nonsense, it wakes up the brain cells. Fantasy is a necessary ingredient in living."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Have you ever been in love? Horrible isn't it? It makes you so vulnerable. It opens your chest and it opens up your heart and it means that someone can get inside you and mess you up."
  },
  {
    "author": "Steve Martin",
    "quote": "A day without sunshine is like, you know, night."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "A reader lives a thousand lives before he dies, said Jojen. The man who never reads lives only one."
  },
  {
    "author": "Mark Twain",
    "quote": "Never put off till tomorrow what may be done day after tomorrow just as well."
  },
  {
    "author": "Lao Tzu",
    "quote": "Being deeply loved by someone gives you strength, while loving someone deeply gives you courage."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "You have brains in your head. You have feet in your shoes. You can steer yourself any direction you choose. You're on your own. And you know what you know. And YOU are the one who'll decide where to go..."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "That which does not kill us makes us stronger."
  },
  {
    "author": "George Eliot",
    "quote": "It is never too late to be what you might have been."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "For every minute you are angry you lose sixty seconds of happiness."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "This life is what you make it. No matter what, you're going to mess up sometimes, it's a universal truth. But the good part is you get to decide how you're going to mess it up. Girls will be your friends - they'll act like it anyway. But just remember, some come, some go. The ones that stay with you through everything - they're your true best friends. Don't let go of them. Also remember, sisters make the best friends in the world. As for lovers, well, they'll come and go too. And baby, I hate to say it, most of them - actually pretty much all of them are going to break your heart, but you can't give up because if you give up, you'll never find your soulmate. You'll never find that half who makes you whole and that goes for everything. Just because you fail once, doesn't mean you're gonna fail at everything. Keep trying, hold on, and always, always, always believe in yourself, because if you don't, then who will, sweetie? So keep your head high, keep your chin up, and most importantly, keep smiling, because life's a beautiful thing and there's so much to smile about."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It takes a great deal of bravery to stand up to our enemies, but just as much to stand up to our friends."
  },
  {
    "author": "Douglas Adams,",
    "quote": "I love deadlines. I love the whooshing noise they make as they go by."
  },
  {
    "author": "Mother Teresa",
    "quote": "If you judge people, you have no time to love them."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "There is never a time or place for true love. It happens accidentally, in a heartbeat, in a single flashing, throbbing moment."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "I'm not upset that you lied to me, I'm upset that from now on I can't believe you."
  },
  {
    "author": "Albert Einstein",
    "quote": "If you can't explain it to a six year old, you don't understand it yourself."
  },
  {
    "author": "Maya Angelou,",
    "quote": "There is no greater agony than bearing an untold story inside you."
  },
  {
    "author": "Robert A. Heinlein,",
    "quote": "Love is that condition in which the happiness of another person is essential to your own."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "If you only read the books that everyone else is reading, you can only think what everyone else is thinking."
  },
  {
    "author": "Garrison Keillor",
    "quote": "Anyone who thinks sitting in church can make you a Christian must also think that sitting in a garage can make you a car."
  },
  {
    "author": "Jorge Luis Borges",
    "quote": "I have always imagined that Paradise will be a kind of library."
  },
  {
    "author": "Pablo Picasso",
    "quote": "Everything you can imagine is real."
  },
  {
    "author": "Robert A. Heinlein",
    "quote": "Women and cats will do as they please, and men and dogs should relax and get used to the idea."
  },
  {
    "author": "Anaïs Nin",
    "quote": "We don't see things as they are, we see them as we are."
  },
  {
    "author": "Bob Marley",
    "quote": "You may not be her first, her last, or her only. She loved before she may love again. But if she loves you now, what else matters? She's not perfect—you aren't either, and the two of you may never be perfect together but if she can make you laugh, cause you to think twice, and admit to being human and making mistakes, hold onto her and give her the most you can. She may not be thinking about you every second of the day, but she will give you a part of her that she knows you can break—her heart. So don't hurt her, don't change her, don't analyze and don't expect more than she can give. Smile when she makes you happy, let her know when she makes you mad, and miss her when she's not there."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Sometimes the questions are complicated and the answers are simple."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "You love me. Real or not real?"
  },
  {
    "author": "Lemony Snicket,",
    "quote": "Never trust anyone who has not brought a book with them."
  },
  {
    "author": "C.S. Lewis",
    "quote": "You can never get a cup of tea large enough or a book long enough to suit me."
  },
  {
    "author": "William Nicholson,",
    "quote": "We read to know we're not alone."
  },
  {
    "author": "John Green,",
    "quote": "Sometimes, you read a book and it fills you with this weird evangelical zeal, and you become convinced that the shattered world will never be put back together unless and until all living humans read the book."
  },
  {
    "author": "Charles M. Schulz",
    "quote": "All you need is love. But a little chocolate now and then doesn't hurt."
  },
  {
    "author": "George Bernard Shaw",
    "quote": "Life isn't about finding yourself. Life is about creating yourself."
  },
  {
    "author": "Jim Henson",
    "quote": "Beauty is in the eye of the beholder and it may be necessary from time to time to give a stupid or misinformed beholder a black eye."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Of course it is happening inside your head, Harry, but why on earth should that mean that it is not real?"
  },
  {
    "author": "Dr. Seuss,",
    "quote": "Today you are You, that is truer than true. There is no one alive who is Youer than You."
  },
  {
    "author": "Woody Allen",
    "quote": "I'm not afraid of death; I just don't want to be there when it happens."
  },
  {
    "author": "J.K. Rowling",
    "quote": "It is impossible to live without failing at something, unless you live so cautiously that you might as well not have lived at all—in which case, you fail by default."
  },
  {
    "author": "Oscar Wilde",
    "quote": "If one cannot enjoy reading a book over and over again, there is no use in reading it at all."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "To the well-organized mind, death is but the next great adventure."
  },
  {
    "author": "Albert Einstein",
    "quote": "If you want your children to be intelligent, read them fairy tales. If you want them to be more intelligent, read them more fairy tales."
  },
  {
    "author": "John Green,",
    "quote": "I'm in love with you, he said quietly."
  },
  {
    "author": "Albert Einstein",
    "quote": "Logic will get you from A to Z; imagination will get you everywhere."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Have you fallen in love with the wrong person yet?'"
  },
  {
    "author": "Paul   Terry",
    "quote": "Whenever I feel the need to exercise, I lie down until it goes away."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "I am nothing special, of this I am sure. I am a common man with common thoughts and I've led a common life. There are no monuments dedicated to me and my name will soon be forgotten, but I've loved another with all my heart and soul, and to me, this has always been enough.."
  },
  {
    "author": "Markus Zusak,",
    "quote": "Sometimes people are beautiful."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Love looks not with the eyes, but with the mind; And therefore is wing'd Cupid painted blind. Nor hath love's mind of any judgment taste; Wings and no eyes figure unheedy haste: And therefore is love said to be a child, Because in choice he is so oft beguil'd."
  },
  {
    "author": "Bob Marley",
    "quote": "The truth is, everyone is going to hurt you. You just got to find the ones worth suffering for."
  },
  {
    "author": "John Green,",
    "quote": "You don't get to choose if you get hurt in this world...but you do have some say in who hurts you. I like my choices."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "The more that you read, the more things you will know. The more that you learn, the more places you'll go."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "Folks are usually about as happy as they make their minds up to be."
  },
  {
    "author": "Theodore Roosevelt",
    "quote": "Do what you can, with what you have, where you are."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "There is no friend as loyal as a book."
  },
  {
    "author": "Bob Marley",
    "quote": "One good thing about music, when it hits you, you feel no pain."
  },
  {
    "author": "Douglas Adams,",
    "quote": "The story so far:"
  },
  {
    "author": "Groucho Marx",
    "quote": "I find television very educating. Every time somebody turns on the set, I go into the other room and read a book."
  },
  {
    "author": "Winston S. Churchill",
    "quote": "Success is not final, failure is not fatal: it is the courage to continue that counts."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Love is like the wind, you can't see it but you can feel it."
  },
  {
    "author": "Mother Teresa",
    "quote": "Not all of us can do great things. But we can do small things with great love."
  },
  {
    "author": "Helen Keller",
    "quote": "When one door of happiness closes, another opens; but often we look so long at the closed door that we do not see the one which has been opened for us."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "So, this is my life. And I want you to know that I am both happy and sad and I'm still trying to figure out how that could be."
  },
  {
    "author": "Shel Silverstein",
    "quote": "Listen to the mustn'ts, child. Listen to the don'ts. Listen to the shouldn'ts, the impossibles, the won'ts. Listen to the never haves, then listen close to me... Anything can happen, child. Anything can be."
  },
  {
    "author": "Jane Austen,",
    "quote": "There is nothing I would not do for those who are really my friends. I have no notion of loving people by halves, it is not my nature."
  },
  {
    "author": "Joan Powers,",
    "quote": "If you live to be a hundred, I want to live to be a hundred minus one day so I never have to live without you."
  },
  {
    "author": "Albert Einstein",
    "quote": "Life is like riding a bicycle. To keep your balance, you must keep moving."
  },
  {
    "author": "Charles Bukowski",
    "quote": "Some people never go crazy. What truly horrible lives they must lead."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "People think a soul mate is your perfect fit, and that's what everyone wants. But a true soul mate is a mirror, the person who shows you everything that is holding you back, the person who brings you to your own attention so you can change your life."
  },
  {
    "author": "Jodi Picoult,",
    "quote": "You don't love someone because they're perfect, you love them in spite of the fact that they're not."
  },
  {
    "author": "John Green",
    "quote": "Saying 'I notice you're a nerd' is like saying, 'Hey, I notice that you'd rather be intelligent than be stupid, that you'd rather be thoughtful than be vapid, that you believe that there are things that matter more than the arrest record of Lindsay Lohan. Why is that?' In fact, it seems to me that most contemporary insults are pretty lame. Even 'lame' is kind of lame. Saying 'You're lame' is like saying 'You walk with a limp.' Yeah, whatever, so does 50 Cent, and he's done all right for himself."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It matters not what someone is born, but what they grow to be."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "What really knocks me out is a book that, when you're all done reading it, you wish the author that wrote it was a terrific friend of yours and you could call him up on the phone whenever you felt like it. That doesn't happen much, though."
  },
  {
    "author": "Anais Nin",
    "quote": "Love never dies a natural death. It dies because we don't know how to replenish its source. It dies of blindness and errors and betrayals. It dies of illness and wounds; it dies of weariness, of witherings, of tarnishings."
  },
  {
    "author": "Alexandre Dumas-fils",
    "quote": "The difference between genius and stupidity is: genius has its limits."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "If you can make a woman laugh, you can make her do anything."
  },
  {
    "author": "Robert Fulghum,",
    "quote": "We’re all a little weird. And life is a little weird. And when we find someone whose weirdness is compatible with ours, we join up with them and fall into mutually satisfying weirdness—and call it love—true love."
  },
  {
    "author": "Oscar Wilde",
    "quote": "It is what you read when you don't have to that determines what you will be when you can't help it."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "Not all those who wander are lost."
  },
  {
    "author": "Alfred Tennyson",
    "quote": "If I had a flower for every time I thought of you...I could walk through my garden forever."
  },
  {
    "author": "Walter M. Miller Jr.,",
    "quote": "You don’t"
  },
  {
    "author": "Eleanor Roosevelt",
    "quote": "Do one thing every day that scares you."
  },
  {
    "author": "Virginia Woolf,",
    "quote": "I would venture to guess that Anon, who wrote so many poems without signing them, was often a woman."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "The trouble with having an open mind, of course, is that people will insist on coming along and trying to put things in it."
  },
  {
    "author": "John Green,",
    "quote": "Some infinities are bigger than other infinities."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "One must always be careful of books, said Tessa, and what is inside them, for words have the power to change us."
  },
  {
    "author": "Bill Watterson,",
    "quote": "Reality continues to ruin my life."
  },
  {
    "author": "Marthe Troly-Curtin,",
    "quote": "Time you enjoy wasting is not wasted time."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "Things change. And friends leave. Life doesn't stop for anybody."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "There is no pretending, Jace said with absolute clarity. I love you, and I will love you until I die, and if there is life after that, I'll love you then."
  },
  {
    "author": "Toni Morrison",
    "quote": "If there's a book that you want to read, but it hasn't been written yet, then you must write it."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "I wish it need not have happened in my time, said Frodo."
  },
  {
    "author": "Bob Marley",
    "quote": "Who are you to judge the life I live?"
  },
  {
    "author": "Marilyn Monroe",
    "quote": "The real lover is the man who can thrill you by kissing your forehead or smiling into your eyes or just staring into space."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "To love at all is to be vulnerable. Love anything and your heart will be wrung and possibly broken. If you want to make sure of keeping it intact you must give it to no one, not even an animal. Wrap it carefully round with hobbies and little luxuries; avoid all entanglements. Lock it up safe in the casket or coffin of your selfishness. But in that casket, safe, dark, motionless, airless, it will change. It will not be broken; it will become unbreakable, impenetrable, irredeemable. To love is to be vulnerable."
  },
  {
    "author": "John Green,",
    "quote": "The only way out of the labyrinth of suffering is to forgive."
  },
  {
    "author": "Jane Austen,",
    "quote": "I declare after all there is no enjoyment like reading! How much sooner one tires of any thing than of a book! -- When I have a house of my own, I shall be miserable if I have not an excellent library."
  },
  {
    "author": "Jess C. Scott,",
    "quote": "When someone loves you, the way they talk about you is different. You feel safe and comfortable."
  },
  {
    "author": "A.A. Milne,",
    "quote": "Piglet sidled up to Pooh from behind."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "He's like a drug for you, Bella."
  },
  {
    "author": "George Carlin",
    "quote": "The reason I talk to myself is because I’m the only one whose answers I accept."
  },
  {
    "author": "Benjamin Franklin Wade",
    "quote": "Go to heaven for the climate and hell for the company."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Do not pity the dead, Harry. Pity the living, and, above all those who live without love."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "And, when you want something, all the universe conspires in helping you to achieve it."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "A wise girl kisses but doesn't love, listens but doesn't believe, and leaves before she is left."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Dumbledore watched her fly away, and as her silvery glow faded he turned back to Snape, and his eyes were full of tears."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "There is nothing to writing. All you do is sit down at a typewriter and bleed."
  },
  {
    "author": "Rosemarie Urquico",
    "quote": "You should date a girl who reads."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "The books that the world calls immoral are books that show the world its own shame."
  },
  {
    "author": "John Lennon",
    "quote": "You may say I'm a dreamer, but I'm not the only one. I hope someday you'll join us. And the world will live as one."
  },
  {
    "author": "Mark Twain",
    "quote": "′Classic′ - a book which people praise and don't read."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I am good, but not an angel. I do sin, but I am not the devil. I am just a small girl in a big world trying to find someone to love."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "I've been making a list of the things they don't teach you at school. They don't teach you how to love somebody. They don't teach you how to be famous. They don't teach you how to be rich or how to be poor. They don't teach you how to walk away from someone you don't love any longer. They don't teach you how to know what's going on in someone else's mind. They don't teach you what to say to someone who's dying. They don't teach you anything worth knowing."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "You don’t forget the face of the person who was your last hope."
  },
  {
    "author": "Bessie Anderson Stanley,",
    "quote": "He has achieved success who has lived well, laughed often, and loved much;"
  },
  {
    "author": "W.C. Fields",
    "quote": "I am free of all prejudice. I hate everyone equally."
  },
  {
    "author": "Charles M. Schulz",
    "quote": "I love mankind ... it's people I can't stand!!"
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "Finish each day and be done with it. You have done what you could. Some blunders and absurdities no doubt crept in; forget them as soon as you can. Tomorrow is a new day. You shall begin it serenely and with too high a spirit to be encumbered with your old nonsense."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I can never read all the books I want; I can never be all the people I want and live all the lives I want. I can never train myself in all the skills I want. And why do I want? I want to live and feel all the shades, tones and variations of mental and physical experience possible in my life. And I am horribly limited."
  },
  {
    "author": "Mark Twain",
    "quote": "I have never let my schooling interfere with my education."
  },
  {
    "author": "Harper Lee,",
    "quote": "You never really understand a person until you consider things from his point of view... Until you climb inside of his skin and walk around in it."
  },
  {
    "author": "John Green,",
    "quote": "The marks humans leave are too often scars."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Remember, we're madly in love, so it's all right to kiss me anytime you feel like it."
  },
  {
    "author": "Jane Austen,",
    "quote": "A lady's imagination is very rapid; it jumps from admiration to love, from love to matrimony in a moment."
  },
  {
    "author": "C.S. Lewis",
    "quote": "Some day you will be old enough to start reading fairy tales again."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "We are what we pretend to be, so we must be careful about what we pretend to be."
  },
  {
    "author": "Marianne Williamson,",
    "quote": "Our deepest fear is not that we are inadequate. Our deepest fear is that we are powerful beyond measure. It is our light, not our darkness that most frightens us. We ask ourselves, 'Who am I to be brilliant, gorgeous, talented, fabulous?' Actually, who are you not to be? You are a child of God. Your playing small does not serve the world. There is nothing enlightened about shrinking so that other people won't feel insecure around you. We are all meant to shine, as children do. We were born to make manifest the glory of God that is within us. It's not just in some of us; it's in everyone. And as we let our own light shine, we unconsciously give other people permission to do the same. As we are liberated from our own fear, our presence automatically liberates others."
  },
  {
    "author": "J.M. Barrie,",
    "quote": "To die will be an awfully big adventure."
  },
  {
    "author": "Albert Einstein",
    "quote": "Anyone who has never made a mistake has never tried anything new."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "And in that moment, I swear we were infinite."
  },
  {
    "author": "Stephen King,",
    "quote": "Books are a uniquely portable magic."
  },
  {
    "author": "John Green,",
    "quote": "What a slut time is. She screws everybody."
  },
  {
    "author": "Lewis Carroll",
    "quote": "It’s no use going back to yesterday, because I was a different person then."
  },
  {
    "author": "E.E. Cummings",
    "quote": "It takes courage to grow up and become who you really are."
  },
  {
    "author": "Jimi Hendrix,",
    "quote": "I'm the one that's got to die when it's time for me to die, so let me live my life the way I want to."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "The truth is rarely pure and never simple."
  },
  {
    "author": "Madeleine L'Engle",
    "quote": "You have to write the book that wants to be written. And if the book will be too difficult for grown-ups, then you write it for children."
  },
  {
    "author": "Khaled Hosseini",
    "quote": "But better to get hurt by the truth than comforted with a lie."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "So it's not gonna be easy. It's going to be really hard; we're gonna have to work at this everyday, but I want to do that because I want you. I want all of you, forever, everyday. You and me... everyday."
  },
  {
    "author": "John Green,",
    "quote": "Books are the ultimate Dumpees: put them down and they’ll wait for you forever; pay attention to them and they always love you back."
  },
  {
    "author": "Veronica Roth,",
    "quote": "We believe in ordinary acts of bravery, in the courage that drives one person to stand up for another."
  },
  {
    "author": "Linda Grayson",
    "quote": "There is nothing better than a friend, unless it is a friend with chocolate."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "... a mind needs books as a sword needs a whetstone, if it is to keep its edge."
  },
  {
    "author": "Ayn Rand,",
    "quote": "[Dean] My dear fellow, who will let you?"
  },
  {
    "author": "Mark Twain",
    "quote": "The fear of death follows from the fear of life. A man who lives fully is prepared to die at any time."
  },
  {
    "author": "C.S. Lewis",
    "quote": "I believe in Christianity as I believe that the sun has risen: not only because I see it, but because by it I see everything else."
  },
  {
    "author": "John Green,",
    "quote": "There are infinite numbers between 0 and 1. There's .1 and .12 and .112 and an infinite collection of others. Of course, there is a bigger infinite set of numbers between 0 and 2, or between 0 and a million. Some infinities are bigger than other infinities. A writer we used to like taught us that. There are days, many of them, when I resent the size of my unbounded set. I want more numbers than I'm likely to get, and God, I want more numbers for Augustus Waters than he got. But, Gus, my love, I cannot tell you how thankful I am for our little infinity. I wouldn't trade it for the world. You gave me a forever within the numbered days, and I'm grateful."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "The truth. Dumbledore sighed. It is a beautiful and terrible thing, and should therefore be treated with great caution."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Memories warm you up from the inside. But they also tear you apart."
  },
  {
    "author": "Mark Twain",
    "quote": "A lie can travel half way around the world while the truth is putting on its shoes."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Remember, if the time should come when you have to make a choice between what is right and what is easy, remember what happened to a boy who was good, and kind, and brave, because he strayed across the path of Lord Voldemort. Remember Cedric Diggory."
  },
  {
    "author": "Mark Twain",
    "quote": "Never tell the truth to people who are not worthy of it."
  },
  {
    "author": "Pablo Neruda,",
    "quote": "I love you as certain dark things are to be loved,"
  },
  {
    "author": "Aristotle",
    "quote": "Knowing yourself is the beginning of all wisdom."
  },
  {
    "author": "Alfred Lord Tennyson,",
    "quote": "Tis better to have loved and lost"
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Just when you think it can't get any worse, it can. And just when you think it can't get any better, it can."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Only the very weak-minded refuse to be influenced by literature and poetry."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "It's so hard to forget pain, but it's even harder to remember sweetness. We have no scar to show for happiness. We learn so little from peace."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "It's the possibility of having a dream come true that makes life interesting."
  },
  {
    "author": "Charles J. Sykes,",
    "quote": "Be nice to nerds. You may end up working for them. We all could."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Be not afraid of greatness. Some are born great, some achieve greatness, and others have greatness thrust upon them."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Do you remember me telling you we are practicing non-verbal spells, Potter?"
  },
  {
    "author": "Maya Angelou,",
    "quote": "What you're supposed to do when you don't like a thing is change it. If you can't change it, change the way you think about it. Don't complain."
  },
  {
    "author": "George Orwell,",
    "quote": "Perhaps one did not want to be loved so much as to be understood."
  },
  {
    "author": "Socrates",
    "quote": "The only true wisdom is in knowing you know nothing."
  },
  {
    "author": "Ernest Hemingway,",
    "quote": "Happiness in intelligent people is the rarest thing I know."
  },
  {
    "author": "Nicolas Chamfort",
    "quote": "A day without laughter is a day wasted."
  },
  {
    "author": "Bob Marley",
    "quote": "He’s not perfect. You aren’t either, and the two of you will never be perfect. But if he can make you laugh at least once, causes you to think twice, and if he admits to being human and making mistakes, hold onto him and give him the most you can. He isn’t going to quote poetry, he’s not thinking about you every moment, but he will give you a part of him that he knows you could break. Don’t hurt him, don’t change him, and don’t expect for more than he can give. Don’t analyze. Smile when he makes you happy, yell when he makes you mad, and miss him when he’s not there. Love hard when there is love to be had. Because perfect guys don’t exist, but there’s always one guy that is perfect for you."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "A person's a person, no matter how small."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Yes: I am a dreamer. For a dreamer is one who can only find his way by moonlight, and his punishment is that he sees the dawn before the rest of the world."
  },
  {
    "author": "John Green,",
    "quote": "Thomas Edison's last words were"
  },
  {
    "author": "Oscar Wilde",
    "quote": "You can never be overdressed or overeducated."
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "I became insane, with long intervals of horrible sanity."
  },
  {
    "author": "Frank Herbert,",
    "quote": "I must not fear. Fear is the mind-killer. Fear is the little-death that brings total obliteration. I will face my fear. I will permit it to pass over me and through me. And when it has gone past I will turn the inner eye to see its path. Where the fear has gone there will be nothing. Only I will remain."
  },
  {
    "author": "Henri Nouwen,",
    "quote": "When we honestly ask ourselves which person in our lives mean the most to us, we often find that it is those who, instead of giving advice, solutions, or cures, have chosen rather to share our pain and touch our wounds with a warm and tender hand. The friend who can be silent with us in a moment of despair or confusion, who can stay with us in an hour of grief and bereavement, who can tolerate not knowing, not curing, not healing and face with us the reality of our powerlessness, that is a friend who cares."
  },
  {
    "author": "John Green,",
    "quote": "When adults say, Teenagers think they are invincible with that sly, stupid smile on their faces, they don't know how right they are. We need never be hopeless, because we can never be irreparably broken. We think that we are invincible because we are. We cannot be born, and we cannot die. Like all energy, we can only change shapes and sizes and manifestations. They forget that when they get old. They get scared of losing and failing. But that part of us greater than the sum of our parts cannot begin and cannot end, and so it cannot fail."
  },
  {
    "author": "John Green,",
    "quote": "Oh, I wouldn't mind, Hazel Grace. It would be a privilege to have my heart broken by you."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Numbing the pain for a while will make it worse when you finally feel it."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "I finally understood what true love meant...love meant that you care for another person's happiness more than your own, no matter how painful the choices you face might be."
  },
  {
    "author": "Ralph Waldo Emerson,",
    "quote": "It is one of the blessings of old friends that you can afford to be stupid with them."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "The one you love and the one who loves you are never, ever the same person."
  },
  {
    "author": "Cassandra Clare",
    "quote": "Jesus! Luke exclaimed."
  },
  {
    "author": "Charles W. Eliot",
    "quote": "Books are the quietest and most constant of friends; they are the most accessible and wisest of counselors, and the most patient of teachers."
  },
  {
    "author": "Terry Johnson,",
    "quote": "Have you ever noticed how ‘What the hell’ is always the right decision to make?"
  },
  {
    "author": "Markus Herz",
    "quote": "Be careful about reading health books. Some fine day you'll die of a misprint."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Just because you have the emotional range of a teaspoon doesn't mean we all have."
  },
  {
    "author": "Roald Dahl",
    "quote": "Those who don't believe in magic will never find it."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "An eye for an eye will only make the whole world blind."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "You can't live your life for other people. You've got to do what's right for you, even if it hurts some people you love."
  },
  {
    "author": "Victor hugo",
    "quote": "Music expresses that which cannot be put into words and that which cannot remain silent"
  },
  {
    "author": "Isaac Asimov",
    "quote": "The saddest aspect of life right now is that science gathers knowledge faster than society gathers wisdom."
  },
  {
    "author": "Harper Lee,",
    "quote": "Until I feared I would lose it, I never loved to read. One does not love breathing."
  },
  {
    "author": "Charlotte Brontë,",
    "quote": "I am no bird; and no net ensnares me: I am a free human being with an independent will."
  },
  {
    "author": "Albert Camus",
    "quote": "You will never be happy if you continue to search for what happiness consists of. You will never live if you are looking for the meaning of life."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "If you're gonna be two-faced at least make one of them pretty."
  },
  {
    "author": "Albert Einstein",
    "quote": "I speak to everyone in the same way, whether he is the garbage man or the president of the university."
  },
  {
    "author": "Helen Keller",
    "quote": "I would rather walk with a friend in the dark, than alone in the light."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "Do you hate people?"
  },
  {
    "author": "William Styron,",
    "quote": "A great book should leave you with many experiences, and slightly exhausted at the end. You live several lives while reading."
  },
  {
    "author": "John Green,",
    "quote": "So I walked back to my room and collapsed on the bottom bunk, thinking that if people were rain, I was drizzle and she was a hurricane."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "When we love, we always strive to become better than we are. When we strive to become better than we are, everything around us becomes better too."
  },
  {
    "author": "Joe Klaas,",
    "quote": "The truth will set you free, but first it will piss you off."
  },
  {
    "author": "Anne Frank,",
    "quote": "How wonderful it is that nobody need wait a single moment before starting to improve the world."
  },
  {
    "author": "C.S. Lewis",
    "quote": "A children's story that can only be enjoyed by children is not a good children's story in the slightest."
  },
  {
    "author": "Lemony Snicket",
    "quote": "Fate is like a strange, unpopular restaurant filled with odd little waiters who bring you things you never asked for and don't always like."
  },
  {
    "author": "Frederick Lewis Donaldson",
    "quote": "The Seven Social Sins are:"
  },
  {
    "author": "C.E.M. Joad",
    "quote": "Creativity is knowing how to hide your sources"
  },
  {
    "author": "Stephen King",
    "quote": "If you don't have time to read, you don't have the time (or the tools) to write. Simple as that."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Is this the part where you start tearing off strips of your shirt to bind my wounds?"
  },
  {
    "author": "Rick Riordan,",
    "quote": "With great power... comes great need to take a nap. Wake me up later."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Never forget what you are, for surely the world will not. Make it your strength. Then it can never be your weakness. Armour yourself in it, and it will never be used to hurt you."
  },
  {
    "author": "Lisa Kleypas,",
    "quote": "I no longer believed in the idea of soul mates, or love at first sight. But I was beginning to believe that a very few times in your life, if you were lucky, you might meet someone who was exactly right for you. Not because he was perfect, or because you were, but because your combined flaws were arranged in a way that allowed two separate beings to hinge together."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I wish I could freeze this moment, right here, right now and live in it forever."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Happiness is when what you think, what you say, and what you do are in harmony."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "Give a man a fire and he's warm for a day, but set fire to him and he's warm for the rest of his life."
  },
  {
    "author": "Rita Mae Brown",
    "quote": "The statistics on sanity are that one out of every four people is suffering from a mental illness. Look at your 3 best friends. If they're ok, then it's you."
  },
  {
    "author": "Mark Twain",
    "quote": "Keep away from people who try to belittle your ambitions. Small people always do that, but the really great make you feel that you, too, can become great."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "Life is an awful, ugly place to not have a best friend."
  },
  {
    "author": "Laurel Thatcher Ulrich,",
    "quote": "Well-behaved women seldom make history."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I don't want to be a man, said Jace. I want to be an angst-ridden teenager who can't confront his own inner demons and takes it out verbally on other people instead."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "We're all human, aren't we? Every human life is worth the same, and worth saving."
  },
  {
    "author": "Joseph Conrad,",
    "quote": "Being a woman is a terribly difficult trade since it consists principally of dealings with men."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "One is loved because one is loved. No reason is needed for loving."
  },
  {
    "author": "Virginia Woolf,",
    "quote": "Lock up your libraries if you like; but there is no gate, no lock, no bolt that you can set upon the freedom of my mind."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "So we beat on, boats against the current, borne back ceaselessly into the past."
  },
  {
    "author": "Leo Tolstoy",
    "quote": "Everyone thinks of changing the world, but no one thinks of changing himself."
  },
  {
    "author": "C.S. Lewis",
    "quote": "If we find ourselves with a desire that nothing in this world can satisfy, the most probable explanation is that we were made for another world."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "I don't know half of you half as well as I should like; and I like less than half of you half as well as you deserve."
  },
  {
    "author": "Robert Frost",
    "quote": "The Road Not Taken"
  },
  {
    "author": "John Green,",
    "quote": "The world is not a wish-granting factory."
  },
  {
    "author": "Roald Dahl",
    "quote": "And above all, watch with glittering eyes the whole world around you because the greatest secrets are always hidden in the most unlikely places. Those who don't believe in magic will never find it."
  },
  {
    "author": "Henry Wadsworth Longfellow",
    "quote": "Every man has his secret sorrows which the world knows not; and often times we call a man cold when he is only sad."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "When I despair, I remember that all through history the way of truth and love have always won. There have been tyrants and murderers, and for a time, they can seem invincible, but in the end, they always fall. Think of it--always."
  },
  {
    "author": "Jane Austen,",
    "quote": "In vain have I struggled. It will not do. My feelings will not be repressed. You must allow me to tell you how ardently I admire and love you."
  },
  {
    "author": "Marlene Dietrich",
    "quote": "It's the friends you can call up at 4 a.m. that matter."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "There's nothing like deep breaths after laughing that hard. Nothing in the world like a sore stomach for the right reasons."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Becoming fearless isn't the point. That's impossible. It's learning how to control your fear, and how to be free from it."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I am not pretty. I am not beautiful. I am as radiant as the sun."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "It's far better to be unhappy alone than unhappy with someone — so far."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Sometimes you have to be apart from people you love, but that doesn't make you love them any less. Sometimes you love them more."
  },
  {
    "author": "Jodi Picoult,",
    "quote": "Let me tell you this: if you meet a loner, no matter what they tell you, it's not because they enjoy solitude. It's because they have tried to blend into the world before, and people continue to disappoint them."
  },
  {
    "author": "George Harrison",
    "quote": "If you don't know where you're going, any road'll take you there"
  },
  {
    "author": "Paulo Coelho,",
    "quote": "There is only one thing that makes a dream impossible to achieve: the fear of failure."
  },
  {
    "author": "Robert Frost",
    "quote": "We love the things we love for what they are."
  },
  {
    "author": "Rainer Maria Rilke,",
    "quote": "Perhaps all the dragons in our lives are princesses who are only waiting to see us act, just once, with beauty and courage. Perhaps everything that frightens us is, in its deepest essence, something helpless that wants our love."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "I would die for you. But I won't live for you."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Never love anyone who treats you like you're ordinary."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "All God does is watch us and kill us when we get boring. We must never, ever be boring."
  },
  {
    "author": "Ray Bradbury",
    "quote": "You don't have to burn books to destroy a culture. Just get people to stop reading them."
  },
  {
    "author": "Emily Brontë,",
    "quote": "He's more myself than I am. Whatever our souls are made of, his and mine are the same."
  },
  {
    "author": "John Green",
    "quote": "You can love someone so much...But you can never love people as much as you can miss them."
  },
  {
    "author": "Audrey Hepburn",
    "quote": "Nothing is impossible, the word itself says 'I'm possible'!"
  },
  {
    "author": "Suzanne Collins,",
    "quote": "It takes ten times as long to put yourself back together as it does to fall apart."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Most people are other people. Their thoughts are someone else's opinions, their lives a mimicry, their passions a quotation."
  },
  {
    "author": "Jack Kerouac,",
    "quote": "[...]the only people for me are the mad ones, the ones who are mad to live, mad to talk, mad to be saved, desirous of everything at the same time, the ones who never yawn or say a commonplace thing, but burn, burn, burn like fabulous yellow roman candles exploding like spiders across the stars and in the middle you see the blue centerlight pop and everybody goes Awww!"
  },
  {
    "author": "Sarah Dessen,",
    "quote": "Love is needing someone. Love is putting up with someone's bad qualities because they somehow complete you."
  },
  {
    "author": "Eleanor Roosevelt",
    "quote": "Do what you feel in your heart to be right – for you’ll be criticized anyway."
  },
  {
    "author": "Herbert Bayard Swope",
    "quote": "I can't give you a sure-fire formula for success, but I can give you a formula for failure: try to please everybody all the time."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "So, I love you because the entire universe conspired to help me find you."
  },
  {
    "author": "Anonymous,",
    "quote": "Love is patient, love is kind. It does not envy, it does not boast, it is not proud. It is not rude, it is not self-seeking, it is not easily angered, it keeps no record of wrongs. Love does not delight in evil but rejoices with the truth. It always protects, always trusts, always hopes, always perseveres."
  },
  {
    "author": "George V. Higgins,",
    "quote": "This life’s hard, but it’s harder if you’re stupid."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "Sometimes I can hear my bones straining under the weight of all the lives I'm not living."
  },
  {
    "author": "Douglas Adams",
    "quote": "I refuse to answer that question on the grounds that I don't know the answer"
  },
  {
    "author": "Margaret Mead",
    "quote": "Never doubt that a small group of thoughtful, committed, citizens can change the world. Indeed, it is the only thing that ever has."
  },
  {
    "author": "Mitch Albom,",
    "quote": "Death ends a life, not a relationship."
  },
  {
    "author": "John Green,",
    "quote": "What is the point of being alive if you don't at least try to do something remarkable?"
  },
  {
    "author": "Neil Gaiman",
    "quote": "May your coming year be filled with magic and dreams and good madness. I hope you read some fine books and kiss someone who thinks you're wonderful, and don't forget to make some art -- write or draw or build or sing or live as only you can. And I hope, somewhere in the next year, you surprise yourself."
  },
  {
    "author": "Albert Einstein",
    "quote": "Never memorize something that you can look up."
  },
  {
    "author": "E.E. Cummings",
    "quote": "I carry your heart with me (I carry it in my heart)I am never without it (anywhere"
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Sometimes you wake up. Sometimes the fall kills you. And sometimes, when you fall, you fly."
  },
  {
    "author": "John Green",
    "quote": "Maybe our favorite quotations say more about us than about the stories and people we're quoting."
  },
  {
    "author": "Langston Hughes",
    "quote": "Hold fast to dreams,"
  },
  {
    "author": "Dalai Lama XIV",
    "quote": "Happiness is not something ready made. It comes from your own actions."
  },
  {
    "author": "John Lennon",
    "quote": "Count your age by friends, not years. Count your life by smiles, not tears."
  },
  {
    "author": "John Green,",
    "quote": "What a treacherous thing to believe that a person is more than a person."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "All we have to decide is what to do with the time that is given us."
  },
  {
    "author": "Kahlil Gibran,",
    "quote": "You talk when you cease to be at peace with your thoughts."
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "All that we see or seem is but a dream within a dream."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Indifference and neglect often do much more damage than outright dislike."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Wit beyond measure is man’s greatest treasure."
  },
  {
    "author": "C.S. Lewis",
    "quote": "The Christian does not think God will love us because we are good, but that God will make us good because He loves us."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "We are only as strong as we are united, as weak as we are divided."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "I like the night. Without the dark, we'd never see the stars."
  },
  {
    "author": "Mahatma Gandhi,",
    "quote": "The weak can never forgive. Forgiveness is the attribute of the strong."
  },
  {
    "author": "Gustave Flaubert",
    "quote": "Do not read, as children do, to amuse yourself, or like the ambitious, for the purpose of instruction. No, read in order to live."
  },
  {
    "author": "Mother Teresa",
    "quote": "Peace begins with a smile.."
  },
  {
    "author": "Markus Zusak,",
    "quote": "The only thing worse than a boy who hates you: a boy that loves you."
  },
  {
    "author": "H.N. Turteltaub,",
    "quote": "If you were half as funny as you think you are, you'd be twice as funny as you really are."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "So, I guess we are who we are for alot of reasons. And maybe we'll never know most of them. But even if we don't have the power to choose where we come from, we can still choose where we go from there. We can still do things. And we can try to feel okay about them."
  },
  {
    "author": "Albert Camus",
    "quote": "In the depth of winter, I finally learned that within me there lay an invincible summer."
  },
  {
    "author": "John Green,",
    "quote": "Imagining the future is a kind of nostalgia. (...) You spend your whole life stuck in the labyrinth, thinking about how you'll escape it one day, and how awesome it will be, and imagining that future keeps you going, but you never do it. You just use the future to escape the present."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "You are my best friend as well as my lover, and I do not know which side of you I enjoy the most. I treasure each side, just as I have treasured our life together."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "You are, and always have been, my dream."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Is it true that you shouted at Professor Umbridge?"
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "You're going to come across people in your life who will say all the right words at all the right times. But in the end, it's always their actions you should judge them by. It's actions, not words, that matter."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "We came to see Jace. Is he alright?"
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Mr. Moony presents his compliments to Professor Snape, and begs him to keep his abnormally large nose out of other people's business."
  },
  {
    "author": "Charlotte Brontë,",
    "quote": "I would always rather be happy than dignified."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "To the people who look at the stars and wish, Rhys."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "Friendship is unnecessary, like philosophy, like art.... It has no survival value; rather it is one of those things which give value to survival."
  },
  {
    "author": "Fyodor Dostoevsky,",
    "quote": "Above all, don't lie to yourself. The man who lies to himself and listens to his own lie comes to a point that he cannot distinguish the truth within him, or around him, and so loses all respect for himself and for others. And having no respect he ceases to love."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "I hope she'll be a fool -- that's the best thing a girl can be in this world, a beautiful little fool."
  },
  {
    "author": "Mark Twain",
    "quote": "In a good bookroom you feel in some mysterious way that you are absorbing the wisdom contained in all the books through your skin, without even opening them."
  },
  {
    "author": "Aldous Huxley,",
    "quote": "Facts do not cease to exist because they are ignored."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "He can run faster than Severus Snape confronted with shampoo."
  },
  {
    "author": "Sam Levenson,",
    "quote": "For attractive lips, speak words of kindness."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "Don't think or judge, just listen."
  },
  {
    "author": "Michael Cunningham,",
    "quote": "You cannot find peace by avoiding life."
  },
  {
    "author": "Christian D. Larson,",
    "quote": "Promise Yourself"
  },
  {
    "author": "Oscar Wilde,",
    "quote": "You will always be fond of me. I represent to you all the sins you never had the courage to commit."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "And those who were seen dancing were thought to be insane by those who could not hear the music."
  },
  {
    "author": "John Green,",
    "quote": "Grief does not change you, Hazel. It reveals you."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "And now I’m looking at you, he said, and you’re asking me if I still want you, as if I could stop loving you. As if I would want to give up the thing that makes me stronger than anything else ever has. I never dared give much of myself to anyone before – bits of myself to the Lightwoods, to Isabelle and Alec, but it took years to do it – but, Clary, since the first time I saw you, I have belonged to you completely. I still do. If you want me."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Happy Hunger Games! And may the odds be ever in your favor."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "If more of us valued food and cheer and song above hoarded gold, it would be a merrier world."
  },
  {
    "author": "Groucho Marx",
    "quote": "When you're in jail, a good friend will be trying to bail you out. A best friend will be in the cell next to you saying, 'Damn, that was fun'."
  },
  {
    "author": "Oscar Wilde",
    "quote": "A good friend will always stab you in the front."
  },
  {
    "author": "George Orwell,",
    "quote": "Who controls the past controls the future. Who controls the present controls the past."
  },
  {
    "author": "Kurt Vonnegut",
    "quote": "Those who believe in telekinetics, raise my hand."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "Some humans would do anything to see if it was possible to do it. If you put a large switch in some cave somewhere, with a sign on it saying 'End-of-the-World Switch. PLEASE DO NOT TOUCH', the paint wouldn't even have time to dry."
  },
  {
    "author": "Albert Camus",
    "quote": "Man is the only creature who refuses to be what he is."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "Whatever you are, be a good one."
  },
  {
    "author": "Jonathan Swift",
    "quote": "May you live every day of your life."
  },
  {
    "author": "Douglas Adams,",
    "quote": "For instance, on the planet Earth, man had always assumed that he was more intelligent than dolphins because he had achieved so much—the wheel, New York, wars and so on—whilst all the dolphins had ever done was muck about in the water having a good time. But conversely, the dolphins had always believed that they were far more intelligent than man—for precisely the same reasons."
  },
  {
    "author": "Gilda Radner",
    "quote": "I wanted a perfect ending. Now I've learned, the hard way, that some poems don't rhyme, and some stories don't have a clear beginning, middle, and end. Life is about not knowing, having to change, taking the moment and making the best of it, without knowing what's going to happen next."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Don't touch any of my weapons without my permission."
  },
  {
    "author": "Plato",
    "quote": "Be kind, for everyone you meet is fighting a harder battle."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "And once the storm is over, you won’t remember how you made it through, how you managed to survive. You won’t even be sure, whether the storm is really over. But one thing is certain. When you come out of the storm, you won’t be the same person who walked in. That’s what this storm’s all about."
  },
  {
    "author": "Albert Einstein",
    "quote": "When you are courting a nice girl an hour seems like a second. When you sit on a red-hot cinder a second seems like an hour. That's relativity."
  },
  {
    "author": "Oscar Levant",
    "quote": "There's a fine line between genius and insanity. I have erased this line."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "Libraries were full of ideas—perhaps the most dangerous and powerful of all weapons."
  },
  {
    "author": "George R. R. Martin",
    "quote": "Sleep is good, he said, and books are better."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Women are meant to be loved, not to be understood."
  },
  {
    "author": "Carter Crocker",
    "quote": "Promise me you'll always remember: You're braver than you believe, and stronger than you seem, and smarter than you think."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Where there is love there is life."
  },
  {
    "author": "Richelle Mead,",
    "quote": "You can't force love, I realized. It's there or it isn't. If it's not there, you've got to be able to admit it. If it is there, you've got to do whatever it takes to protect the ones you love."
  },
  {
    "author": "Carter Crocker",
    "quote": "If ever there is tomorrow when we're not together... there is something you must always remember. You are braver than you believe, stronger than you seem, and smarter than you think. But the most important thing is, even if we're apart... I'll always be with you."
  },
  {
    "author": "Thomas Szasz",
    "quote": "Two wrongs don't make a right, but they make a good excuse."
  },
  {
    "author": "Lemony Snicket",
    "quote": "Wicked people never have time for reading. It's one of the reasons for their wickedness."
  },
  {
    "author": "Plato",
    "quote": "Every heart sings a song, incomplete, until another heart whispers back. Those who wish to sing always find a song. At the touch of a lover, everyone becomes a poet."
  },
  {
    "author": "Markus Zusak,",
    "quote": "I have hated words and I have loved them, and I hope I have made them right."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "I love you. I am who I am because of you. You are every reason, every hope, and every dream I've ever had, and no matter what happens to us in the future, everyday we are together is the greatest day of my life. I will always be yours."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "I think you still love me, but we can’t escape the fact that I’m not enough for you. I knew this was going to happen. So I’m not blaming you for falling in love with another woman. I’m not angry, either. I should be, but I’m not. I just feel pain. A lot of pain. I thought I could imagine how much this would hurt, but I was wrong."
  },
  {
    "author": "Anais Nin",
    "quote": "We write to taste life twice, in the moment and in retrospect."
  },
  {
    "author": "Mark Twain",
    "quote": "Substitute 'damn' every time you're inclined to write 'very;' your editor will delete it and the writing will be just as it should be."
  },
  {
    "author": "Oscar Wilde",
    "quote": "I don't want to go to heaven. None of my friends are there."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Doubt thou the stars are fire;"
  },
  {
    "author": "Marilyn Monroe",
    "quote": "When it comes down to it, I let them think what they want. If they care enough to bother with what I do, then I'm already better than them."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Attitude is a choice. Happiness is a choice. Optimism is a choice. Kindness is a choice. Giving is a choice. Respect is a choice. Whatever choice you make makes you. Choose wisely."
  },
  {
    "author": "Lady Gaga",
    "quote": "Some women choose to follow men, and some women choose to follow their dreams. If you're wondering which way to go, remember that your career will never wake up and tell you that it doesn't love you anymore."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Death's got an Invisibility Cloak? Harry interrupted again."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I've never fooled anyone. I've let people fool themselves. They didn't bother to find out who and what I was. Instead they would invent a character for me. I wouldn't argue with them. They were obviously loving somebody I wasn't."
  },
  {
    "author": "Carl Gustav Jung",
    "quote": "The meeting of two personalities is like the contact of two chemical substances: if there is any reaction, both are transformed."
  },
  {
    "author": "Anne Frank,",
    "quote": "It's really a wonder that I haven't dropped all my ideals, because they seem so absurd and impossible to carry out. Yet I keep them, because in spite of everything, I still believe that people are really good at heart."
  },
  {
    "author": "Chris Rock",
    "quote": "You know the world is going crazy when the best rapper is a white guy, the best golfer is a black guy, the tallest guy in the NBA is Chinese, the Swiss hold the America's Cup, France is accusing the U.S. of arrogance, Germany doesn't want to go to war, and the three most powerful men in America are named Bush, Dick, and Colin. Need I say more?"
  },
  {
    "author": "Rick Riordan,",
    "quote": "If my life is going to mean anything, I have to live it myself."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "I love sleep. My life has the tendency to fall apart when I'm awake, you know?"
  },
  {
    "author": "Rick Riordan,",
    "quote": "Let us find the dam snack bar, Zoe said. We should eat while we can."
  },
  {
    "author": "Nicholas Klein",
    "quote": "First they ignore you. Then they ridicule you. And then they attack you and want to burn you. And then they build monuments to you."
  },
  {
    "author": "Albert Einstein",
    "quote": "A clever person solves a problem. A wise person avoids it."
  },
  {
    "author": "Anaïs Nin",
    "quote": "I, with a deeper instinct, choose a man who compels my strength, who makes enormous demands on me, who does not doubt my courage or my toughness, who does not believe me naïve or innocent, who has the courage to treat me like a woman."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "And now here is my secret, a very simple secret: It is only with the heart that one can see rightly; what is essential is invisible to the eye."
  },
  {
    "author": "Zelda Fitzgerald",
    "quote": "Nobody has ever measured, not even poets, how much the heart can hold."
  },
  {
    "author": "Nicholas Sparks",
    "quote": "The best love is the kind that awakens the soul and makes us reach for more, that plants a fire in our hearts and brings peace to our minds. And that's what you've given me. That's what I'd hoped to give you forever"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "It means 'Shadowhunters: Looking Better in Black Than the Widows of our Enemies Since 1234'."
  },
  {
    "author": "Stephen King,",
    "quote": "Get busy living or get busy dying."
  },
  {
    "author": "John Lennon",
    "quote": "There are two basic motivating forces: fear and love. When we are afraid, we pull back from life. When we are in love, we open to all that life has to offer with passion, excitement, and acceptance. We need to learn to love ourselves first, in all our glory and our imperfections. If we cannot love ourselves, we cannot fully open to our ability to love others or our potential to create. Evolution and all hopes for a better world rest in the fearlessness and open-hearted vision of people who embrace life."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "It's only after we've lost everything that we're free to do anything."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I saw my life branching out before me like the green fig tree in the story. From the tip of every branch, like a fat purple fig, a wonderful future beckoned and winked. One fig was a husband and a happy home and children, and another fig was a famous poet and another fig was a brilliant professor, and another fig was Ee Gee, the amazing editor, and another fig was Europe and Africa and South America, and another fig was Constantin and Socrates and Attila and a pack of other lovers with queer names and offbeat professions, and another fig was an Olympic lady crew champion, and beyond and above these figs were many more figs I couldn't quite make out. I saw myself sitting in the crotch of this fig tree, starving to death, just because I couldn't make up my mind which of the figs I would choose. I wanted each and every one of them, but choosing one meant losing all the rest, and, as I sat there, unable to decide, the figs began to wrinkle and go black, and, one by one, they plopped to the ground at my feet."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "I can believe things that are true and things that aren't true and I can believe things where nobody knows if they're true or not."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "We all die. The goal isn't to live forever, the goal is to create something that will."
  },
  {
    "author": "Rumi",
    "quote": "Your task is not to seek for love, but merely to seek and find all the barriers within yourself that you have built against it."
  },
  {
    "author": "Nicole Krauss,",
    "quote": "Once upon a time there was a boy who loved a girl, and her laughter was a question he wanted to spend his whole life answering."
  },
  {
    "author": "Maya Angelou",
    "quote": "When someone shows you who they are believe them the first time."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Destroying things is much easier than making them."
  },
  {
    "author": "Brigham Young",
    "quote": "You educate a man; you educate a man. You educate a woman; you educate a generation."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Well, don't expect us to be too impressed. We just saw Finnick Odair in his underwear."
  },
  {
    "author": "Robert Fulghum,",
    "quote": "I believe that imagination is stronger than knowledge. That myth is more potent than history. That dreams are more powerful than facts. That hope always triumphs over experience. That laughter is the only cure for grief. And I believe that love is stronger than death."
  },
  {
    "author": "E.B. White",
    "quote": "If the world were merely seductive, that would be easy. If it were merely challenging, that would be no problem. But I arise in the morning torn between a desire to improve the world and a desire to enjoy the world. This makes it hard to plan the day."
  },
  {
    "author": "Rumi",
    "quote": "Out beyond ideas of wrongdoing"
  },
  {
    "author": "Albert Einstein",
    "quote": "Science without religion is lame, religion without science is blind."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Don't be pushed around by the fears in your mind. Be led by the dreams in your heart."
  },
  {
    "author": "Edgar Allen Poe",
    "quote": "We loved with a love that was more than love."
  },
  {
    "author": "Robert Frost,",
    "quote": "These woods are lovely, dark and deep,"
  },
  {
    "author": "John Green,",
    "quote": "When I look at my room, I see a girl who loves books."
  },
  {
    "author": "Philip K. Dick,",
    "quote": "It is sometimes an appropriate response to reality to go insane."
  },
  {
    "author": "Mark Twain",
    "quote": "Reader, suppose you were an idiot. And suppose you were a member of Congress. But I repeat myself."
  },
  {
    "author": "Stephen King",
    "quote": "Books are the perfect entertainment: no commercials, no batteries, hours of enjoyment for each dollar spent. What I wonder is why everybody doesn't carry a book around for those inevitable dead spots in life."
  },
  {
    "author": "J.M. Barrie,",
    "quote": "All the world is made of faith, and trust, and pixie dust."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "We fell in love, despite our differences, and once we did, something rare and beautiful was created. For me, love like that has only happened once, and that's why every minute we spent together has been seared in my memory. I'll never forget a single moment of it."
  },
  {
    "author": "Rainbow Rowell,",
    "quote": "Eleanor was right. She never looked nice. She looked like art, and art wasn't supposed to look nice; it was supposed to make you feel something."
  },
  {
    "author": "William Shakespeare,",
    "quote": "The fault, dear Brutus, is not in our stars, but in ourselves."
  },
  {
    "author": "Arundhati Roy,",
    "quote": "To love. To be loved. To never forget your own insignificance. To never get used to the unspeakable violence and the vulgar disparity of life around you. To seek joy in the saddest places. To pursue beauty to its lair. To never simplify what is complicated or complicate what is simple. To respect strength, never power. Above all, to watch. To try and understand. To never look away. And never, never to forget."
  },
  {
    "author": "May Sarton",
    "quote": "We have to dare to be ourselves, however frightening or strange that self may prove to be."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I took a deep breath and listened to the old brag of my heart. I am, I am, I am."
  },
  {
    "author": "L.M. Montgomery",
    "quote": "Isn't it nice to think that tomorrow is a new day with no mistakes in it yet?"
  },
  {
    "author": "A.A. Milne,",
    "quote": "You can't stay in your corner of the Forest waiting for others to come to you. You have to go to them sometimes."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "If you expect nothing from somebody you are never disappointed."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Anyone who lives within their means suffers from a lack of imagination."
  },
  {
    "author": "Billy Sunday,",
    "quote": "Going to church doesn’t make you a Christian any more than going to a garage makes you an automobile."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Life is a book and there are a thousand pages I have not yet read."
  },
  {
    "author": "Théophile Gautier",
    "quote": "Chance is perhaps the pseudonym of God when he does not want to sign."
  },
  {
    "author": "Mary Oliver",
    "quote": "Tell me, what is it you plan to do"
  },
  {
    "author": "Jane Austen,",
    "quote": "I do not want people to be very agreeable, as it saves me the trouble of liking them a great deal."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "You're a prefect? Oh Ronnie! That's everyone in the family!"
  },
  {
    "author": "Voltaire",
    "quote": "Let us read, and let us dance; these two amusements will never do any harm to the world."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "And so the lion fell in love with the lamb… he murmured. I looked away, hiding my eyes as I thrilled to the word."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "This is a good sign, having a broken heart. It means we have tried for something."
  },
  {
    "author": "Aristotle,",
    "quote": "It is the mark of an educated mind to be able to entertain a thought without accepting it."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "I DON'T CARE! Harry yelled at them, snatching up a lunascope and throwing it into the fireplace. I'VE HAD ENOUGH, I'VE SEEN ENOUGH, I WANT OUT, I WANT IT TO END, I DON'T CARE ANYMORE!"
  },
  {
    "author": "Albert Einstein",
    "quote": "Any fool can know. The point is to understand."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "And I'm suppose to sit by while you date boys and fall in love with someone else, get married...? His voice tightened. And meanwhile, I'll die a little bit more every day, watching."
  },
  {
    "author": "Charles Bukowski",
    "quote": "For those who believe in God, most of the big questions are answered. But for those of us who can't readily accept the God formula, the big answers don't remain stone-written. We adjust to new conditions and discoveries. We are pliable. Love need not be a command nor faith a dictum. I am my own god. We are here to unlearn the teachings of the church, state, and our educational system. We are here to drink beer. We are here to kill war. We are here to laugh at the odds and live our lives so well that Death will tremble to take us."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "Unless someone like you cares a whole awful lot,"
  },
  {
    "author": "George Carlin",
    "quote": "The planet is fine. The people are fucked."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "We should all start to live before we get too old. Fear is stupid. So are regrets."
  },
  {
    "author": "John Green,",
    "quote": "There will come a time when all of us are dead. All of us. There will come a time when there are no human beings remaining to remember that anyone ever existed or that our species ever did anything. There will be no one left to remember Aristotle or Cleopatra, let alone you. Everything that we did and built and wrote and thought and discovered will be forgotten and all of this will have been for naught. Maybe that time is coming soon and maybe it is millions of years away, but even if we survive the collapse of our sun, we will not survive forever. There was time before organisms experienced consciousness, and there will be time after. And if the inevitability of human oblivion worries you, I encourage you to ignore it. God knows that’s what everyone else does."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Every saint has a past, and every sinner has a future."
  },
  {
    "author": "A.A. Milne,",
    "quote": "Some people care too much. I think it's called love."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "Never laugh at live dragons."
  },
  {
    "author": "Sir Francis Bacon",
    "quote": "Some books should be tasted, some devoured, but only a few should be chewed and digested thoroughly."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Deep in the meadow, hidden far away"
  },
  {
    "author": "Desiderius Erasmus Roterodamus",
    "quote": "When I have a little money, I buy books; and if I have any left, I buy food and clothes."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "The secret of life, though, is to fall seven times and to get up eight times."
  },
  {
    "author": "Jane Austen,",
    "quote": "The more I know of the world, the more I am convinced that I shall never see a man whom I can really love. I require so much!"
  },
  {
    "author": "Emily Dickinson",
    "quote": "Hope is the thing with feathers"
  },
  {
    "author": "John Green,",
    "quote": "I wanted so badly to lie down next to her on the couch, to wrap my arms around her and sleep. Not fuck, like in those movies. Not even have sex. Just sleep together in the most innocent sense of the phrase. But I lacked the courage and she had a boyfriend and I was gawky and she was gorgeous and I was hopelessly boring and she was endlessly fascinating. So I walked back to my room and collapsed on the bottom bunk, thinking that if people were rain, I was drizzle and she was hurricane."
  },
  {
    "author": "Søren Kierkegaard",
    "quote": "Life can only be understood backwards; but it must be lived forwards."
  },
  {
    "author": "Charlaine Harris",
    "quote": "Here’s to books, the cheapest vacation you can buy."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It is the unknown we fear when we look upon death and darkness, nothing more."
  },
  {
    "author": "John Lennon",
    "quote": "I believe in everything until it's disproved. So I believe in fairies, the myths, dragons. It all exists, even if it's in your mind. Who's to say that dreams and nightmares aren't as real as the here and now?"
  },
  {
    "author": "Shana Abe",
    "quote": "I heard what you said. I’m not the silly romantic you think. I don’t want the heavens or the shooting stars. I don’t want gemstones or gold. I have those things already. I want…a steady hand. A kind soul. I want to fall asleep, and wake, knowing my heart is safe. I want to love, and be loved."
  },
  {
    "author": "C.S. Lewis",
    "quote": "Eating and reading are two pleasures that combine admirably."
  },
  {
    "author": "Stephen Hawking",
    "quote": "One, remember to look up at the stars and not down at your feet. Two, never give up work. Work gives you meaning and purpose and life is empty without it. Three, if you are lucky enough to find love, remember it is there and don't throw it away."
  },
  {
    "author": "Lemony Snicket",
    "quote": "Reading is one form of escape. Running for your life is another."
  },
  {
    "author": "Edgar Allan Poe,",
    "quote": "Those who dream by day are cognizant of many things which escape those who dream only by night."
  },
  {
    "author": "Dave Matthews Band",
    "quote": "A guy and a girl can be just friends, but at one point or another, they will fall for each other...Maybe temporarily, maybe at the wrong time, maybe too late, or maybe forever"
  },
  {
    "author": "C. JoyBell C.",
    "quote": "You can talk with someone for years, everyday, and still, it won't mean as much as what you can have when you sit in front of someone, not saying a word, yet you feel that person with your heart, you feel like you have known the person for forever.... connections are made with the heart, not the tongue."
  },
  {
    "author": "Charles Bukowski",
    "quote": "Sometimes you climb out of bed in the morning and you think, I'm not going to make it, but you laugh inside — remembering all the times you've felt that way."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "Faithless is he that says farewell when the road darkens."
  },
  {
    "author": "Albert Einstein",
    "quote": "Reality is merely an illusion, albeit a very persistent one."
  },
  {
    "author": "Evans G. Valens,",
    "quote": "How lucky I am to have known somebody and something that saying goodbye to is so damned awful."
  },
  {
    "author": "St. Augustine",
    "quote": "The world is a book and those who do not travel read only one page."
  },
  {
    "author": "Veronica Roth,",
    "quote": "I might be in love with you. He smiles a little. I'm waiting until I'm sure to tell you, though."
  },
  {
    "author": "haruki murakami,",
    "quote": "Pain is inevitable. Suffering is optional."
  },
  {
    "author": "Jack Kerouac,",
    "quote": "One day I will find the right words, and they will be simple."
  },
  {
    "author": "Albert Einstein",
    "quote": "If we knew what it was we were doing, it would not be called research, would it?"
  },
  {
    "author": "Pat Conroy,",
    "quote": "You get a little moody sometimes but I think that's because you like to read. People that like to read are always a little fucked up."
  },
  {
    "author": "Madeline Miller,",
    "quote": "I could recognize him by touch alone, by smell; I would know him blind, by the way his breaths came and his feet struck the earth. I would know him in death, at the end of the world."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Instead of worrying about what you cannot control, shift your energy to what you can create."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Do you remember back at the hotel when you promised that if we lived, you’d get dressed up in a nurse’s outfit and give me a sponge bath? asked Jace."
  },
  {
    "author": "Oscar Wilde",
    "quote": "I am not young enough to know everything."
  },
  {
    "author": "Chad Sugg,",
    "quote": "If you're reading this..."
  },
  {
    "author": "Mae West",
    "quote": "There are no good girls gone wrong - just bad girls found out."
  },
  {
    "author": "Laurence J. Peter",
    "quote": "If a cluttered desk is a sign of a cluttered mind, of what, then, is an empty desk a sign?"
  },
  {
    "author": "Mark Twain",
    "quote": "Don’t go around saying the world owes you a living. The world owes you nothing. It was here first."
  },
  {
    "author": "Neil Gaiman",
    "quote": "I hope that in this year to come, you make mistakes. Because if you are making mistakes...you're Doing Something."
  },
  {
    "author": "Phyllis Diller",
    "quote": "Never go to bed mad. Stay up and fight."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Experience is merely the name men gave to their mistakes."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "We live and breathe words. .... It was books that made me feel that perhaps I was not completely alone. They could be honest with me, and I with them. Reading your words, what you wrote, how you were lonely sometimes and afraid, but always brave; the way you saw the world, its colors and textures and sounds, I felt--I felt the way you thought, hoped, felt, dreamt. I felt I was dreaming and thinking and feeling"
  },
  {
    "author": "Henry David Thoreau,",
    "quote": "I learned this, at least, by my experiment: that if one advances confidently in the direction of his dreams, and endeavors to live the life which he has imagined, he will meet with a success unexpected in common hours."
  },
  {
    "author": "Albert Einstein",
    "quote": "I have no special talents. I am only passionately curious."
  },
  {
    "author": "Stephen King",
    "quote": "Monsters are real, and ghosts are real too. They live inside us, and sometimes, they win."
  },
  {
    "author": "George Orwell",
    "quote": "In a time of deceit telling the truth is a revolutionary act."
  },
  {
    "author": "John Milton,",
    "quote": "The mind is its own place, and in itself can make a heaven of hell, a hell of heaven.."
  },
  {
    "author": "Jerome K. Jerome",
    "quote": "I like work: it fascinates me. I can sit and look at it for hours."
  },
  {
    "author": "James Baldwin",
    "quote": "You think your pain and your heartbreak are unprecedented in the history of the world, but then you read. It was books that taught me that the things that tormented me most were the very things that connected me with all the people who were alive, who had ever been alive."
  },
  {
    "author": "Harper Lee,",
    "quote": "I wanted you to see what real courage is, instead of getting the idea that courage is a man with a gun in his hand. It's when you know you're licked before you begin, but you begin anyway and see it through no matter what."
  },
  {
    "author": "Charles Bukowski",
    "quote": "I've never been lonely. I've been in a room -- I've felt suicidal. I've been depressed. I've felt awful -- awful beyond all -- but I never felt that one other person could enter that room and cure what was bothering me...or that any number of people could enter that room. In other words, loneliness is something I've never been bothered with because I've always had this terrible itch for solitude. It's being at a party, or at a stadium full of people cheering for something, that I might feel loneliness. I'll quote Ibsen, The strongest men are the most alone. I've never thought, Well, some beautiful blonde will come in here and give me a fuck-job, rub my balls, and I'll feel good. No, that won't help. You know the typical crowd, Wow, it's Friday night, what are you going to do? Just sit there? Well, yeah. Because there's nothing out there. It's stupidity. Stupid people mingling with stupid people. Let them stupidify themselves. I've never been bothered with the need to rush out into the night. I hid in bars, because I didn't want to hide in factories. That's all. Sorry for all the millions, but I've never been lonely. I like myself. I'm the best form of entertainment I have. Let's drink more wine!"
  },
  {
    "author": "John Lennon",
    "quote": "When I was 5 years old, my mother always told me that happiness was the key to life. When I went to school, they asked me what I wanted to be when I grew up. I wrote down ‘happy’. They told me I didn’t understand the assignment, and I told them they didn’t understand life."
  },
  {
    "author": "George Bernard Shaw",
    "quote": "A life spent making mistakes is not only more honorable, but more useful than a life spent doing nothing."
  },
  {
    "author": "Maya Angelou",
    "quote": "We delight in the beauty of the butterfly, but rarely admit the changes it has gone through to achieve that beauty."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "Always do what you are afraid to do."
  },
  {
    "author": "Martin Luther King Jr.,",
    "quote": "I have decided to stick to love...Hate is too great a burden to bear."
  },
  {
    "author": "Alexandre Dumas",
    "quote": "There is neither happiness nor misery in the world; there is only the comparison of one state with another, nothing more. He who has felt the deepest grief is best able to experience supreme happiness. We must have felt what it is to die, Morrel, that we may appreciate the enjoyments of life."
  },
  {
    "author": "Tom Bodett",
    "quote": "They say a person needs just three things to be truly happy in this world: someone to love, something to do, and something to hope for."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "It is a curious thing, the death of a loved one. We all know that our time in this world is limited, and that eventually all of us will end up underneath some sheet, never to wake up. And yet it is always a surprise when it happens to someone we know. It is like walking up the stairs to your bedroom in the dark, and thinking there is one more stair than there is. Your foot falls down, through the air, and there is a sickly moment of dark surprise as you try and readjust the way you thought of things."
  },
  {
    "author": "John Green,",
    "quote": "That's always seemed so ridiculous to me, that people want to be around someone because they're pretty. It's like picking your breakfeast cereals based on color instead of taste."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "I would have come for you. And if I couldn't walk, I'd crawl to you, and no matter how broken we were, we'd fight our way out together-knives drawn, pistols blazing. Because that's what we do. We never stop fighting."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Sarcasm is the last refuge of the imaginatively bankrupt."
  },
  {
    "author": "Martin Luther King Jr.,",
    "quote": "Our lives begin to end the day we become silent about things that matter."
  },
  {
    "author": "Trisha Yearwood",
    "quote": "What's meant to be will always find a way"
  },
  {
    "author": "John Green,",
    "quote": "May I see you again? he asked. There was an endearing nervousness in his voice."
  },
  {
    "author": "Arthur Schopenhauer",
    "quote": "Talent hits a target no one else can hit. Genius hits a target no one else can see."
  },
  {
    "author": "Bertrand Russell",
    "quote": "There are two motives for reading a book; one, that you enjoy it; the other, that you can boast about it."
  },
  {
    "author": "George Bernard Shaw",
    "quote": "Make it a rule never to give a child a book you would not read yourself."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "I think that if I ever have kids, and they are upset, I won't tell them that people are starving in China or anything like that because it wouldn't change the fact that they were upset. And even if somebody else has it much worse, that doesn't really change the fact that you have what you have."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Malachi scowled. I don't remember the Clave inviting you into the Glass City, Magnus Bane."
  },
  {
    "author": "William Shakespear,",
    "quote": "There is nothing either good or bad, but thinking makes it so."
  },
  {
    "author": "Oscar Wilde",
    "quote": "A thing is not necessarily true because a man dies for it."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Hell is empty and all the devils are here."
  },
  {
    "author": "Stephen King,",
    "quote": "When his life was ruined, his family killed, his farm destroyed, Job knelt down on the ground and yelled up to the heavens, Why god? Why me? and the thundering voice of God answered, There's just something about you that pisses me off."
  },
  {
    "author": "Carl Sagan",
    "quote": "Somewhere, something incredible is waiting to be known."
  },
  {
    "author": "Anais Nin",
    "quote": "And the day came when the risk to remain tight in a bud was more painful than the risk it took to blossom."
  },
  {
    "author": "Martin Luther King Jr.",
    "quote": "In the end, we will remember not the words of our enemies, but the silence of our friends."
  },
  {
    "author": "Ayn Rand,",
    "quote": "Do not let your fire go out, spark by irreplaceable spark in the hopeless swamps of the not-quite, the not-yet, and the not-at-all. Do not let the hero in your soul perish in lonely frustration for the life you deserved and have never been able to reach. The world you desire can be won. It exists.. it is real.. it is possible.. it's yours."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "The world is indeed full of peril, and in it there are many dark places; but still there is much that is fair, and though in all lands love is now mingled with grief, it grows perhaps the greater."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Hearts are made to be broken."
  },
  {
    "author": "Walt Disney Company,",
    "quote": "The flower that blooms in adversity is the rarest and most beautiful of all."
  },
  {
    "author": "John Greenleaf Whittier,",
    "quote": "Of all sad words of tongue or pen, the saddest are these, 'It might have been."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "It is hard enough to remember my opinions, without also remembering my reasons for them!"
  },
  {
    "author": "Douglas Adams,",
    "quote": "There is a theory which states that if ever anyone discovers exactly what the Universe is for and why it is here, it will instantly disappear and be replaced by something even more bizarre and inexplicable."
  },
  {
    "author": "John Green,",
    "quote": "It is so hard to leave—until you leave. And then it is the easiest goddamned thing in the world."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I'm coming back into focus when Caesar asks him if he has a girlfriend back home. Peeta hesitates, then gives an unconvincing shake of his head."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "The boy never cried again, and he never forgot what he'd learned: that to love is to destroy, and that to be loved is to be the one destroyed."
  },
  {
    "author": "Laurie Halse Anderson,",
    "quote": "THE FIRST TEN LIES THEY TELL YOU IN HIGH SCHOOL"
  },
  {
    "author": "Theodore Roosevelt",
    "quote": "It is not the critic who counts; not the man who points out how the strong man stumbles, or where the doer of deeds could have done them better. The credit belongs to the man who is actually in the arena, whose face is marred by dust and sweat and blood; who strives valiantly; who errs, who comes short again and again, because there is no effort without error and shortcoming; but who does actually strive to do the deeds; who knows great enthusiasms, the great devotions; who spends himself in a worthy cause; who at the best knows in the end the triumph of high achievement, and who at the worst, if he fails, at least fails while daring greatly, so that his place shall never be with those cold and timid souls who neither know victory nor defeat."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "You could rattle the stars, she whispered. You could do anything, if only you dared. And deep down, you know it, too. That’s what scares you most."
  },
  {
    "author": "F. Scott Fitzgerald",
    "quote": "The loneliest moment in someone’s life is when they are watching their whole world fall apart, and all they can do is stare blankly."
  },
  {
    "author": "Fyodor Dostoevsky,",
    "quote": "Pain and suffering are always inevitable for a large intelligence and a deep heart. The really great men must, I think, have great sadness on earth."
  },
  {
    "author": "Winston Churchill",
    "quote": "You have enemies? Good. That means you've stood up for something, sometime in your life."
  },
  {
    "author": "Lloyd Alexander",
    "quote": "Fantasy is hardly an escape from reality. It's a way of understanding it."
  },
  {
    "author": "Jane Austen,",
    "quote": "It is a truth universally acknowledged, that a single man in possession of a good fortune, must be in want of a wife."
  },
  {
    "author": "Frederick Douglass",
    "quote": "Once you learn to read, you will be forever free."
  },
  {
    "author": "Leo Tolstoy  ,",
    "quote": "All happy families are alike; each unhappy family is unhappy in its own way."
  },
  {
    "author": "oscar wilde",
    "quote": "You don't love someone for their looks, or their clothes, or for their fancy car, but because they sing a song only you can hear."
  },
  {
    "author": "Bette Midler",
    "quote": "Give a girl the right shoes, and she can conquer the world."
  },
  {
    "author": "Henry Ford",
    "quote": "Whether you think you can, or you think you can't--you're right."
  },
  {
    "author": "John Green,",
    "quote": "Augustus Waters was a self-aggrandizing bastard. But we forgive him. We forgive him not because he had a heart as figuratively good as his literal one sucked, or because he knew more about how to hold a cigarette than any nonsmoker in history, or because he got eighteen years when he should've gotten more.'"
  },
  {
    "author": "E.B. White,",
    "quote": "Why did you do all this for me?' he asked. 'I don't deserve it. I've never done anything for you.' 'You have been my friend,' replied Charlotte. 'That in itself is a tremendous thing."
  },
  {
    "author": "Anne Frank",
    "quote": "Think of all the beauty still left around you and be happy."
  },
  {
    "author": "Jane Austen,",
    "quote": "There are few people whom I really love, and still fewer of whom I think well. The more I see of the world, the more am I dissatisfied with it; and every day confirms my belief of the inconsistency of all human characters, and of the little dependence that can be placed on the appearance of merit or sense."
  },
  {
    "author": "Martin Luther King Jr.",
    "quote": "Faith is taking the first step even when you can't see the whole staircase."
  },
  {
    "author": "Sarah   Williams",
    "quote": "I have loved the stars too fondly to be fearful of the night."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "And by the way, everything in life is writable about if you have the outgoing guts to do it, and the imagination to improvise. The worst enemy to creativity is self-doubt."
  },
  {
    "author": "Milan Kundera",
    "quote": "Two people in love, alone, isolated from the world, that's beautiful."
  },
  {
    "author": "George Carlin,",
    "quote": "Here's all you have to know about men and women: women are crazy, men are stupid. And the main reason women are crazy is that men are stupid."
  },
  {
    "author": "Mark Twain",
    "quote": "I did not attend his funeral, but I sent a nice letter saying I approved of it."
  },
  {
    "author": "Fran Lebowitz,",
    "quote": "Think before you speak. Read before you think."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "I want to stand as close to the edge as I can without going over. Out on the edge you see all kinds of things you can't see from the center."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Be the reason someone smiles. Be the reason someone feels loved and believes in the goodness in people."
  },
  {
    "author": "Khaled Hosseini,",
    "quote": "For you, a thousand times over"
  },
  {
    "author": "Rumi",
    "quote": "The wound is the place where the Light enters you."
  },
  {
    "author": "Abigail Van Buren",
    "quote": "The best index to a person's character is how he treats people who can't do him any good, and how he treats people who can't fight back."
  },
  {
    "author": "John Green,",
    "quote": "Books so special and rare and yours that advertising your affection feels like a betrayal."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "She was a girl who knew how to be happy even when she was sad. And that’s important—you know"
  },
  {
    "author": "Charles Bukowski,",
    "quote": "If you're going to try, go all the way. Otherwise, don't even start. This could mean losing girlfriends, wives, relatives and maybe even your mind. It could mean not eating for three or four days. It could mean freezing on a park bench. It could mean jail. It could mean derision. It could mean mockery--isolation. Isolation is the gift. All the others are a test of your endurance, of how much you really want to do it. And, you'll do it, despite rejection and the worst odds. And it will be better than anything else you can imagine. If you're going to try, go all the way. There is no other feeling like that. You will be alone with the gods, and the nights will flame with fire. You will ride life straight to perfect laughter. It's the only good fight there is."
  },
  {
    "author": "Henry Ward Beecherr",
    "quote": "Where is human nature so weak as in the bookstore?"
  },
  {
    "author": "William Shakespeare,",
    "quote": "This above all: to thine own self be true,"
  },
  {
    "author": "Mark Twain",
    "quote": "God created war so that Americans would learn geography."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "Whoever fights monsters should see to it that in the process he does not become a monster. And if you gaze long enough into an abyss, the abyss will gaze back into you."
  },
  {
    "author": "Isaac Asimov,",
    "quote": "Never let your sense of morals prevent you from doing what is right."
  },
  {
    "author": "Maya Angelou",
    "quote": "Courage is the most important of all the virtues because without courage, you can't practice any other virtue consistently."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "I have a history of making decisions very quickly about men. I have always fallen in love fast and without measuring risks. I have a tendency not only to see the best in everyone, but to assume that everyone is emotionally capable of reaching his highest potential. I have fallen in love more times than I care to count with the highest potential of a man, rather than with the man himself, and I have hung on to the relationship for a long time (sometimes far too long) waiting for the man to ascend to his own greatness. Many times in romance I have been a victim of my own optimism."
  },
  {
    "author": "W.C. Fields",
    "quote": "If at first you don't succeed, try, try again. Then quit. No use being a damn fool about it."
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "I spent my life folded between the pages of books."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Well, I’m not kissing the mundane, said Jace. I’d rather stay down here and rot."
  },
  {
    "author": "Thomas Jefferson",
    "quote": "I cannot live without books."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "You know, you could live a thousand lifetimes and not deserve him."
  },
  {
    "author": "Charles Bukowski",
    "quote": "We're all going to die, all of us, what a circus! That alone should make us love each other but it doesn't. We are terrorized and flattened by trivialities, we are eaten up by nothing."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Waiting is painful. Forgetting is painful. But not knowing which to do is the worst kind of suffering."
  },
  {
    "author": "Emily Jane Brontë ,",
    "quote": "If all else perished, and he remained, I should still continue to be; and if all else remained, and he were annihilated, the universe would turn to a mighty stranger."
  },
  {
    "author": "Aristotle",
    "quote": "What is a friend? A single soul dwelling in two bodies."
  },
  {
    "author": "Albert Einstein",
    "quote": "A human being is a part of the whole called by us universe, a part limited in time and space. He experiences himself, his thoughts and feeling as something separated from the rest, a kind of optical delusion of his consciousness. This delusion is a kind of prison for us, restricting us to our personal desires and to affection for a few persons nearest to us. Our task must be to free ourselves from this prison by widening our circle of compassion to embrace all living creatures and the whole of nature in its beauty."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Take responsibility of your own happiness, never put it in other people’s hands."
  },
  {
    "author": "Carlos Ruiz Zafón,",
    "quote": "Books are mirrors: you only see in them what you already have inside you."
  },
  {
    "author": "C.S. Lewis",
    "quote": "I can't imagine a man really enjoying a book and reading it only once."
  },
  {
    "author": "Stephanie Perkins,",
    "quote": "For the two of us, home isn't a place. It is a person. And we are finally home."
  },
  {
    "author": "Audrey Hepburn",
    "quote": "The most important thing is to enjoy your life—to be happy—it's all that matters."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "If you remember me, then I don't care if everyone else forgets."
  },
  {
    "author": "Coco Chanel",
    "quote": "The most courageous act is still to think for yourself. Aloud."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "No relationship is perfect, ever. There are always some ways you have to bend, to compromise, to give something up in order to gain something greater...The love we have for each other is bigger than these small differences. And that's the key. It's like a big pie chart, and the love in a relationship has to be the biggest piece. Love can make up for a lot."
  },
  {
    "author": "Robert Frost",
    "quote": "Never be bullied into silence. Never allow yourself to be made a victim. Accept no one’s definition of your life; define yourself."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "People aren't either wicked or noble. They're like chef's salads, with good things and bad things chopped and mixed together in a vinaigrette of confusion and conflict."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Not everything is about you, Clary said furiously."
  },
  {
    "author": "Anonymous,",
    "quote": "Love is always patient and kind. It is never jealous. Love is never boastful or conceited. It is never rude or selfish. It does not take offense and is not resentful. Love takes no pleasure in other people’s sins, but delights in the truth. It is always ready to excuse, to trust, to hope, and to endure whatever comes."
  },
  {
    "author": "Charles Bukowski",
    "quote": "what matters most is how well you walk through the fire"
  },
  {
    "author": "Oscar Wilde,",
    "quote": "The very essence of romance is uncertainty."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I am a man he told her, and men do not consume pink beverages. Get thee gone woman, and bring me something brown."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Those who find ugly meanings in beautiful things are corrupt without being charming. This is a fault. Those who find beautiful meanings in beautiful things are the cultivated. For these there is hope. They are the elect to whom beautiful things mean only Beauty. There is no such thing as a moral or an immoral book. Books are well written, or badly written. That is all."
  },
  {
    "author": "William Faulkner",
    "quote": "Read, read, read. Read everything -- trash, classics, good and bad, and see how they do it. Just like a carpenter who works as an apprentice and studies the master. Read! You'll absorb it."
  },
  {
    "author": "Maya Angelou,",
    "quote": "I can be changed by what happens to me. But I refuse to be reduced by it."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "Respect other people's feelings. It might mean nothing to you, but it could mean everything to them."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Be mindful. Be grateful. Be positive. Be true. Be kind."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Have you ever been in love? Horrible isn't it? It makes you so vulnerable. It opens your chest and it opens up your heart and it means that someone can get inside you and mess you up. You build up all these defenses, you build up a whole suit of armor, so that nothing can hurt you, then one stupid person, no different from any other stupid person, wanders into your stupid life...You give them a piece of you. They didn't ask for it. They did something dumb one day, like kiss you or smile at you, and then your life isn't your own anymore. Love takes hostages. It gets inside you. It eats you out and leaves you crying in the darkness, so simple a phrase like 'maybe we should be just friends' turns into a glass splinter working its way into your heart. It hurts. Not just in the imagination. Not just in the mind. It's a soul-hurt, a real gets-inside-you-and-rips-you-apart pain. I hate love."
  },
  {
    "author": "Pablo Neruda,",
    "quote": "Love is so short, forgetting is so long."
  },
  {
    "author": "John Green,",
    "quote": "What the hell is that? I laughed."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Accept yourself, love yourself, and keep moving forward. If you want to fly, you have to give up what weighs you down."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Bran thought about it. 'Can a man still be brave if he's afraid?'"
  },
  {
    "author": "Socrates",
    "quote": "The unexamined life is not worth living."
  },
  {
    "author": "Ellen DeGeneres,",
    "quote": "Accept who you are. Unless you're a serial killer."
  },
  {
    "author": "Mae West",
    "quote": "I generally avoid temptation unless I can't resist it."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "There is always some madness in love. But there is also always some reason in madness."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "They didn’t agree on much. In fact, they didn’t agree on anything. They fought all the time and challenged each other ever day. But despite their differences, they had one important thing in common. They were crazy about each other."
  },
  {
    "author": "Martin Luther King Jr.",
    "quote": "If you can't fly then run, if you can't run then walk, if you can't walk then crawl, but whatever you do you have to keep moving forward."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Everything in the world is about sex except sex. Sex is about power."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Is this the part where you say if I hurt her, you'll kill me?"
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "We are all different. Don’t judge, understand instead."
  },
  {
    "author": "Albert Camus",
    "quote": "Nobody realizes that some people expend tremendous energy merely to be normal."
  },
  {
    "author": "Ned Vizzini,",
    "quote": "I didn't want to wake up. I was having a much better time asleep. And that's really sad. It was almost like a reverse nightmare, like when you wake up from a nightmare you're so relieved. I woke up into a nightmare."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Man is least himself when he talks in his own person. Give him a mask, and he will tell you the truth."
  },
  {
    "author": "Stephen King",
    "quote": "Good books don't give up all their secrets at once."
  },
  {
    "author": "Albert Einstein",
    "quote": "Try not to become a man of success. Rather become a man of value."
  },
  {
    "author": "Jon Katz",
    "quote": "I think if I've learned anything about friendship, it's to hang in, stay connected, fight for them, and let them fight for you. Don't walk away, don't be distracted, don't be too busy or tired, don't take them for granted. Friends are part of the glue that holds life and faith together. Powerful stuff."
  },
  {
    "author": "Saul Bellow",
    "quote": "You never have to change anything you got up in the middle of the night to write."
  },
  {
    "author": "George Orwell,",
    "quote": "All animals are equal, but some animals are more equal than others."
  },
  {
    "author": "William Shakespeare",
    "quote": "It is not in the stars to hold our destiny but in ourselves."
  },
  {
    "author": "Daniel Pennac",
    "quote": "Reader's Bill of Rights"
  },
  {
    "author": "Marilyn Monroe",
    "quote": "All little girls should be told they are pretty, even if they aren't."
  },
  {
    "author": "Victor Hugo,",
    "quote": "He never went out without a book under his arm, and he often came back with two."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "It's not true that I had nothing on. I had the radio on."
  },
  {
    "author": "John Green,",
    "quote": "I'm not saying that everything is survivable. Just that everything except the last thing is."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Not my daughter, you bitch!"
  },
  {
    "author": "Roald Dahl,",
    "quote": "So please, oh please, we beg, we pray,"
  },
  {
    "author": "maya angelou",
    "quote": "I love to see a young girl go out and grab the world by the lapels. Life's a bitch. You've got to go out and kick ass."
  },
  {
    "author": "Benjamin Franklin",
    "quote": "Either write something worth reading or do something worth writing."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You could have had anything else in the world, and you asked for me."
  },
  {
    "author": "Mark Twain",
    "quote": "Never allow someone to be your priority while allowing yourself to be their option."
  },
  {
    "author": "Mark Twain",
    "quote": "I was gratified to be able to answer promptly, and I did. I said I didn’t know."
  },
  {
    "author": "Alan Moore",
    "quote": "My experience of life is that it is not divided up into genres; it’s a horrifying, romantic, tragic, comical, science-fiction cowboy detective novel. You know, with a bit of pornography if you're lucky."
  },
  {
    "author": "Oprah Winfrey",
    "quote": "Turn your wounds into wisdom."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Nothing that’s worthwhile is ever easy. Remember that."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "When you're struggling with something, look at all the people around you and realize that every single person you see is struggling with something, and to them, it's just as hard as what you're going through."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "Once on a yellow piece of paper with green lines"
  },
  {
    "author": "Charles M. Schulz",
    "quote": "Happiness is a warm puppy."
  },
  {
    "author": "Alice Hoffman",
    "quote": "Books may well be the only true magic."
  },
  {
    "author": "Robert Frost",
    "quote": "No tears in the writer, no tears in the reader. No surprise in the writer, no surprise in the reader."
  },
  {
    "author": "George Orwell,",
    "quote": "War is peace."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You said you were going for a walk!? What kind of walk takes six hours?"
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "Deserves it! I daresay he does. Many that live deserve death. And some that die deserve life. Can you give it to them? Then do not be too eager to deal out death in judgement. For even the very wise cannot see all ends."
  },
  {
    "author": "Arthur C. Clarke",
    "quote": "Two possibilities exist: either we are alone in the Universe or we are not. Both are equally terrifying."
  },
  {
    "author": "Albert Einstein",
    "quote": "The important thing is not to stop questioning. Curiosity has its own reason for existence. One cannot help but be in awe when he contemplates the mysteries of eternity, of life, of the marvelous structure of reality. It is enough if one tries merely to comprehend a little of this mystery each day."
  },
  {
    "author": "Marie Lu,",
    "quote": "Each day means a new twenty-four hours. Each day means everything's possible again. You live in the moment, you die in the moment, you take it all one day at a time."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Life is too short to waste your time on people who don’t respect, appreciate, and value you."
  },
  {
    "author": "Arthur Conan Doyle,",
    "quote": "When you have eliminated all which is impossible, then whatever remains, however improbable, must be the truth."
  },
  {
    "author": "Jane Austen,",
    "quote": "I cannot fix on the hour, or the spot, or the look or the words, which laid the foundation. It is too long ago. I was in the middle before I knew that I had begun."
  },
  {
    "author": "Winston S. Churchill",
    "quote": "Men occasionally stumble over the truth, but most of them pick themselves up and hurry off as if nothing had happened."
  },
  {
    "author": "Eleanor Roosevelt,",
    "quote": "You gain strength, courage and confidence by every experience in which you really stop to look fear in the face. You are able to say to yourself, 'I have lived through this horror. I can take the next thing that comes along.' You must do the thing you think you cannot do."
  },
  {
    "author": "John Green,",
    "quote": "Without pain, how could we know joy?' This is an old argument in the field of thinking about suffering and its stupidity and lack of sophistication could be plumbed for centuries but suffice it to say that the existence of broccoli does not, in any way, affect the taste of chocolate."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "Kiss me, and you will see how important I am."
  },
  {
    "author": "Albert Camus",
    "quote": "Should I kill myself, or have a cup of coffee?"
  },
  {
    "author": "J. D. Salinger",
    "quote": "Don't ever tell anybody anything. If you do, you start missing everybody."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Remember when you tried to convince me to feed a poultry pie to the mallards in the park to see if you could breed a race of cannibal ducks?"
  },
  {
    "author": "John Steinbeck,",
    "quote": "I wonder how many people I've looked at all my life and never seen."
  },
  {
    "author": "Jane Smiley,",
    "quote": "Many people, myself among them, feel better at the mere sight of a book."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Believe in yourself. You are braver than you think, more talented than you know, and capable of more than you imagine."
  },
  {
    "author": "Jonathan Safran Foer",
    "quote": "You cannot protect yourself from sadness without protecting yourself from happiness."
  },
  {
    "author": "Leonardo da Vinci",
    "quote": "Painting is poetry that is seen rather than felt, and poetry is painting that is felt rather than seen."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Fantasy is a necessary ingredient in living, it's a way of looking at life through the wrong end of a telescope."
  },
  {
    "author": "George Carlin",
    "quote": "Religion has actually convinced people that there's an invisible man living in the sky who watches everything you do, every minute of every day. And the invisible man has a special list of ten things he does not want you to do. And if you do any of these ten things, he has a special place, full of fire and smoke and burning and torture and anguish, where he will send you to live and suffer and burn and choke and scream and cry forever and ever 'til the end of time!"
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "You must have chaos within you to give birth to a dancing star."
  },
  {
    "author": "Woody Allen",
    "quote": "I don't know the question, but sex is definitely the answer."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "It is said that your life flashes before your eyes just before you die. That is true, it's called Life."
  },
  {
    "author": "Niccolò Machiavelli,",
    "quote": "Everyone sees what you appear to be, few experience what you really are."
  },
  {
    "author": "Nora Ephron",
    "quote": "Above all, be the heroine of your life, not the victim."
  },
  {
    "author": "Rumi",
    "quote": "Stop acting so small. You are the universe in ecstatic motion."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "There comes a time when the world gets quiet and the only thing left is your own heart. So you'd better learn the sound of it. Otherwise you'll never understand what it's saying."
  },
  {
    "author": "Neil Gaiman",
    "quote": "Life is a disease: sexually transmitted, and invariably fatal."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Live the Life of Your Dreams: Be brave enough to live the life of your dreams according to your vision and purpose instead of the expectations and opinions of others."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "The simple things are also the most extraordinary things, and only the wise can see them."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "I am very interested and fascinated how everyone loves each other, but no one really likes each other."
  },
  {
    "author": "Friedrich Wilhelm Nietzsche",
    "quote": "You have your way. I have my way. As for the right way, the correct way, and the only way, it does not exist."
  },
  {
    "author": "Daphne du Maurier",
    "quote": "But luxury has never appealed to me, I like simple things, books, being alone, or with somebody who understands."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "You're still trying to protect me. Real or not real, he whispers."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Why fit in when you were born to stand out?"
  },
  {
    "author": "Haruki Murakami,",
    "quote": "What happens when people open their hearts?"
  },
  {
    "author": "Haruki Marukami",
    "quote": "Whatever it is you're seeking won't come in the form you're expecting."
  },
  {
    "author": "Jhumpa Lahiri,",
    "quote": "That's the thing about books. They let you travel without moving your feet."
  },
  {
    "author": "E.E. Cummings",
    "quote": "To be nobody but"
  },
  {
    "author": "Khaled Hosseini,",
    "quote": "It may be unfair, but what happens in a few days, sometimes even a single day, can change the course of a whole lifetime..."
  },
  {
    "author": "Joseph Brodsky",
    "quote": "There are worse crimes than burning books. One of them is not reading them."
  },
  {
    "author": "Gabriel Garcia Marquez",
    "quote": "What matters in life is not what happens to you but what you remember and how you remember it."
  },
  {
    "author": "F. Scott Fitzgerald",
    "quote": "That is part of the beauty of all literature. You discover that your longings are universal longings, that you're not lonely and isolated from anyone. You belong."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "Many boys will bring you flowers. But someday you'll meet a boy who will learn your favorite flower, your favorite song, your favorite sweet. And even if he is too poor to give you any of them, it won't matter because he will have taken the time to know you as no one else does. Only that boy earns your heart."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "Everyone should be able to do one card trick, tell two jokes, and recite three poems, in case they are ever trapped in an elevator."
  },
  {
    "author": "Ray Bradbury,",
    "quote": "You must stay drunk on writing so reality cannot destroy you."
  },
  {
    "author": "Cicero",
    "quote": "If you have a garden and a library, you have everything you need."
  },
  {
    "author": "Ursula K. Le Guin,",
    "quote": "Love doesn't just sit there, like a stone, it has to be made, like bread; remade all the time, made new."
  },
  {
    "author": "Jamie McGuire,",
    "quote": "To douchebags! he said, gesturing to Brad. And to girls that break your heart, he bowed his head to me. His eyes lost focus. And to the absolute fucking horror of losing your best friend because you were stupid enough to fall in love with her."
  },
  {
    "author": "Douglas Coupland,",
    "quote": "Remember: the time you feel lonely is the time you most need to be by yourself. Life's cruelest irony."
  },
  {
    "author": "Edgar Allan Poe,",
    "quote": "I have great faith in fools - self-confidence my friends will call it."
  },
  {
    "author": "Jim Morrison",
    "quote": "People are afraid of themselves, of their own reality; their feelings most of all. People talk about how great love is, but that’s bullshit. Love hurts. Feelings are disturbing. People are taught that pain is evil and dangerous. How can they deal with love if they’re afraid to feel? Pain is meant to wake us up. People try to hide their pain. But they’re wrong. Pain is something to carry, like a radio. You feel your strength in the experience of pain. It’s all in how you carry it. That’s what matters. Pain is a feeling. Your feelings are a part of you. Your own reality. If you feel ashamed of them, and hide them, you’re letting society destroy your reality. You should stand up for your right to feel your pain."
  },
  {
    "author": "Terry Pratchett",
    "quote": "Stories of imagination tend to upset those without one."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "You have to die a few times before you can really"
  },
  {
    "author": "C.S. Lewis,",
    "quote": "Imagine yourself as a living house. God comes in to rebuild that house. At first, perhaps, you can understand what He is doing. He is getting the drains right and stopping the leaks in the roof and so on; you knew that those jobs needed doing and so you are not surprised. But presently He starts knocking the house about in a way that hurts abominably and does not seem to make any sense. What on earth is He up to? The explanation is that He is building quite a different house from the one you thought of - throwing out a new wing here, putting on an extra floor there, running up towers, making courtyards. You thought you were being made into a decent little cottage: but He is building a palace. He intends to come and live in it Himself."
  },
  {
    "author": "David Sedaris,",
    "quote": "If you're looking for sympathy you'll find it between shit and syphilis in the dictionary."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Stupid people are dangerous."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Prayer is not asking. It is a longing of the soul. It is daily admission of one's weakness. It is better in prayer to have a heart without words than words without a heart."
  },
  {
    "author": "Pamela Redmond Satran",
    "quote": "A WOMAN SHOULD HAVE ...."
  },
  {
    "author": "Sigmund Freud",
    "quote": "One day, in retrospect, the years of struggle will strike you as the most beautiful."
  },
  {
    "author": "S.E. Hinton,",
    "quote": "I lie to myself all the time. But I never believe me."
  },
  {
    "author": "Daphne Rae,",
    "quote": "I have found the paradox, that if you love until it hurts, there can be no more hurt, only more love."
  },
  {
    "author": "Candace Bushnell,",
    "quote": "Man may have discovered fire, but women discovered how to play with it."
  },
  {
    "author": "John Green,",
    "quote": "Some tourists think Amsterdam is a city of sin, but in truth it is a city of freedom. And in freedom, most people find sin."
  },
  {
    "author": "Walt Disney",
    "quote": "Laughter is timeless. Imagination has no age. And dreams are forever."
  },
  {
    "author": "Charles Bukowski",
    "quote": "The problem with the world is that the intelligent people are full of doubts, while the stupid ones are full of confidence."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "That does it, said Jace. I'm going to get you a dictionary for Christmas this year."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "My ambition is handicapped by laziness"
  },
  {
    "author": "John Green,",
    "quote": "They love their hair because they're not smart enough to love something more interesting."
  },
  {
    "author": "Oscar Wilde",
    "quote": "I think God, in creating man, somewhat overestimated his ability."
  },
  {
    "author": "Nelson Mandela",
    "quote": "Education is the most powerful weapon which you can use to change the world."
  },
  {
    "author": "Ray Bradbury,",
    "quote": "I have never listened to anyone who criticized my taste in space travel, sideshows or gorillas. When this occurs, I pack up my dinosaurs and leave the room."
  },
  {
    "author": "Christopher Paolini,",
    "quote": "Books are my friends, my companions. They make me laugh and cry and find meaning in life."
  },
  {
    "author": "John Lennon",
    "quote": "As usual, there is a great woman behind every idiot."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "Don’t waste your time in anger, regrets, worries, and grudges. Life is too short to be unhappy."
  },
  {
    "author": "Winston S. Churchill",
    "quote": "If you are going through hell, keep going."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Beneath the makeup and behind the smile I am just a girl who wishes for the world."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "But I don’t want to go among mad people, Alice remarked."
  },
  {
    "author": "Katie McGarry,",
    "quote": "I don't go looking for trouble. Trouble usually finds me."
  },
  {
    "author": "Mark Twain",
    "quote": "But who prays for Satan? Who, in eighteen centuries, has had the common humanity to pray for the one sinner that needed it most?"
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "Nothing of me is original. I am the combined effort of everyone I've ever known."
  },
  {
    "author": "Dale Carnegie,",
    "quote": "It isn't what you have or who you are or where you are or what you are doing that makes you happy or unhappy. It is what you think about it."
  },
  {
    "author": "Anthony G. Oettinger",
    "quote": "Time flies like an arrow; fruit flies like a banana."
  },
  {
    "author": "William Goldman,",
    "quote": "Life is pain, highness. Anyone who says differently is selling something."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "What I need is the dandelion in the spring. The bright yellow that means rebirth instead of destruction. The promise that life can go on, no matter how bad our losses. That it can be good again."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Being crazy isn't enough."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "I like your Christ, I do not like your Christians. Your Christians are so unlike your Christ."
  },
  {
    "author": "William Faulkner",
    "quote": "Never be afraid to raise your voice for honesty and truth and compassion against injustice and lying and greed. If people all over the world...would do this, it would change the earth."
  },
  {
    "author": "Mark Twain,",
    "quote": "The difference between the"
  },
  {
    "author": "Rick Riordan,",
    "quote": "Deadlines just aren't real to me until I'm staring one in the face."
  },
  {
    "author": "Kahlil Gibran",
    "quote": "If you love somebody, let them go, for if they return, they were always yours. If they don't, they never were."
  },
  {
    "author": "Maya Angelou",
    "quote": "I don't trust people who don't love themselves and tell me, 'I love you.' ... There is an African saying which is: Be careful when a naked person offers you a shirt."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "I never travel without my diary. One should always have something sensational to read in the train."
  },
  {
    "author": "Patrick Rothfuss,",
    "quote": "There are three things all wise men fear: the sea in storm, a night with no moon, and the anger of a gentle man."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "What I want is to be needed. What I need is to be indispensable to somebody. Who I need is somebody that will eat up all my free time, my ego, my attention. Somebody addicted to me. A mutual addiction."
  },
  {
    "author": "William Faulkner",
    "quote": "You cannot swim for new horizons until you have courage to lose sight of the shore."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "Why do you go away? So that you can come back. So that you can see the place you came from with new eyes and extra colors. And the people there see you differently, too. Coming back to where you started is not the same as never leaving."
  },
  {
    "author": "Paul Auster,",
    "quote": "Reading was my escape and my comfort, my consolation, my stimulant of choice: reading for the pure pleasure of it, for the beautiful stillness that surrounds you when you hear an author's words reverberating in your head."
  },
  {
    "author": "Bette Davis",
    "quote": "When a man gives his opinion, he's a man. When a woman gives her opinion, she's a bitch."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Percy wouldn't notice a joke if it danced naked in front of him wearing one of Dobby's hats."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "Love does not consist of gazing at each other, but in looking outward together in the same direction."
  },
  {
    "author": "J.K. Rowling",
    "quote": "Books are like mirrors: if a fool looks in, you cannot expect a genius to look out."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Don't Just"
  },
  {
    "author": "Roy T. Bennett",
    "quote": "Don't let the expectations and opinions of other people affect your decisions. It's your life, not theirs. Do what matters most to you; do what makes you feel alive and happy. Don't let the expectations and ideas of others limit who you are. If you let others tell you who you are, you are living their reality — not yours. There is more to life than pleasing people. There is much more to life than following others' prescribed path. There is so much more to life than what you experience right now. You need to decide who you are for yourself. Become a whole being. Adventure."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "It's a dangerous business, Frodo, going out your door. You step onto the road, and if you don't keep your feet, there's no knowing where you might be swept off to."
  },
  {
    "author": "Coco Chanel",
    "quote": "A girl should be two things: classy and fabulous."
  },
  {
    "author": "Mark Twain",
    "quote": "I do not fear death. I had been dead for billions and billions of years before I was born, and had not suffered the slightest inconvenience from it."
  },
  {
    "author": "Pablo Picasso",
    "quote": "Every child is an artist. The problem is how to remain an artist once he grows up."
  },
  {
    "author": "Henry Rollins,",
    "quote": "It hurts to let go. Sometimes it seems the harder you try to hold on to something or someone the more it wants to get away. You feel like some kind of criminal for having felt, for having wanted. For having wanted to be wanted. It confuses you, because you think that your feelings were wrong and it makes you feel so small because it's so hard to keep it inside when you let it out and it doesn't coma back. You're left so alone that you can't explain. Damn, there's nothing like that, is there? I've been there and you have too. You're nodding your head."
  },
  {
    "author": "C.S. Lewis",
    "quote": "No book is really worth reading at the age of ten which is not equally – and often far more – worth reading at the age of fifty and beyond."
  },
  {
    "author": "Walt Whitman,",
    "quote": "Resist much, obey little."
  },
  {
    "author": "Audrey Hepburn",
    "quote": "I love people who make me laugh. I honestly think it's the thing I like most, to laugh. It cures a multitude of ills. It's probably the most important thing in a person."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "My daddy said, that the first time you fall in love, it changes you forever and no matter how hard you try, that feeling just never goes away."
  },
  {
    "author": "Jane Austen,",
    "quote": "Angry people are not always wise."
  },
  {
    "author": "Eleanor Roosevelt",
    "quote": "The future belongs to those who believe in the beauty of their dreams."
  },
  {
    "author": "Bob Marley",
    "quote": "Some people feel the rain. Others just get wet."
  },
  {
    "author": "Veronica Roth,",
    "quote": "I have a theory that selflessness and bravery aren't all that different."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "It’s only after you’ve stepped outside your comfort zone that you begin to change, grow, and transform."
  },
  {
    "author": "Paul McCartney,",
    "quote": "And, in the end"
  },
  {
    "author": "Vladimir Nabokov,",
    "quote": "It was love at first sight, at last sight, at ever and ever sight."
  },
  {
    "author": "Confucious",
    "quote": "By three methods we may learn wisdom: First, by reflection, which is noblest; Second, by imitation, which is easiest; and third by experience, which is the bitterest."
  },
  {
    "author": "Greg Behrendt",
    "quote": "If he’s not calling you, it’s because you are not on his mind. If he creates expectations for you, and then doesn’t follow through on little things, he will do same for big things. Be aware of this and realize that he’s okay with disappointing you. Don’t be with someone who doesn’t do what they say they’re going to do. If he’s choosing not to make a simple effort that would put you at ease and bring harmony to a recurring fight, then he doesn’t respect your feelings and needs. Busy is another word for asshole. Asshole is another word for the guy you’re dating. You deserve a fcking phone call."
  },
  {
    "author": "Agatha Christie",
    "quote": "I like living. I have sometimes been wildly, despairingly, acutely miserable, racked with sorrow; but through it all I still know quite certainly that just to be alive is a grand thing."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Everybody has a secret world inside of them. I mean everybody. All of the people in the whole world, I mean everybody — no matter how dull and boring they are on the outside. Inside them they've all got unimaginable, magnificent, wonderful, stupid, amazing worlds... Not just one world. Hundreds of them. Thousands, maybe."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "I don't want to die without any scars."
  },
  {
    "author": "Mark Twain,",
    "quote": "Truth is stranger than fiction, but it is because Fiction is obliged to stick to possibilities; Truth isn't."
  },
  {
    "author": "William Shakespeare,",
    "quote": "If music be the food of love, play on;"
  },
  {
    "author": "Mark Twain",
    "quote": "Loyalty to country ALWAYS. Loyalty to government, when it deserves it."
  },
  {
    "author": "Irwin Shaw",
    "quote": "There are too many books I haven’t read, too many places I haven’t seen, too many memories I haven’t kept long enough."
  },
  {
    "author": "Marilyn Monroe,",
    "quote": "I don't mind living in a man's world, as long as I can be a woman in it."
  },
  {
    "author": "Winston S. Churchill",
    "quote": "My tastes are simple: I am easily satisfied with the best."
  },
  {
    "author": "C.S. Lewis",
    "quote": "To be a Christian means to forgive the inexcusable because God has forgiven the inexcusable in you."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Even if you cannot change all the people around you, you can change the people you choose to be around. Life is too short to waste your time on people who don’t respect, appreciate, and value you. Spend your life with people who make you smile, laugh, and feel loved."
  },
  {
    "author": "William Shakespeare,",
    "quote": "When he shall die,"
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "You cannot control the behavior of others, but you can always choose how you respond to it."
  },
  {
    "author": "F. Scott Fitzgerald",
    "quote": "Show me a hero, and I'll write you a tragedy."
  },
  {
    "author": "Rumi",
    "quote": "Yesterday I was clever, so I wanted to change the world. Today I am wise, so I am changing myself."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I don't want to lose the boy with the bread."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "Kaz leaned back. What's the easiest way to steal a man's wallet?"
  },
  {
    "author": "Stephen King",
    "quote": "Fiction is the truth inside the lie."
  },
  {
    "author": "Anton Chekhov",
    "quote": "Don't tell me the moon is shining; show me the glint of light on broken glass."
  },
  {
    "author": "Louisa May Alcott,",
    "quote": "She is too fond of books, and it has turned her brain."
  },
  {
    "author": "Mortimer J. Adler",
    "quote": "In the case of good books, the point is not to see how many of them you can get through, but rather how many can get through to you."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "The nicest thing for me is sleep, then at least I can dream."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Wow, Thalia muttered. Apollo is hot."
  },
  {
    "author": "Markus Zusak,",
    "quote": "Like most misery, it started with apparent happiness."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "More smiling, less worrying. More compassion, less judgment. More blessed, less stressed. More love, less hate."
  },
  {
    "author": "Patrick Ness,",
    "quote": "You do not write your life with words...You write it with actions. What you think is not important. It is only important what you"
  },
  {
    "author": "John Green,",
    "quote": "It's a metaphor, see: You put the killing thing right between your teeth, but you don't give it the power to do its killing."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "She generally gave herself very good advice, (though she very seldom followed it)."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "Everything was beautiful and nothing hurt."
  },
  {
    "author": "Anonymous,",
    "quote": "And now these three remain: faith, hope and love. But the greatest of these is love."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Why do people have to be this lonely? What's the point of it all? Millions of people in this world, all of them yearning, looking to others to satisfy them, yet isolating themselves. Why? Was the earth put here just to nourish human loneliness?"
  },
  {
    "author": "Douglas Adams,",
    "quote": "The fact that we live at the bottom of a deep gravity well, on the surface of a gas covered planet going around a nuclear fireball 90 million miles away and think this to be normal is obviously some indication of how skewed our perspective tends to be."
  },
  {
    "author": "Mother Teresa",
    "quote": "I am not sure exactly what heaven will be like, but I know that when we die and it comes time for God to judge us, He will not ask, 'How many good things have you done in your life?' rather He will ask, 'How much love did you put into what you did?"
  },
  {
    "author": "John Green,",
    "quote": "What is an instant death anyway? How long is an instant? Is it one second? Ten? The pain of those seconds must have been awful as her heart burst and her lungs collapsed and there was no air and no blood to her brain and only raw panic. What the hell is instant? Nothing is instant. Instant rice takes five minutes, instant pudding an hour. I doubt that an instant of blinding pain feels particularly instantaneous."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "It's strange because sometimes, I read a book, and I think I am the people in the book."
  },
  {
    "author": "Gabriel García Márquez",
    "quote": "No medicine cures what happiness cannot."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "With freedom, flowers, books, and the moon, who could not be perfectly happy?"
  },
  {
    "author": "Fyodor Dostoevsky,",
    "quote": "To go wrong in one's own way is better than to go right in someone else's."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "It's just that I don't want to be somebody's crush. If somebody likes me, I want them to like the real me, not what they think I am. And I don't want them to carry it around inside. I want them to show me, so I can feel it too."
  },
  {
    "author": "Andrew  Boyd,",
    "quote": "We’re all seeking that special person who is right for us. But if you’ve been through enough relationships, you begin to suspect there’s no right person, just different flavors of wrong. Why is this? Because you yourself are wrong in some way, and you seek out partners who are wrong in some complementary way. But it takes a lot of living to grow fully into your own wrongness. And it isn’t until you finally run up against your deepest demons, your unsolvable problems—the ones that make you truly who you are—that we’re ready to find a lifelong mate. Only then do you finally know what you’re looking for. You’re looking for the wrong person. But not just any wrong person: it's got to be the right wrong person—someone you lovingly gaze upon and think, This is the problem I want to have."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Will looked horrified. What kind of monster could possibly hate chocolate?"
  },
  {
    "author": "Stephen King",
    "quote": "The most important things are the hardest to say. They are the things you get ashamed of, because words diminish them -- words shrink things that seemed limitless when they were in your head to no more than living size when they're brought out. But it's more than that, isn't it? The most important things lie too close to wherever your secret heart is buried, like landmarks to a treasure your enemies would love to steal away. And you may make revelations that cost you dearly only to have people look at you in a funny way, not understanding what you've said at all, or why you thought it was so important that you almost cried while you were saying it. That's the worst, I think. When the secret stays locked within not for want of a teller but for want of an understanding ear."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "My nightmares are usually about losing you. I'm okay once I realize you're here."
  },
  {
    "author": "David Foster Wallace",
    "quote": "The so-called ‘psychotically depressed’ person who tries to kill herself doesn’t do so out of quote ‘hopelessness’ or any abstract conviction that life’s assets and debits do not square. And surely not because death seems suddenly appealing. The person in whom Its invisible agony reaches a certain unendurable level will kill herself the same way a trapped person will eventually jump from the window of a burning high-rise. Make no mistake about people who leap from burning windows. Their terror of falling from a great height is still just as great as it would be for you or me standing speculatively at the same window just checking out the view; i.e. the fear of falling remains a constant. The variable here is the other terror, the fire’s flames: when the flames get close enough, falling to death becomes the slightly less terrible of two terrors. It’s not desiring the fall; it’s terror of the flames. And yet nobody down on the sidewalk, looking up and yelling ‘Don’t!’ and ‘Hang on!’, can understand the jump. Not really. You’d have to have personally been trapped and felt flames to really understand a terror way beyond falling."
  },
  {
    "author": "Stephen King,",
    "quote": "The road to hell is paved with adverbs."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "You haven't got a letter on yours, George observed. I suppose she thinks you don't forget your name. But we're not stupid-we know we're called Gred and Forge."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Love conquers all, Aphrodite promised. Look at Helen and Paris. Did they let anything come between them?"
  },
  {
    "author": "John Green,",
    "quote": "The town was paper, but the memories were not."
  },
  {
    "author": "John Green",
    "quote": "because nerds like us are allowed to be unironically enthusiastic about stuff. Nerds are allowed to love stuff, like jump-up-and-down-in-the-chair-can’t-control-yourself love it. Hank, when people call people nerds, mostly what they’re saying is ‘you like stuff.’ Which is just not a good insult at all. Like, ‘you are too enthusiastic about the miracle of human consciousness’."
  },
  {
    "author": "Cassandra Clare",
    "quote": "I am a badass, and I recognize that you, too, are a badass."
  },
  {
    "author": "Joan Crawford",
    "quote": "Love is a fire. But whether it is going to warm your hearth or burn down your house, you can never tell."
  },
  {
    "author": "Lao Tzu,",
    "quote": "Simplicity, patience, compassion."
  },
  {
    "author": "Mawlana Jalal-al-Din Rumi",
    "quote": "What you seek is seeking you."
  },
  {
    "author": "Harper Lee,",
    "quote": "People generally see what they look for, and hear what they listen for."
  },
  {
    "author": "Jack Kerouac",
    "quote": "Live, travel, adventure, bless, and don't be sorry."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Freedom is not worth having if it does not include the freedom to make mistakes."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Fire is catching! And if we burn, you burn with us!"
  },
  {
    "author": "Veronica Roth,",
    "quote": "Fear doesn't shut you down; it wakes you up"
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "I was never really insane except upon occasions when my heart was touched."
  },
  {
    "author": "Khalil Gibran,",
    "quote": "Let there be spaces in your togetherness, And let the winds of the heavens dance between you. Love one another but make not a bond of love: Let it rather be a moving sea between the shores of your souls. Fill each other's cup but drink not from one cup. Give one another of your bread but eat not from the same loaf. Sing and dance together and be joyous, but let each one of you be alone, Even as the strings of a lute are alone though they quiver with the same music. Give your hearts, but not into each other's keeping. For only the hand of Life can contain your hearts. And stand together, yet not too near together: For the pillars of the temple stand apart, And the oak tree and the cypress grow not in each other's shadow."
  },
  {
    "author": "John Green,",
    "quote": "Maybe 'okay' will be our 'always"
  },
  {
    "author": "Margaret Mitchell",
    "quote": "Life's under no obligation to give us what we expect."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "All grown-ups were once children... but only few of them remember it."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Peter would probably throw a party if I stopped breathing.'"
  },
  {
    "author": "Martin Luther King, Jr.",
    "quote": "But I know, somehow, that only when it is dark enough can you see the stars."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Nobody can hurt me without my permission."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "I will not say: do not weep; for not all tears are an evil."
  },
  {
    "author": "Robert Louis Stevenson",
    "quote": "Don't judge each day by the harvest you reap but by the seeds that you plant."
  },
  {
    "author": "George Burns",
    "quote": "Happiness is having a large, loving, caring, close-knit family in another city."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Death must be so beautiful. To lie in the soft brown earth, with the grasses waving above one's head, and listen to silence. To have no yesterday, and no tomorrow. To forget time, to forgive life, to be at peace."
  },
  {
    "author": "Lois Lowry,",
    "quote": "The worst part of holding the memories is not the pain. It's the loneliness of it. Memories need to be shared."
  },
  {
    "author": "Kinky Friedman",
    "quote": "My dear,"
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "You are the answer to every prayer I've offered. You are a song, a dream, a whisper, and I don't know how I could have lived without you for as long as I have."
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "If you look for perfection, you'll never be content."
  },
  {
    "author": "Hunter S. Thompson,",
    "quote": "Life should not be a journey to the grave with the intention of arriving safely in a pretty and well preserved body, but rather to skid in broadside in a cloud of smoke, thoroughly used up, totally worn out, and loudly proclaiming Wow! What a Ride!"
  },
  {
    "author": "Virginia Woolf,",
    "quote": "Books are the mirrors of the soul."
  },
  {
    "author": "E. E. Cummings",
    "quote": "Unbeing dead isn't being alive."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Everyone seems to have a clear idea of how other people should lead their lives, but none about his or her own."
  },
  {
    "author": "Maya Angelou",
    "quote": "I did then what I knew how to do. Now that I know better, I do better."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "The past is a place of reference, not a place of residence; the past is a place of learning, not a place of living."
  },
  {
    "author": "Markus Zusak,",
    "quote": "It kills me sometimes, how people die."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "If pain must come, may it come quickly. Because I have a life to live, and I need to live it in the best way possible. If he has to make a choice, may he make it now. Then I will either wait for him or forget him."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Nobody likes being alone that much. I don't go out of my way to make friends, that's all. It just leads to disappointment."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "Sometimes people don't want to hear the truth because they don't want their illusions destroyed."
  },
  {
    "author": "Helen Keller",
    "quote": "The best and most beautiful things in the world cannot be seen or even touched. They must be felt with the heart"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Don't order any of the faerie food, said Jace, looking at her over the top of his menu. It tends to make humans a little crazy. One minute you're munching a faerie plum, the next minute you're running naked down Madison Avenue with antlers on your head. Not, he added hastily, that this has ever happened to me."
  },
  {
    "author": "Anne Tyler",
    "quote": "I read so I can live more than one life in more than one place."
  },
  {
    "author": "Charles Dickens,",
    "quote": "There is nothing in the world so irresistibly contagious as laughter and good humor."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "I don’t know if you’ve ever felt like that. That you wanted to sleep for a thousand years. Or just not exist. Or just not be aware that you do exist. Or something like that. I think wanting that is very morbid, but I want it when I get like this. That’s why I’m trying not to think. I just want it all to stop spinning."
  },
  {
    "author": "Anne Rice,",
    "quote": "None of us really changes over time. We only become more fully what we are."
  },
  {
    "author": "Vincent Van Gogh",
    "quote": "It is good to love many things, for therein lies the true strength, and whosoever loves much performs much, and can accomplish much, and what is done in love is well done."
  },
  {
    "author": "Mark Twain",
    "quote": "Wrinkles should merely indicate where the smiles have been."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Be careful of love. It'll twist your brain around and leave you thinking up is down and right is wrong."
  },
  {
    "author": "Olin Miller",
    "quote": "You probably wouldn’t worry about what people think of you if you could know how seldom they do."
  },
  {
    "author": "Rudyard Kipling",
    "quote": "Words are, of course, the most powerful drug used by mankind."
  },
  {
    "author": "Flannery O'Connor",
    "quote": "The truth does not change according to our ability to stomach it."
  },
  {
    "author": "Jane Austen,",
    "quote": "I hate to hear you talk about all women as if they were fine ladies instead of rational creatures. None of us want to be in calm waters all our lives."
  },
  {
    "author": "Veronica Roth,",
    "quote": "I have something I need to tell you, he says. I run my fingers along the tendons in his hands and look back at him. I might be in love with you. He smiles a little. I'm waiting until I'm sure to tell you, though."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Sometimes crying or laughing are the only options left, and laughing feels better right now."
  },
  {
    "author": "Bill Watterson",
    "quote": "It's not denial. I'm just selective about the reality I accept."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "I cannot remember the books I've read any more than the meals I have eaten; even so, they have made me."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "What I say is, a town isn’t a town without a bookstore. It may call itself a town, but unless it’s got a bookstore, it knows it’s not foolin’ a soul."
  },
  {
    "author": "Rainer Maria Rilke",
    "quote": "Be patient toward all that is unsolved in your heart and try to love the questions themselves, like locked rooms and like books that are now written in a very foreign tongue. Do not now seek the answers, which cannot be given you because you would not be able to live them. And the point is, to live everything. Live the questions now. Perhaps you will then gradually, without noticing it, live along some distant day into the answer."
  },
  {
    "author": "Taylor Swift",
    "quote": "People haven't always been there for me but music always has."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "To define is to limit."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I can feel Peeta press his forehead into my temple and he asks, 'So now that you've got me, what are you going to do with me?' I turn into him. 'Put you somewhere you can't get hurt."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "Life becomes easier and more beautiful when we can see the good in other people."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Fear cuts deeper than swords."
  },
  {
    "author": "Maya Angelou",
    "quote": "Music was my refuge. I could crawl into the space between the notes and curl my back to loneliness."
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "I think... if it is true that"
  },
  {
    "author": "Albert Einstein",
    "quote": "The world as we have created it is a process of our thinking. It cannot be changed without changing our thinking."
  },
  {
    "author": "Raymond Carver",
    "quote": "Woke up this morning with a terrific urge to lie in bed all day and read."
  },
  {
    "author": "Bob Marley",
    "quote": "None but ourselves can free our minds."
  },
  {
    "author": "J.M. Barrie,",
    "quote": "Never say goodbye because goodbye means going away and going away means forgetting."
  },
  {
    "author": "Dan Brown,",
    "quote": "Everything is possible. The impossible just takes longer."
  },
  {
    "author": "Alexander Pope",
    "quote": "Blessed is he who expects nothing, for he shall never be disappointed."
  },
  {
    "author": "Markus Zusak,",
    "quote": "I am haunted by humans."
  },
  {
    "author": "Muhammad Ali",
    "quote": "Friendship is the hardest thing in the world to explain. It's not something you learn in school. But if you haven't learned the meaning of friendship, you really haven't learned anything."
  },
  {
    "author": "Martin Luther King Jr.,",
    "quote": "Let no man pull you so low as to hate him."
  },
  {
    "author": "Marcel Proust",
    "quote": "Let us be grateful to the people who make us happy; they are the charming gardeners who make our souls blossom."
  },
  {
    "author": "Gayle Forman,",
    "quote": "Sometimes you make choices in life and sometimes choices make you."
  },
  {
    "author": "Margaret Atwood",
    "quote": "War is what happens when language fails."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "Why, sometimes I've believed as many as six impossible things before breakfast."
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "It is amazing how complete is the delusion that beauty is goodness."
  },
  {
    "author": "Jane Austen,",
    "quote": "Vanity and pride are different things, though the words are often used synonymously. A person may be proud without being vain. Pride relates more to our opinion of ourselves, vanity to what we would have others think of us."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "Angry, and half in love with her, and tremendously sorry, I turned away."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I've got a stele we can use. Who wants to do me?"
  },
  {
    "author": "Steve Maraboli,",
    "quote": "The truth is, unless you let go, unless you forgive yourself, unless you forgive the situation, unless you realize that the situation is over, you cannot move forward."
  },
  {
    "author": "Frank Zappa",
    "quote": "Without deviation from the norm, progress is not possible."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "Fantasy is escapist, and that is its glory. If a soldier is imprisioned by the enemy, don't we consider it his duty to escape?. . .If we value the freedom of mind and soul, if we're partisans of liberty, then it's our plain duty to escape, and to take as many people with us as we can!"
  },
  {
    "author": "Tupac Shakur",
    "quote": "You can spend minutes, hours, days, weeks, or even months over-analyzing a situation; trying to put the pieces together, justifying what could've, would've happened... or you can just leave the pieces on the floor and move the fuck on."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Ever had a flying burrito hit you? Well, it's a deadly projectile, right up there with cannonballs and grenades."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Don't talk to me."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Do what is right, not what is easy nor what is popular."
  },
  {
    "author": "James A. Baldwin",
    "quote": "Love does not begin and end the way we seem to think it does. Love is a battle, love is a war; love is a growing up."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "It's all right to love someone who doesn't love you back, as long as they're worth you loving them. As long as they deserve it."
  },
  {
    "author": "Benjamin Spock",
    "quote": "Trust yourself. You know more than you think you do."
  },
  {
    "author": "John Green,",
    "quote": "I may die young, but at least I'll die smart."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "If you want to be happy, do not dwell in the past, do not worry about the future, focus on living fully in the present."
  },
  {
    "author": "Anais Nin,",
    "quote": "Each friend represents a world in us, a world possibly not born until they arrive, and it is only by this meeting that a new world is born."
  },
  {
    "author": "Charlotte Brontë,",
    "quote": "Do you think I am an automaton? — a machine without feelings? and can bear to have my morsel of bread snatched from my lips, and my drop of living water dashed from my cup? Do you think, because I am poor, obscure, plain, and little, I am soulless and heartless? You think wrong! — I have as much soul as you — and full as much heart! And if God had gifted me with some beauty and much wealth, I should have made it as hard for you to leave me, as it is now for me to leave you. I am not talking to you now through the medium of custom, conventionalities, nor even of mortal flesh: it is my spirit that addresses your spirit; just as if both had passed through the grave, and we stood at God's feet, equal — as we are!"
  },
  {
    "author": "Marcus Aurelius,",
    "quote": "You have power over your mind - not outside events. Realize this, and you will find strength."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "He must have known I'd want to leave you."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "You know, Minister, I disagree with Dumbledore on many counts...but you cannot deny he's got style..."
  },
  {
    "author": "Ernest Hemingway,",
    "quote": "The most painful thing is losing yourself in the process of loving someone too much, and forgetting that you are special too."
  },
  {
    "author": "Rabindranath Tagore,",
    "quote": "Clouds come floating into my life, no longer to carry rain or usher storm, but to add color to my sunset sky."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "God has no religion."
  },
  {
    "author": "Aldous Huxley,",
    "quote": "Words can be like X-rays if you use them properly – they’ll go through anything. You read and you’re pierced."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Who said nights were for sleep?"
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "I don't want to repeat my innocence. I want the pleasure of losing it again."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Let us step into the night and pursue that flighty temptress, adventure."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "He who has a why to live for can bear almost any how."
  },
  {
    "author": "Patrick Rothfuss,",
    "quote": "It's like everyone tells a story about themselves inside their own head. Always. All the time. That story makes you what you are. We build ourselves out of that story."
  },
  {
    "author": "Pedro Calderon de la Barca",
    "quote": "When love is not madness it is not love."
  },
  {
    "author": "Joseph Campbell",
    "quote": "Life has no meaning. Each of us has meaning and we bring it to life. It is a waste to be asking the question when you are the answer."
  },
  {
    "author": "Jane Austen,",
    "quote": "You pierce my soul. I am half agony, half hope...I have loved none but you."
  },
  {
    "author": "A.A. Milne,",
    "quote": "People say nothing is impossible, but I do nothing every day."
  },
  {
    "author": "Anna Quindlen,",
    "quote": "Books are the plane, and the train, and the road. They are the destination, and the journey. They are home."
  },
  {
    "author": "Herman Melville",
    "quote": "It is better to fail in originality than to succeed in imitation."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "That's the problem with drinking, I thought, as I poured myself a drink. If something bad happens you drink in an attempt to forget; if something good happens you drink in order to celebrate; and if nothing happens you drink to make something happen."
  },
  {
    "author": "Madeline Miller,",
    "quote": "And perhaps it is the greater grief, after all, to be left on earth when another is gone."
  },
  {
    "author": "Albert Schweitzer",
    "quote": "Sometimes our light goes out, but is blown again into instant flame by an encounter with another human being."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "This moment will just be another story someday."
  },
  {
    "author": "Lao Tzu",
    "quote": "The journey of a thousand miles begins with a single step."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "One of the Silent Brothers is here to see you. Hodge sent me to wake you up. Actually he offered to wake you himself, but since it's 5 a.m., I figured you'd be less cranky if you had something nice to look at."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "I’m here. I love you. I don’t care if you need to stay up crying all night long, I will stay with you. If you need the medication again, go ahead and take it—I will love you through that, as well. If you don’t need the medication, I will love you, too. There’s nothing you can ever do to lose my love. I will protect you until you die, and after your death I will still protect you. I am stronger than Depression and I am braver than Loneliness and nothing will ever exhaust me."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Success is not how high you have climbed, but how you make a positive difference to the world."
  },
  {
    "author": "Gillian Flynn,",
    "quote": "Men always say that as the defining compliment, don’t they? She’s a cool girl. Being the Cool Girl means I am a hot, brilliant, funny woman who adores football, poker, dirty jokes, and burping, who plays video games, drinks cheap beer, loves threesomes and anal sex, and jams hot dogs and hamburgers into her mouth like she’s hosting the world’s biggest culinary gang bang while somehow maintaining a size 2, because Cool Girls are above all hot. Hot and understanding. Cool Girls never get angry; they only smile in a chagrined, loving manner and let their men do whatever they want. Go ahead, shit on me, I don’t mind, I’m the Cool Girl."
  },
  {
    "author": "J.K. rowling,",
    "quote": "Fear of a name increases fear of the thing itself."
  },
  {
    "author": "John Waters",
    "quote": "If you go home with somebody, and they don't have books, don't fuck 'em!"
  },
  {
    "author": "Laurell K. Hamilton,",
    "quote": "There are wounds that never show on the body that are deeper and more hurtful than anything that bleeds."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You guessed? You must have been pretty sure, considering you could have killed me."
  },
  {
    "author": "Shel Silverstein",
    "quote": "How many slams in an old screen door? Depends how loud you shut it. How many slices in a bread? Depends how thin you cut it. How much good inside a day? Depends how good you live 'em. How much love inside a friend? Depends how much you give 'em."
  },
  {
    "author": "Albert Einstein",
    "quote": "Once you can accept the universe as matter expanding into nothing that is something, wearing stripes with plaid comes easy."
  },
  {
    "author": "Henry David Thoreau,",
    "quote": "Rather than love, than money, than fame, give me truth."
  },
  {
    "author": "Cathy Guiswite",
    "quote": "When life gives you lemons, squirt someone in the eye."
  },
  {
    "author": "J.K. Rowling",
    "quote": "We do not need magic to transform our world. We carry all the power we need inside ourselves already."
  },
  {
    "author": "Bertrand Russell",
    "quote": "Do not fear to be eccentric in opinion, for every opinion now accepted was once eccentric."
  },
  {
    "author": "A. A. Milne,",
    "quote": "It is more fun to talk with someone who doesn't use long, difficult words but rather short, easy words like What about lunch?"
  },
  {
    "author": "John Green,",
    "quote": "What you must understand about me is that I’m a deeply unhappy person."
  },
  {
    "author": "C.S. Lewis",
    "quote": "We are not necessarily doubting that God will do the best for us; we are wondering how painful the best will turn out to be."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "there is a loneliness in this world so great"
  },
  {
    "author": "Elisabeth Kübler-Ross",
    "quote": "The most beautiful people we have known are those who have known defeat, known suffering, known struggle, known loss, and have found their way out of the depths. These persons have an appreciation, a sensitivity, and an understanding of life that fills them with compassion, gentleness, and a deep loving concern. Beautiful people do not just happen."
  },
  {
    "author": "Albert Einstein,",
    "quote": "The most beautiful experience we can have is the mysterious. It is the fundamental emotion that stands at the cradle of true art and true science."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "Begin at the beginning, the King said, very gravely, and go on till you come to the end: then stop."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Sometimes fate is like a small sandstorm that keeps changing directions. You change direction but the sandstorm chases you. You turn again, but the storm adjusts. Over and over you play this out, like some ominous dance with death just before dawn. Why? Because this storm isn't something that blew in from far away, something that has nothing to do with you. This storm is you. Something"
  },
  {
    "author": "John Green,",
    "quote": "It always shocked me when I realized that I wasn’t the only person in the world who thought and felt such strange and awful things."
  },
  {
    "author": "Neil Gaiman",
    "quote": "People think dreams aren't real just because they aren't made of matter, of particles. Dreams are real. But they are made of viewpoints, of images, of memories and puns and lost hopes."
  },
  {
    "author": "Steve Maraboli,",
    "quote": "Dare to Be"
  },
  {
    "author": "Timothy Leary",
    "quote": "Women who seek to be equal with men lack ambition."
  },
  {
    "author": "Veronica Roth,",
    "quote": "A brave man acknowledges the strength of others."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Why are they all staring? demanded Albus as he and Rose craned around to look at the other students."
  },
  {
    "author": "Elbert Hubbard",
    "quote": "God will not look you over for medals, degrees or diplomas but for scars."
  },
  {
    "author": "Kalu Ndukwe Kalu",
    "quote": "The things you do for yourself are gone when you are gone, but the things you do for others remain as your legacy."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Pursue what catches your heart, not what catches your eyes."
  },
  {
    "author": "John Green,",
    "quote": "Some people have lives; some people have music."
  },
  {
    "author": "Stephanie Klein,",
    "quote": "Tell the truth, or someone will tell it for you."
  },
  {
    "author": "Rumi",
    "quote": "Don’t grieve. Anything you lose comes round in another form."
  },
  {
    "author": "Langston Hughes,",
    "quote": "Life is for the living."
  },
  {
    "author": "Pablo Picasso",
    "quote": "Art is the lie that enables us to realize the truth."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Keep Going"
  },
  {
    "author": "Alice Walker",
    "quote": "No person is your friend who demands your silence, or denies your right to grow."
  },
  {
    "author": "Charles Dickens,",
    "quote": "I loved her against reason, against promise, against peace, against hope, against happiness, against all discouragement that could be."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Can I help you with something?"
  },
  {
    "author": "Terry Pratchett,",
    "quote": "If cats looked like frogs we'd realize what nasty, cruel little bastards they are. Style. That's what people remember."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Think left and think right and think low and think high. Oh, the thinks you can think up if only you try!"
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "In heaven, all the interesting people are missing."
  },
  {
    "author": "Oscar Wilde (attributed to)",
    "quote": "Some cause happiness wherever they go; others whenever they go."
  },
  {
    "author": "Gillian Anderson",
    "quote": "Well, it seems to me that the best relationships - the ones that last - are frequently the ones that are rooted in friendship. You know, one day you look at the person and you see something more than you did the night before. Like a switch has been flicked somewhere. And the person who was just a friend is... suddenly the only person you can ever imagine yourself with."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "If you like her, if she makes you happy, and if you feel like you know her---then don't let her go."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Finnick? I say, Maybe some pants?"
  },
  {
    "author": "Charles Bukowski,",
    "quote": "I wanted the whole world or nothing."
  },
  {
    "author": "Elie Wiesel",
    "quote": "There may be times when we are powerless to prevent injustice, but there must never be a time when we fail to protest."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "I suppose I'll have to add the force of gravity to my list of enemies."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "The best way to find out if you can trust somebody is to trust them."
  },
  {
    "author": "Umberto Eco",
    "quote": "We live for books."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Some old wounds never truly heal, and bleed again at the slightest word."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "I am coming to terms with the fact that loving someone requires a leap of faith, and that a soft landing is never guaranteed."
  },
  {
    "author": "Stephen King,",
    "quote": "The scariest moment is always just before you start."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "The only way to find true happiness is to risk being completely cut open."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "Enjoy it. Because it's happening."
  },
  {
    "author": "Maya Angelou,",
    "quote": "You may not control all the events that happen to you, but you can decide not to be reduced by them."
  },
  {
    "author": "Richelle Mead,",
    "quote": "Only a true best friend can protect you from your immortal enemies."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "There is nothing noble in being superior to your fellow man; true nobility is being superior to your former self."
  },
  {
    "author": "Albert Einstein",
    "quote": "I know not with what weapons World War III will be fought, but World War IV will be fought with sticks and stones."
  },
  {
    "author": "Mary Wollstonecraft Shelley,",
    "quote": "Nothing is so painful to the human mind as a great and sudden change."
  },
  {
    "author": "Mawlana Jalal-al-Din Rumi,",
    "quote": "The minute I heard my first love story,"
  },
  {
    "author": "Albert Einstein",
    "quote": "If I were not a physicist, I would probably be a musician. I often think in music. I live my daydreams in music. I see my life in terms of music."
  },
  {
    "author": "P.G. Wodehouse",
    "quote": "There is no surer foundation for a beautiful friendship than a mutual taste in literature."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Mom says it's because she has PMS."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "Some things don't last forever, but some things do. Like a good song, or a good book, or a good memory you can take out and unfold in your darkest times, pressing down on the corners and peering in close, hoping you still recognize the person you see there."
  },
  {
    "author": "Leonardo da Vinci",
    "quote": "A painter should begin every canvas with a wash of black, because all things in nature are dark except where exposed by the light."
  },
  {
    "author": "Richelle Mead,",
    "quote": "I’d said it before and meant it: Alive or undead, the love of my life was a badass."
  },
  {
    "author": "Rainer Maria Rilke",
    "quote": "Let everything happen to you"
  },
  {
    "author": "William Shakespeare",
    "quote": "We know what we are, but not what we may be."
  },
  {
    "author": "John Green,",
    "quote": "If you don't imagine, nothing ever happens at all."
  },
  {
    "author": "A.A. Milne",
    "quote": "Weeds are flowers, too, once you get to know them."
  },
  {
    "author": "Fyodor Dostoevsky,",
    "quote": "What is hell? I maintain that it is the suffering of being unable to love."
  },
  {
    "author": "Lao Tzu,",
    "quote": "Knowing others is intelligence;"
  },
  {
    "author": "sylvia plath",
    "quote": "Perhaps when we find ourselves wanting everything, it is because we are dangerously close to wanting nothing."
  },
  {
    "author": "Douglas Adams,",
    "quote": "The Guide says there is an art to flying, said Ford, or rather a knack. The knack lies in learning how to throw yourself at the ground and miss."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "No mourners. No funerals. Among them, it passed for 'good luck."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I felt my lungs inflate with the onrush of scenery—air, mountains, trees, people. I thought, This is what it is to be happy."
  },
  {
    "author": "David Foster Wallace,",
    "quote": "Everybody is identical in their secret unspoken belief that way deep down they are different from everyone else."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "True love is rare, and it's the only thing that gives life real meaning."
  },
  {
    "author": "Khaled Hosseini,",
    "quote": "I suspect the truth is that we are waiting, all of us, against insurmountable odds, for something extraordinary to happen to us."
  },
  {
    "author": "Rose Fitzgerald Kennedy",
    "quote": "It has been said, 'time heals all wounds.' I do not agree. The wounds remain. In time, the mind, protecting its sanity, covers them with scar tissue and the pain lessens. But it is never gone."
  },
  {
    "author": "Allen Ginsberg",
    "quote": "Follow your inner moonlight; don't hide the madness."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "Would you tell me, please, which way I ought to go from here?"
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "All I ever wanted was to reach out and touch another human being not just with my hands but with my heart."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Declarations of love amuse me. Especially when unrequited."
  },
  {
    "author": "Mary Oliver",
    "quote": "You do not have to be good."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "People aren't born good or bad. Maybe they're born with tendencies either way, but its the way you live your life that matters."
  },
  {
    "author": "G.K. Chesterton",
    "quote": "The true soldier fights not because he hates what is in front of him, but because he loves what is behind him."
  },
  {
    "author": "Nicholas Sparks",
    "quote": "I love you more than there are stars in the sky and fish in the sea."
  },
  {
    "author": "Robert Frost",
    "quote": "A poem begins as a lump in the throat, a sense of wrong, a homesickness, a lovesickness."
  },
  {
    "author": "Ray Bradbury,",
    "quote": "Why is it, he said, one time, at the subway entrance, I feel I've known you so many years?"
  },
  {
    "author": "Max Lucado",
    "quote": "A woman's heart should be so hidden in God that a man has to seek Him just to find her."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "Music is a total constant. That's why we have such a strong visceral connection to it, you know? Because a song can take you back instantly to a moment, or a place, or even a person. No matter what else has changed in your or the world, that one song says the same, just like that moment."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "No. I can survive well enough on my own— if given the proper reading material."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Dumbledore says people find it far easier to forgive others for being wrong than being right."
  },
  {
    "author": "Lance Armstrong Sally Jenkins,",
    "quote": "Pain is temporary. Quitting lasts forever."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Investigation? Isabelle laughed. Now we're detectives? Maybe we should all have code names."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "There are no facts, only interpretations."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "It is the time you have wasted for your rose that makes your rose so important."
  },
  {
    "author": "Shel Silverstein,",
    "quote": "There are no happy endings."
  },
  {
    "author": "Walt Disney",
    "quote": "It's kind of fun to do the impossible."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "Among other things, you'll find that you're not the first person who was ever confused and frightened and even sickened by human behavior. You're by no means alone on that score, you'll be excited and stimulated to know. Many, many men have been just as troubled morally and spiritually as you are right now. Happily, some of them kept records of their troubles. You'll learn from them—if you want to. Just as someday, if you have something to offer, someone will learn something from you. It's a beautiful reciprocal arrangement. And it isn't education. It's history. It's poetry."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Nowadays people know the price of everything and the value of nothing."
  },
  {
    "author": "Donna Tartt,",
    "quote": "Beauty is terror. Whatever we call beautiful, we quiver before it."
  },
  {
    "author": "Victor Hugo,",
    "quote": "Even the darkest night will end and the sun will rise."
  },
  {
    "author": "Richelle Mead,",
    "quote": "Do you think I'm pretty?"
  },
  {
    "author": "Vladimir Nabokov,",
    "quote": "And the rest is rust and stardust."
  },
  {
    "author": "Jane Austen",
    "quote": "but for my own part, if a book is well written, I always find it too short."
  },
  {
    "author": "G.K. Chesterton,",
    "quote": "Poets have been mysteriously silent on the subject of cheese."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "Do I not destroy my enemies when I make them my friends?"
  },
  {
    "author": "Corrie Ten Boom,",
    "quote": "Worry does not empty tomorrow of its sorrow, it empties today of its strength."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "Don't be afraid of your fears. They're not there to scare you. They're there to let you know that something is worth it."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "What's this? he demanded, looking from Clary to his companions, as if they might know what she was doing there."
  },
  {
    "author": "Jim MORRISON",
    "quote": "The most important kind of freedom is to be what you really are. You trade in your reality for a role. You trade in your sense for an act. You give up your ability to feel, and in exchange, put on a mask. There can't be any large-scale revolution until there's a personal revolution, on an individual level. It's got to happen inside first."
  },
  {
    "author": "Marcus Aurelius,",
    "quote": "Dwell on the beauty of life. Watch the stars, and see yourself running with them."
  },
  {
    "author": "Becca Fitzpatrick,",
    "quote": "You smell good, too, said Patch"
  },
  {
    "author": "D.H. Lawrence,",
    "quote": "A woman has to live her life, or live to repent not having lived it."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "I will have you without armor, Kaz Brekker. Or I will not have you at all."
  },
  {
    "author": "Henry James",
    "quote": "Three things in human life are important: the first is to be kind; the second is to be kind; and the third is to be kind."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You know, Gabriel said, there was a time I thought we could be friends, Will."
  },
  {
    "author": "Martin Luther King Jr.,",
    "quote": "There comes a time when one must take a position that is neither safe, nor politic, nor popular, but he must take it because conscience tells him it is right."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I have the choice of being constantly active and happy or introspectively passive and sad. Or I can go mad by ricocheting in between."
  },
  {
    "author": "Taylor Swift",
    "quote": "When I was a little girl I used to read fairy tales. In fairy tales you meet Prince Charming and he's everything you ever wanted. In fairy tales the bad guy is very easy to spot. The bad guy is always wearing a black cape so you always know who he is. Then you grow up and you realize that Prince Charming is not as easy to find as you thought. You realize the bad guy is not wearing a black cape and he's not easy to spot; he's really funny, and he makes you laugh, and he has perfect hair."
  },
  {
    "author": "Albert Einstein",
    "quote": "You never fail until you stop trying."
  },
  {
    "author": "Kiera Cass,",
    "quote": "Break my heart. Break it a thousand times if you like. It was only ever yours to break anyway."
  },
  {
    "author": "Lou Holtz",
    "quote": "It's not the load that breaks you down, it's the way you carry it."
  },
  {
    "author": "Herman Hesse,",
    "quote": "For me, trees have always been the most penetrating preachers. I revere them when they live in tribes and families, in forests and groves. And even more I revere them when they stand alone. They are like lonely persons. Not like hermits who have stolen away out of some weakness, but like great, solitary men, like Beethoven and Nietzsche. In their highest boughs the world rustles, their roots rest in infinity; but they do not lose themselves there, they struggle with all the force of their lives for one thing only: to fulfil themselves according to their own laws, to build up their own form, to represent themselves. Nothing is holier, nothing is more exemplary than a beautiful, strong tree. When a tree is cut down and reveals its naked death-wound to the sun, one can read its whole history in the luminous, inscribed disk of its trunk: in the rings of its years, its scars, all the struggle, all the suffering, all the sickness, all the happiness and prosperity stand truly written, the narrow years and the luxurious years, the attacks withstood, the storms endured. And every young farmboy knows that the hardest and noblest wood has the narrowest rings, that high on the mountains and in continuing danger the most indestructible, the strongest, the ideal trees grow."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "There's plenty of sense in nonsense sometimes, if you wish to look for it."
  },
  {
    "author": "A.A. Milne,",
    "quote": "I think we dream so we don’t have to be apart for so long. If we’re in each other’s dreams, we can be together all the time."
  },
  {
    "author": "Carl Sagan,",
    "quote": "Look again at that dot. That's here. That's home. That's us. On it everyone you love, everyone you know, everyone you ever heard of, every human being who ever was, lived out their lives. The aggregate of our joy and suffering, thousands of confident religions, ideologies, and economic doctrines, every hunter and forager, every hero and coward, every creator and destroyer of civilization, every king and peasant, every young couple in love, every mother and father, hopeful child, inventor and explorer, every teacher of morals, every corrupt politician, every superstar, every supreme leader, every saint and sinner in the history of our species lived there-on a mote of dust suspended in a sunbeam."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "I don't want to be at the mercy of my emotions. I want to use them, to enjoy them, and to dominate them."
  },
  {
    "author": "Jane Austen,",
    "quote": "There is a stubbornness about me that never can bear to be frightened at the will of others. My courage always rises at every attempt to intimidate me."
  },
  {
    "author": "Nicolas Chamfort",
    "quote": "The most wasted of all days is one without laughter."
  },
  {
    "author": "Jane Austen,",
    "quote": "What are men to rocks and mountains?"
  },
  {
    "author": "Lemony Snicket,",
    "quote": "If writers wrote as carelessly as some people talk, then adhasdh asdglaseuyt[bn[ pasdlgkhasdfasdf."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "I mean, if the relationship can't survive the long term, why on earth would it be worth my time and energy for the short term?"
  },
  {
    "author": "Henry David Thoreau",
    "quote": "I went to the woods because I wished to live deliberately, to front only the essential facts of life, and see if I could not learn what it had to teach, and not, when I came to die, discover that I had not lived. I did not wish to live what was not life, living is so dear; nor did I wish to practise resignation, unless it was quite necessary. I wanted to live deep and suck out all the marrow of life, to live so sturdily and Spartan-like as to put to rout all that was not life, to cut a broad swath and shave close, to drive life into a corner, and reduce it to its lowest terms..."
  },
  {
    "author": "Santosh Kalwar,",
    "quote": "I was smiling yesterday,I am smiling today and I will smile tomorrow.Simply because life is too short to cry for anything."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "The silence depressed me. It wasn't the silence of silence. It was my own silence."
  },
  {
    "author": "Albert Camus",
    "quote": "Live to the point of tears."
  },
  {
    "author": "Mark Twain",
    "quote": "Books are for people who wish they were somewhere else."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Learn to light a candle in the darkest moments of someone’s life. Be the light that helps others see; it is what gives life its deepest significance."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Make improvements, not excuses. Seek respect, not attention."
  },
  {
    "author": "J. K. Rowling,",
    "quote": "You'll stay with me?'"
  },
  {
    "author": "Lauren Oliver,",
    "quote": "I love you. Remember. They cannot take it"
  },
  {
    "author": "Gabriel García Márquez,",
    "quote": "It's enough for me to be sure that you and I exist at this moment."
  },
  {
    "author": "St. Francis Of Assisi,",
    "quote": "All the darkness in the world cannot extinguish the light of a single candle."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Everything tells me that I am about to make a wrong decision, but making mistakes is just part of life. What does the world want of me? Does it want me to take no risks, to go back to where I came from because I didn't have the courage to say yes to life?"
  },
  {
    "author": "David Mitchell,",
    "quote": "My life amounts to no more than one drop in a limitless ocean. Yet what is any ocean, but a multitude of drops?"
  },
  {
    "author": "Thich Nhat Hanh,",
    "quote": "Walk as if you are kissing the Earth with your feet."
  },
  {
    "author": "Orhan Pamuk,",
    "quote": "I read a book one day and my whole life was changed."
  },
  {
    "author": "Diane Duane,",
    "quote": "Reading one book is like eating one potato chip."
  },
  {
    "author": "John Green,",
    "quote": "That’s part of what I like about the book in some ways. It portrays death truthfully. You die in the middle of your life, in the middle of a sentence"
  },
  {
    "author": "Dr. Seuss",
    "quote": "I have heard there are troubles of more than one kind. Some come from ahead and some come from behind. But I've bought a big bat. I'm all ready you see. Now my troubles are going to have troubles with me!"
  },
  {
    "author": "Charles Bukowski",
    "quote": "Find what you love and let it kill you."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "She wasn't bitter. She was sad, though. But it was a hopeful kind of sad. The kind of sad that just takes time."
  },
  {
    "author": "Frank Herbert",
    "quote": "There is no real ending. It’s just the place where you stop the story."
  },
  {
    "author": "Bob Moorehead,",
    "quote": "The paradox of our time in history is that we have taller buildings but shorter tempers, wider Freeways, but narrower viewpoints. We spend more, but have less, we buy more, but enjoy less. We have bigger houses and smaller families, more conveniences, but less time. We have more degrees but less sense, more knowledge, but less judgment, more experts, yet more problems, more medicine, but less wellness."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "The man of knowledge must be able not only to love his enemies but also to hate his friends."
  },
  {
    "author": "Mary Shelley,",
    "quote": "Beware; for I am fearless, and therefore powerful."
  },
  {
    "author": "Robert Frost",
    "quote": "Some say the world will end in fire,"
  },
  {
    "author": "Maya Angelou",
    "quote": "Success is liking yourself, liking what you do, and liking how you do it."
  },
  {
    "author": "Emily Dickinson",
    "quote": "If I can stop one heart from breaking, I shall not live in vain."
  },
  {
    "author": "Robert Frost",
    "quote": "Love is an irresistible desire to be irresistibly desired."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Cinderella? Snow White? What's that? An illness?"
  },
  {
    "author": "Steven Wright",
    "quote": "Right now I’m having amnesia and déjà vu at the same time. I think I’ve forgotten this before."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "If you want to forget something or someone, never hate it, or never hate him/her. Everything and everyone that you hate is engraved upon your heart; if you want to let go of something, if you want to forget, you cannot hate."
  },
  {
    "author": "E.L. Doctorow",
    "quote": "Writing is a socially acceptable form of schizophrenia."
  },
  {
    "author": "Alfred Lord Tennyson",
    "quote": "Hope"
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Start each day with a positive thought and a grateful heart."
  },
  {
    "author": "Annie Proulx",
    "quote": "You know, one of the tragedies of real life is that there is no background music."
  },
  {
    "author": "Edward Gorey",
    "quote": "Books. Cats. Life is Good."
  },
  {
    "author": "Louis L'Amour",
    "quote": "Start writing, no matter what. The water does not flow until the faucet is turned on."
  },
  {
    "author": "Mark Twain",
    "quote": "What would men be without women? Scarce, sir...mighty scarce."
  },
  {
    "author": "John Green,",
    "quote": "I believe the universe wants to be noticed. I think the universe is inprobably biased toward the consciousness, that it rewards intelligence in part because the universe enjoys its elegance being observed. And who am I, living in the middle of history, to tell the universe that it-or my observation of it-is temporary?"
  },
  {
    "author": "Neil Gaiman,",
    "quote": "I lived in books more than I lived anywhere else."
  },
  {
    "author": "L. Frank Baum,",
    "quote": "No thief, however skillful, can rob one of knowledge, and that is why knowledge is the best and safest treasure to acquire."
  },
  {
    "author": "F. Scott Fitzgerald",
    "quote": "I fell in love with her courage, her sincerity, and her flaming self respect. And it's these things I'd believe in, even if the whole world indulged in wild suspicions that she wasn't all she should be. I love her and it is the beginning of everything."
  },
  {
    "author": "John Lennon",
    "quote": "The more I see, the less I know for sure."
  },
  {
    "author": "Agatha Christie,",
    "quote": "It is a curious thought, but it is only when you see people looking ridiculous that you realize just how much you love them."
  },
  {
    "author": "Erica Jong",
    "quote": "Everyone has talent. What's rare is the courage to follow it to the dark places where it leads."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Remember that wherever your heart is, there you will find your treasure."
  },
  {
    "author": "Douglas Adams,",
    "quote": "Don't Panic."
  },
  {
    "author": "Bertrand Russell,",
    "quote": "Of all forms of caution, caution in love is perhaps the most fatal to true happiness."
  },
  {
    "author": "William Blake,",
    "quote": "To see a World in a Grain of Sand"
  },
  {
    "author": "Rick Riordan,",
    "quote": "How did you die?"
  },
  {
    "author": "E.L. James,",
    "quote": "Laters, baby."
  },
  {
    "author": "Mitch Albom,",
    "quote": "All endings are also beginnings. We just don't know it at the time."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Treat everyone with politeness and kindness, not because they are nice, but because you are."
  },
  {
    "author": "Jack Kerouac,",
    "quote": "There was nowhere to go but everywhere, so just keep on rolling under the stars."
  },
  {
    "author": "John Green,",
    "quote": "Francois Rabelais. He was a poet. And his last words were I go to seek a Great Perhaps. That's why I'm going. So I don't have to wait until I die to start seeking a Great Perhaps."
  },
  {
    "author": "Italo Calvino,",
    "quote": "A classic is a book that has never finished saying what it has to say."
  },
  {
    "author": "Jeanette Winterson",
    "quote": "Book collecting is an obsession, an occupation, a disease, an addiction, a fascination, an absurdity, a fate. It is not a hobby. Those who do it must do it."
  },
  {
    "author": "Madeline Miller,",
    "quote": "In the darkness, two shadows, reaching through the hopeless, heavy dusk. Their hands meet, and light spills in a flood like a hundred golden urns pouring out of the sun."
  },
  {
    "author": "Jorge Luis Borges",
    "quote": "I am not sure that I exist, actually. I am all the writers that I have read, all the people that I have met, all the women that I have loved; all the cities I have visited."
  },
  {
    "author": "H.G. Wells",
    "quote": "We all have our time machines, don't we. Those that take us back are memories...And those that carry us forward, are dreams."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "You believe lies so you eventually learn to trust no one but yourself."
  },
  {
    "author": "Charles Bukowski",
    "quote": "An intellectual says a simple thing in a hard way. An artist says a hard thing in a simple way."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "It was books that made me feel that perhaps I was not completely alone. They could be honest with me, and I with them."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "How do you feel, Georgie? whispered Mrs. Weasley."
  },
  {
    "author": "Khaled Hosseini,",
    "quote": "And that's the thing about people who mean everything they say. They think everyone else does too."
  },
  {
    "author": "Maya Angelou",
    "quote": "My mission in life is not merely to survive, but to thrive; and to do so with some passion, some compassion, some humor, and some style."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Albus Severus, Harry said quietly, so that nobody but Ginny could hear, and she was tactful enough to pretend to be waving to Rose, who was now on the train, you were named for two headmasters of Hogwarts. One of them was a Slytherin and he was probably the bravest man I ever knew."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "She'd laughed, and if he could have bottled the sound and gotten drunk on it every night, he would have. It terrified him."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "You’ve got about as much charm as a dead slug."
  },
  {
    "author": "C.S. Lewis",
    "quote": "There are far, far better things ahead than any we leave behind."
  },
  {
    "author": "Donald Miller,",
    "quote": "When you stop expecting people to be perfect, you can like them for who they are."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "You’re wishin’ too much, baby. You gotta stop wearing your wishbone where your backbone oughtta be."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Be grateful for what you already have while you pursue your goals."
  },
  {
    "author": "J.K. Rowling",
    "quote": "I don't believe in the kind of magic in my books. But I do believe something very magical can happen when you read a good book."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "A good library will never be too neat, or too dusty, because somebody will always be in it, taking books off the shelves and staying up late reading them."
  },
  {
    "author": "Fitzgerald F. Scott,",
    "quote": "I was within and without, simultaneously enchanted and repelled by the inexhaustible variety of life."
  },
  {
    "author": "أحلام مستغانمي",
    "quote": "أجمل حب هو الذي نعثر عليه أثناء بحثنا عن شيء آخر"
  },
  {
    "author": "Jimi Hendrix",
    "quote": "When the power of love overcomes the love of power, the world will know peace."
  },
  {
    "author": "John F. Kennedy",
    "quote": "The Chinese use two brush strokes to write the word 'crisis.' One brush stroke stands for danger; the other for opportunity. In a crisis, be aware of the danger--but recognize the opportunity."
  },
  {
    "author": "Stephen King,",
    "quote": "Some birds are not meant to be caged, that's all. Their feathers are too bright, their songs too sweet and wild. So you let them go, or when you open the cage to feed them they somehow fly out past you. And the part of you that knows it was wrong to imprison them in the first place rejoices, but still, the place where you live is that much more drab and empty for their departure."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "Why didn't I learn to treat everything like it was the last time. My greatest regret was how much I believed in the future."
  },
  {
    "author": "James Patterson,",
    "quote": "Basically, I have two speeds.... Hostile or smart-aleck. Your choice."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Believe in Your Heart"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Don't. Clary raised a warning hand. I'm not really in the mood right now."
  },
  {
    "author": "François Rabelais",
    "quote": "I go to seek a Great Perhaps."
  },
  {
    "author": "Philip Pullman",
    "quote": "After nourishment, shelter and companionship, stories are the thing we need most in the world."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "It's just that...I just think that some things are meant to be broken. Imperfect. Chaotic. It's the universe's way of providing contrast, you know? There have to be a few holes in the road. It's how life is."
  },
  {
    "author": "Herman Hesse",
    "quote": "Learn what is to be taken seriously and laugh at the rest."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "And I like large parties. They’re so intimate. At small parties there isn’t any privacy."
  },
  {
    "author": "مصطفى محمود,",
    "quote": "لن تكون متدينا إلا بالعلم ...فالله لا يعبد بالجهل"
  },
  {
    "author": "Henry David Thoreau",
    "quote": "How vain it is to sit down to write when you have not stood up to live."
  },
  {
    "author": "Victor Hugo ,",
    "quote": "What Is Love? I have met in the streets a very poor young man who was in love. His hat was old, his coat worn, the water passed through his shoes and the stars through his soul"
  },
  {
    "author": "Richard Dawkins,",
    "quote": "We are all atheists about most of the gods that humanity has ever believed in. Some of us just go one god further."
  },
  {
    "author": "Winston S. Churchill",
    "quote": "History will be kind to me for I intend to write it."
  },
  {
    "author": "Cornelia Funke,",
    "quote": "Stories never really end...even if the books like to pretend they do. Stories always go on. They don't end on the last page, any more than they begin on the first page."
  },
  {
    "author": "Voltaire",
    "quote": "Judge a man by his questions rather than by his answers."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "If no one in the entire world cared about you, did you really exist at all?"
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Tell your heart that the fear of suffering is worse than the suffering itself. And that no heart has ever suffered when it goes in search of its dreams, because every second of the search is a second's encounter with God and with eternity."
  },
  {
    "author": "Madeleine L'Engle",
    "quote": "A book, too, can be a star, a living fire to lighten the darkness, leading out into the expanding universe."
  },
  {
    "author": "Gordon B. Hinckley",
    "quote": "Life is to be enjoyed, not endured"
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "He's a wallflower. You see things. You keep quiet about them. And you understand."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "And so it goes..."
  },
  {
    "author": "haruki murakami",
    "quote": "No matter how much suffering you went through, you never wanted to let go of those memories."
  },
  {
    "author": "Pablo Neruda,",
    "quote": "Well, now"
  },
  {
    "author": "Madeline Miller,",
    "quote": "Name one hero who was happy."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Hate the sin, love the sinner."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Just because you call an electric eel a rubber duck doesn't make it a rubber duck, does it? And God help the poor bastard who decides they want to take a bath with the duckie. (Jace Wayland)"
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Now, you two – this year, you behave yourselves. If I get one more owl telling me you've – you've blown up a toilet or –"
  },
  {
    "author": "Dr. Seuss,",
    "quote": "You're off to Great Places!"
  },
  {
    "author": "C. JoyBell C.",
    "quote": "We have to allow ourselves to be loved by the people who really love us, the people who really matter. Too much of the time, we are blinded by our own pursuits of people to love us, people that don't even matter, while all that time we waste and the people who do love us have to stand on the sidewalk and watch us beg in the streets! It's time to put an end to this. It's time for us to let ourselves be loved."
  },
  {
    "author": "Harper Lee,",
    "quote": "The one thing that doesn't abide by majority rule is a person's conscience."
  },
  {
    "author": "Lauren Oliver,",
    "quote": "You can't be happy unless you're unhappy sometimes."
  },
  {
    "author": "Albert Einstein",
    "quote": "Great spirits have always encountered violent opposition from mediocre minds."
  },
  {
    "author": "Federico García Lorca,",
    "quote": "To burn with desire and keep quiet about it is the greatest punishment we can bring on ourselves."
  },
  {
    "author": "Madeline Miller,",
    "quote": "He is half of my soul, as the poets say."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Ah, said a voice from the doorway, having your annual ‘everyone thinks Will is a lunatic’ meeting, are you?"
  },
  {
    "author": "Amy Bloom",
    "quote": "You are imperfect, permanently and inevitably flawed. And you are beautiful."
  },
  {
    "author": "Emily Dickinson",
    "quote": "Forever is composed of nows."
  },
  {
    "author": "William Shakespeare,",
    "quote": "All the world's a stage,"
  },
  {
    "author": "Mark Twain",
    "quote": "Sanity and happiness are an impossible combination."
  },
  {
    "author": "Katharine Hepburn",
    "quote": "If you obey all of the rules, you miss all of the fun."
  },
  {
    "author": "Nicholas Sparks",
    "quote": "The reason it hurts so much to separate is because our souls are connected."
  },
  {
    "author": "Vincent Willem van Gogh",
    "quote": "I dream my painting and I paint my dream."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Mom. I have something to tell you. I’m undead. Now, I know you may have some preconceived notions about the undead. I know you may not be comfortable with the idea of me being undead. But I’m here to tell you that undead are just like you and me … well, okay. Possibly more like me than you."
  },
  {
    "author": "Gregory Maguire,",
    "quote": "People who claim that they're evil are usually no worse than the rest of us... It's people who claim that they're good, or any way better than the rest of us, that you have to be wary of."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "Do you wish me a good morning, or mean that it is a good morning whether I want it or not; or that you feel good this morning; or that it is a morning to be good on?"
  },
  {
    "author": "Virginia Woolf",
    "quote": "Why are women... so much more interesting to men than men are to women?"
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "The individual has always had to struggle to keep from being overwhelmed by the tribe. If you try it, you will be lonely often, and sometimes frightened. But no price is too high to pay for the privilege of owning yourself."
  },
  {
    "author": "Charles Bukowski",
    "quote": "there are worse things"
  },
  {
    "author": "Jodi Picoult,",
    "quote": "Maybe who we are isn't so much about what we do, but rather what we're capable of when we least expect it."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Education is an admirable thing, but it is well to remember from time to time that nothing that is worth knowing can be taught."
  },
  {
    "author": "Charles Dickens",
    "quote": "Never close your lips to those whom you have already opened your heart."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You see, cuckoos are parasites. They lay their eggs in other birds' nests. When the egg hatches, the baby cuckoo pushes the other baby birds out of the nest. The poor parent birds work themselves to death trying to find enough food to feed the enormous cuckoo child who has murdered their babies and taken their places."
  },
  {
    "author": "Franz Kafka",
    "quote": "A book must be the axe for the frozen sea within us."
  },
  {
    "author": "Nora Ephron",
    "quote": "Reading is escape, and the opposite of escape; it's a way to make contact with reality after a day of making things up, and it's a way of making contact with someone else's imagination after a day that's all too real."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Follow your heart, listen to your inner voice, stop caring about what others think."
  },
  {
    "author": "Richard P. Feynman",
    "quote": "Nobody ever figures out what life is all about, and it doesn't matter. Explore the world. Nearly everything is really interesting if you go into it deeply enough."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Holey? You have the the whole world of ear-related humor before you, you go for holey?"
  },
  {
    "author": "Pearl S. Buck",
    "quote": "Many people lose the small joys in the hope for the big happiness."
  },
  {
    "author": "Bob Marley,",
    "quote": "If she's amazing, she won't be easy. If she's easy, she won't be amazing. If she's worth it, you wont give up. If you give up, you're not worthy. ... Truth is, everybody is going to hurt you; you just gotta find the ones worth suffering for."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Out of the corner of her eye she thought she saw Jace shoot her a look of white rage - but when she glanced at him, he looked as he always did: easy, confident, slightly bored."
  },
  {
    "author": "Rick Riordan,",
    "quote": "People are more difficult to work with than machines. And when you break a person, he can't be fixed."
  },
  {
    "author": "charles bukowski",
    "quote": "If you're losing your soul and you know it, then you've still got a soul left to lose"
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "The heart is an arrow. It demands aim to land true."
  },
  {
    "author": "Jane Austen,",
    "quote": "I can listen no longer in silence. I must speak to you by such means as are within my reach. You pierce my soul. I am half agony, half hope. Tell me not that I am too late, that such precious feelings are gone for ever. I offer myself to you again with a heart even more your own than when you almost broke it, eight years and a half ago. Dare not say that man forgets sooner than woman, that his love has an earlier death. I have loved none but you. Unjust I may have been, weak and resentful I have been, but never inconstant. You alone have brought me to Bath. For you alone, I think and plan. Have you not seen this? Can you fail to have understood my wishes? I had not waited even these ten days, could I have read your feelings, as I think you must have penetrated mine. I can hardly write. I am every instant hearing something which overpowers me. You sink your voice, but I can distinguish the tones of that voice when they would be lost on others. Too good, too excellent creature! You do us justice, indeed. You do believe that there is true attachment and constancy among men. Believe it to be most fervent, most undeviating, in F. W."
  },
  {
    "author": "Rumi",
    "quote": "Dance, when you're broken open. Dance, if you've torn the bandage off. Dance in the middle of the fighting. Dance in your blood. Dance when you're perfectly free."
  },
  {
    "author": "JK Rowling,",
    "quote": "Things we lose have a way of coming back to us in the end, if not always in the way we expect."
  },
  {
    "author": "E.M. Forster,",
    "quote": "It isn't possible to love and part. You will wish that it was. You can transmute love, ignore it, muddle it, but you can never pull it out of you. I know by experience that the poets are right: love is eternal."
  },
  {
    "author": "Albert Camus",
    "quote": "But in the end one needs more courage to live than to kill himself."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "This is your life and its ending one moment at a time."
  },
  {
    "author": "Jean-Paul Sartre",
    "quote": "If you're lonely when you're alone, you're in bad company."
  },
  {
    "author": "Leonardo da Vinci",
    "quote": "Once you have tasted flight, you will forever walk the earth with your eyes turned skyward, for there you have been, and there you will always long to return."
  },
  {
    "author": "Jay Asher,",
    "quote": "You don’t know what goes on in anyone’s life but your own. And when you mess with one part of a person’s life, you’re not messing with just that part. Unfortunately, you can’t be that precise and selective. When you mess with one part of a person’s life, you’re messing with their entire life. Everything. . . affects everything."
  },
  {
    "author": "H. Jackson Brown Jr.",
    "quote": "Don't say you don't have enough time. You have exactly the same number of hours per day that were given to Helen Keller, Pasteur, Michelangelo, Mother Teresa, Leonardo da Vinci, Thomas Jefferson, and Albert Einstein."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "A man can no more diminish God's glory by refusing to worship Him than a lunatic can put out the sun by scribbling the word 'darkness' on the walls of his cell."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "No amount of regretting can change the past, and no amount of worrying can change the future."
  },
  {
    "author": "Colleen Hoover,",
    "quote": "Don't take life too seriously. Punch it in the face when it needs a good hit. Laugh at it."
  },
  {
    "author": "Miguel de Cervantes Saavedra,",
    "quote": "Finally, from so little sleeping and so much reading, his brain dried up and he went completely out of his mind."
  },
  {
    "author": "Cassandra Clare",
    "quote": "Usually I'm remarkably good natured. Try me on a day that doesn't end in y."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "That was the thing. You never got used to it, the idea of someone being gone. Just when you think it's reconciled, accepted, someone points it out to you, and it just hits you all over again, that shocking."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "There was a clatter as the basilisk fangs cascaded out of Hermione's arms. Running at Ron, she flung them around his neck and kissed him full on the mouth. Ron threw away the fangs and broomstick he was holding and responded with such enthusiasm that he lifted Hermione off her feet."
  },
  {
    "author": "Dave Eggers",
    "quote": "Books have a unique way of stopping time in a particular moment and saying: Let’s not forget this."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "And so with the sunshine and the great bursts of leaves growing on the trees, just as things grow in fast movies, I had that familiar conviction that life was beginning over again with the summer."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "If you are allergic to a thing, it is best not to put that thing in your mouth, particularly if the thing is cats."
  },
  {
    "author": "Jodi Picoult,",
    "quote": "If you gave someone your heart and they died, did they take it with them? Did you spend the rest of forever with a hole inside you that couldn't be filled?"
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "And on the subject of burning books: I want to congratulate librarians, not famous for their physical strength or their powerful political connections or their great wealth, who, all over this country, have staunchly resisted anti-democratic bullies who have tried to remove certain books from their shelves, and have refused to reveal to thought police the names of persons who have checked out those titles."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "War must be, while we defend our lives against a destroyer who would devour all; but I do not love the bright sword for its sharpness, nor the arrow for its swiftness, nor the warrior for his glory. I love only that which they defend."
  },
  {
    "author": "Franz Kafka",
    "quote": "Don't bend; don't water it down; don't try to make it logical; don't edit your own soul according to the fashion. Rather, follow your most intense obsessions mercilessly."
  },
  {
    "author": "John Green,",
    "quote": "I'm a grenade and at some point I'm going to blow up and I would like to minimize the casualties, okay?"
  },
  {
    "author": "Robert Marley",
    "quote": "One love, one heart, one destiny."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "The Road goes ever on and on"
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Life is about accepting the challenges along the way, choosing to keep moving forward, and savoring the journey."
  },
  {
    "author": "S.E. Hinton",
    "quote": "If you have two friends in your lifetime, you're lucky. If you have one good friend, you're more than lucky."
  },
  {
    "author": "Neil Gaiman",
    "quote": "Stories may well be lies, but they are good lies that say true things, and which can sometimes pay the rent."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "When someone is crying, of course, the noble thing to do is to comfort them. But if someone is trying to hide their tears, it may also be noble to pretend you do not notice them."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "When someone leaves, it's because someone else is about to arrive."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "We have to continually be jumping off cliffs and developing our wings on the way down."
  },
  {
    "author": "mahatma gandhi",
    "quote": "I will not let anyone walk through my mind with their dirty feet."
  },
  {
    "author": "Virginia Woolf,",
    "quote": "One cannot think well, love well, sleep well, if one has not dined well."
  },
  {
    "author": "Veronica Roth,",
    "quote": "People, I have discovered, are layers and layers of secrets. You believe you know them, that you understand them, but their motives are always hidden from you, buried in their own hearts. You will never know them, but sometimes you decide to trust them."
  },
  {
    "author": "Soren Kierkegaard",
    "quote": "The function of prayer is not to influence God, but rather to change the nature of the one who prays."
  },
  {
    "author": "Kahlil Gibran",
    "quote": "Trees are poems the earth writes upon the sky, We fell them down and turn them into paper,"
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Top 15 Things Money Can’t Buy"
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "It's not natural for women to fight."
  },
  {
    "author": "J. K. Rowling,",
    "quote": "The thing about growing up with Fred and George, said Ginny thoughtfully, is that you sort of start thinking anything's possible if you've got enough nerve."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "The greater the love, the greater the tragedy when it's over."
  },
  {
    "author": "Viktor E. Frankl,",
    "quote": "Everything can be taken from a man but one thing: the last of the human freedoms—to choose one’s attitude in any given set of circumstances, to choose one’s own way."
  },
  {
    "author": "Philip K. Dick,",
    "quote": "Reality is that which, when you stop believing in it, doesn't go away."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "If you want to really hurt you parents, and you don't have the nerve to be gay, the least you can do is go into the arts. I'm not kidding. The arts are not a way to make a living. They are a very human way of making life more bearable. Practicing an art, no matter how well or badly, is a way to make your soul grow, for heaven's sake. Sing in the shower. Dance to the radio. Tell stories. Write a poem to a friend, even a lousy poem. Do it as well as you possible can. You will get an enormous reward. You will have created something."
  },
  {
    "author": "Nelson Mandela",
    "quote": "When a man is denied the right to live the life he believes in, he has no choice but to become an outlaw."
  },
  {
    "author": "Jane Austen,",
    "quote": "I could easily forgive his pride, if he had not mortified mine."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Acts of Kindness:"
  },
  {
    "author": "John Green,",
    "quote": "Maybe there's something you're afraid to say, or someone you're afraid to love, or somewhere you're afraid to go. It's gonna hurt. It's gonna hurt because it matters."
  },
  {
    "author": "Sylvia Plath",
    "quote": "Mad Girl's Love Song"
  },
  {
    "author": "Bukkyo Dendo Kyokai,",
    "quote": "The secret of health for both mind and body is not to mourn for the past, nor to worry about the future, but to live the present moment wisely and earnestly."
  },
  {
    "author": "Augusten Burroughs",
    "quote": "I, myself, am made entirely of flaws, stitched together with good intentions."
  },
  {
    "author": "Clive Barker,",
    "quote": "Any fool can be happy. It takes a man with real heart to make beauty out of the stuff that makes us weep."
  },
  {
    "author": "kurt vonnegut",
    "quote": "If I should ever die, God forbid, let this be my epitaph:"
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "He thinks he'll be remembered as the villain in the story. But I forgot to tell him that the villain is usually the person who locks up the maiden and throws away the key. He was the one who let me out."
  },
  {
    "author": "Hunter S. Thompson,",
    "quote": "We are all alone, born alone, die alone, and—in spite of True Romance magazines—we shall all someday look back on our lives and see that, in spite of our company, we were alone the whole way. I do not say lonely—at least, not all the time—but essentially, and finally, alone. This is what makes your self-respect so important, and I don't see how you can respect yourself if you must look in the hearts and minds of others for your happiness."
  },
  {
    "author": "Albert Einstein",
    "quote": "The measure of intelligence is the ability to change."
  },
  {
    "author": "Irving Stone,",
    "quote": "There are no faster or firmer friendships than those formed between people who love the same books."
  },
  {
    "author": "Maya Angelou",
    "quote": "Have enough courage to trust love one more time and always one more time."
  },
  {
    "author": "Stephen King",
    "quote": "Both Rowling and Meyer, they’re speaking directly to young people. … The real difference is that Jo Rowling is a terrific writer and Stephenie Meyer can’t write worth a darn. She’s not very good."
  },
  {
    "author": "John Green,",
    "quote": "Because you are beautiful. I enjoy looking at beautiful people, and I decided a while ago not to deny myself the simpler pleasures of existence"
  },
  {
    "author": "Pablo Neruda,",
    "quote": "I want"
  },
  {
    "author": "Scott Westerfeld,",
    "quote": "What you do, the way you think, makes you beautiful."
  },
  {
    "author": "Honoré de Balzac",
    "quote": "Solitude is fine but you need someone to tell that solitude is fine."
  },
  {
    "author": "Rumi,",
    "quote": "Don't be satisfied with stories, how things have gone with others. Unfold your own myth."
  },
  {
    "author": "Rumi",
    "quote": "If you are irritated by every rub, how will your mirror be polished?"
  },
  {
    "author": "George Orwell",
    "quote": "Every generation imagines itself to be more intelligent than the one that went before it, and wiser than the one that comes after it."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "No, I'm just a very naughty boy. I do all sorts of bad things. I kick kittens. I make rude gestures at nuns."
  },
  {
    "author": "George Carlin",
    "quote": "Fighting for peace is like screwing for virginity."
  },
  {
    "author": "Terry Pratchett",
    "quote": "In ancient times cats were worshipped as gods; they have not forgotten this."
  },
  {
    "author": "August Wilson",
    "quote": "Confront the dark parts of yourself, and work to banish them with illumination and forgiveness. Your willingness to wrestle with your demons will cause your angels to sing."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "So be sure when you step, Step with care and great tact. And remember that life's A Great Balancing Act. And will you succeed? Yes! You will, indeed! (98 and ¾ percent guaranteed) Kid, you'll move mountains."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "I'm quite illiterate, but I read a lot."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "Always do sober what you said you'd do drunk. That will teach you to keep your mouth shut."
  },
  {
    "author": "Hans Christian Andersen,",
    "quote": "But a mermaid has no tears, and therefore she suffers so much more."
  },
  {
    "author": "David Foster Wallace,",
    "quote": "I do things like get in a taxi and say, The library, and step on it."
  },
  {
    "author": "Franz Kafka",
    "quote": "I am a cage, in search of a bird."
  },
  {
    "author": "Yann Martel,",
    "quote": "It is true that those we meet can change us, sometimes so profoundly that we are not the same afterwards, even unto our names."
  },
  {
    "author": "Johann Wolfgang von Goethe,",
    "quote": "One ought, every day at least, to hear a little song, read a good poem, see a fine picture, and, if it were possible, to speak a few reasonable words."
  },
  {
    "author": "Malcolm X,",
    "quote": "You're not to be so blind with patriotism that you can't face reality. Wrong is wrong, no matter who does it or says it."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "Time is a drug. Too much of it kills you."
  },
  {
    "author": "Hafiz",
    "quote": "And still, after all this time,"
  },
  {
    "author": "C.S. Lewis",
    "quote": "Love is not affectionate feeling, but a steady wish for the loved person's ultimate good as far as it can be obtained."
  },
  {
    "author": "Tina Fey,",
    "quote": "Do your thing and don't care if they like it."
  },
  {
    "author": "Mary Oliver",
    "quote": "Someone I loved once gave me a box full of darkness. It took me years to understand that this too, was a gift."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "I can resist anything except temptation."
  },
  {
    "author": "Plato",
    "quote": "We can easily forgive a child who is afraid of the dark; the real tragedy of life is when men are afraid of the light."
  },
  {
    "author": "T.S. Eliot,",
    "quote": "For last year's words belong to last year's language"
  },
  {
    "author": "Rumi",
    "quote": "You were born with wings, why prefer to crawl through life?"
  },
  {
    "author": "Markus Zusak,",
    "quote": "Even death has a heart."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Be brave to stand for what you believe in even if you stand alone."
  },
  {
    "author": "Arthur Conan Doyle",
    "quote": "It is a great thing to start life with a small number of really good books which are your very own."
  },
  {
    "author": "Aldous Huxley,",
    "quote": "After silence, that which comes nearest to expressing the inexpressible is music."
  },
  {
    "author": "J. M. Barrie,",
    "quote": "The moment you doubt whether you can fly, you cease for ever to be able to do it."
  },
  {
    "author": "Pablo Neruda",
    "quote": "As if you were on fire from within."
  },
  {
    "author": "John Steinbeck,",
    "quote": "Maybe ever’body in the whole damn world is scared of each other."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "Three Rings for the Elven-kings under the sky,"
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "When we are tired, we are attacked by ideas we conquered long ago."
  },
  {
    "author": "Markus Zusak,",
    "quote": "I wanted to tell the book thief many things, about beauty and brutality. But what could I tell her about those things that she didn't already know? I wanted to explain that I am constantly overestimating and underestimating the human race-that rarely do I ever simply estimate it. I wanted to ask her how the same thing could be so ugly and so glorious, and its words and stories so damning and brilliant."
  },
  {
    "author": "أحمد خالد توفيق",
    "quote": "أحيانًا يساعدنا الآخرون بأن يكونوا فى حياتنا فحسب"
  },
  {
    "author": "Rumi",
    "quote": "When you do things from your soul, you feel a river moving in you, a joy."
  },
  {
    "author": "Antoine de Saint-Exupéry",
    "quote": "Goodbye, said the fox. And now here is my secret, a very simple secret: It is only with the heart that one can see rightly; what is essential is invisible to the eye."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "It's not the face, but the expressions on it. It's not the voice, but what you say. It's not how you look in that body, but the thing you do with it. You are beautiful."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I was thinking about the first time I ever saw you, he said, and how after that I couldn't forget you. I wanted to, but I couldn't stop myself. I forced Hodge to let me be the one who came to find you and bring you back to the Institue. And even back then, in that stupid coffee shop, when I saw you sitting on that couch with Simon, even then that felt wrong to me-- I should have been the one sitting with you. The one who made you laugh like that. I couldn't get rid of that feeling. That it should have been me. And the more I knew you, the more I felt it--it had never been like that for me before. I'd always wanted a girl and then gotten to know her and not wanted her anymore, but with you the feeling just got stronger and stronger until that night when you showed up at Renwick's and I knew."
  },
  {
    "author": "Anais Nin",
    "quote": "Life shrinks or expands in proportion to one's courage."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "The first draft of anything is shit."
  },
  {
    "author": "Rumi",
    "quote": "Forget safety."
  },
  {
    "author": "Dr. Seuss",
    "quote": "How did it get so late so soon?"
  },
  {
    "author": "Kathryn Stockett,",
    "quote": "You is kind. You is smart. You is important."
  },
  {
    "author": "Anais Nin",
    "quote": "How wrong is it for a woman to expect the man to build the world she wants, rather than to create it herself?"
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "What makes the desert beautiful,' said the little prince, 'is that somewhere it hides a well..."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "The world breaks everyone, and afterward, many are strong at the broken places."
  },
  {
    "author": "Mark Twain",
    "quote": "When I was a boy of 14, my father was so ignorant I could hardly stand to have the old man around. But when I got to be 21, I was astonished at how much the old man had learned in seven years."
  },
  {
    "author": "Edna St. Vincent Millay",
    "quote": "They say when you are missing someone that they are probably feeling the same, but I don't think it's possible for you to miss me as much as I'm missing you right now"
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Understanding is the first step to acceptance, and only with acceptance can there be recovery."
  },
  {
    "author": "Margaret Fuller",
    "quote": "Today a reader, tomorrow a leader."
  },
  {
    "author": "Markus Zusak,",
    "quote": "He does something to me, that boy. Every time. It’s his only detriment. He steps on my heart. He makes me cry."
  },
  {
    "author": "William Shakespeare,",
    "quote": "You speak an infinite deal of nothing."
  },
  {
    "author": "Betty Smith,",
    "quote": "The world was hers for the reading."
  },
  {
    "author": "Patrick Ness,",
    "quote": "There is not always a good guy. Nor is there always a bad one. Most people are somewhere in between."
  },
  {
    "author": "George Orwell,",
    "quote": "The best books... are those that tell you what you know already."
  },
  {
    "author": "John Green,",
    "quote": "It's not because I want to make out with her."
  },
  {
    "author": "Joyce Carol Oates,",
    "quote": "I never change, I simply become more myself."
  },
  {
    "author": "Margaret Atwood",
    "quote": "I would like to be the air that inhabits you for a moment only. I would like to be that unnoticed and that necessary."
  },
  {
    "author": "Cornelia Funke,",
    "quote": "Isn't it odd how much fatter a book gets when you've read it several times? Mo had said...As if something were left between the pages every time you read it. Feelings, thoughts, sounds, smells...and then, when you look at the book again many years later, you find yourself there, too, a slightly younger self, slightly different, as if the book had preserved you like a pressed flower...both strange and familiar."
  },
  {
    "author": "Markus Zusak,",
    "quote": "Imagine smiling after a slap in the face. Then think of doing it twenty-four hours a day."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Is standing by the window muttering about blood something he does all the time? asked Simon."
  },
  {
    "author": "Anais Nin",
    "quote": "I am an excitable person who only understands life lyrically, musically, in whom feelings are much stronger as reason. I am so thirsty for the marvelous that only the marvelous has power over me. Anything I can not transform into something marvelous, I let go. Reality doesn't impress me. I only believe in intoxication, in ecstasy, and when ordinary life shackles me, I escape, one way or another. No more walls."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "All you have to do is write one true sentence. Write the truest sentence that you know."
  },
  {
    "author": "Taylor Swift",
    "quote": "To me, Fearless is not the absense of fear. It's not being completely unafraid. To me, Fearless is having fears. Fearless is having doubts. Lots of them. To me, Fearless is living in spite of those things that scare you to death."
  },
  {
    "author": "Viktor E. Frankl,",
    "quote": "When we are no longer able to change a situation, we are challenged to change ourselves."
  },
  {
    "author": "John Green,",
    "quote": "At some point, you just pull off the Band-Aid, and it hurts, but then it's over and you're relieved."
  },
  {
    "author": "Albert Camus,",
    "quote": "You know what charm is: a way of getting the answer yes without having asked any clear question."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "The most beautiful things in the world cannot be seen or touched, they are felt with the heart."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Isabelle drifted over, Jace a pace behind her. She was wearing a long black dress with boots and an even longer cutaway coat of soft green velvet, the color of moss. I can't believe you did it! she exclaimed. How did you get Magnus to let Jace leave?"
  },
  {
    "author": "Tom Robbins",
    "quote": "We waste time looking for the perfect lover, instead of creating the perfect love."
  },
  {
    "author": "John Steinbeck,",
    "quote": "And now that you don't have to be perfect, you can be good."
  },
  {
    "author": "Harper Lee,",
    "quote": "Atticus told me to delete the adjectives and I'd have the facts."
  },
  {
    "author": "Oriah Mountain Dreamer",
    "quote": "It doesn't interest me what you do for a living. I want to know what you ache for, and if you dare to dream of meeting your heart's longing."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "Happiness is the consequence of personal effort. You fight for it, strive for it, insist upon it, and sometimes even travel around the world looking for it. You have to participate relentlessly in the manifestations of your own blessings. And once you have achieved a state of happiness, you must never become lax about maintaining it. You must make a mighty effort to keep swimming upward into that happiness forever, to stay afloat on top of it."
  },
  {
    "author": "Nicholas Sparks",
    "quote": "It happens to everyone as they grow up. You find out who you are and what you want, and then you realize that people you've known forever don't see things the way you do. So you keep the wonderful memories, but find yourself moving on."
  },
  {
    "author": "Sarah Dessen",
    "quote": "Sometimes it seems safer to hold it all in, where the only person who can judge is yourself."
  },
  {
    "author": "Friedrich Wilhelm Nietzsche",
    "quote": "We should consider every day lost on which we have not danced at least once."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "All we demanded was our right to twinkle."
  },
  {
    "author": "Orson Scott Card,",
    "quote": "Perhaps it's impossible to wear an identity without becoming what you pretend to be."
  },
  {
    "author": "Niels Bohr",
    "quote": "An expert is a person who has made all the mistakes that can be made in a very narrow field."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "I dream. Sometimes I think that's the only right thing to do."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "The purpose of life is not to be happy. It is to be useful, to be honorable, to be compassionate, to have it make some difference that you have lived and lived well."
  },
  {
    "author": "Charlotte Bronte,",
    "quote": "Life appears to me too short to be spent in nursing animosity or registering wrongs."
  },
  {
    "author": "Oscar Wilde",
    "quote": "A cynic is a man who knows the price of everything, and the value of nothing."
  },
  {
    "author": "Robert Bloch",
    "quote": "Despite my ghoulish reputation, I really have the heart of a small boy. I keep it in a jar on my desk."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Words are easy, like the wind; faithful friends are hard to find."
  },
  {
    "author": "John Green,",
    "quote": "You don't remember what happened. What you remember becomes what happened."
  },
  {
    "author": "Anita Desai",
    "quote": "Wherever you go becomes a part of you somehow."
  },
  {
    "author": "T.H. White,",
    "quote": "The bravest people are the ones who don’t mind looking like cowards."
  },
  {
    "author": "Albert Einstein",
    "quote": "Gravitation is not responsible for people falling in love."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "Live in the sunshine, swim the sea, drink the wild air."
  },
  {
    "author": "Jerry Seinfeld",
    "quote": "If a book about failures doesn't sell, is it a success?"
  },
  {
    "author": "Steve Maraboli",
    "quote": "Letting go means to come to the realization that some people are a part of your history, but not a part of your destiny."
  },
  {
    "author": "Albert Einstein",
    "quote": "It is not that I'm so smart. But I stay with the questions much longer."
  },
  {
    "author": "Zora Neale Hurston,",
    "quote": "There are years that ask questions and years that answer."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Don't feel bad, I'm usually about to die."
  },
  {
    "author": "Pablo Neruda,",
    "quote": "Tonight I can write the saddest lines"
  },
  {
    "author": "Lauren Oliver,",
    "quote": "Maybe you can afford to wait. Maybe for you there's a tomorrow. Maybe for you there's one thousand tomorrows, or three thousand, or ten, so much time you can bathe in it, roll around it, let it slide like coins through you fingers. So much time you can waste it."
  },
  {
    "author": "Mo Willems,",
    "quote": "If you ever find yourself in the wrong story, leave."
  },
  {
    "author": "L. M. Montgomery,",
    "quote": "I'm so glad I live in a world where there are Octobers."
  },
  {
    "author": "Corrie ten Boom",
    "quote": "Never be afraid to trust an unknown future to a known God."
  },
  {
    "author": "Frank McCourt,",
    "quote": "You might be poor, your shoes might be broken, but your mind is a palace."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Oh well... I'd just been thinking, if you had died, you'd have been welcome to share my toilet."
  },
  {
    "author": "Aldous Huxley,",
    "quote": "But I don't want comfort. I want God, I want poetry, I want real danger, I want freedom, I want goodness. I want sin."
  },
  {
    "author": "Albert Camus",
    "quote": "The only way to deal with an unfree world is to become so absolutely free that your very existence is an act of rebellion."
  },
  {
    "author": "Virginia Woolf",
    "quote": "If you do not tell the truth about yourself you cannot tell it about other people."
  },
  {
    "author": "Natalie Babbitt,",
    "quote": "Don't be afraid of death; be afraid of an unlived life. You don't have to live forever, you just have to live."
  },
  {
    "author": "Barbara Kingsolver,",
    "quote": "The very least you can do in your life is figure out what you hope for. And the most you can do is live inside that hope. Not admire it from a distance but live right in it, under its roof."
  },
  {
    "author": "Benjamin Disraeli",
    "quote": "There are three types of lies -- lies, damn lies, and statistics."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Great things happen to those who don't stop believing, trying, learning, and being grateful."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "You need to learn how to select your thoughts just the same way you select your clothes every day. This is a power you can cultivate. If you want to control things in your life so bad, work on the mind. That's the only thing you should be trying to control."
  },
  {
    "author": "Thomas Merton,",
    "quote": "The beginning of love is the will to let those we love be perfectly themselves, the resolution not to twist them to fit our own image. If in loving them we do not love what they are, but only their potential likeness to ourselves, then we do not love them: we only love the reflection of ourselves we find in them"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Don't stop there. I suppose there are also, what, vampires and werewolves and zombies?"
  },
  {
    "author": "Pablo Neruda",
    "quote": "Someday, somewhere - anywhere, unfailingly, you'll find yourself, and that, and only that, can be the happiest or bitterest hour of your life."
  },
  {
    "author": "Søren Kierkegaard",
    "quote": "People demand freedom of speech as a compensation for the freedom of thought which they seldom use."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "Fall down again, Bella?'"
  },
  {
    "author": "Mark Twain",
    "quote": "Don't part with your illusions. When they are gone you may still exist, but you have ceased to live."
  },
  {
    "author": "John Green,",
    "quote": "Sometimes, you read a book and it fills you with this weird evangelical zeal, and you become convinced that the shattered world will never be put back together unless and until all living humans read the book. And then there are books like An Imperial Affliction, which you can't tell people about, books so special and rare and yours that advertising your affection feels like betrayal"
  },
  {
    "author": "Arthur C. Clarke",
    "quote": "I'm sure the universe is full of intelligent life. It's just been too intelligent to come here."
  },
  {
    "author": "Chico Xavier",
    "quote": "‎Though nobody can go back and make a new beginning... Anyone can start over and make a new ending."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "You know, when it works, love is pretty amazing. It's not overrated. There's a reason for all those songs."
  },
  {
    "author": "Franz Kafka",
    "quote": "Many a book is like a key to unknown chambers within the castle of one’s own self."
  },
  {
    "author": "Audrey Niffenegger,",
    "quote": "Don't you think it's better to be extremely happy for a short while, even if you lose it, than to be just okay for your whole life?"
  },
  {
    "author": "J.K. Rowling",
    "quote": "Is 'fat' really the worst thing a human being can be? Is 'fat' worse than 'vindictive', 'jealous', 'shallow', 'vain', 'boring' or 'cruel'? Not to me."
  },
  {
    "author": "Emily Brontë,",
    "quote": "Be with me always - take any form - drive me mad! only do not leave me in this abyss, where I cannot find you! Oh, God! it is unutterable! I can not live without my life! I can not live without my soul!"
  },
  {
    "author": "Becca Fitzpatrick,",
    "quote": "Say 'provoking' again. Your mouth looks provocative when you do."
  },
  {
    "author": "Charles Dickens,",
    "quote": "Suffering has been stronger than all other teaching, and has taught me to understand what your heart used to be. I have been bent and broken, but - I hope - into a better shape."
  },
  {
    "author": "Logan Pearsall Smith",
    "quote": "People say that life is the thing, but I prefer reading."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Grover was sniffing the wind, looking nervous. He fished out his acorns and threw them into the sand, then played his pipes. They rearranged themselves in a pattern that made no sense to me, but Grover looked concerned."
  },
  {
    "author": "Walter Cronkite",
    "quote": "Whatever the cost of our libraries, the price is cheap compared to that of an ignorant nation."
  },
  {
    "author": "Lucy Maud Montgomery,",
    "quote": "It's been my experience that you can nearly always enjoy things if you make up your mind firmly that you will."
  },
  {
    "author": "Colette",
    "quote": "You will do foolish things, but do them with enthusiasm."
  },
  {
    "author": "George Bernard Shaw,",
    "quote": "You see things; you say, 'Why?' But I dream things that never were; and I say 'Why not?"
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Never lose hope. Storms make people stronger and never last forever."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "You here to finish me off, Sweetheart?"
  },
  {
    "author": "Fernando Pessoa,",
    "quote": "Literature is the most agreeable way of ignoring life."
  },
  {
    "author": "Coco Chanel",
    "quote": "It’s probably not just by chance that I’m alone. It would be very hard for a man to live with me, unless he’s terribly strong. And if he’s stronger than I, I’m the one who can’t live with him. … I’m neither smart nor stupid, but I don’t think I’m a run-of-the-mill person. I’ve been in business without being a businesswoman, I’ve loved without being a woman made only for love. The two men I’ve loved, I think, will remember me, on earth or in heaven, because men always remember a woman who caused them concern and uneasiness. I’ve done my best, in regard to people and to life, without precepts, but with a taste for justice."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Don't feel sorry for yourself. Only assholes do that."
  },
  {
    "author": "Ralph Ellison,",
    "quote": "What and how much had I lost by trying to do only what was expected of me instead of what I myself had wished to do?"
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I shut my eyes and all the world drops dead;"
  },
  {
    "author": "Nicholson Baker,",
    "quote": "I woke up thinking a very pleasant thought. There is lots left in the world to read."
  },
  {
    "author": "Stephen Hawking",
    "quote": "We are just an advanced breed of monkeys on a minor planet of a very average star. But we can understand the Universe. That makes us something very special."
  },
  {
    "author": "William Shakespeare,",
    "quote": "These violent delights have violent ends"
  },
  {
    "author": "Ally Condie,",
    "quote": "Growing apart doesn't change the fact that for a long time we grew side by side; our roots will always be tangled. I'm glad for that."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "I cannot believe in a God who wants to be praised all the time."
  },
  {
    "author": "Scott Adams",
    "quote": "I love you like a fat kid loves cake!"
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "Look after my heart - I've left it with you."
  },
  {
    "author": "Christopher Paolini,",
    "quote": "Live in the present, remember the past, and fear not the future, for it doesn't exist and never shall. There is only now."
  },
  {
    "author": "John Steinbeck,",
    "quote": "All great and precious things are lonely."
  },
  {
    "author": "Stephen King",
    "quote": "If you want to be a writer, you must do two things above all others: read a lot and write a lot."
  },
  {
    "author": "Raymond Chandler,",
    "quote": "To say goodbye is to die a little."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "He smiled understandingly-much more than understandingly. It was one of those rare smiles with a quality of eternal reassurance in it, that you may come across four or five times in life. It faced--or seemed to face--the whole eternal world for an instant, and then concentrated on you with an irresistible prejudice in your favor. It understood you just as far as you wanted to be understood, believed in you as you would like to believe in yourself, and assured you that it had precisely the impression of you that, at your best, you hoped to convey."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "It was not the feeling of completeness I so needed, but the feeling of not being empty."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "I wasn't actually in love, but I felt a sort of tender curiosity."
  },
  {
    "author": "Ralph Ellison,",
    "quote": "When I discover who I am, I’ll be free."
  },
  {
    "author": "Bill  Nye",
    "quote": "Everyone you will ever meet knows something you don't."
  },
  {
    "author": "Patrick Rothfuss,",
    "quote": "Words are pale shadows of forgotten names. As names have power, words have power. Words can light fires in the minds of men. Words can wring tears from the hardest hearts."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "And when her lips met mine, I knew that I could live to be a hundred and visit every country in the world, but nothing would ever compare to that single moment when I first kissed the girl of my dreams and knew that my love would last forever."
  },
  {
    "author": "Pablo Neruda",
    "quote": "I crave your mouth, your voice, your hair."
  },
  {
    "author": "W.P. Kinsella",
    "quote": "Success is getting what you want, happiness is wanting what you get"
  },
  {
    "author": "Paulo Coelho",
    "quote": "Don't waste your time with explanations: people only hear what they want to hear."
  },
  {
    "author": "Douglas Adams,",
    "quote": "Time is an illusion. Lunchtime doubly so."
  },
  {
    "author": "J.R. Ward,",
    "quote": "Welcome to the wonderful world of jealousy, he thought. For the price of admission, you get a splitting headache, a nearly irresistable urge to commit murder, and an inferiority complex. Yippee."
  },
  {
    "author": "Voltaire",
    "quote": "It is forbidden to kill; therefore all murderers are punished unless they kill in large numbers and to the sound of trumpets."
  },
  {
    "author": "Eckhart Tolle",
    "quote": "The past has no power over the present moment."
  },
  {
    "author": "Albert Camus",
    "quote": "In the midst of winter, I found there was, within me, an invincible summer."
  },
  {
    "author": "Anne Frank",
    "quote": "I can shake off everything as I write; my sorrows disappear, my courage is reborn."
  },
  {
    "author": "George Bernard Shaw",
    "quote": "If you want to tell people the truth, make them laugh, otherwise they'll kill you."
  },
  {
    "author": "Alan Bennett,",
    "quote": "The best moments in reading are when you come across something – a thought, a feeling, a way of looking at things – which you had thought special and particular to you. Now here it is, set down by someone else, a person you have never met, someone even who is long dead. And it is as if a hand has come out and taken yours."
  },
  {
    "author": "Mark Twain,",
    "quote": "Travel is fatal to prejudice, bigotry, and narrow-mindedness, and many of our people need it sorely on these accounts. Broad, wholesome, charitable views of men and things cannot be acquired by vegetating in one little corner of the earth all one's lifetime."
  },
  {
    "author": "Anne Lamott",
    "quote": "You will lose someone you can’t live without,and your heart will be badly broken, and the bad news is that you never completely get over the loss of your beloved. But this is also the good news. They live forever in your broken heart that doesn’t seal back up. And you come through. It’s like having a broken leg that never heals perfectly—that still hurts when the weather gets cold, but you learn to dance with the limp."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Yeah, Quirrell was a great teacher. There was just that minor drawback of him having Lord Voldemort sticking out of the back of his head!"
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "What you do speaks so loudly that I cannot hear what you say."
  },
  {
    "author": "Kurt Vonnegut",
    "quote": "Hello babies. Welcome to Earth. It's hot in the summer and cold in the winter. It's round and wet and crowded. On the outside, babies, you've got a hundred years here. There's only one rule that I know of, babies-God damn it, you've got to be kind."
  },
  {
    "author": "Ian Fleming",
    "quote": "Never say 'no' to adventures. Always say 'yes,' otherwise you'll lead a very dull life."
  },
  {
    "author": "Lois Lowry,",
    "quote": "Take pride in your pain; you are stronger than those who have none"
  },
  {
    "author": "George Carlin",
    "quote": "Have you ever noticed that anybody driving slower than you is an idiot, and anyone going faster than you is a maniac?"
  },
  {
    "author": "Ivan Turgenev",
    "quote": "If we wait for the moment when everything, absolutely everything is ready, we shall never begin."
  },
  {
    "author": "Joel Osteen,",
    "quote": "You must make a decision that you are going to move on. It wont happen automatically. You will have to rise up and say, ‘I don’t care how hard this is, I don’t care how disappointed I am, I’m not going to let this get the best of me. I’m moving on with my life."
  },
  {
    "author": "Emily Dickinson",
    "quote": "That it will never come again is what makes life so sweet."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Do not fear failure but rather fear not trying."
  },
  {
    "author": "Cormac McCarthy,",
    "quote": "You never know what worse luck your bad luck has saved you from."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "We all bear scars,... Mine just happen to be more visible than most."
  },
  {
    "author": "Clare Boothe Luce",
    "quote": "Money can't buy happiness, but it can make you awfully comfortable while you're being miserable."
  },
  {
    "author": "Ernest Hemingway,",
    "quote": "Maybe...you'll fall in love with me all over again."
  },
  {
    "author": "Paulo Coelho",
    "quote": "Love is an untamed force. When we try to control it, it destroys us. When we try to imprison it, it enslaves us. When we try to understand it, it leaves us feeling lost and confused."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "They’re not hideous, said Tessa."
  },
  {
    "author": "Robert Frost",
    "quote": "Education is the ability to listen to almost anything without losing your temper or your self-confidence."
  },
  {
    "author": "Jalal Ad-Din Rumi",
    "quote": "Knock, And He'll open the door"
  },
  {
    "author": "Jon Krakauer,",
    "quote": "Happiness [is] only real when shared"
  },
  {
    "author": "A.A. Milne",
    "quote": "How do you spell 'love'? - Piglet"
  },
  {
    "author": "Sarah Dessen,",
    "quote": "So you're always honest, I said."
  },
  {
    "author": "Milan Kundera",
    "quote": "You can't measure the mutual affection of two human beings by the number of words they exchange."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Clary,"
  },
  {
    "author": "Voltaire",
    "quote": "‎Life is a shipwreck, but we must not forget to sing in the lifeboats."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Though she be but little, she is fierce!"
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "Jesper knocked his head against the hull and cast his eyes heavenward. Fine. But if Pekka Rollins kills us all, I’m going to get Wylan’s ghost to teach my ghost how to play the flute just so that I can annoy the hell out of your ghost."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "The meek may inherit the earth, but at the moment it belongs to the conceited. Like me."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "So it's you and a syringe against the Capitol? See, this is why no one lets you make the plans."
  },
  {
    "author": "John Locke",
    "quote": "Reading furnishes the mind only with materials of knowledge; it is thinking that makes what we read ours."
  },
  {
    "author": "W. Somerset Maugham",
    "quote": "There are three rules for writing a novel. Unfortunately, no one knows what they are."
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "He stepped down, trying not to look long at her, as if she were the sun, yet he saw her, like the sun, even without looking."
  },
  {
    "author": "Stephen King,",
    "quote": "you can, you should, and if you’re brave enough to start, you will."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Every great love starts with a great story..."
  },
  {
    "author": "Christopher Paolini",
    "quote": "Books should go where they will be most appreciated, and not sit unread, gathering dust on a forgotten shelf, don't you agree?"
  },
  {
    "author": "George Bernard Shaw,",
    "quote": "The reasonable man adapts himself to the world: the unreasonable one persists in trying to adapt the world to himself. Therefore all progress depends on the unreasonable man."
  },
  {
    "author": "Marjorie Pay Hinckley",
    "quote": "The only way to get through life is to laugh your way through it. You either have to laugh or cry. I prefer to laugh. Crying gives me a headache."
  },
  {
    "author": "Mae West",
    "quote": "Every man I meet wants to protect me. I can't figure out what from."
  },
  {
    "author": "Rick Riordan",
    "quote": "I nodded, looking at Rachel with respect. You hit the Lord of the Titans in the eye with a blue plastic hairbrush."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Life, he realize, was much like a song. In the beginning there is mystery, in the end there is confirmation, but it's in the middle where all the emotion resides to make the whole thing worthwhile."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "When it is dark enough, you can see the stars."
  },
  {
    "author": "Norton Juster,",
    "quote": "So many things are possible just as long as you don't know they're impossible."
  },
  {
    "author": "James Baldwin",
    "quote": "You think your pain and your heartbreak are unprecedented in the history of the world, but then you read."
  },
  {
    "author": "Johann Wolfgang von Goethe",
    "quote": "If you treat an individual as he is, he will remain how he is. But if you treat him as if he were what he ought to be and could be, he will become what he ought to be and could be."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "To the stars who listen—and the dreams that are answered."
  },
  {
    "author": "Shawn Slovo,",
    "quote": "Love is a temporary madness, it erupts like volcanoes and then subsides. And when it subsides, you have to make a decision. You have to work out whether your roots have so entwined together that it is inconceivable that you should ever part. Because this is what love is. Love is not breathlessness, it is not excitement, it is not the promulgation of promises of eternal passion, it is not the desire to mate every second minute of the day, it is not lying awake at night imagining that he is kissing every cranny of your body. No, don't blush, I am telling you some truths. That is just being in love, which any fool can do. Love itself is what is left over when being in love has burned away, and this is both an art and a fortunate accident."
  },
  {
    "author": "Joseph Campbell",
    "quote": "We must be willing to let go of the life we planned so as to have the life that is waiting for us."
  },
  {
    "author": "Stewart O'Nan,",
    "quote": "You couldn't relive your life, skipping the awful parts, without losing what made it worthwhile. You had to accept it as a whole--like the world, or the person you loved."
  },
  {
    "author": "Tennessee Williams,",
    "quote": "If I got rid of my demons, I’d lose my angels."
  },
  {
    "author": "Gayle Forman,",
    "quote": "I realize now that dying is easy. Living is hard."
  },
  {
    "author": "Elizabeth Peters",
    "quote": "No woman really wants a man to carry her off; she only wants him to want to do it."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "And I thought about how many people have loved those songs. And how many people got through a lot of bad times because of those songs. And how many people enjoyed good times with those songs. And how much those songs really mean. I think it would be great to have written one of those songs. I bet if I wrote one of them, I would be very proud. I hope the people who wrote those songs are happy. I hope they feel it's enough. I really do because they've made me happy. And I'm only one person."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I could not tell you if I loved you the first moment I saw you, or if it was the second or third or fourth. But I remember the first moment I looked at you walking toward me and realized that somehow the rest of the world seemed to vanish when I was with you."
  },
  {
    "author": "Rob Reiner",
    "quote": "Everybody talks about wanting to change things and help and fix, but ultimately all you can do is fix yourself. And that's a lot. Because if you can fix yourself, it has a ripple effect."
  },
  {
    "author": "Johnny Cash",
    "quote": "All your life, you will be faced with a choice. You can choose love or hate…I choose love."
  },
  {
    "author": "Walt Whitman",
    "quote": "What is that you express in your eyes? It seems to me more than all the print I have read in my life."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "Let us learn to show our friendship for a man when he is alive and not after he is dead."
  },
  {
    "author": "John Green,",
    "quote": "It's just that most really good-looking people are stupid, so I exceed expectations.'"
  },
  {
    "author": "John A. Shedd",
    "quote": "A ship is safe in harbor, but that's not what ships are for."
  },
  {
    "author": "Margaret Thatcher",
    "quote": "In politics, If you want anything said, ask a man. If you want anything done, ask a woman."
  },
  {
    "author": "Lao Tzu",
    "quote": "Life is a series of natural and spontaneous changes. Don't resist them; that only creates sorrow. Let reality be reality. Let things flow naturally forward in whatever way they like."
  },
  {
    "author": "A.A. Milne",
    "quote": "I knew when I met you an adventure was going to happen."
  },
  {
    "author": "J.M. Barrie,",
    "quote": "I'm not young enough to know everything."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Always find opportunities to make someone smile, and to offer random acts of kindness in everyday life."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "Crying is all right in its way while it lasts. But you have to stop sooner or later, and then you still have to decide what to do."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Cowards die many times before their deaths;"
  },
  {
    "author": "Annie Dillard,",
    "quote": "She read books as one would breathe air, to fill up and live."
  },
  {
    "author": "Rick Riordan,",
    "quote": "What if it lines up like it did in the Trojan War ... Athena versus Poseidon?"
  },
  {
    "author": "Chinua Achebe",
    "quote": "If you don't like someone's story, write your own."
  },
  {
    "author": "Shel Silverstein",
    "quote": "If you are a dreamer come in"
  },
  {
    "author": "Henry van Dyke,",
    "quote": "Time is"
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Why were you lurking under our window?"
  },
  {
    "author": "Sarah Dessen,",
    "quote": "It's a lot easier to be lost than found. It's the reason we're always searching and rarely discovered--so many locks not enough keys."
  },
  {
    "author": "Vincent Van Gogh",
    "quote": "Be clearly aware of the stars and infinity on high. Then life seems almost enchanted after all."
  },
  {
    "author": "Jeffrey Eugenides,",
    "quote": "Biology gives you a brain. Life turns it into a mind."
  },
  {
    "author": "Rodney Dangerfield",
    "quote": "I came from a real tough neighborhood. Once a guy pulled a knife on me. I knew he wasn't a professional, the knife had butter on it."
  },
  {
    "author": "Christopher Morley,",
    "quote": "There is no mistaking a real book when one meets it. It is like falling in love."
  },
  {
    "author": "Émile Zola",
    "quote": "If you ask me what I came to do in this world, I, an artist, will answer you: I am here to live out loud."
  },
  {
    "author": "Rick Riordan,",
    "quote": "The real story of the Fleece: there were these two children of Zeus, Cadmus and Europa, okay? They were about to get offered up as human sacrifices, when they prayed to Zeus to save them. So Zeus sent this magical flying ram with golden wool, which picked them up in Greece and carried them all the way to Colchis in Asia Minor. Well, actually it carried Cadmus. Europa fell off and died along the way, but that's not important."
  },
  {
    "author": "Truman Capote",
    "quote": "Failure is the condiment that gives success its flavor."
  },
  {
    "author": "Nathaniel Hawthorne,",
    "quote": "A single dream is more powerful than a thousand realities."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "I regret that it takes a life to learn how to live."
  },
  {
    "author": "William Shakespeare,",
    "quote": "To be, or not to be: that is the question:"
  },
  {
    "author": "Suzanne Collins,",
    "quote": "And then he gives me a smile that just seems so genuinely sweet with just the right touch of shyness that unexpected warmth rushes through me."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "One can never have enough socks, said Dumbledore. Another Christmas has come and gone and I didn't get a single pair. People will insist on giving me books."
  },
  {
    "author": "A.A. Milne",
    "quote": "Sometimes,' said Pooh, 'the smallest things take up the most room in your heart."
  },
  {
    "author": "A.A. Milne,",
    "quote": "Rivers know this: there is no hurry. We shall get there some day."
  },
  {
    "author": "Robert Jordan",
    "quote": "Any fool knows men and women think differently at times, but the biggest difference is this. Men forget, but never forgive; women forgive, but never forget."
  },
  {
    "author": "Maurice Sendak",
    "quote": "A book is really like a lover. It arranges itself in your life in a way that is beautiful."
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "There is no exquisite beauty… without some strangeness in the proportion."
  },
  {
    "author": "Ayn Rand,",
    "quote": "If you don't know, the thing to do is not to get scared, but to learn."
  },
  {
    "author": "Mark Twain",
    "quote": "Everyone is a moon, and has a dark side which he never shows to anybody."
  },
  {
    "author": "Tina Fey,",
    "quote": "Some people say, Never let them see you cry. I say, if you’re so mad you could just cry, then cry. It terrifies everyone."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "And when at last you find someone to whom you feel you can pour out your soul, you stop in shock at the words you utter— they are so rusty, so ugly, so meaningless and feeble from being kept in the small cramped dark inside you so long."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "Before you, Bella, my life was like a moonless night. Very dark, but there were stars, points of light and reason. ...And then you shot across my sky like a meteor. Suddenly everything was on fire; there was brilliancy, there was beauty. When you were gone, when the meteor had fallen over the horizon, everything went black. Nothing had changed, but my eyes were blinded by the light. I couldn’t see the stars anymore. And there was no more reason, for anything."
  },
  {
    "author": "Simon and Garfunkel",
    "quote": "I've got nothing to do today but smile."
  },
  {
    "author": "Socrates",
    "quote": "I cannot teach anybody anything. I can only make them think"
  },
  {
    "author": "Oscar Wilde,",
    "quote": "All women become like their mothers. That is their tragedy. No man does, and that is his."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "America will never be destroyed from the outside. If we falter and lose our freedoms, it will be because we destroyed ourselves."
  },
  {
    "author": "Julian Barnes,",
    "quote": "Books say: She did this because. Life says: She did this. Books are where things are explained to you; life is where things aren't. I'm not surprised some people prefer books."
  },
  {
    "author": "Deborah Reber,",
    "quote": "Letting go doesn't mean that you don't care about someone anymore. It's just realizing that the only person you really have control over is yourself."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "She says nothing at all, but simply stares upward into the dark sky and watches, with sad eyes, the slow dance of the infinite stars."
  },
  {
    "author": "George Carlin",
    "quote": "That's why they call it the American Dream, because you have to be asleep to believe it."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "It's often just enough to be with someone. I don't need to touch them. Not even talk. A feeling passes between you both. You're not alone."
  },
  {
    "author": "Milan Kundera,",
    "quote": "Anyone whose goal is 'something higher' must expect someday to suffer vertigo. What is vertigo? Fear of falling? No, Vertigo is something other than fear of falling. It is the voice of the emptiness below us which tempts and lures us, it is the desire to fall, against which, terrified, we defend ourselves."
  },
  {
    "author": "Rumi",
    "quote": "When I am with you, we stay up all night."
  },
  {
    "author": "Marcus Aurelius,",
    "quote": "The happiness of your life depends upon the quality of your thoughts."
  },
  {
    "author": "Diana Gabaldon,",
    "quote": "I stood still, vision blurring, and in that moment, I heard my heart break. It was a small, clean sound, like the snapping of a flower's stem."
  },
  {
    "author": "Taylor Jenkins Reid,",
    "quote": "People think that intimacy is about sex. But intimacy is about truth. When you realize you can tell someone your truth, when you can show yourself to them, when you stand in front of them bare and their response is 'you're safe with me'- that's intimacy."
  },
  {
    "author": "William Arthur Ward",
    "quote": "The pessimist complains about the wind; the optimist expects it to change; the realist adjusts the sails."
  },
  {
    "author": "Charles Bukowski",
    "quote": "Some lose all mind and become soul,insane."
  },
  {
    "author": "Salvador Dali",
    "quote": "Have no fear of perfection - you'll never reach it."
  },
  {
    "author": "Lemony Snicket",
    "quote": "All the secrets of the world are contained in books. Read at your own risk."
  },
  {
    "author": "Isaac Asimov",
    "quote": "In life, unlike chess, the game continues after checkmate."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "The only way to get rid of temptation is to yield to it."
  },
  {
    "author": "Sun Tzu,",
    "quote": "Appear weak when you are strong, and strong when you are weak."
  },
  {
    "author": "Mark Twain",
    "quote": "Clothes make the man. Naked people have little or no influence on society."
  },
  {
    "author": "Franz Kafka",
    "quote": "Youth is happy because it has the capacity to see beauty. Anyone who keeps the ability to see beauty never grows old."
  },
  {
    "author": "Ray Bradbury",
    "quote": "We are cups, constantly and quietly being filled. The trick is, knowing how to tip ourselves over and let the beautiful stuff out."
  },
  {
    "author": "José N. Harris,",
    "quote": "Tears shed for another person are not a sign of weakness. They are a sign of a pure heart."
  },
  {
    "author": "Joss Whedon",
    "quote": "Remember to always be yourself. Unless you suck."
  },
  {
    "author": "Toni Morrison,",
    "quote": "You wanna fly, you got to give up the shit that weighs you down."
  },
  {
    "author": "Laurie Halse Anderson,",
    "quote": "When people don't express themselves, they die one piece at a time."
  },
  {
    "author": "T.H. White,",
    "quote": "The best thing for being sad, replied Merlin, beginning to puff and blow, is to learn something. That's the only thing that never fails. You may grow old and trembling in your anatomies, you may lie awake at night listening to the disorder of your veins, you may miss your only love, you may see the world about you devastated by evil lunatics, or know your honour trampled in the sewers of baser minds. There is only one thing for it then — to learn. Learn why the world wags and what wags it. That is the only thing which the mind can never exhaust, never alienate, never be tortured by, never fear or distrust, and never dream of regretting. Learning is the only thing for you. Look what a lot of things there are to learn."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I realize only one person will be damaged beyond repair if Peeta dies. Me."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "There are so many fragile things, after all. People break so easily, and so do dreams and hearts."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "The unreal is more powerful than the real. Because nothing is as perfect as you can imagine it. Because its only intangible ideas, concepts, beliefs, fantasies that last. Stone crumbles. Wood rots. People, well, they die. But things as fragile as a thought, a dream, a legend, they can go on and on. If you can change the way people think. The way they see themselves. The way they see the world. You can change the way people live their lives. That's the only lasting thing you can create."
  },
  {
    "author": "Lao Tzu",
    "quote": "A good traveler has no fixed plans and is not intent on arriving."
  },
  {
    "author": "Veronica Roth,",
    "quote": "I am selfish. I am brave."
  },
  {
    "author": "Margaret Mead",
    "quote": "Children must be taught how to think, not what to think."
  },
  {
    "author": "Lisa Schroeder",
    "quote": "Was it hard? I ask."
  },
  {
    "author": "Patrick Rothfuss,",
    "quote": "Perhaps the greatest faculty our minds possess is the ability to cope with pain. Classic thinking teaches us of the four doors of the mind, which everyone moves through according to their need."
  },
  {
    "author": "Anne Frank,",
    "quote": "I've found that there is always some beauty left -- in nature, sunshine, freedom, in yourself; these can all help you."
  },
  {
    "author": "Douglas Adams,",
    "quote": "A common mistake that people make when trying to design something completely foolproof is to underestimate the ingenuity of complete fools."
  },
  {
    "author": "Alice Walker",
    "quote": "The most common way people give up their power is by thinking they don't have any."
  },
  {
    "author": "Pablo Neruda",
    "quote": "You can cut all the flowers but you cannot keep Spring from coming."
  },
  {
    "author": "Markus Zusak,",
    "quote": "A DEFINITION NOT FOUND"
  },
  {
    "author": "Jorge Luis Borges",
    "quote": "I cannot sleep unless I am surrounded by books."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Dogs never bite me. Just humans."
  },
  {
    "author": "Kristin Cashore,",
    "quote": "I'm not going to wear a red dress, she said."
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "I have absolutely no pleasure in the stimulants in which I sometimes so madly indulge. It has not been in the pursuit of pleasure that I have periled life and reputation and reason. It has been the desperate attempt to escape from torturing memories, from a sense of insupportable loneliness and a dread of some strange impending doom."
  },
  {
    "author": "Carl Sagan,",
    "quote": "Every one of us is, in the cosmic perspective, precious. If a human disagrees with you, let him live. In a hundred billion galaxies, you will not find another."
  },
  {
    "author": "Thomas Mann,",
    "quote": "A writer is someone for whom writing is more difficult than it is for other people."
  },
  {
    "author": "Rick Riordan,",
    "quote": "It's funny how humans can wrap their mind around things and fit them into their version of reality."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It was, he thought, the difference between being dragged into the arena to face a battle to the death and walking into the arena with your head held high. Some people, perhaps, would say that there was little to choose between the two ways, but Dumbledore knew - and so do I, thought Harry, with a rush of fierce pride, and so did my parents - that there was all the difference in the world."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It is my belief... that the truth is generally preferable to lies."
  },
  {
    "author": "Washington Irving",
    "quote": "There is a sacredness in tears....They are the messengers of overwhelming grief, of deep contrition and of unspeakable love."
  },
  {
    "author": "Madonna",
    "quote": "I'm tough, I'm ambitious, and I know exactly what I want. If that makes me a bitch, okay."
  },
  {
    "author": "Harper Lee,",
    "quote": "I think there's just one kind of folks. Folks."
  },
  {
    "author": "Mark Twain,",
    "quote": "You can't depend on your eyes when your imagination is out of focus."
  },
  {
    "author": "John Green,",
    "quote": "Much of my life had been devoted to trying not to cry in front of people who loved me, so I knew what Augustus was doing. You clench your teeth. You look up. You tell yourself that if they see you cry, it will hurt them, and you will be nothing but a Sadness in their lives, and you must not become a mere sadness, so you will not cry, and you say all of this to yourself while looking up at the ceiling, and then you swallow even though your throat does not want to close and you look at the person who loves you and smile."
  },
  {
    "author": "Bill Watterson",
    "quote": "Sometimes when I'm talking, my words can't keep up with my thoughts. I wonder why we think faster than we speak. Probably so we can think twice."
  },
  {
    "author": "S.E. Hinton,",
    "quote": "Stay gold, Ponyboy. Stay gold . . . The pillow seemed to sink a little, and Johnny died."
  },
  {
    "author": "Winston S. Churchill",
    "quote": "Success is stumbling from failure to failure with no loss of enthusiasm."
  },
  {
    "author": "Lilith Saintcrow,",
    "quote": "Better to be strong than pretty and useless."
  },
  {
    "author": "Walt Whitman,",
    "quote": "Do I contradict myself?"
  },
  {
    "author": "C. JoyBell C.",
    "quote": "You will find that it is necessary to let things go; simply for the reason that they are heavy. So let them go, let go of them. I tie no weights to my ankles."
  },
  {
    "author": "أحمد خالد توفيق",
    "quote": "أتمنى أن أبكي و أرتجف , التصق بواحد من الكبار , لكن الحقيقة القاسية هي أنك الكبار! .. أنت من يجب أن يمنح القوة و الأمن للآخرين!"
  },
  {
    "author": "Jay McInerney,",
    "quote": "The capacity for friendship is God's way of apologizing for our families."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "I am trying here to prevent anyone saying the really foolish thing that people often say about Him: I’m ready to accept Jesus as a great moral teacher, but I don’t accept his claim to be God. That is the one thing we must not say. A man who was merely a man and said the sort of things Jesus said would not be a great moral teacher. He would either be a lunatic — on the level with the man who says he is a poached egg — or else he would be the Devil of Hell. You must make your choice. Either this man was, and is, the Son of God, or else a madman or something worse. You can shut him up for a fool, you can spit at him and kill him as a demon or you can fall at his feet and call him Lord and God, but let us not come with any patronizing nonsense about his being a great human teacher. He has not left that open to us. He did not intend to."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "I loved you like a man loves a woman he never touches, only writes to, keeps little photographs of."
  },
  {
    "author": "Mark Twain",
    "quote": "If you pick up a starving dog and make him prosperous he will not bite you. This is the principal difference between a dog and man."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Sometimes when I look at you, I feel I'm gazing at a distant star."
  },
  {
    "author": "Holly Black,",
    "quote": "If I cannot be better than them, I will become so much worse."
  },
  {
    "author": "Groucho Marx",
    "quote": "From the moment I picked up your book until I put it down, I was convulsed with laughter. Some day I intend reading it."
  },
  {
    "author": "Veronica Roth,",
    "quote": "We both have war inside us. Sometimes it keeps us alive. Sometimes it threatens to destroy us."
  },
  {
    "author": "John Muir",
    "quote": "The clearest way into the Universe is through a forest wilderness."
  },
  {
    "author": "Charles Bukowski",
    "quote": "Real loneliness is not necessarily limited to when you are alone."
  },
  {
    "author": "Kahlil Gibran",
    "quote": "Out of suffering have emerged the strongest souls; the most massive characters are seared with scars."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You endure what is unbearable, and you bear it. That is all."
  },
  {
    "author": "John Cheever",
    "quote": "I've been homesick for countries I've never been, and longed to be where I couldn't be."
  },
  {
    "author": "William Blake,",
    "quote": "A truth that's told with bad intent"
  },
  {
    "author": "Markus Zusak,",
    "quote": "Maybe everyone can live beyond what they're capable of."
  },
  {
    "author": "Saul Bellow",
    "quote": "People can lose their lives in libraries. They ought to be warned."
  },
  {
    "author": "Douglas Adams,",
    "quote": "A learning experience is one of those things that says, 'You know that thing you just did? Don't do that."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Behind every exquisite thing that existed, there was something tragic."
  },
  {
    "author": "Bob Marley",
    "quote": "Don't Gain The World & Lose Your Soul, Wisdom Is Better Than Silver Or Gold."
  },
  {
    "author": "Jane Austen",
    "quote": "Ah! There is nothing like staying at home, for real comfort."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "But who can say what's best? That's why you need to grab whatever chance you have of happiness where you find it, and not worry about other people too much. My experience tells me that we get no more than two or three such chances in a life time, and if we let them go, we regret it for the rest of our lives."
  },
  {
    "author": "Henry Miller",
    "quote": "The one thing we can never get enough of is love. And the one thing we never give enough of is love."
  },
  {
    "author": "Ralph Waldo Emerson,",
    "quote": "Is it so bad, then, to be misunderstood? Pythagoras was misunderstood, and Socrates, and Jesus, and Luther, and Copernicus, and Galileo, and Newton, and every pure and wise spirit that ever took flesh. To be great is to be misunderstood."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "It's like Tolstoy said. Happiness is an allegory, unhappiness a"
  },
  {
    "author": "J. D. Salinger,",
    "quote": "Anyway, I keep picturing all these little kids playing some game in this big field of rye and all. Thousands of little kids, and nobody's around - nobody big, I mean - except me. And I'm standing on the edge of some crazy cliff. What I have to do, I have to catch everybody if they start to go over the cliff - I mean if they're running and they don't look where they're going I have to come out from somewhere and catch them. That's all I do all day. I'd just be the catcher in the rye and all. I know it's crazy, but that's the only thing I'd really like to be."
  },
  {
    "author": "Ray Bradbury,",
    "quote": "Stuff your eyes with wonder, he said, live as if you'd drop dead in ten seconds. See the world. It's more fantastic than any dream made or paid for in factories."
  },
  {
    "author": "Jojo Moyes,",
    "quote": "You only get one life. It's actually your duty to live it as fully as possible."
  },
  {
    "author": "Mother Theresa",
    "quote": "Yesterday is gone. Tomorrow has not yet come. We have only today. Let us begin."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Of all the trees we could've hit, we had to get one that hits back."
  },
  {
    "author": "Jimi Hendrix",
    "quote": "Knowledge speaks, but wisdom listens"
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Our story has three parts: a beginning, a middle, and an end. And although this is the way all stories unfold, I still can't believe that ours didn't go on forever."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Cruelty does not make a person dishonest, the same way bravery does not make a person kind."
  },
  {
    "author": "Bob Marley",
    "quote": "Love the life you live."
  },
  {
    "author": "Douglas Adams,",
    "quote": "Would it save you a lot of time if I just gave up and went mad now?"
  },
  {
    "author": "Rumi",
    "quote": "Raise your words, not voice. It is rain that grows flowers, not thunder."
  },
  {
    "author": "Will Rogers",
    "quote": "Even if you are on the right track, you’ll get run over if you just sit there."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "You realize that our mistrust of the future makes it hard to give up the past."
  },
  {
    "author": "Thomas Jefferson",
    "quote": "Do you want to know who you are? Don't ask. Act! Action will delineate and define you."
  },
  {
    "author": "Anais Nin",
    "quote": "We do not grow absolutely, chronologically. We grow sometimes in one dimension, and not in another; unevenly. We grow partially. We are relative. We are mature in one realm, childish in another. The past, present, and future mingle and pull us backward, forward, or fix us in the present. We are made up of layers, cells, constellations."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "And he took her in his arms and kissed her under the sunlit sky, and he cared not that they stood high upon the walls in the sight of many."
  },
  {
    "author": "Douglas Adams,",
    "quote": "Let's think the unthinkable, let's do the undoable. Let us prepare to grapple with the ineffable itself, and see if we may not eff it after all."
  },
  {
    "author": "Dan Brown,",
    "quote": "Great minds are always feared by lesser minds."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "The only way that we can live, is if we grow. The only way that we can grow is if we change. The only way that we can change is if we learn. The only way we can learn is if we are exposed. And the only way that we can become exposed is if we throw ourselves out into the open. Do it. Throw yourself."
  },
  {
    "author": "Dan Brown,",
    "quote": "Science and religion are not at odds. Science is simply too young to understand."
  },
  {
    "author": "John Guare,",
    "quote": "It's amazing how a little tomorrow can make up for a whole lot of yesterday."
  },
  {
    "author": "Noël Coward,",
    "quote": "It's discouraging to think how many people are shocked by honesty and how few by deceit."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Don't tell me, Jace said, Simon's turned himself into an ocelot and you want me to do something about it before Isabelle makes him into a stole. Well, you'll have have to wait till tomorrow. I'm out of commission. He pointed at himself - he was wearing blue pajamas with a hole in the sleeve. Look. Jammies."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "I am too fond of reading books to care to write them."
  },
  {
    "author": "Benjamin Franklin,",
    "quote": "Three may keep a secret, if two of them are dead."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "My Best Friend is a person who will give me a book I have not read."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "The snake which cannot cast its skin has to die. As well the minds which are prevented from changing their opinions; they cease to be mind."
  },
  {
    "author": "Margaret Atwood",
    "quote": "Men are afraid that women will laugh at them. Women are afraid that men will kill them."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "I have come to accept the feeling of not knowing where I am going. And I have trained myself to love it. Because it is only when we are suspended in mid-air with no landing in sight, that we force our wings to unravel and alas begin our flight. And as we fly, we still may not know where we are going to. But the miracle is in the unfolding of the wings. You may not know where you're going, but you know that so long as you spread your wings, the winds will carry you."
  },
  {
    "author": "Victor Hugo,",
    "quote": "Music expresses that which cannot be said and on which it is impossible to be silent."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "A purpose of human life, no matter who is controlling it, is to love whoever is around to be loved."
  },
  {
    "author": "Murakami, Haruki",
    "quote": "Anyone who falls in love is searching for the missing pieces of themselves. So anyone who's in love gets sad when they think of their lover. It's like stepping back inside a room you have fond memories of, one you haven't seen in a long time."
  },
  {
    "author": "William Wordsworth,",
    "quote": "The best portion of a good man's life: his little, nameless unremembered acts of kindness and love."
  },
  {
    "author": "David Byrne",
    "quote": "Sometimes it's a form of love just to talk to somebody that you have nothing in common with and still be fascinated by their presence."
  },
  {
    "author": "Franz Kafka",
    "quote": "I think we ought to read only the kind of books that wound or stab us. If the book we're reading doesn't wake us up with a blow to the head, what are we reading for? So that it will make us happy, as you write? Good Lord, we would be happy precisely if we had no books, and the kind of books that make us happy are the kind we could write ourselves if we had to. But we need books that affect us like a disaster, that grieve us deeply, like the death of someone we loved more than ourselves, like being banished into forests far from everyone, like a suicide. A book must be the axe for the frozen sea within us. That is my belief."
  },
  {
    "author": "Dorothy Parker",
    "quote": "Beauty is only skin deep, but ugly goes clean to the bone."
  },
  {
    "author": "John Green,",
    "quote": "You gave me a forever within the numbered days, and I'm grateful."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "She seems so cool, so focused, so quiet, yet her eyes remain fixed upon the horizon. You think you know all there is to know about her immediately upon meeting her, but everything you think you know is wrong. Passion flows through her like a river of blood."
  },
  {
    "author": "Carl Gustav Jung",
    "quote": "Everything that irritates us about others can lead us to an understanding of ourselves."
  },
  {
    "author": "Chuck Klosterman,",
    "quote": "Art and love are the same thing: It’s the process of seeing yourself in things that are not you."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "Still round the corner there may wait"
  },
  {
    "author": "Oscar Wilde,",
    "quote": "There is only one thing in the world worse than being talked about, and that is not being talked about."
  },
  {
    "author": "Irina Dunn",
    "quote": "A woman without a man is like a fish without a bicycle."
  },
  {
    "author": "Jamie McGuire,",
    "quote": "I knew the second I met you"
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "It's possible to go on, no matter how impossible it seems, and that in time, the grief . . . lessens. It may not go away completely, but after a while it's not so overwhelming."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "being alone never felt right. sometimes it felt good, but it never felt right."
  },
  {
    "author": "W.G. Sebald,",
    "quote": "It is thanks to my evening reading alone that I am still more or less sane."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "You cannot pick and choose what parts of her to love."
  },
  {
    "author": "Tamora Pierce,",
    "quote": "Every now and then I like to do as I'm told, just to confuse people."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Winter is coming."
  },
  {
    "author": "Carlos Ruiz Zafon,",
    "quote": "Fools talk, cowards are silent, wise men listen."
  },
  {
    "author": "Hermann Hesse,",
    "quote": "If you hate a person, you hate something in him that is part of yourself. What isn't part of ourselves doesn't disturb us."
  },
  {
    "author": "John Steinbeck,",
    "quote": "I believe a strong woman may be stronger than a man, particularly if she happens to have love in her heart. I guess a loving woman is indestructible."
  },
  {
    "author": "Walt Whitman",
    "quote": "This is what you shall do; Love the earth and sun and the animals, despise riches, give alms to every one that asks, stand up for the stupid and crazy, devote your income and labor to others, hate tyrants, argue not concerning God, have patience and indulgence toward the people, take off your hat to nothing known or unknown or to any man or number of men, go freely with powerful uneducated persons and with the young and with the mothers of families, read these leaves in the open air every season of every year of your life, re-examine all you have been told at school or church or in any book, dismiss whatever insults your own soul, and your very flesh shall be a great poem and have the richest fluency not only in its words but in the silent lines of its lips and face and between the lashes of your eyes and in every motion and joint of your body."
  },
  {
    "author": "Anne Lamott",
    "quote": "Lighthouses don’t go running all over an island looking for boats to save; they just stand there shining."
  },
  {
    "author": "Joshua Slocum,",
    "quote": "I had already found that it was not good to be alone, and so made companionship with what there was around me, sometimes with the universe and sometimes with my own insignificant self; but my books were always my friends, let fail all else."
  },
  {
    "author": "David Levithan,",
    "quote": "I am constantly torn between killing myself and killing everyone around me."
  },
  {
    "author": "Patricia Highsmith",
    "quote": "My imagination functions much better when I don't have to speak to people."
  },
  {
    "author": "Golda Meir",
    "quote": "Don't be so humble - you are not that great."
  },
  {
    "author": "Charles Dickens,",
    "quote": "There are books of which the backs and covers are by far the best parts."
  },
  {
    "author": "Margaret Mead",
    "quote": "I was wise enough never to grow up, while fooling people into believing I had."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "If I had a world of my own, everything would be nonsense. Nothing would be what it is, because everything would be what it isn't. And contrary wise, what is, it wouldn't be. And what it wouldn't be, it would. You see?"
  },
  {
    "author": "Colleen Hoover,",
    "quote": "There is no such thing as bad people. We’re all just people who sometimes do bad things."
  },
  {
    "author": "L. Frank Baum",
    "quote": "Never give up... No one knows what's going to happen next."
  },
  {
    "author": "Jane Goodall",
    "quote": "What you do makes a difference, and you have to decide what kind of difference you want to make."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "I am looking for friends. What does that mean -- tame?"
  },
  {
    "author": "Mark Twain",
    "quote": "If you don't read the newspaper, you're uninformed. If you read the newspaper, you're mis-informed."
  },
  {
    "author": "George Carlin",
    "quote": "May the forces of evil become confused on the way to your house."
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "Respect was invented to cover the empty place where love should be."
  },
  {
    "author": "William Blake",
    "quote": "It is easier to forgive an enemy than to forgive a friend."
  },
  {
    "author": "Bette Midler",
    "quote": "The worst part of success is trying to find someone who is happy for you."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "He was my mum and dad's best friend. He's a convicted murderer, but he's broken out of wizard prison and he's on the run. He likes to keep in touch with me, though...keep up with my news...check if I'm happy..."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Today was good. Today was fun. Tomorrow is another one."
  },
  {
    "author": "William Golding,",
    "quote": "Maybe there is a beast… maybe it's only us."
  },
  {
    "author": "Stendhal,",
    "quote": "A good book is an event in my life."
  },
  {
    "author": "Karen Marie Moning,",
    "quote": "One day you will kiss a man you can't breathe without, and find that breath is of little consequence."
  },
  {
    "author": "Marcus Aurelius ,",
    "quote": "Everything we hear is an opinion, not a fact. Everything we see is a perspective, not the truth."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "When everyone knows you’re a monster, you needn’t waste time doing every monstrous thing."
  },
  {
    "author": "Louisa May Alcott,",
    "quote": "I like good strong words that mean something…"
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Yes, frosting. The final defense of the dying."
  },
  {
    "author": "Ursula K. Le Guin,",
    "quote": "People who deny the existence of dragons are often eaten by dragons. From within."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "I meant, said Ipslore bitterly, what is there in this world that truly makes living worthwhile?"
  },
  {
    "author": "غسان كنفاني",
    "quote": "!لك شيء في هذا العالم.. فقم"
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Peeta, you said at the interview you’d had a crush on me forever. When did forever start?"
  },
  {
    "author": "L.M. Montgomery,",
    "quote": "Kindred spirits are not so scarce as I used to think. It's splendid to find out there are so many of them in the world."
  },
  {
    "author": "John Steinbeck,",
    "quote": "There ain't no sin and there ain't no virtue. There's just stuff people do."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "If I'd observed all the rules I'd never have got anywhere."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "What are all these? Clary asked."
  },
  {
    "author": "A.A. Milne",
    "quote": "Promise me you'll never forget me because if I thought you would, I'd never leave."
  },
  {
    "author": "John Lennon",
    "quote": "A dream you dream alone is only a dream. A dream you dream together is reality."
  },
  {
    "author": "Dr. Seuss",
    "quote": "If things start happening, don't worry, don't stew, just go right along and you'll start happening too."
  },
  {
    "author": "Terry Pratchett",
    "quote": "Wisdom comes from experience. Experience is often a result of lack of wisdom."
  },
  {
    "author": "Alan Watts",
    "quote": "Trying to define yourself is like trying to bite your own teeth."
  },
  {
    "author": "Jodi Picoult",
    "quote": "Once you had put the pieces back together, even though you may look intact, you were never quite the same as you'd been before the fall."
  },
  {
    "author": "Louisa May Alcott,",
    "quote": "I am not afraid of storms, for I am learning how to sail my ship."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "let me live, love, and say it well in good sentences"
  },
  {
    "author": "Douglas Adams,",
    "quote": "Isn't it enough to see that a garden is beautiful without having to believe that there are fairies at the bottom of it too?"
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "Make your own Bible. Select and collect all the words and sentences that in all your readings have been to you like the blast of a trumpet."
  },
  {
    "author": "John Green,",
    "quote": "Did you know that for pretty much the entire history of the human species, the average life span was less than thirty years? You could count on ten years or so of real adulthood, right? There was no planning for retirement, There was no planning for a career. There was no planning. No time for plannning. No time for a future. But then the life spans started getting longer, and people started having more and more future. And now life has become the future. Every moment of your life is lived for the future--you go to high school so you can go to college so you can get a good job so you can get a nice house so you can afford to send your kids to college so they can get a good job so they can get a nice house so they can afford to send their kids to college."
  },
  {
    "author": "Nick Hornby,",
    "quote": "People worry about kids playing with guns, and teenagers watching violent videos; we are scared that some sort of culture of violence will take them over. Nobody worries about kids listening to thousands - literally thousands - of songs about broken hearts and rejection and pain and misery and loss."
  },
  {
    "author": "Jay Asher,",
    "quote": "No one knows for certain how much impact they have on the lives of other people. Oftentimes, we have no clue. Yet we push it just the same."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "I fell in love with you, smartass, because you were one of us—because you weren’t afraid of me, and you decided to end your spectacular victory by throwing that piece of bone at Amarantha like a javelin. I felt Cassian’s spirit beside me in that moment, and could have sworn I heard him say, ‘If you don’t marry her, you stupid prick, I will."
  },
  {
    "author": "Joseph Heller,",
    "quote": "He was going to live forever, or die in the attempt."
  },
  {
    "author": "Dylan Thomas,",
    "quote": "Do not go gentle into that good night."
  },
  {
    "author": "Sara Henderson",
    "quote": "Don't wait for a light to appear at the end of the tunnel, stride down there and light the bloody thing yourself."
  },
  {
    "author": "C.S. Lewis",
    "quote": "Pain insists upon being attended to. God whispers to us in our pleasures, speaks in our consciences, but shouts in our pains. It is his megaphone to rouse a deaf world."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "I'm not sentimental--I'm as romantic as you are. The idea, you know,"
  },
  {
    "author": "Albert Einstein",
    "quote": "Creativity is intelligence having fun."
  },
  {
    "author": "Albert Einstein",
    "quote": "The world is a dangerous place to live, not because of the people who are evil, but because of the people who don't do anything about it."
  },
  {
    "author": "Gandhi",
    "quote": "Your beliefs become your thoughts,"
  },
  {
    "author": "Oscar Wilde,",
    "quote": "To love oneself is the beginning of a lifelong romance."
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "I'm oxygen and he's dying to breathe."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "Yes, I was infatuated with you: I am still. No one has ever heightened such a keen capacity of physical sensation in me. I cut you out because I couldn't stand being a passing fancy. Before I give my body, I must give my thoughts, my mind, my dreams. And you weren't having any of those."
  },
  {
    "author": "Neil Gaiman",
    "quote": "Most books on witchcraft will tell you that witches work naked. This is because most books on witchcraft were written by men."
  },
  {
    "author": "Sharon Salzberg",
    "quote": "You yourself, as much as anybody in the entire universe, deserve your love and affection."
  },
  {
    "author": "William Shakespeare,",
    "quote": "My tongue will tell the anger of my heart, or else my heart concealing it will break."
  },
  {
    "author": "Becca Fitzpatrick,",
    "quote": "You possess other people's...bodies."
  },
  {
    "author": "Confucius",
    "quote": "It does not matter how slowly you go as long as you do not stop."
  },
  {
    "author": "Markus Zusak,",
    "quote": "She leaned down and looked at his lifeless face and Leisel kissed her best friend, Rudy Steiner, soft and true on his lips. He tasted dusty and sweet. He tasted like regret in the shadows of trees and in the glow of the anarchist's suit collection. She kissed him long and soft, and when she pulled herself away, she touched his mouth with her fingers...She did not say goodbye. She was incapable, and after a few more minutes at his side, she was able to tear herself from the ground. It amazes me what humans can do, even when streams are flowing down their faces and they stagger on..."
  },
  {
    "author": "Eric Roth,",
    "quote": "For what it’s worth: it’s never too late or, in my case, too early to be whoever you want to be. There’s no time limit, stop whenever you want. You can change or stay the same, there are no rules to this thing. We can make the best or the worst of it. I hope you make the best of it. And I hope you see things that startle you. I hope you feel things you never felt before. I hope you meet people with a different point of view. I hope you live a life you’re proud of. If you find that you’re not, I hope you have the courage to start all over again."
  },
  {
    "author": "e.e. cummings,",
    "quote": "For whatever we lose (like a you or a me),"
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "And I asked myself about the present: how wide it was, how deep it was, how much was mine to keep."
  },
  {
    "author": "Edward Albee",
    "quote": "You're alive only once, as far as we know, and what could be worse than getting to the end of your life and realizing you hadn't lived it?"
  },
  {
    "author": "Sylvia Plath,",
    "quote": "If neurotic is wanting two mutually exclusive things at one and the same time, then I'm neurotic as hell. I'll be flying back and forth between one mutually exclusive thing and another for the rest of my days."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "No matter what he does, every person on earth plays a central role in the history of the world. And normally he doesn't know it."
  },
  {
    "author": "Lewis Carroll ,",
    "quote": "Who in the world am I? Ah, that's the great puzzle."
  },
  {
    "author": "Madeline Miller,",
    "quote": "When he died, all things soft and beautiful and bright would be buried with him."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "In the beginning there was nothing, which exploded."
  },
  {
    "author": "John Green,",
    "quote": "I didn’t need you, you idiot. I picked you. And then you picked me back."
  },
  {
    "author": "Dalai Lama XIV",
    "quote": "Love is the absence of judgment."
  },
  {
    "author": "Mawlana Jalal-al-Din Rumi",
    "quote": "My soul is from elsewhere, I'm sure of that, and I intend to end up there."
  },
  {
    "author": "Isabel Allende",
    "quote": "The library is inhabited by spirits that come out of the pages at night."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "Light thinks it travels faster than anything but it is wrong. No matter how fast light travels, it finds the darkness has always got there first, and is waiting for it."
  },
  {
    "author": "George Carlin",
    "quote": "Never underestimate the power of stupid people in large groups."
  },
  {
    "author": "J. K. Rowling,",
    "quote": "There are some things you can't share without ending up liking each other, and knocking out a twelve-foot mountain troll is one of them."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "It is absurd to divide people into good and bad. People are either charming or tedious."
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "Believe nothing you hear, and only one half that you see."
  },
  {
    "author": "Gilda Radner",
    "quote": "I wanted a perfect ending. Now I've learned, the hard way, that some poems don't rhyme, and some stories don't have a clear beginning, middle, and end."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "I knew, in the silence that followed, that anything could happen here. It might be too late: again, I might have missed my chance. But I would at least know I tried, that I took my heart and extended my hand, whatever the outcome."
  },
  {
    "author": "Rick Riordan,",
    "quote": "In a way, it's nice to know that there are Greek gods out there, because you have somebody to blame when things go wrong. For instance, when you're walking away from a bus that's just been attacked by monster hags and blown up by lightning, and it's raining on top of everything else, most people might think that's just really bad luck; when you're a half-blood, you understand that some devine force is really trying to mess up your day."
  },
  {
    "author": "Veronica Roth,",
    "quote": "You think my first instinct is to protect you. Because you're small, or a girl, or a Stiff. But you're wrong."
  },
  {
    "author": "Caitlyn Siehl,",
    "quote": "Do not fall in love with people like me."
  },
  {
    "author": "W.B. Yeats",
    "quote": "The world is full of magic things, patiently waiting for our senses to grow sharper."
  },
  {
    "author": "Alan Moore,",
    "quote": "People shouldn't be afraid of their government. Governments should be afraid of their people."
  },
  {
    "author": "Cassandra Clare",
    "quote": "So when the moon's only partly full, you only feel a little wolfy?"
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "People have forgotten this truth, the fox said. But you mustn’t forget it. You become responsible forever for what you’ve tamed. You’re responsible for your rose."
  },
  {
    "author": "John Lennon",
    "quote": "One thing you can't hide - is when you're crippled inside."
  },
  {
    "author": "Anne Bronte",
    "quote": "But he who dares not grasp the thorn"
  },
  {
    "author": "Shmuley Boteach",
    "quote": "There is greatness in doing something you hate for the sake of someone you love."
  },
  {
    "author": "Laurie Halse Anderson,",
    "quote": "You have to know what you stand for, not just what you stand against."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Success makes so many people hate you. I wish it wasn't that way. It would be wonderful to enjoy success without seeing envy in the eyes of those around you."
  },
  {
    "author": "Paulo Coelho",
    "quote": "We can never judge the lives of others, because each person knows only their own pain and renunciation. It's one thing to feel that you are on the right path, but it's another to think that yours is the only path."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Then I realize what it is. It's him. Something about him makes me feel like I am about to fall. Or turn to liquid. Or burst into flames."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "She was the heir of ash and fire, and she would bow to no one."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Keep smiling, because life is a beautiful thing and there's so much to smile about."
  },
  {
    "author": "Mark Twain",
    "quote": "Always do what is right. It will gratify half of mankind and astound the other."
  },
  {
    "author": "T.S. Eliot",
    "quote": "Only those who will risk going too far can possibly find out how far one can go."
  },
  {
    "author": "George R.R. Martin",
    "quote": "The best fantasy is written in the language of dreams. It is alive as dreams are alive, more real than real ... for a moment at least ... that long magic moment before we wake."
  },
  {
    "author": "Kazuo Ishiguro",
    "quote": "There was another life that I might have had, but I am having this one."
  },
  {
    "author": "Guy de Maupassant",
    "quote": "Our memory is a more perfect world than the universe: it gives back life to those who no longer exist."
  },
  {
    "author": "Margaret Lee Runbeck",
    "quote": "Silence make the real conversations between friends. Not the saying, but the never needing to say that counts."
  },
  {
    "author": "Audrey Hepburn",
    "quote": "The beauty of a woman is not in the clothes she wears, the figure that she carries, or the way she combs her hair. The beauty of a woman is seen in her eyes, because that is the doorway to her heart, the place where love resides. True beauty in a woman is reflected in her soul. It's the caring that she lovingly gives, the passion that she shows & the beauty of a woman only grows with passing years."
  },
  {
    "author": "Plato",
    "quote": "Only the dead have seen the end of war."
  },
  {
    "author": "Ray Bradbury,",
    "quote": "Everyone must leave something behind when he dies, my grandfather said. A child or a book or a painting or a house or a wall built or a pair of shoes made. Or a garden planted. Something your hand touched some way so your soul has somewhere to go when you die, and when people look at that tree or that flower you planted, you're there."
  },
  {
    "author": "J.K. Rowling ,",
    "quote": "Youth can not know how age thinks and feels. But old men are guilty if they forget what it was to be young."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "When I had nothing to lose, I had everything. When I stopped being who I am, I found myself."
  },
  {
    "author": "Thomas Merton ,",
    "quote": "Art enables us to find ourselves and lose ourselves at the same time."
  },
  {
    "author": "Benjamin Franklin",
    "quote": "Tell me and I forget, teach me and I may remember, involve me and I learn."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "I wonder if the snow"
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "We can know only that we know nothing. And that is the highest degree of human wisdom."
  },
  {
    "author": "Maxine Hong Kingston",
    "quote": "In a time of destruction, create something."
  },
  {
    "author": "Arthur Schopenhauer",
    "quote": "Compassion is the basis of morality."
  },
  {
    "author": "Jeaniene Frost,",
    "quote": "I'm saying that I'm a moody, insecure, narrow-minded, jealous, borderline homicidal bitch, and I want you to promise me that you're okay with that, because it's who I am, and you're what I need."
  },
  {
    "author": "Becca Fitzpatrick,",
    "quote": "Keep in mind that people change, but the past doesn't."
  },
  {
    "author": "Veronica Roth,",
    "quote": "I suppose a fire that burns that bright is not meant to last."
  },
  {
    "author": "George Orwell,",
    "quote": "The creatures outside looked from pig to man, and from man to pig, and from pig to man again; but already it was impossible to say which was which."
  },
  {
    "author": "Benjamin Franklin,",
    "quote": "They who can give up essential liberty to obtain a little temporary safety deserve neither liberty nor safety."
  },
  {
    "author": "Douglas Adams,",
    "quote": "The ships hung in the sky in much the same way that bricks don't."
  },
  {
    "author": "Sherrilyn Kenyon,",
    "quote": "Life isn't finding shelter in the storm. It's about learning to dance in the rain."
  },
  {
    "author": "Milan Kundera,",
    "quote": "When the heart speaks, the mind finds it indecent to object."
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "The moon is a loyal companion."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "I am glad you are here with me. Here at the end of all things, Sam."
  },
  {
    "author": "Paulo Coelho",
    "quote": "A child can teach an adult three things: to be happy for no reason, to always be busy with something, and to know how to demand with all his might that which he desires."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Never forget what you are, for surely the world will not. Make it your strength. Then it can never be your weakness."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Your friend's poetry is terrible, he said."
  },
  {
    "author": "C. S. Lewis",
    "quote": "I have learned now that while those who speak about one's miseries usually hurt, those who keep silence hurt more."
  },
  {
    "author": "Mawlana Jalal-al-Din Rumi",
    "quote": "I want to see you."
  },
  {
    "author": "مصطفى محمود,",
    "quote": "و كلما أمسكت بحالة من حالاتي و قلت هذا هو أنا .. ما تلبث هذه الحالة أن تفلت من أصابعي و تحل محلها حالة أخرى .. هي أنا .. أيضاً.."
  },
  {
    "author": "Barbara W. Tuchman",
    "quote": "Books are the carriers of civilization...They are companions, teachers, magicians, bankers of the treasures of the mind. Books are humanity in print."
  },
  {
    "author": "Confucious",
    "quote": "Everything has beauty, but not everyone sees it."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "You should never be surprised when someone treats you with respect, you should expect it."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "Don't feel bad for one moment about doing what brings you joy."
  },
  {
    "author": "Mother Teresa",
    "quote": "Every time you smile at someone, it is an action of love, a gift to that person, a beautiful thing."
  },
  {
    "author": "Oprah Winfrey",
    "quote": "You can have it all. Just not all at once."
  },
  {
    "author": "Coco Chanel,",
    "quote": "A girl should be two things: who and what she wants."
  },
  {
    "author": "William Shakespeare,",
    "quote": "My bounty is as boundless as the sea,"
  },
  {
    "author": "Terry Pratchett,",
    "quote": "DON'T THINK OF IT AS DYING, said Death. JUST THINK OF IT AS LEAVING EARLY TO AVOID THE RUSH."
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "Books are easily destroyed. But words will live as long as people can remember them."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "We didn't talk about anything heavy or light. We were just there together. And that was enough"
  },
  {
    "author": "Napoleon Bonaparte",
    "quote": "Never interrupt your enemy when he is making a mistake."
  },
  {
    "author": "أحلام مستغانمي,",
    "quote": "أحسد الأطفال الرضّع، لأنهم يملكون وحدهم حق الصراخ والقدرة عليه، قبل أن تروض الحياة حبالهم الصوتية، وتعلِّمهم الصمت"
  },
  {
    "author": "Eoin Colfer,",
    "quote": "Confidence is ignorance. If you're feeling cocky, it's because there's something you don't know."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Must you go? I was rather hoping you'd stay and be a ministering angel, but if you must go, you must."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I'll just have them change the entry in the demonology textbook from 'almost extinct' to 'not extinct enough for Alec. He prefers his monsters really, really extinct.' Will that make you happy?"
  },
  {
    "author": "Eleanor Roosevelt",
    "quote": "The purpose of life is to live it, to taste experience to the utmost, to reach out eagerly and without fear for newer and richer experience."
  },
  {
    "author": "Mark Twain",
    "quote": "Courage is resistance to fear, mastery of fear - not absence of fear."
  },
  {
    "author": "Pablo Neruda",
    "quote": "Sonnet XVII"
  },
  {
    "author": "David Mitchell,",
    "quote": "A half-read book is a half-finished love affair."
  },
  {
    "author": "Roald Dahl",
    "quote": "So please, oh please, we beg, we pray, go throw your TV set away, and in its place you can install, a lovely bookshelf on the wall."
  },
  {
    "author": "Zig Ziglar",
    "quote": "Lack of direction, not lack of time, is the problem. We all have twenty-four hour days."
  },
  {
    "author": "Sylvia Plath",
    "quote": "Remember, remember, this is now, and now, and now. Live it, feel it, cling to it. I want to become acutely aware of all I’ve taken for granted."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Nothing in the world is ever completely wrong. Even a stopped clock is right twice a day."
  },
  {
    "author": "Lao Tsu,",
    "quote": "Those who know do not speak. Those who speak do not know."
  },
  {
    "author": "Susan Sontag,",
    "quote": "My library is an archive of longings."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "It's all in the view. That's what I mean about forever, too. For any one of us our forever could end in an hour, or a hundred years from now. You never know for sure, so you'd better make every second count."
  },
  {
    "author": "Patrick Rothfuss,",
    "quote": "It's the questions we can't answer that teach us the most. They teach us how to think. If you give a man an answer, all he gains is a little fact. But give him a question and he'll look for his own answers."
  },
  {
    "author": "Nicholas Sparks",
    "quote": "I don't know that love changes. People change. Circumstances change."
  },
  {
    "author": "Henry Miller,",
    "quote": "A book lying idle on a shelf is wasted ammunition."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Where there is love, there is often also hate. They can exist side by side."
  },
  {
    "author": "Benjamin Alire Sáenz,",
    "quote": "I bet you could sometimes find all the mysteries of the universe in someone's hand."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Quotation is a serviceable substitute for wit."
  },
  {
    "author": "Charles Bukowski",
    "quote": "I will remember the kisses"
  },
  {
    "author": "Charles M. Schulz",
    "quote": "What's the good of living if you don't try a few things?"
  },
  {
    "author": "Charles Dickens",
    "quote": "Have a heart that never hardens, and a temper that never tires, and a touch that never hurts."
  },
  {
    "author": "Ayn Rand",
    "quote": "Learn to value yourself, which means: fight for your happiness."
  },
  {
    "author": "Rumi",
    "quote": "silence is the language of god,"
  },
  {
    "author": "Lady Gaga",
    "quote": "Trust is like a mirror, you can fix it if it's broken, but you can still see the crack in that mother fucker's reflection."
  },
  {
    "author": "Jay Asher,",
    "quote": "A lot of you cared, just not enough."
  },
  {
    "author": "George Orwell,",
    "quote": "If you want to keep a secret, you must also hide it from yourself."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "When you find your path, you must not be afraid. You need to have sufficient courage to make mistakes. Disappointment, defeat, and despair are the tools God uses to show us the way."
  },
  {
    "author": "Barack Obama",
    "quote": "Change will not come if we wait for some other person, or if we wait for some other time. We are the ones we've been waiting for. We are the change that we seek."
  },
  {
    "author": "Khaled Hosseini,",
    "quote": "There is only one sin. and that is theft... when you tell a lie, you steal someones right to the truth."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Even strength must bow to wisdom sometimes."
  },
  {
    "author": "J.M. Barrie,",
    "quote": "Dreams do come true, if only we wish hard enough. You can have anything in life if you will sacrifice everything else for it."
  },
  {
    "author": "Jennifer L. Armentrout,",
    "quote": "Beautiful face. Beautiful body. Horrible attitude. It was the holy trinity of hot boys."
  },
  {
    "author": "Winston Churchill",
    "quote": "Tact is the ability to tell someone to go to hell in such a way that they look forward to the trip."
  },
  {
    "author": "Rainer Maria Rilke,",
    "quote": "We need, in love, to practice only this: letting each other go. For holding on comes easily; we do not need to learn it."
  },
  {
    "author": "A.J. Cronin",
    "quote": "Worry never robs tomorrow of its sorrow, but only saps today of its strength."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Happiness can be found, even in the darkest of times, if one only remembers to turn on the light."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "That's why when major badasses greet each other in movies, they don't say anything, they just nod. The nod means, 'I' am a badass, and I recognize that you, too, are a badass,' but they don't say anything because they're Wolverine and Magneto and it would mess up their vibe to explain."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "The glory of friendship is not the outstretched hand, not the kindly smile, nor the joy of companionship; it is the spiritual inspiration that comes to one when you discover that someone else believes in you and is willing to trust you with a friendship."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Go on with what your heart tells you, or you will lose all."
  },
  {
    "author": "George Gordon Byron",
    "quote": "And thus the heart will break, yet brokenly live on."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "When I get lonely these days, I think: So BE lonely, Liz. Learn your way around loneliness. Make a map of it. Sit with it, for once in your life. Welcome to the human experience. But never again use another person's body or emotions as a scratching post for your own unfulfilled yearnings."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Politeness is deception in pretty packaging."
  },
  {
    "author": "Herbert Hoover",
    "quote": "Older men declare war. But it is youth that must fight and die."
  },
  {
    "author": "Frank Zappa",
    "quote": "If you end up with a boring miserable life because you listened to your mom, your dad, your teacher, your priest, or some guy on television telling you how to do your shit, then you deserve it."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Children begin by loving their parents; as they grow older they judge them; sometimes they forgive them."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "All alone! Whether you like it or not, alone is something you'll be quite a lot!"
  },
  {
    "author": "Jim Morrison",
    "quote": "Expose yourself to your deepest fear; after that, fear has no power, and the fear of freedom shrinks and vanishes. You are free."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Without suffering, there'd be no compassion."
  },
  {
    "author": "Markus Zusak,",
    "quote": "A snowball in the face is surely the perfect beginning to a lasting friendship."
  },
  {
    "author": "John Green,",
    "quote": "But it is the nature of stars to cross, and never was Shakespeare more wrong than when he has Cassius note, ‘The fault, dear Brutus, is not in our stars / But in ourselves."
  },
  {
    "author": "Audrey Hepburn",
    "quote": "There is more to sex appeal than just measurements. I don't need a bedroom to prove my womanliness. I can convey just as much sex appeal, picking apples off a tree or standing in the rain."
  },
  {
    "author": "Vladimir Nabokov,",
    "quote": "Lolita, light of my life, fire of my loins. My sin, my soul. Lo-lee-ta: the tip of the tongue taking a trip of three steps down the palate to tap, at three, on the teeth. Lo. Lee. Ta. She was Lo, plain Lo, in the morning, standing four feet ten in one sock. She was Lola in slacks. She was Dolly at school. She was Dolores on the dotted line. But in my arms she was always Lolita. Did she have a precursor? She did, indeed she did. In point of fact, there might have been no Lolita at all had I not loved, one summer, an initial girl-child. In a princedom by the sea. Oh when? About as many years before Lolita was born as my age was that summer. You can always count on a murderer for a fancy prose style. Ladies and gentlemen of the jury, exhibit number one is what the seraphs, the misinformed, simple, noble-winged seraphs, envied. Look at this tangle of thorns."
  },
  {
    "author": "Rick Riordan",
    "quote": "Dreams like a podcast,"
  },
  {
    "author": "Christopher Hitchens,",
    "quote": "Owners of dogs will have noticed that, if you provide them with food and water and shelter and affection, they will think you are god. Whereas owners of cats are compelled to realize that, if you provide them with food and water and shelter and affection, they draw the conclusion that"
  },
  {
    "author": "Hanya Yanagihara,",
    "quote": "You won’t understand what I mean now, but someday you will: the only trick of friendship, I think, is to find people who are better than you are—not smarter, not cooler, but kinder, and more generous, and more forgiving—and then to appreciate them for what they can teach you, and to try to listen to them when they tell you something about yourself, no matter how bad—or good—it might be, and to trust them, which is the hardest thing of all. But the best, as well."
  },
  {
    "author": "Madeline Miller,",
    "quote": "I am made of memories."
  },
  {
    "author": "Joseph Heller,",
    "quote": "Just because you're paranoid doesn't mean they aren't after you."
  },
  {
    "author": "Jay Asher,",
    "quote": "You can't stop the future"
  },
  {
    "author": "Dorothy Parker",
    "quote": "If you want to know what God thinks of money, just look at the people he gave it to."
  },
  {
    "author": "Sarah   Williams,",
    "quote": "Though my soul may set in darkness, it will rise in perfect light;"
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "The saddest people I've ever met in life are the ones who don't care deeply about anything at all. Passion and satisfaction go hand in hand, and without them, any happiness is only temporary, because there's nothing to make it last."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "When I was a child, adults would tell me not to make things up, warning me of what would happen if I did. As far as I can tell so far, it seems to involve lots of foreign travel and not having to get up too early in the morning."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I desire the things that will destroy me in the end."
  },
  {
    "author": "C.S. Lewis",
    "quote": "Atheism turns out to be too simple. If the whole universe has no meaning, we should never have found out that it has no meaning..."
  },
  {
    "author": "E.L. James,",
    "quote": "- Why don't you like to be touched?"
  },
  {
    "author": "Steve Maraboli,",
    "quote": "If people refuse to look at you in a new light and they can only see you for what you were, only see you for the mistakes you've made, if they don't realize that you are not your mistakes, then they have to go."
  },
  {
    "author": "Galway Kinnell",
    "quote": "Let our scars fall in love."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "It wouldn't be my move, Jace agreed. First the candy and flowers, then the apology letters, then the ravenous demon hordes. In that order."
  },
  {
    "author": "Nicholas Sparks",
    "quote": "If conversation was the lyrics, laughter was the music, making time spent together a melody that could be replayed over and over without getting stale."
  },
  {
    "author": "Mark Twain",
    "quote": "Kindness is a language which the deaf can hear and the blind can see."
  },
  {
    "author": "François de La Rochefoucauld",
    "quote": "No persons are more frequently wrong, than those who will not admit they are wrong."
  },
  {
    "author": "Carlos Ruiz Zafón,",
    "quote": "Every book, every volume you see here, has a soul. The soul of the person who wrote it and of those who read it and lived and dreamed with it. Every time a book changes hands, every time someone runs his eyes down its pages, its spirit grows and strengthens."
  },
  {
    "author": "C.S. Lewis",
    "quote": "God can't give us peace and happiness apart from Himself because there is no such thing."
  },
  {
    "author": "H. P. Lovecraft",
    "quote": "The world is indeed comic, but the joke is on mankind."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I want to grow old without facelifts. I want to have the courage to be loyal to the face I have made."
  },
  {
    "author": "William Wordsworth",
    "quote": "Fill your paper with the breathings of your heart."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Lost opportunities, lost possibilities, feelings we can never get back. That's part of what it means to be alive. But inside our heads - at least that's where I imagine it - there's a little room where we store those memories. A room like the stacks in this library. And to understand the workings of our own heart we have to keep on making new reference cards. We have to dust things off every once in awhile, let in fresh air, change the water in the flower vases. In other words, you'll live forever in your own private library."
  },
  {
    "author": "D.H. Lawrence,",
    "quote": "We've got to live, no matter how many skies have fallen."
  },
  {
    "author": "Christopher Hitchens",
    "quote": "That which can be asserted without evidence, can be dismissed without evidence."
  },
  {
    "author": "Robert Ingersoll",
    "quote": "If you want to find out what a man is to the bottom, give him power. Any man can stand adversity — only a great man can stand prosperity. It is the glory of Abraham Lincoln that he never abused power only on the side of mercy"
  },
  {
    "author": "Coco Chanel",
    "quote": "Don't spend time beating on a wall, hoping to transform it into a door."
  },
  {
    "author": "Cynthia Ozick",
    "quote": "We take for granted the very things that most deserve our gratitude."
  },
  {
    "author": "Lev Grossman,",
    "quote": "If there's a single lesson that life teaches us, it's that wishing doesn't make it so."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Time doesn’t heal emotional pain, you need to learn how to let go."
  },
  {
    "author": "Jane Austen,",
    "quote": "I must learn to be content with being happier than I deserve."
  },
  {
    "author": "Edna St. Vincent Millay",
    "quote": "I know I am but summer to your heart, and not the full four seasons of the year."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Honestly, if you were any slower, you’d be going backward."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Families are messy. Immortal families are eternally messy. Sometimes the best we can do is to remind each other that we're related for better or for worse...and try to keep the maiming and killing to a minimum."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "When you spend so long trapped in darkness, Lucien, you find that the darkness begins to stare back."
  },
  {
    "author": "C.S. Lewis",
    "quote": "It is a good rule after reading a new book, never to allow yourself another new one till you have read an old one in between."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "Here is a lesson in creative writing. First rule: Do not use semicolons. They are transvestite hermaphrodites representing absolutely nothing. All they do is show you've been to college."
  },
  {
    "author": "Emily Brontë,",
    "quote": "I wish I were a girl again, half-savage and hardy, and free."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "In individuals, insanity is rare; but in groups, parties, nations and epochs, it is the rule."
  },
  {
    "author": "Steve Maraboli",
    "quote": "Cry. Forgive. Learn. Move on. Let your tears water the seeds of your future happiness."
  },
  {
    "author": "Robert Orben",
    "quote": "Illegal aliens have always been a problem in the United States. Ask any Indian."
  },
  {
    "author": "Francois Mauriac",
    "quote": "If you would tell me the heart of a man, tell me not what he reads, but what he rereads."
  },
  {
    "author": "Barbara Kingsolver,",
    "quote": "Don’t try to make life a mathematics problem with yourself in the center and everything coming out equal. When you’re good, bad things can still happen. And if you’re bad, you can still be lucky."
  },
  {
    "author": "Veronica Roth,",
    "quote": "I fell in love with him. But I don't just stay with him by default as if there's no one else available to me. I stay with him because I choose to, every day that I wake up, every day that we fight or lie to each other or disappoint each other. I choose him over and over again, and he chooses me."
  },
  {
    "author": "David Levithan,",
    "quote": "It was a mistake, you said. But the cruel thing was, it felt like the mistake was mine, for trusting you."
  },
  {
    "author": "Umberto Eco,",
    "quote": "Books are not made to be believed, but to be subjected to inquiry. When we consider a book, we mustn't ask ourselves what it says but what it means..."
  },
  {
    "author": "Mark Twain",
    "quote": "The trouble is not in dying for a friend, but in finding a friend worth dying for."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Are you implying that shreds of my reputation remain intact? Will demanded with mock horror. Clearly I have been doing something wrong. Or not something wrong, as the case may be."
  },
  {
    "author": "Margaret Atwood",
    "quote": "A word after a word after a word is power."
  },
  {
    "author": "Aldous Huxley",
    "quote": "You shall know the truth and the truth shall make you mad."
  },
  {
    "author": "Hemingway, Ernest",
    "quote": "I drink to make other people more interesting."
  },
  {
    "author": "Victoria Aveyard,",
    "quote": "The truth is what I make it. I could set this world on fire and call it rain."
  },
  {
    "author": "Charlotte Brontë,",
    "quote": "I do not think, sir, you have any right to command me, merely because you are older than I, or because you have seen more of the world than I have; your claim to superiority depends on the use you have made of your time and experience."
  },
  {
    "author": "Kate DiCamillo,",
    "quote": "Open your heart. Someone will come. Someone will come for you. But first you must open your heart."
  },
  {
    "author": "Euripides,",
    "quote": "Talk sense to a fool and he calls you foolish."
  },
  {
    "author": "Edward Gorey",
    "quote": "The helpful thought for which you look"
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "How nice -- to feel nothing, and still get full credit for being alive."
  },
  {
    "author": "Orhan Pamuk,",
    "quote": "Happiness is holding someone in your arms and knowing you hold the whole world."
  },
  {
    "author": "John Grisham,",
    "quote": "Don't compromise yourself - you're all you have."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Who, being loved, is poor?"
  },
  {
    "author": "Marguerite Duras",
    "quote": "Our mothers always remain the strangest, craziest people we've ever met."
  },
  {
    "author": "Lauren Oliver,",
    "quote": "So many things become beautiful when you really look."
  },
  {
    "author": "Dalai Lama XIV",
    "quote": "If you think you are too small to make a difference, try sleeping with a mosquito."
  },
  {
    "author": "T.S. Eliot",
    "quote": "This is the way the world ends"
  },
  {
    "author": "Daniel J. Boorstin",
    "quote": "The greatest enemy of knowledge is not ignorance, it is the illusion of knowledge."
  },
  {
    "author": "Christopher Paolini",
    "quote": "Because you can't argue with all the fools in the world. It's easier to let them have their way, then trick them when they're not paying attention."
  },
  {
    "author": "Confucius",
    "quote": "Wheresoever you go, go with all your heart."
  },
  {
    "author": "Emma Donoghue,",
    "quote": "Scared is what you're feeling. Brave is what you're doing."
  },
  {
    "author": "Horace Mann",
    "quote": "A house without books is like a room without windows."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "From there to here, from here to there, funny things are everywhere!"
  },
  {
    "author": "Desmond Tutu",
    "quote": "Do your little bit of good where you are; it's those little bits of good put together that overwhelm the world."
  },
  {
    "author": "Mitch Albom,",
    "quote": "All parents damage their children. It cannot be helped. Youth, like pristine glass, absorbs the prints of its handlers. Some parents smudge, others crack, a few shatter childhoods completely into jagged little pieces, beyond repair."
  },
  {
    "author": "Zelda Fitzgerald,",
    "quote": "She refused to be bored chiefly because she wasn't boring."
  },
  {
    "author": "A.A. Milne",
    "quote": "One of the advantages of being disorganized is that one is always having surprising discoveries."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "I felt like crying but nothing came out. it was just a sort of sad sickness, sick sad, when you can't feel any worse. I think you know it. I think everybody knows it now and then. but I think I have known it pretty often, too often."
  },
  {
    "author": "Albert Einstein",
    "quote": "If A is a success in life, then A equals x plus y plus z. Work is x; y is play; and z is keeping your mouth shut"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I thought I'd lie on the floor and writhe in pain for a while, he grunted, It relaxes me."
  },
  {
    "author": "Dante Alighieri,",
    "quote": "Do not be afraid; our fate"
  },
  {
    "author": "Marissa Meyer,",
    "quote": "Even in the Future the Story Begins with Once Upon a Time."
  },
  {
    "author": "Stephen Fry",
    "quote": "If you know someone who’s depressed, please resolve never to ask them why. Depression isn’t a straightforward response to a bad situation; depression just is, like the weather."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Did you ever think that in a past life Alec was an old woman with ninety cats who was always yelling at the neighborhood kids to get off her lawn? Because I do,"
  },
  {
    "author": "Hunter S. Thompson,",
    "quote": "A man who procrastinates in his choosing will inevitably have his choice made for him by circumstance."
  },
  {
    "author": "Anna Quindlen",
    "quote": "The thing that is really hard, and really amazing, is giving up on being perfect and beginning the work of becoming yourself."
  },
  {
    "author": "Alan Bennett,",
    "quote": "What she was finding also was how one book led to another, doors kept opening wherever she turned and the days weren't long enough for the reading she wanted to do."
  },
  {
    "author": "Martin Luther King Jr.",
    "quote": "Nothing in the world is more dangerous than sincere ignorance and conscientious stupidity."
  },
  {
    "author": "Anne Sexton",
    "quote": "As it has been said:"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "They say time heals all wounds, but that presumes the source of the grief is finite"
  },
  {
    "author": "Tennessee Williams,",
    "quote": "Time is the longest distance between two places."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It is a curious thing, Harry, but perhaps those who are best suited to power are those who have never sought it. Those who, like you, have leadership thrust upon them, and take up the mantle because they must, and find to their own surprise that they wear it well."
  },
  {
    "author": "William Shakespeare,",
    "quote": "By the pricking of my thumbs,"
  },
  {
    "author": "أحمد خالد توفيق",
    "quote": "إن المرأة تحب رجلها ليس لأنه أقوى الرجال، و لا أوسمهم، و لا أغناهم، بل لأنه هو.. بضعفه و قوته.. و الحب ليس إستعراض قوة لكنه طاقة عطاء دافئة مستمرة"
  },
  {
    "author": "Thomas Paine,",
    "quote": "The mind once enlightened cannot again become dark."
  },
  {
    "author": "Sylvia Plath",
    "quote": "Is there no way out of the mind?"
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Nitwit! Blubber! Oddment! Tweak!"
  },
  {
    "author": "Robert Frost",
    "quote": "Forgive, O Lord, my little jokes on Thee"
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "You are not your job, you're not how much money you have in the bank. You are not the car you drive. You're not the contents of your wallet. You are not your fucking khakis. You are all singing, all dancing crap of the world."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "I'm on Aslan's side even if there isn't any Aslan to lead it. I'm going to live as like a Narnian as I can even if there isn't any Narnia."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "There are good days and hard days for me—even now. Don’t let the hard days win."
  },
  {
    "author": "Ira Glass",
    "quote": "Nobody tells this to people who are beginners, I wish someone told me. All of us who do creative work, we get into it because we have good taste. But there is this gap. For the first couple years you make stuff, it’s just not that good. It’s trying to be good, it has potential, but it’s not. But your taste, the thing that got you into the game, is still killer. And your taste is why your work disappoints you. A lot of people never get past this phase, they quit. Most people I know who do interesting, creative work went through years of this. We know our work doesn’t have this special thing that we want it to have. We all go through this. And if you are just starting out or you are still in this phase, you gotta know its normal and the most important thing you can do is do a lot of work. Put yourself on a deadline so that every week you will finish one story. It is only by going through a volume of work that you will close that gap, and your work will be as good as your ambitions. And I took longer to figure out how to do this than anyone I’ve ever met. It’s gonna take awhile. It’s normal to take awhile. You’ve just gotta fight your way through."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "I like to see people reunited, I like to see people run to each other, I like the kissing and the crying, I like the impatience, the stories that the mouth can't tell fast enough, the ears that aren't big enough, the eyes that can't take in all of the change, I like the hugging, the bringing together, the end of missing someone."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "When people talk, listen completely. Most people never listen."
  },
  {
    "author": "Stephanie Perkins,",
    "quote": "The more you know who you are, and what you want, the less you let things upset you."
  },
  {
    "author": "Anne Frank,",
    "quote": "No one has ever become poor by giving."
  },
  {
    "author": "Richelle Mead,",
    "quote": "Ah, my daughter,ʺ he said. ʺEighteen, and already youʹve been accused of murder, aided felons, and acquired a death count higher than most guardians will ever see.ʺ He paused. ʺI couldnʹt be prouder."
  },
  {
    "author": "Beatrix Potter",
    "quote": "There is something delicious about writing the first words of a story. You never quite know where they'll take you."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "My concern is not whether God is on our side; my greatest concern is to be on God's side, for God is always right."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "No one can construct for you the bridge upon which precisely you must cross the stream of life, no one but you yourself alone."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Let me give you a piece of advice. The handsome young fellow who's trying to rescue you from a hideous fate is never wrong. Not even if he says the sky is purple and made of hedgehogs."
  },
  {
    "author": "Kurt Vonnegut",
    "quote": "Of all the words of mice and men, the saddest are, It might have been."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "Love can change a person the way a parent can change a baby- awkwardly, and often with a great deal of mess."
  },
  {
    "author": "Lois McMaster Bujold,",
    "quote": "Reputation is what other people know about you. Honor is what you know about yourself."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "And I guess I realized at that moment that I really did love her. Because there was nothing to gain, and that didn't matter."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "the free soul is rare, but you know it when you see it - basically because you feel good, very good, when you are near or with them."
  },
  {
    "author": "Gordon B. Hinckley",
    "quote": "Try a little harder to be a little better."
  },
  {
    "author": "Katherine Mansfield",
    "quote": "The pleasure of all reading is doubled when one lives with another who shares the same books."
  },
  {
    "author": "John Green,",
    "quote": "Whenever you read a cancer booklet or website or whatever, they always list depression among the side effects of cancer. But, in fact, depression is not a side effect of cancer. Depression is a side effect of dying."
  },
  {
    "author": "Maya Angelou",
    "quote": "Never make someone a priority when all you are to them is an option."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "You see I usually find myself among strangers because I drift here and there trying to forget the sad things that happened to me."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "Then the Grinch thought of something he hadn't before! What if Christmas, he thought, doesn't come from a store. What if Christmas...perhaps...means a little bit more!"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You could have fooled me. Everytime I called you, Luke said you were sick. I figured you were avoiding me. Again."
  },
  {
    "author": "Carl Sagan,",
    "quote": "The nitrogen in our DNA, the calcium in our teeth, the iron in our blood, the carbon in our apple pies were made in the interiors of collapsing stars. We are made of starstuff."
  },
  {
    "author": "Jude Deveraux,",
    "quote": "My soul will find yours."
  },
  {
    "author": "John Green,",
    "quote": "The pleasure of remembering had been taken from me, because there was no longer anyone to remember with. It felt like losing your co-rememberer meant losing the memory itself, as if the things we'd done were less real and important than they had been hours before."
  },
  {
    "author": "Kahlil Gibran",
    "quote": "Ever has it been that love knows not its own depth until the hour of separation."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Knowing too much of your future is never a good thing."
  },
  {
    "author": "Fyodor Dostoevsky,",
    "quote": "I say let the world go to hell, but I should always have my tea."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "It's not gray, Clary felt compelled to point out. It's green."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I don't want tea, said Clary, with muffled force. I want to find my mother. And then I want to find out who took her in the first place, and I want to kill them."
  },
  {
    "author": "Dodie Smith,",
    "quote": "There is only one page left to write on. I will fill it with words of only one syllable. I love. I have loved. I will love."
  },
  {
    "author": "Michael Ondaatje,",
    "quote": "She had always wanted words, she loved them; grew up on them. Words gave her clarity, brought reason, shape."
  },
  {
    "author": "Arundhati Roy,",
    "quote": "That's what careless words do. They make people love you a little less."
  },
  {
    "author": "Laini Taylor,",
    "quote": "Once upon a time, an angel and a devil fell in love."
  },
  {
    "author": "Temple Grandin",
    "quote": "I am different, not less."
  },
  {
    "author": "John Green,",
    "quote": "When did we see each other face-to-face? Not until you saw into my cracks and I saw into yours. Before that, we were just looking at ideas of each other, like looking at your window shade but never seeing inside. But once the vessel cracks, the light can get in. The light can get out."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "To shine your brightest light is to be who you truly are."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Crying is for plain women. Pretty women go shopping."
  },
  {
    "author": "Oscar Wilde",
    "quote": "I have the simplest tastes. I am always satisfied with the best."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "When we least expect it, life sets us a challenge to test our courage and willingness to change; at such a moment, there is no point in pretending that nothing has happened or in saying that we are not yet ready. The challenge will not wait. Life does not look back. A week is more than enough time for us to decide whether or not to accept our destiny."
  },
  {
    "author": "Mae West",
    "quote": "I wrote the story myself. It's about a girl who lost her reputation and never missed it."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You're just worried they'll hire a male instructor and he'll be hotter than you."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "Courage is found in unlikely places."
  },
  {
    "author": "Maya Angelou",
    "quote": "You may encounter many defeats, but you must not be defeated. In fact, it may be necessary to encounter the defeats, so you can know who you are, what you can rise from, how you can still come out of it."
  },
  {
    "author": "Thomas Merton,",
    "quote": "The beginning of love is the will to let those we love be perfectly themselves, the resolution not to twist them to fit our own image."
  },
  {
    "author": "Astrid Lindgren",
    "quote": "A childhood without books – that would be no childhood. That would be like being shut out from the enchanted place where you can go and find the rarest kind of joy."
  },
  {
    "author": "Honore de Balzac",
    "quote": "Reading brings us unknown friends"
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "Did you know that 'I told you so' has a brother,Jacob? she asked cutting me off. His name is 'Shut the hell up'."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Sometimes, when I have to do something I don't want to do, I pretend I'm a character from a book. It's easier to know what they would do."
  },
  {
    "author": "Rick Riordan,",
    "quote": "We're staying together, he promised. You're not getting away from me. Never again."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "I'm a success today because I had a friend who believed in me and I didn't have the heart to let him down."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "Strange as it may seem, I still hope for the best, even though the best, like an interesting piece of mail, so rarely arrives, and even when it does it can be lost so easily."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Give her hell from us, Peeves."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "May the odds be ever in your favor!"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You're an idiot."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "In time, the hurt began to fade and it was easier to just let it go. At least I thought it was. But in every boy I met in the next few years, I found myself looking for you, and when the feelings got too strong, I'd write you another letter. But I never sent them for fear of what I might find. By then, you'd gone on with your life and I didn't want to think about you loving someone else. I wanted to remember us like we were that summer. I didn't ever want to lose that."
  },
  {
    "author": "Susan Sontag",
    "quote": "I haven't been everywhere, but it's on my list."
  },
  {
    "author": "Laini Taylor,",
    "quote": "Hope can be a powerful force. Maybe there's no actual magic in it, but when you know what you hope for most and hold it like a light within you, you can make things happen, almost like magic."
  },
  {
    "author": "George Bernard Shaw",
    "quote": "Animals are my friends...and I don't eat my friends."
  },
  {
    "author": "Conan O'Brien",
    "quote": "If you work really hard, and you're kind, amazing things will happen."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Ah, music, he said, wiping his eyes. A magic beyond all we do here!"
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Really, the combination of the scabs and the ointment looks hideous. I can't help enjoying his distress."
  },
  {
    "author": "Edward J. Stieglitz",
    "quote": "The important thing to you is not how many years in your life, but how much life in your years!"
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I always channel my emotions into my work. That way, I don't hurt anyone but myself."
  },
  {
    "author": "Margaret Atwood,",
    "quote": "Don't let the bastards grind you down."
  },
  {
    "author": "George Eliot",
    "quote": "What do we live for, if it is not to make life less difficult for each other?"
  },
  {
    "author": "Marion Zimmer Bradley,",
    "quote": "Remain true to yourself, child. If you know your own heart, you will always have one friend who does not lie."
  },
  {
    "author": "Steve Wozniak",
    "quote": "If you love what you do and are willing to do what it takes, it's within your reach. And it'll be worth every minute you spend alone at night, thinking and thinking about what it is you want to design or build. It'll be worth it, I promise."
  },
  {
    "author": "Edna St. Vincent Millay",
    "quote": "Where you used to be, there is a hole in the world, which I find myself constantly walking around in the daytime, and falling in at night. I miss you like hell."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "You'd think people had better things to gossip about, said Ginny as she sat on the common room floor, leaning against Harry’s legs and reading the Daily Prophet. Three Dementor attacks in a week, and all Romilda Vane does is ask me if it’s true you’ve got a Hippogriff tattooed across your chest."
  },
  {
    "author": "L. Frank Baum,",
    "quote": "There is no place like home."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "You must not lose faith in humanity. Humanity is like an ocean; if a few drops of the ocean are dirty, the ocean does not become dirty."
  },
  {
    "author": "Orson Welles",
    "quote": "Ask not what you can do for your country. Ask what’s for lunch."
  },
  {
    "author": "Deepak Chopra",
    "quote": "Every time you are tempted to react in the same old way, ask if you want to be a prisoner of the past or a pioneer of the future."
  },
  {
    "author": "Max Lucado,",
    "quote": "Faith is not the belief that God will do what you want. It is the belief that God will do what is right."
  },
  {
    "author": "A.A. Milne",
    "quote": "What day is it? asked Pooh."
  },
  {
    "author": "John Green,",
    "quote": "Have you really read all those books in your room?"
  },
  {
    "author": "Blaise Pascal",
    "quote": "The heart has its reasons which reason knows not."
  },
  {
    "author": "Charles Bukowski",
    "quote": "those who escape hell"
  },
  {
    "author": "Frances Hodgson Burnett,",
    "quote": "If you look the right way, you can see that the whole world is a garden."
  },
  {
    "author": "Markus Zusak",
    "quote": "Sometimes you read a book so special that you want to carry it around with you for months after you've finished just to stay near it."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "When you play a game of thrones you win or you die."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Sometimes you have to lose all you have to find out who you truly are."
  },
  {
    "author": "Santosh Kalwar,",
    "quote": "We are addicted to our thoughts. We cannot change anything if we cannot change our thinking."
  },
  {
    "author": "Rumi,",
    "quote": "Sell your cleverness and buy bewilderment."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "Be thankful for everything that happens in your life; it’s all an experience."
  },
  {
    "author": "Kiera Cass,",
    "quote": "True love is usually the most inconvenient kind."
  },
  {
    "author": "Neil Gaiman",
    "quote": "Tomorrow may be hell, but today was a good writing day, and on the good writing days nothing else matters."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "My name is Celaena Sardothien. But it makes no difference if my name's Celaena or Lillian or Bitch, because I'd still beat you, no matter what you call me."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Peeta, how come I never know when you're having a nightmare? I say."
  },
  {
    "author": "Pablo Picasso",
    "quote": "Art washes away from the soul the dust of everyday life."
  },
  {
    "author": "Karen Marie Moning,",
    "quote": "I love books, by the way, way more than movies. Movies tell you what to think. A good book lets you choose a few thoughts for yourself. Movies show you the pink house. A good book tells you there's a pink house and lets you paint some of the finishing touches, maybe choose the roof style,park your own car out front. My imagination has always topped anything a movie could come up with. Case in point, those darned Harry Potter movies. That was so not what that part-Veela-chick, Fleur Delacour, looked like."
  },
  {
    "author": "محمود درويش",
    "quote": "و كن من أنتَ حيث تكون"
  },
  {
    "author": "Dr. Seuss,",
    "quote": "I meant what I said and I said what I meant. An elephant's faithful one-hundred percent!"
  },
  {
    "author": "Paulo Coelho",
    "quote": "Tears are words that need to be written."
  },
  {
    "author": "Julio Cortázar",
    "quote": "Come sleep with me: We won't make Love, Love will make us."
  },
  {
    "author": "Anne Frank,",
    "quote": "I don't think of all the misery, but of the beauty that still remains."
  },
  {
    "author": "Doris Lessing",
    "quote": "Whatever you're meant to do, do it now. The conditions are always impossible."
  },
  {
    "author": "Elie Wiesel",
    "quote": "Friendship marks a life even more deeply than love. Love risks degenerating into obsession, friendship is never anything but sharing."
  },
  {
    "author": "Octavia Butler,",
    "quote": "In order to rise"
  },
  {
    "author": "Lauren Kate,",
    "quote": "Sometimes beautiful things come into our lives out of nowhere. We can't always understand them, but we have to trust in them. I know you want to question everything, but sometimes it pays to just have a little faith."
  },
  {
    "author": "Danielle Steel,",
    "quote": "Maybe some people just aren't meant to be in our lives forever. Maybe some people are just passing through. It's like some people just come through our lives to bring us something: a gift, a blessing, a lesson we need to learn. And that's why they're here. You'll have that gift forever."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "I want you always to remember me. Will you remember that I existed, and that I stood next to you here like this?"
  },
  {
    "author": "Benjamin Alire Sáenz,",
    "quote": "Words were different when they lived inside of you."
  },
  {
    "author": "P.C. Cast,",
    "quote": "Remember, darkness does not always equate to evil, just as light does not always bring good."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "The reason it hurts so much to separate is because our souls are connected. Maybe they always have been and will be. Maybe we've lived a thousand lives before this one and in each of them we've found each other. And maybe each time, we've been forced apart for the same reasons. That means that this goodbye is both a goodbye for the past ten thousand years and a prelude to what will come."
  },
  {
    "author": "Lao Tzu,",
    "quote": "When you are content to be simply yourself and don't compare or compete, everyone will respect you."
  },
  {
    "author": "Rebecca West",
    "quote": "I myself have never been able to find out precisely what feminism is: I only know that people call me a feminist whenever I express sentiments that differentiate me from a doormat."
  },
  {
    "author": "jonathan safran foer",
    "quote": "Time was passing like a hand waving from a train I wanted to be on."
  },
  {
    "author": "Albert Camus,",
    "quote": "I may not have been sure about what really did interest me, but I was absolutely sure about what didn't."
  },
  {
    "author": "Charles Dickens,",
    "quote": "A wonderful fact to reflect upon, that every human creature is constituted to be that profound secret and mystery to every other."
  },
  {
    "author": "Veronica Roth,",
    "quote": "There are so many ways to be brave in this world. Sometimes bravery involves laying down your life for something bigger than yourself, or for someone else. Sometimes it involves giving up everything you have ever known, or everyone you have ever loved, for the sake of something greater."
  },
  {
    "author": "Carl Sandburg",
    "quote": "Time is the coin of your life. You spend it. Do not allow others to spend it for you."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "A diary with no drawings of me in it? Where are the torrid fantasies? The romance covers?"
  },
  {
    "author": "Rainer Maria Rilke,",
    "quote": "Therefore, dear Sir, love your solitude and try to sing out with the pain it causes you. For those who are near you are far away... and this shows that the space around you is beginning to grow vast.... be happy about your growth, in which of course you can't take anyone with you, and be gentle with those who stay behind; be confident and calm in front of them and don't torment them with your doubts and don't frighten them with your faith or joy, which they wouldn't be able to comprehend. Seek out some simple and true feeling of what you have in common with them, which doesn't necessarily have to alter when you yourself change again and again; when you see them, love life in a form that is not your own and be indulgent toward those who are growing old, who are afraid of the aloneness that you trust.... and don't expect any understanding; but believe in a love that is being stored up for you like an inheritance, and have faith that in this love there is a strength and a blessing so large that you can travel as far as you wish without having to step outside it."
  },
  {
    "author": "Nikolai V. Gogol",
    "quote": "The longer and more carefully we look at a funny story, the sadder it becomes."
  },
  {
    "author": "Socrates",
    "quote": "There is only one good, knowledge, and one evil, ignorance."
  },
  {
    "author": "Charlotte Brontë",
    "quote": "The trouble is not that I am single and likely to stay single, but that I am lonely and likely to stay lonely."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I'm going to wake Peeta, I say."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "He accused me of being Dumbledore's man through and through."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "I'm sick of just liking people. I wish to God I could meet somebody I could respect."
  },
  {
    "author": "Ursula K. Le Guin,",
    "quote": "It is good to have an end to journey toward; but it is the journey that matters, in the end."
  },
  {
    "author": "Pablo Neruda,",
    "quote": "so I wait for you like a lonely house"
  },
  {
    "author": "Terry Pratchett",
    "quote": "It's not worth doing something unless someone, somewhere, would much rather you weren't doing it."
  },
  {
    "author": "John Green,",
    "quote": "He was gone, and I did not have time to tell him what I had just now realized: that I forgave him, and that she forgave us, and that we had to forgive to survive in the labyrinth. There were so many of us who would have to live with things done and things left undone that day. Things that did not go right, things that seemed okay at the time because we could not see the future. If only we could see the endless string of consequences that result from our smallest actions. But we can’t know better until knowing better is useless. And as I walked back to give Takumi’s note to the Colonel, I saw that I would never know. I would never know her well enough to know her thoughts in those last minutes, would never know if she left us on purpose. But the not-knowing would not keep me from caring, and I would always love Alaska Young, my crooked neighbor, with all my crooked heart."
  },
  {
    "author": "John Updike,",
    "quote": "It is easy to love people in memory; the hard thing is to love them when they are there in front of you."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "You know how they say you only hurt the ones you love? Well, it works both ways."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "People come, people go – they’ll drift in and out of your life, almost like characters in a favorite book. When you finally close the cover, the characters have told their story and you start up again with another book, complete with new characters and adventures. Then you find yourself focusing on the new ones, not the ones from the past."
  },
  {
    "author": "Charles Lamb,",
    "quote": "Tis the privilege of friendship to talk nonsense, and to have her nonsense respected."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "I am always saying Glad to've met you to somebody I'm not at all glad I met. If you want to stay alive, you have to say that stuff, though."
  },
  {
    "author": "Maya Angelou",
    "quote": "You can only become truly accomplished at something you love. Don’t make money your goal. Instead pursue the things you love doing and then do them so well that people can’t take their eyes off of you."
  },
  {
    "author": "Kurt Vonnegut Jr.,",
    "quote": "And I urge you to please notice when you are happy, and exclaim or murmur or think at some point, 'If this isn't nice, I don't know what is."
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "From childhood's hour I have not been. As others were, I have not seen. As others saw, I could not awaken. My heart to joy at the same tone. And all I loved, I loved alone."
  },
  {
    "author": "Margaret Walker",
    "quote": "When I was about eight, I decided that the most wonderful thing, next to a human being, was a book."
  },
  {
    "author": "Kazuo Ishiguro,",
    "quote": "Memories, even your most precious ones, fade surprisingly quickly. But I don’t go along with that. The memories I value most, I don’t ever see them fading."
  },
  {
    "author": "Robert A. Heinlein,",
    "quote": "Happiness consists in getting enough sleep. Just that, nothing more."
  },
  {
    "author": "Edgar Allan Poe,",
    "quote": "Once upon a midnight dreary, while I pondered, weak and weary,"
  },
  {
    "author": "Marcel Proust",
    "quote": "The real voyage of discovery consists not in seeking new landscapes, but in having new eyes."
  },
  {
    "author": "Albert Schweitzer",
    "quote": "There are two means of refuge from the misery of life — music and cats."
  },
  {
    "author": "Keri Hulme,",
    "quote": "You want to know about anybody? See what books they read, and how they've been read..."
  },
  {
    "author": "Brian Andreas,",
    "quote": "I read once that the ancient Egyptians had fifty words for sand & the Eskimos had a hundred words for snow. I wish I had a thousand words for love, but all that comes to mind is the way you move against me while you sleep & there are no words for that."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Adults are just obsolete children and the hell with them."
  },
  {
    "author": "Yogi Berra,",
    "quote": "Always go to other people's funerals, otherwise they won't come to yours."
  },
  {
    "author": "Nick Hornby",
    "quote": "It's no good pretending that any relationship has a future if your record collections disagree violently or if your favorite films wouldn't even speak to each other if they met at a party."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "There are only the pursued, the pursuing, the busy and the tired."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "The scar had not pained Harry for nineteen years. All was well."
  },
  {
    "author": "Virginia Woolf",
    "quote": "I can only note that the past is beautiful because one never realises an emotion at the time. It expands later, and thus we don't have complete emotions about the present, only about the past."
  },
  {
    "author": "Jennifer Niven,",
    "quote": "You are all the colors in one, at full brightness."
  },
  {
    "author": "Jane Austen,",
    "quote": "If I loved you less, I might be able to talk about it more."
  },
  {
    "author": "John Boyne",
    "quote": "There's things that happen in a person's life that are so scorched in the memory and burned into the heart that there's no forgetting them."
  },
  {
    "author": "Tennessee Williams,",
    "quote": "I've got the guts to die. What I want to know is, have you got the guts to live?"
  },
  {
    "author": "Harlan Ellison",
    "quote": "You are not entitled to your opinion. You are entitled to your"
  },
  {
    "author": "Jack Kerouac",
    "quote": "I like too many things and get all confused and hung-up running from one falling star to another till i drop. This is the night, what it does to you. I had nothing to offer anybody except my own confusion."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "What do you want?"
  },
  {
    "author": "Mitch Albom",
    "quote": "Lost love is still love. It takes a different form, that's all. You can't see their smile or bring them food or tousle their hair or move them around a dance floor. But when those senses weaken another heightens. Memory. Memory becomes your partner. You nurture it. You hold it. You dance with it."
  },
  {
    "author": "Maya Angelou,",
    "quote": "Pretty women wonder where my secret lies."
  },
  {
    "author": "Robert Frost",
    "quote": "If we couldn't laugh we would all go insane."
  },
  {
    "author": "Søren Kierkegaard ,",
    "quote": "Anxiety is the dizziness of freedom."
  },
  {
    "author": "E.Y. Harburg",
    "quote": "Somewhere over the rainbow, skies are blue, and the dreams that you dare to dream really do come true."
  },
  {
    "author": "Michael Crichton",
    "quote": "If you don't know history, then you don't know anything. You are a leaf that doesn't know it is part of a tree."
  },
  {
    "author": "Richelle Mead,",
    "quote": "The spell. Victor said you had to want me... to care about me... for it to work. When he didn't say anything, I tried to grip his shirt, but my fingers were too weak. Did you? Did you want me?"
  },
  {
    "author": "Shel Silverstein",
    "quote": "I cannot go to school today"
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "And all the books you've read have been read by other people. And all the songs you've loved have been heard by other people. And that girl that's pretty to you is pretty to other people. and that if you looked at these facts when you were happy, you would feel great because you are describing 'unity."
  },
  {
    "author": "William Goldman,",
    "quote": "When I was your age, television was called books."
  },
  {
    "author": "Charles Bukowski",
    "quote": "Boring damned people. All over the earth. Propagating more boring damned people. What a horror show. The earth swarmed with them."
  },
  {
    "author": "Robert Louis Stevenson,",
    "quote": "I travel not to go anywhere, but to go. I travel for travel's sake. The great affair is to move."
  },
  {
    "author": "Erin Morgenstern,",
    "quote": "The finest of pleasures are always the unexpected ones."
  },
  {
    "author": "Emilie Autumn,",
    "quote": "It gives me strength to have somebody to fight for; I can never fight for myself, but, for others, I can kill."
  },
  {
    "author": "Ransom Riggs,",
    "quote": "I used to dream about escaping my ordinary life, but my life was never ordinary. I had simply failed to notice how extraordinary it was."
  },
  {
    "author": "Jon Krakauer,",
    "quote": "It's not always necessary to be strong, but to feel strong."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "You never change your life until you step out of your comfort zone; change begins at the end of your comfort zone."
  },
  {
    "author": "Peter Shaffer,",
    "quote": "The trouble is if you don’t spend your life yourself, other people spend it for you."
  },
  {
    "author": "Sophocles",
    "quote": "One word"
  },
  {
    "author": "Virginia Woolf",
    "quote": "Writing is like sex. First you do it for love, then you do it for your friends, and then you do it for money."
  },
  {
    "author": "Arthur William Edgar O'Shaughnessy,",
    "quote": "We are the music makers, and we are the dreamers of dreams."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "I'm a business man, he'd told her. No more, no less."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "Fear is a phoenix. You can watch it burn a thousand times and still it will return."
  },
  {
    "author": "Stephanie Perkins,",
    "quote": "Is it possible for home to be a person and not a place?"
  },
  {
    "author": "Ray Bradbury",
    "quote": "You must write every single day of your life... You must lurk in libraries and climb the stacks like ladders to sniff books like perfumes and wear books like hats upon your crazy heads... may you be in love every day for the next 20,000 days. And out of that love, remake a world."
  },
  {
    "author": "Bill Cosby",
    "quote": "A word to the wise ain't necessary, it's the stupid ones who need advice."
  },
  {
    "author": "Harper Lee,",
    "quote": "Sometimes the Bible in the hand of one man is worse than a whisky bottle in the hand of (another)... There are just some kind of men who - who're so busy worrying about the next world they've never learned to live in this one, and you can look down the street and see the results."
  },
  {
    "author": "Madeline Miller,",
    "quote": "We were like gods at the dawning of the world, & our joy was so bright we could see nothing else but the other."
  },
  {
    "author": "Rick Riordan,",
    "quote": "It's hard to enjoy practical jokes when your whole life feels like one."
  },
  {
    "author": "James Baldwin",
    "quote": "Children have never been very good at listening to their elders, but they have never failed to imitate them."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I must have loved you a lot."
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "Words, I think, are such unpredictable creatures."
  },
  {
    "author": "Henry Wadsworth Longfellow",
    "quote": "The love of learning, the sequestered nooks,"
  },
  {
    "author": "Neil Gaiman",
    "quote": "[D]on't ever apologise to an author for buying something in paperback, or taking it out from a library (that's what they're there for."
  },
  {
    "author": "Bob Marley",
    "quote": "The greatness of a man is not in how much wealth he acquires, but in his integrity and his ability to affect those around him positively."
  },
  {
    "author": "Agatha Christie,",
    "quote": "Very few of us are what we seem."
  },
  {
    "author": "Arthur G. Lewis,",
    "quote": "It is not the size of the dog in the fight that counts, but the fight in the dog that wins."
  },
  {
    "author": "Stieg Larsson,",
    "quote": "Friendship- my definition- is built on two things. Respect and trust. Both elements have to be there. And it has to be mutual. You can have respect for someone, but if you don't have trust, the friendship will crumble."
  },
  {
    "author": "E.E. Cummings",
    "quote": "Trust your heart if the seas catch fire, live by love though the stars walk backward."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Truth only means something when it's hard to admit."
  },
  {
    "author": "Joyce Carol Oates",
    "quote": "Reading is the sole means by which we slip, involuntarily, often helplessly, into another's skin, another's voice, another's soul."
  },
  {
    "author": "Evelyn Waugh,",
    "quote": "Sometimes, I feel the past and the future pressing so hard on either side that there's no room for the present at all."
  },
  {
    "author": "Adrienne Rich",
    "quote": "There must be those among whom we can sit down and weep and still be counted as warriors."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Even in half demon hunter clothes, Clary thought, he looked like the kind of boy who'd come over your house to pick you up for a date and be polite to your parents and nice to your pets."
  },
  {
    "author": "Stephen King",
    "quote": "I think that we're all mentally ill. Those of us outside the asylums only hide it a little better - and maybe not all that much better after all."
  },
  {
    "author": "Virginia Woolf",
    "quote": "As a woman I have no country. As a woman I want no country. As a woman, my country is the whole world."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "I like it when somebody gets excited about something. It's nice."
  },
  {
    "author": "C.S. Lewis",
    "quote": "You can make anything by writing."
  },
  {
    "author": "Leonard Cohen,",
    "quote": "There is a crack in everything."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "I like flaws. I think they make things interesting."
  },
  {
    "author": "Gail Carson Levine",
    "quote": "A library is infinity under a roof."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Don't give in to your fears. If you do, you won't be able to talk to your heart."
  },
  {
    "author": "Thomas Wolfe,",
    "quote": "Make your mistakes, take your chances, look silly, but keep on going. Don’t freeze up."
  },
  {
    "author": "Randy Pausch,",
    "quote": "The brick walls are there for a reason. The brick walls are not there to keep us out. The brick walls are there to give us a chance to show how badly we want something. Because the brick walls are there to stop the people who don’t want it badly enough. They’re there to stop the other people."
  },
  {
    "author": "Julian Barnes,",
    "quote": "This was another of our fears: that Life wouldn't turn out to be like Literature."
  },
  {
    "author": "Don Miguel Ruiz",
    "quote": "1. Be Impeccable With Your Word"
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Do not let the memories of your past limit the potential of your future. There are no limits to what you can achieve on your journey through life, except in your mind."
  },
  {
    "author": "Michelle Hodkin,",
    "quote": "Thinking something does not make it true. Wanting something does not make it real."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "please believe that things are good with me, and even when they're not, they will be soon enough. And i will always believe the same about you."
  },
  {
    "author": "Albert Einstein",
    "quote": "Black holes are where God divided by zero."
  },
  {
    "author": "John Muir",
    "quote": "When one tugs at a single thing in nature, he finds it attached to the rest of the world."
  },
  {
    "author": "Mark Twain",
    "quote": "I've lived through some terrible things in my life, some of which actually happened."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "You're a painter. You're a baker. You like to sleep with the windows open. You never take sugar in your tea. And you always double-knot your shoelaces."
  },
  {
    "author": "William Saroyan",
    "quote": "When you laugh, laugh like hell. And when you get angry, get good and angry. Try to be alive. You will be dead soon enough."
  },
  {
    "author": "Margaret Mitchell,",
    "quote": "Burdens are for shoulders strong enough to carry them."
  },
  {
    "author": "Jim Butcher",
    "quote": "When everything goes to hell, the people who stand by you without flinching -- they are your family."
  },
  {
    "author": "Voltaire",
    "quote": "Those who can make you believe absurdities, can make you commit atrocities."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Stop comparing yourself to other people, just choose to be happy and live your own life."
  },
  {
    "author": "Neil Gaiman",
    "quote": "I hope that in this year to come, you make mistakes."
  },
  {
    "author": "Fannie Flagg,",
    "quote": "Remember if people talk behind your back, it only means you are two steps ahead."
  },
  {
    "author": "Maya Angelou",
    "quote": "A woman's heart should be so hidden in God that a man has to seek Him just to find her."
  },
  {
    "author": "Madeline Miller,",
    "quote": "But in a solitary life, there are rare moments when another soul dips near yours, as stars once a year brush the earth. Such a constellation was he to me."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "May it be a light to you in dark places, when all other lights go out."
  },
  {
    "author": "Holly Black,",
    "quote": "Most of all, I hate you because I think of you. Often. It's disgusting, and I can't stop."
  },
  {
    "author": "Audrey Hepburn",
    "quote": "If I’m honest I have to tell you I still read fairy-tales and I like them best of all."
  },
  {
    "author": "George Orwell",
    "quote": "The most effective way to destroy people is to deny and obliterate their own understanding of their history."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Grown-ups don't look like grown-ups on the inside either. Outside, they're big and thoughtless and they always know what they're doing. Inside, they look just like they always have. Like they did when they were your age. Truth is, there aren't any grown-ups. Not one, in the whole wide world."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Selfishness is not living as one wishes to live, it is asking others to live as one wishes to live."
  },
  {
    "author": "Charlotte Bronte,",
    "quote": "I have for the first time found what I can truly love–I have found you. You are my sympathy–my better self–my good angel–I am bound to you with a strong attachment. I think you good, gifted, lovely: a fervent, a solemn passion is conceived in my heart; it leans to you, draws you to my centre and spring of life, wrap my existence about you–and, kindling in pure, powerful flame, fuses you and me in one."
  },
  {
    "author": "Steve Martin",
    "quote": "Some people have a way with words, and other people...oh, uh, not have way."
  },
  {
    "author": "Eugene Field",
    "quote": "No book can be appreciated until it has been slept with and dreamed over."
  },
  {
    "author": "مصطفى محمود,",
    "quote": "الكراهية تكلف أكثر من الحب.. لأنها إحساس غير طبيعي.. إحساس عكسي مثل حركة الأجسام ضد جاذبية الأرض.. تحتاج إلى قوة إضافية وتستهلك وقوداً أكثر"
  },
  {
    "author": "Simone de Beauvoir",
    "quote": "I am too intelligent, too demanding, and too resourceful for anyone to be able to take charge of me entirely. No one knows me or loves me completely. I have only myself"
  },
  {
    "author": "Anais Nin",
    "quote": "I must be a mermaid, Rango. I have no fear of depths and a great fear of shallow living."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "No matter how careful you are, there's going to be the sense you missed something, the collapsed feeling under your skin that you didn't experience it all. There's that fallen heart feeling that you rushed right through the moments where you should've been paying attention."
  },
  {
    "author": "Jodi Picoult,",
    "quote": "If you have a sister and she dies, do you stop saying you have one? Or are you always a sister, even when the other half of the equation is gone?"
  },
  {
    "author": "Charles Dickens,",
    "quote": "It is a far, far better thing that I do, than I have ever done; it is a far, far better rest that I go to than I have ever known."
  },
  {
    "author": "Bill Watterson",
    "quote": "You know, Hobbes, some days even my lucky rocket ship underpants don't help."
  },
  {
    "author": "Harvey Fierstein",
    "quote": "Never be bullied into silence. Never allow yourself to be made a victim. Accept no one's definition of your life, but define yourself."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "When one is in love, one always begins by deceiving one's self, and one always ends by deceiving others. That is what the world calls a romance."
  },
  {
    "author": "Bob Dylan",
    "quote": "Behind every beautiful thing, there's some kind of pain."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "The best way to find yourself is to lose yourself in the service of others."
  },
  {
    "author": "Robert Louis Stevenson",
    "quote": "Life is not a matter of holding good cards, but of playing a poor hand well."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "No one ever told me that grief felt so like fear."
  },
  {
    "author": "Toni Morrison,",
    "quote": "Freeing yourself was one thing, claiming ownership of that freed self was another."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Ginny! said Mr. Weasley, flabbergasted. Haven't I taught you anything? What have I always told you? Never trust anything that can think for itself if you can't see where it keeps its brain?"
  },
  {
    "author": "Fyodor Dostoevsky,",
    "quote": "Man only likes to count his troubles; he doesn't calculate his happiness."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "He needed to tell her...what? That she was lovely and brave and better than anything he deserved. That he was twisted, crooked, wrong, but not so broken that he couldn't pull himself together into some semblance of a man for her. That without meaning to, he'd begun to lean on her, to look for her, to need her near. He needed to thank her for his new hat."
  },
  {
    "author": "Neil Gaiman",
    "quote": "Being a writer is a very peculiar sort of a job: it's always you versus a blank sheet of paper (or a blank screen) and quite often the blank piece of paper wins."
  },
  {
    "author": "Charles Darwin,",
    "quote": "If I had my life to live over again, I would have made a rule to read some poetry and listen to some music at least once every week."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "When the snows fall and the white winds blow, the lone wolf dies but the pack survives."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "Can you understand? Someone, somewhere, can you understand me a little, love me a little? For all my despair, for all my ideals, for all that - I love life. But it is hard, and I have so much - so very much to learn."
  },
  {
    "author": "Rick Riordan,",
    "quote": "The world was collapsing, and the only thing that really mattered to me was that she was alive."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "You are not special. You're not a beautiful and unique snowflake. You're the same decaying organic matter as everything else. We're all part of the same compost heap. We're all singing, all dancing crap of the world."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "It's the job that's never started as takes longest to finish."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "The emotion that can break your heart is sometimes the very one that heals it..."
  },
  {
    "author": "Laurell K. Hamilton,",
    "quote": "I will love you always. When this red hair is white, I will still love you. When the smooth softness of youth is replaced by the delicate softness of age, I will still want to touch your skin. When your face is full of the lines of every smile you have ever smiled, of every surprise I have seen flash through your eyes, when every tear you have ever cried has left its mark upon your face,I will treasure you all the more, because I was there to see it all. I will share your life with you, Meredith, and I will love you until the last breath leaves your body or mine."
  },
  {
    "author": "Steve Jobs",
    "quote": "Remembering that you are going to die is the best way I know to avoid the trap of thinking you have something to lose. You are already naked. There is no reason not to follow your heart."
  },
  {
    "author": "Warsan Shire",
    "quote": "My alone feels so good, I'll only have you if you're sweeter than my solitude."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "Forbidden to remember, terrified to forget; it was a hard line to walk."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Let the first act of every morning be to make the following resolve for the day:"
  },
  {
    "author": "Cornelia Funke,",
    "quote": "Books have to be heavy because the whole world's inside them."
  },
  {
    "author": "Edmund Burke",
    "quote": "The only thing necessary for the triumph of evil is for good men to do nothing."
  },
  {
    "author": "Andy Warhol,",
    "quote": "They always say time changes things, but you actually have to change them yourself."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Jace shook his blond head in exasperation."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "You are not rich until you have a rich heart."
  },
  {
    "author": "Arrigo Boito",
    "quote": "When I saw you I fell in love, and you smiled because you knew."
  },
  {
    "author": "Lillian Hellman",
    "quote": "People change and forget to tell each other."
  },
  {
    "author": "David Foster Wallace,",
    "quote": "The truth will set you free. But not until it is finished with you."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "I fell in love with her when we were together, then fell deeper in love with her in the years we were apart."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Things need not have happened to be true. Tales and dreams are the shadow-truths that will endure when mere facts are dust and ashes, and forgot."
  },
  {
    "author": "Charles Dickens,",
    "quote": "Heaven knows we need never be ashamed of our tears, for they are rain upon the blinding dust of earth, overlying our hard hearts. I was better after I had cried, than before--more sorry, more aware of my own ingratitude, more gentle."
  },
  {
    "author": "Alexandre Dumas,",
    "quote": "I am not proud, but I am happy; and happiness blinds, I think, more than pride."
  },
  {
    "author": "Anais Nin",
    "quote": "I am only responsible for my own heart, you offered yours up for the smashing my darling. Only a fool would give out such a vital organ"
  },
  {
    "author": "Ayn Rand,",
    "quote": "I could die for you. But I couldn't, and wouldn't, live for you."
  },
  {
    "author": "Bob Marley",
    "quote": "Better to die fighting for freedom then be a prisoner all the days of your life."
  },
  {
    "author": "John Green,",
    "quote": "You like someone who can't like you back because unrequited love can be survived in a way that once-requited love cannot."
  },
  {
    "author": "Martin Luther King Jr.",
    "quote": "The ultimate measure of a man is not where he stands in moments of comfort and convenience, but where he stands at times of challenge and controversy."
  },
  {
    "author": "Veronica Roth,",
    "quote": "It must require bravery to be honest all the time."
  },
  {
    "author": "Tim Burton",
    "quote": "One person's craziness is another person's reality."
  },
  {
    "author": "Elizabeth Wurtzel,",
    "quote": "That's the thing about depression: A human being can survive almost anything, as long as she sees the end in sight. But depression is so insidious, and it compounds daily, that it's impossible to ever see the end."
  },
  {
    "author": "Brian Jacques,",
    "quote": "Even the strongest and bravest must sometimes weep. It shows they have a great heart, one that can feel compassion for others."
  },
  {
    "author": "Sun Tzu,",
    "quote": "The supreme art of war is to subdue the enemy without fighting."
  },
  {
    "author": "Honoré de Balzac,",
    "quote": "The more one judges, the less one loves."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "When we don't know who to hate, we hate ourselves."
  },
  {
    "author": "W.C. Fields",
    "quote": "It ain't what they call you, it's what you answer to."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Let the improvement of yourself keep you so busy that you have no time to criticize others."
  },
  {
    "author": "Terry Pratchett",
    "quote": "If you have enough book space, I don't want to talk to you."
  },
  {
    "author": "J.M. Barrie,",
    "quote": "When the first baby laughed for the first time, its laugh broke into a thousand pieces, and they all went skipping about, and that was the beginning of fairies."
  },
  {
    "author": "Lawrence Ferlinghetti",
    "quote": "If you're too open-minded; your brains will fall out."
  },
  {
    "author": "J. K. Rowling,",
    "quote": "What happened down in the dungeons between you and Professor Quirrell is a complete secret, so, naturally the whole school knows."
  },
  {
    "author": "Ben Okri",
    "quote": "Stories can conquer fear, you know. They can make the heart bigger."
  },
  {
    "author": "Boris Pasternak",
    "quote": "I don't like people who have never fallen or stumbled. Their virtue is lifeless and it isn't of much value. Life hasn't revealed its beauty to them."
  },
  {
    "author": "Sheng Wang",
    "quote": "A friend said to me, Hey you need to grow a pair. Grow a pair, Bro. It’s when someone calls you weak, but they associate it with a lack of testicles. Which is weird, because testicles are the most sensitive things in the world. If you suddenly just grew a pair, you’d be a lot more vulnerable. If you want to be tough, you should lose a pair. If you want to be real tough, you should grow a vagina. Those things can take a pounding."
  },
  {
    "author": "Anais Nin",
    "quote": "I am lonely, yet not everybody will do. I don't know why, some people fill the gaps and others emphasize my loneliness. In reality those who satisfy me are those who simply allow me to live with my ''idea of them."
  },
  {
    "author": "Nelson Mandela",
    "quote": "I learned that courage was not the absence of fear, but the triumph over it. The brave man is not he who does not feel afraid, but he who conquers that fear."
  },
  {
    "author": "Charlotte Brontë,",
    "quote": "No sight so sad as that of a naughty child, he began, especially a naughty little girl. Do you know where the wicked go after death?"
  },
  {
    "author": "Maya Angelou,",
    "quote": "Try to be a rainbow in someone's cloud."
  },
  {
    "author": "Daniel Defoe,",
    "quote": "It is never too late to be wise."
  },
  {
    "author": "Edward Abbey",
    "quote": "Better a cruel truth than a comfortable delusion."
  },
  {
    "author": "Albert Einstein",
    "quote": "Everything must be made as simple as possible. But not simpler."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "Life is too short to waste any amount of time on wondering what other people think about you. In the first place, if they had better things going on in their lives, they wouldn't have the time to sit around and talk about you. What's important to me is not others' opinions of me, but what's important to me is my opinion of myself."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Whatever you are physically...male or female, strong or weak, ill or healthy--all those things matter less than what your heart contains. If you have the soul of a warrior, you are a warrior. All those other things, they are the glass that contains the lamp, but"
  },
  {
    "author": "Hunter S. Thompson",
    "quote": "I hate to advocate drugs, alcohol, violence, or insanity to anyone, but they've always worked for me."
  },
  {
    "author": "Sarah Dessen",
    "quote": "Anyone can hide. Facing up to things, working through them, that's what makes you strong."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "It is one of life's bitterest truths that bedtime so often arrives just when things are really getting interesting."
  },
  {
    "author": "Vincent Willem van Gogh",
    "quote": "...and then, I have nature and art and poetry, and if that is not enough, what is enough?"
  },
  {
    "author": "Georg Wilhelm Friedrich Hegel",
    "quote": "Nothing great in the world was accomplished without passion."
  },
  {
    "author": "Richelle Mead,",
    "quote": "The only thing better than imagining Dimitri carrying me in his arms was imagining him shirtless while carrying me in his arms."
  },
  {
    "author": "Yann Martel,",
    "quote": "To choose doubt as a philosophy of life is akin to choosing immobility as a means of transportation."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Remember me and smile, for it's better to forget than to remember me and cry."
  },
  {
    "author": "Jane Austen,",
    "quote": "The Very first moment I beheld him, my heart was irrevocably gone."
  },
  {
    "author": "Janet Fitch,",
    "quote": "Loneliness is the human condition. Cultivate it. The way it tunnels into you allows your soul room to grow. Never expect to outgrow loneliness. Never hope to find people who will understand you, someone to fill that space. An intelligent, sensitive person is the exception, the very great exception. If you expect to find people who will understand you, you will grow murderous with disappointment. The best you'll ever do is to understand yourself, know what it is that you want, and not let the cattle stand in your way."
  },
  {
    "author": "Mark Twain",
    "quote": "Education: the path from cocky ignorance to miserable uncertainty."
  },
  {
    "author": "Franz Kafka",
    "quote": "I am free and that is why I am lost."
  },
  {
    "author": "Charles Lamb",
    "quote": "I always arrive late at the office, but I make up for it by leaving early."
  },
  {
    "author": "Plato",
    "quote": "The price good men pay for indifference to public affairs is to be ruled by evil men."
  },
  {
    "author": "Dante Alighieri",
    "quote": "My course is set for an uncharted sea."
  },
  {
    "author": "Robert Louis Stevenson,",
    "quote": "I kept always two books in my pocket, one to read, one to write in."
  },
  {
    "author": "James Baldwin,",
    "quote": "I imagine one of the reasons people cling to their hates so stubbornly is because they sense, once hate is gone, they will be forced to deal with pain."
  },
  {
    "author": "Heinrich Heine",
    "quote": "Where words leave off, music begins."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "I hope you're pleased with yourselves. We could all have been killed - or worse, expelled. Now if you don't mind, I'm going to bed."
  },
  {
    "author": "Harper Lee,",
    "quote": "Atticus, he was real nice."
  },
  {
    "author": "Stieg Larsson,",
    "quote": "What she had realized was that love was that moment when your heart was about to burst."
  },
  {
    "author": "Erma Bombeck,",
    "quote": "When God Created Mothers"
  },
  {
    "author": "P.C. Cast  Kristin Cast",
    "quote": "If you have good friends, no matter how much life is sucking , they can make you laugh."
  },
  {
    "author": "Audre Lorde,",
    "quote": "Your silence will not protect you."
  },
  {
    "author": "Victor Hugo,",
    "quote": "To love another person is to see the face of God."
  },
  {
    "author": "Andre Aciman,",
    "quote": "We rip out so much of ourselves to be cured of things faster than we should that we go bankrupt by the age of thirty and have less to offer each time we start with someone new. But to feel nothing so as not to feel anything - what a waste!"
  },
  {
    "author": "Richelle Mead,",
    "quote": "Did you see that dress? I saw the dress. Did you like it? He didn't answer. I took that as a yes. Am I going to endanger my reputation if I wear it to the dance? When he spoke, I could barely hear him. You'll endanger the school. I smiled and fell asleep."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Sometimes things fall apart so that better things can fall together"
  },
  {
    "author": "Gustave Flaubert",
    "quote": "Do not read as children do to enjoy themselves, or, as the ambitious do to educate themselves. No, read to live."
  },
  {
    "author": "Jamie McGuire,",
    "quote": "I know we're fucked up, alright? I'm impulsive, and hot tempered, and you get under my skin like no one else. You act like you hate me one minute, and then need me the next. I never get anything right, and I don't deserve you...but I fucking love you, Abby. I love you more than I loved anyone or anything ever. When you're around, I don't need booze, or money, or the fighting, or the one-night stands..."
  },
  {
    "author": "Mother Teresa",
    "quote": "Kind words can be short and easy to speak, but their echoes are truly endless."
  },
  {
    "author": "Anthony Doerr,",
    "quote": "Open your eyes and see what you can with them before they close forever."
  },
  {
    "author": "Mitch Albom,",
    "quote": "So many people walk around with a meaningless life. They seem half-asleep, even when they're busy doing things they think are important. This is because they're chasing the wrong things. The way you get meaning into your life is to devote yourself to loving others, devote yourself to your community around you, and devote yourself to creating something that gives you purpose and meaning."
  },
  {
    "author": "Mother Teresa",
    "quote": "Do not think that love in order to be genuine has to be extraordinary. What we need is to love without getting tired. Be faithful in small things because it is in them that your strength lies."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "We sit silently and watch the world around us. This has taken a lifetime to learn. It seems only the old are able to sit next to one another and not say anything and still feel content. The young, brash and impatient, must always break the silence. It is a waste, for silence is pure. Silence is holy. It draws people together because only those who are comfortable with each other can sit without speaking. This is the great paradox."
  },
  {
    "author": "Jean de La Fontaine",
    "quote": "Rare as is true love, true friendship is rarer."
  },
  {
    "author": "Jack Kornfield,",
    "quote": "In the end"
  },
  {
    "author": "Peter S. Beagle,",
    "quote": "Great heroes need great sorrows and burdens, or half their greatness goes unnoticed. It is all part of the fairy tale."
  },
  {
    "author": "Phyllis Diller",
    "quote": "A smile is a curve that sets everything straight."
  },
  {
    "author": "John Lennon",
    "quote": "There's nowhere you can be that isn't where you're meant to be..."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "It's much easier to not know things sometimes. Things change and friends leave. And life doesn't stop for anybody. I wanted to laugh. Or maybe get mad. Or maybe shrug at how strange everybody was, especially me. I think the idea is that every person has to live for his or her own life and than make the choice to share it with other people. You can't just sit their and put everybody's lives ahead of yours and think that counts as love. You just can't. You have to do things. I'm going to do what I want to do. I'm going to be who I really am. And I'm going to figure out what that is. And we could all sit around and wonder and feel bad about each other and blame a lot of people for what they did or didn't do or what they didn't know. I don't know. I guess there could always be someone to blame. It's just different. Maybe it's good to put things in perspective, but sometimes, I think that the only perspective is to really be there. Because it's okay to feel things. I was really there. And that was enough to make me feel infinite. I feel infinite."
  },
  {
    "author": "Rainbow Rowell,",
    "quote": "I don’t trust anybody. Not anybody. And the more that I care about someone, the more sure I am they’re going to get tired of me and take off."
  },
  {
    "author": "Albert Camus",
    "quote": "Blessed are the hearts that can bend; they shall never be broken."
  },
  {
    "author": "Guy de Maupassant",
    "quote": "Words dazzle and deceive because they are mimed by the face. But black words on a white page are the soul laid bare."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "God, but life is loneliness, despite all the opiates, despite the shrill tinsel gaiety of parties with no purpose, despite the false grinning faces we all wear. And when at last you find someone to whom you feel you can pour out your soul, you stop in shock at the words you utter - they are so rusty, so ugly, so meaningless and feeble from being kept in the small cramped dark inside you so long. Yes, there is joy, fulfillment and companionship - but the loneliness of the soul in its appalling self-consciousness is horrible and overpowering."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "All I have seen teaches me to trust the Creator for all I have not seen."
  },
  {
    "author": "John Green,",
    "quote": "Headline? he asked."
  },
  {
    "author": "Groucho Marx",
    "quote": "Learn from the mistakes of others. You can never live long enough to make them all yourself."
  },
  {
    "author": "Cassandra Clare",
    "quote": "My rapier wit hides my inner pain."
  },
  {
    "author": "Neil Gaiman",
    "quote": "I hope you will have a wonderful year, that you'll dream dangerously and outrageously, that you'll make something that didn't exist before you made it, that you will be loved and that you will be liked, and that you will have people to love and to like in return. And, most importantly (because I think there should be more kindness and more wisdom in the world right now), that you will, when you need to be, be wise, and that you will always be kind."
  },
  {
    "author": "Aristotle",
    "quote": "Educating the mind without educating the heart is no education at all."
  },
  {
    "author": "Lauren Oliver,",
    "quote": "I'd rather die my way than live yours."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "I was always hungry for love. Just once, I wanted to know what it was like to get my fill of it -- to be fed so much love I couldn't take any more. Just once."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "To be fully seen by somebody, then, and be loved anyhow - this is a human offering that can border on miraculous."
  },
  {
    "author": "Eleanor Roosevelt",
    "quote": "It takes courage to love, but pain through love is the purifying fire which those who love generously know. We all know people who are so much afraid of pain that they shut themselves up like clams in a shell and, giving out nothing, receive nothing and therefore shrink until life is a mere living death."
  },
  {
    "author": "Lewis Carroll,",
    "quote": "Curiouser and curiouser!"
  },
  {
    "author": "Zadie Smith",
    "quote": "The past is always tense, the future perfect."
  },
  {
    "author": "Anne Rice",
    "quote": "You do have a story inside you; it lies articulate and waiting to be written — behind your silence and your suffering."
  },
  {
    "author": "Douglas Adams,",
    "quote": "The major problem—"
  },
  {
    "author": "Mae West",
    "quote": "Between two evils, I always pick the one I never tried before."
  },
  {
    "author": "Dr. Seuss",
    "quote": "They say I'm old-fashioned, and live in the past, but sometimes I think progress progresses too fast!"
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "The earth laughs in flowers."
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "In my younger and more vulnerable years my father gave me some advice that I've been turning over in my mind ever since."
  },
  {
    "author": "James Joyce",
    "quote": "Shut your eyes and see."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "I have faith that God will show you the answer. But you have to understand that sometimes it takes a while to be able to recognize what God wants you to do. That's how it often is. God's voice is usually nothing more than a whisper, and you have to listen very carefully to hear it. But other times, in those rarest of moments, the answer is obvious and rings as loud as a church bell."
  },
  {
    "author": "Glen Cook,",
    "quote": "Morning is wonderful. Its only drawback is that it comes at such an inconvenient time of day."
  },
  {
    "author": "Lauren Oliver,",
    "quote": "I guess that’s just part of loving people: You have to give things up. Sometimes you even have to give them up."
  },
  {
    "author": "Sigmund Freud",
    "quote": "Being entirely honest with oneself is a good exercise."
  },
  {
    "author": "Rumi",
    "quote": "In your light I learn how to love. In your beauty, how to make poems. You dance inside my chest where no-one sees you, but sometimes I do, and that sight becomes this art."
  },
  {
    "author": "Charles Darwin,",
    "quote": "A man who dares to waste one hour of time has not discovered the value of life."
  },
  {
    "author": "Tom Robbins",
    "quote": "When we're incomplete, we're always searching for somebody to complete us. When, after a few years or a few months of a relationship, we find that we're still unfulfilled, we blame our partners and take up with somebody more promising. This can go on and on--series polygamy--until we admit that while a partner can add sweet dimensions to our lives, we, each of us, are responsible for our own fulfillment. Nobody else can provide it for us, and to believe otherwise is to delude ourselves dangerously and to program for eventual failure every relationship we enter."
  },
  {
    "author": "Jo Walton,",
    "quote": "It doesn't matter. I have books, new books, and I can bear anything as long as there are books."
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "I want to be the friend you fall hopelessly in love with. The one you take into your arms and into your bed and into the private world you keep trapped in your head. I want to be that kind of friend. The one who will memorize the things you say as well as the shape of your lips when you say them. I want to know every curve, every freckle, every shiver of your body."
  },
  {
    "author": "Alexander Pope,",
    "quote": "To err is human, to forgive, divine."
  },
  {
    "author": "Pablo Neruda",
    "quote": "But I love your feet"
  },
  {
    "author": "Anne Rice,",
    "quote": "Evil is always possible. And goodness is eternally difficult."
  },
  {
    "author": "William Shakespeare,",
    "quote": "To-morrow, and to-morrow, and to-morrow,"
  },
  {
    "author": "F. Scott Fitzgerald",
    "quote": "Whenever you feel like criticizing any one...just remember that all the people in this world haven't had the advantages that you've had."
  },
  {
    "author": "Aung San Suu Kyi",
    "quote": "The only real prison is fear, and the only real freedom is freedom from fear"
  },
  {
    "author": "Rita Mae Brown,",
    "quote": "Sorrow is how we learn to love. Your heart isn't breaking. It hurts because it's getting larger. The larger it gets, the more love it holds."
  },
  {
    "author": "Anthony Powell",
    "quote": "I get a warm feeling among my books."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "The man who passes the sentence should swing the sword. If you would take a man's life, you owe it to him to look into his eyes and hear his final words. And if you cannot bear to do that, then perhaps the man does not deserve to die."
  },
  {
    "author": "Paulo Coelho",
    "quote": "If I am really a part of your dream, you'll come back one day."
  },
  {
    "author": "V.E. Schwab,",
    "quote": "I'd rather die on an adventure than live standing still."
  },
  {
    "author": "Kurt Cobain",
    "quote": "I'd rather be hated for who I am, than loved for who I am not."
  },
  {
    "author": "Woody Allen",
    "quote": "In my next life I want to live my life backwards. You start out dead and get that out of the way. Then you wake up in an old people's home feeling better every day. You get kicked out for being too healthy, go collect your pension, and then when you start work, you get a gold watch and a party on your first day. You work for 40 years until you're young enough to enjoy your retirement. You party, drink alcohol, and are generally promiscuous, then you are ready for high school. You then go to primary school, you become a kid, you play. You have no responsibilities, you become a baby until you are born. And then you spend your last 9 months floating in luxurious spa-like conditions with central heating and room service on tap, larger quarters every day and then Voila! You finish off as an orgasm!"
  },
  {
    "author": "Kate Chopin,",
    "quote": "The voice of the sea speaks to the soul."
  },
  {
    "author": "Rainbow Rowell,",
    "quote": "Holding Eleanor's hand was like holding a butterfly. Or a heartbeat. Like holding something complete, and completely alive."
  },
  {
    "author": "richard siken",
    "quote": "You’re in a car with a beautiful boy, and he won’t tell you that he loves you, but he loves you. And you feel like you’ve done something terrible, like robbed a liquor store, or swallowed pills, or shoveled yourself a grave in the dirt, and you’re tired. You’re in a car with a beautiful boy, and you’re trying not to tell him that you love him, and you’re trying to choke down the feeling, and you’re trembling, but he reaches over and he touches you, like a prayer for which no words exist, and you feel your heart taking root in your body, like you’ve discovered something you didn’t even have a name for."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "He awoke each morning with the desire to do right, to be a good and meaningful person, to be, as simple as it sounded and as impossible as it actually was, happy. And during the course of each day his heart would descend from his chest into his stomach. By early afternoon he was overcome by the feeling that nothing was right, or nothing was right for him, and by the desire to be alone. By evening he was fulfilled: alone in the magnitude of his grief, alone in his aimless guilt, alone even in his loneliness."
  },
  {
    "author": "V. S. Naipaul,",
    "quote": "The only lies for which we are truly punished are those we tell ourselves."
  },
  {
    "author": "J.M. Barrie,",
    "quote": "Second star to the right and straight on 'til morning."
  },
  {
    "author": "Karen Blixen",
    "quote": "I know of a cure for everything: salt water...in one way or the other. Sweat, or tears, or the salt sea."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Trains are great dirty smoky things, said Will. You won't like it."
  },
  {
    "author": "Oscar Wilde",
    "quote": "We are each our own devil, and we make this world our hell."
  },
  {
    "author": "Stephen King",
    "quote": "If you liked being a teenager, there's something really wrong with you."
  },
  {
    "author": "أحلام مستغانمي,",
    "quote": "أي علم هذا الذي لم يستطع حتى الآن أن يضع أصوات من نحب في أقراص ، أو زجاجة دواء نتناولها سرًّا ، عندما نصاب بوعكة عاطفية بدون أن يدري صاحبها كم نحن نحتاجه"
  },
  {
    "author": "Fred Rogers",
    "quote": "When I say it's you I like, I'm talking about that part of you that knows that life is far more than anything you can ever see or hear or touch. That deep part of you that allows you to stand for those things without which humankind cannot survive. Love that conquers hate, peace that rises triumphant over war, and justice that proves more powerful than greed."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "The mark of the immature man is that he wants to die nobly for a cause, while the mark of the mature man is that he wants to live humbly for one."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "The last enemy that shall be destroyed is death."
  },
  {
    "author": "C.G. Jung",
    "quote": "Your visions will become clear only when you can look into your own heart. Who looks outside, dreams; who looks inside, awakes."
  },
  {
    "author": "Leo Tolstoy",
    "quote": "Only people who are capable of loving strongly can also suffer great sorrow, but this same necessity of loving serves to counteract their grief and heals them."
  },
  {
    "author": "Epicurus",
    "quote": "Do not spoil what you have by desiring what you have not; remember that what you now have was once among the things you only hoped for."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "An Unbreakable Vow? said Ron, looking stunned. Nah, he can’t have.... Are you sure?"
  },
  {
    "author": "Jandy Nelson,",
    "quote": "Maybe some people are just meant to be in the same story."
  },
  {
    "author": "Carlos Ruiz Zafón,",
    "quote": "People tend to complicate their own lives, as if living weren't already complicated enough."
  },
  {
    "author": "Rick Riordan,",
    "quote": "Um...is that thing"
  },
  {
    "author": "Noam Chomsky",
    "quote": "We shouldn't be looking for heroes, we should be looking for good ideas."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "I was not a pet, not a doll, not an animal."
  },
  {
    "author": "E.L. James,",
    "quote": "Sometimes I wonder if there's something wrong with me. Perhaps I've spent too long in the company of my literary romantic heroes, and consequently my ideals and expectations are far too high."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "The two hardest tests on the spiritual road are the patience to wait for the right moment and the courage not to be disappointed with what we encounter."
  },
  {
    "author": "Louis L'Amour,",
    "quote": "Once you have read a book you care about, some part of it is always with you."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "Is man merely a mistake of God's? Or God merely a mistake of man?"
  },
  {
    "author": "Ned Vizzini,",
    "quote": "I can't eat and I can't sleep. I'm not doing well in terms of being a functional human, you know?"
  },
  {
    "author": "David Mitchell,",
    "quote": "Our lives are not our own. We are bound to others, past and present, and by each crime and every kindness, we birth our future."
  },
  {
    "author": "George S. Patton",
    "quote": "If everybody is thinking alike, then somebody isn't thinking."
  },
  {
    "author": "Rumi Jalalud-Din",
    "quote": "Ignore those that make you fearful and sad, that degrade you back towards disease and death."
  },
  {
    "author": "Ian Fleming,",
    "quote": "You only live twice:"
  },
  {
    "author": "Anne Frank",
    "quote": "Parents can only give good advice or put them on the right paths, but the final forming of a person's character lies in their own hands."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I don't know who invented high heels, but all women owe him a lot!"
  },
  {
    "author": "Mark Twain",
    "quote": "The best way to cheer yourself is to try to cheer someone else up."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "Books serve to show a man that those original thoughts of his aren't very new after all."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Patience, grasshopper, said Maia. Good things come to those who wait."
  },
  {
    "author": "Harper Lee,",
    "quote": "They're certainly entitled to think that, and they're entitled to full respect for their opinions... but before I can live with other folks I've got to live with myself. The one thing that doesn't abide by majority rule is a person's conscience."
  },
  {
    "author": "Laini Taylor,",
    "quote": "Have you ever asked yourself, do monsters make war, or does war make monsters?"
  },
  {
    "author": "Candace Bushnell,",
    "quote": "Maybe our girlfriends are our soulmates and guys are just people to have fun with."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "Maybe there were people who lived those lives. Maybe this girl was one of them. But what about the rest of us? What about the nobodies and the nothings, the invisible girls?"
  },
  {
    "author": "Jack Kerouac,",
    "quote": "Nothing behind me, everything ahead of me, as is ever so on the road."
  },
  {
    "author": "Hafiz",
    "quote": "Even"
  },
  {
    "author": "Frida Kahlo",
    "quote": "At the end of the day, we can endure much more than we think we can."
  },
  {
    "author": "Mitch Albom,",
    "quote": "Holding anger is a poison...It eats you from inside...We think that by hating someone we hurt them...But hatred is a curved blade...and the harm we do to others...we also do to ourselves."
  },
  {
    "author": "Neil LaBute,",
    "quote": "The future is now. It's time to grow up and be strong. Tomorrow may well be too late."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "I love you, not just for now, but for always, and I dream of the day that you’ll take me in your arms again."
  },
  {
    "author": "Colleen Hoover,",
    "quote": "There are three questions every woman should be able to answer yes to before they commit to a man. If you answer no to any of the three questions, run like hell."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "If the moon smiled, she would resemble you."
  },
  {
    "author": "Rene Descartes",
    "quote": "I think; therefore I am."
  },
  {
    "author": "Neil Gaiman",
    "quote": "This is how you do it: you sit down at the keyboard and you put one word after another until its done. It's that easy, and that hard."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "The surest way to corrupt a youth is to instruct him to hold in higher esteem those who think alike than those who think differently."
  },
  {
    "author": "Marie Curie",
    "quote": "Nothing in life is to be feared, it is only to be understood. Now is the time to understand more, so that we may fear less."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "What is family? They were the people who claimed you. In good, in bad, in parts or in whole, they were the ones who showed up, who stayed in there, regardless. It wasn't just about blood relations or shared chromosomes, but something wider, bigger. We had many families over time. Our family of origin, the family we created, and the groups you moved through while all of this was happening: friends, lovers, sometimes even strangers. None of them perfect, and we couldn't expect them to be. You can't make any one person your world. The trick was to take what each could give you and build your world from it."
  },
  {
    "author": "Ernest Hemingway",
    "quote": "All good books are alike in that they are truer than if they had really happened and after you are finished reading one you will feel that all that happened to you and afterwards it all belongs to you: the good and the bad, the ecstasy, the remorse and sorrow, the people and the places and how the weather was. If you can get so that you can give that to people, then you are a writer."
  },
  {
    "author": "Fannie Flagg,",
    "quote": "I wonder how many people don't get the one they want, but end up with the one they're supposed to be with."
  },
  {
    "author": "Oscar Wilde",
    "quote": "I have nothing to declare except my genius."
  },
  {
    "author": "Jon Krakauer,",
    "quote": "make a radical change in your lifestyle and begin to boldly do things which you may previously never have thought of doing, or been too hesitant to attempt. So many people live within unhappy circumstances and yet will not take the initiative to change their situation because they are conditioned to a life of security, conformity, and conservation, all of which may appear to give one peace of mind, but in reality nothing is more damaging to the adventurous spirit within a man than a secure future. The very basic core of a man's living spirit is his passion for adventure. The joy of life comes from our encounters with new experiences, and hence there is no greater joy than to have an endlessly changing horizon, for each day to have a new and different sun. If you want to get more out of life, you must lose your inclination for monotonous security and adopt a helter-skelter style of life that will at first appear to you to be crazy. But once you become accustomed to such a life you will see its full meaning and its incredible beauty."
  },
  {
    "author": "Henry David Thoreau",
    "quote": "The question is not what you look at, but what you see."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You're the first Shadowhunter I've ever met."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "Some walks you have to take alone."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "you have to love something before you can hate it."
  },
  {
    "author": "Jasper Fforde,",
    "quote": "If the real world were a book, it would never find a publisher. Overlong, detailed to the point of distraction-and ultimately, without a major resolution."
  },
  {
    "author": "Oprah Winfrey",
    "quote": "Be thankful for what you have; you'll end up having more. If you concentrate on what you don't have, you will never, ever have enough."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "No Mourners."
  },
  {
    "author": "Nicole Krauss,",
    "quote": "When will you learn that there isn't a word for everything?"
  },
  {
    "author": "Khalil Gibran",
    "quote": "One day you will ask me which is more important? My life or yours? I will say mine and you will walk away not knowing that you are my life."
  },
  {
    "author": "George Bernard Shaw",
    "quote": "Those who cannot change their minds cannot change anything."
  },
  {
    "author": "Anaïs Nin,",
    "quote": "Reality doesn't impress me. I only believe in intoxication, in ecstasy, and when ordinary life shackles me, I escape, one way or another. No more walls."
  },
  {
    "author": "Simone Elkeles,",
    "quote": "You’re dangerous, he says."
  },
  {
    "author": "Oscar Wilde ,",
    "quote": "What of Art?"
  },
  {
    "author": "Thomas Babington Macaulay,",
    "quote": "What a blessing it is to love books as I love them;- to be able to converse with the dead, and to live amidst the unreal!"
  },
  {
    "author": "Lord Byron",
    "quote": "There is a pleasure in the pathless woods,"
  },
  {
    "author": "Tiffanie DeBartolo,",
    "quote": "Did you really want to die?"
  },
  {
    "author": "Hal Borland",
    "quote": "No winter lasts forever; no spring skips its turn."
  },
  {
    "author": "Victor Hugo",
    "quote": "To put everything in balance is good, to put everything in harmony is better."
  },
  {
    "author": "Neil deGrasse Tyson",
    "quote": "The good thing about science is that it's true whether or not you believe in it."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Alec looked at her and shook his head. How do you manage never to get mud on your clothes?"
  },
  {
    "author": "Annie Proulx",
    "quote": "You should write because you love the shape of stories and sentences and the creation of different words on a page. Writing comes from reading, and reading is the finest teacher of how to write."
  },
  {
    "author": "Haruki Murakami",
    "quote": "But I didn't understand then. That I could hurt somebody so badly she would never recover. That a person can, just by living, damage another human being beyond repair."
  },
  {
    "author": "Bill Watterson",
    "quote": "I'm killing time while I wait for life to shower me with meaning and happiness."
  },
  {
    "author": "Aristotle",
    "quote": "Hope is a waking dream."
  },
  {
    "author": "Alex Haley",
    "quote": "Either you deal with what is the reality, or you can be sure that the reality is going to deal with you."
  },
  {
    "author": "Rick Riordan",
    "quote": "Can you surf really well, then?"
  },
  {
    "author": "Honoré de Balzac",
    "quote": "All happiness depends on courage and work."
  },
  {
    "author": "John Green,",
    "quote": "And then something invisible snapped insider her, and that which had come together commenced to fall apart."
  },
  {
    "author": "Phyllis McGinley",
    "quote": "A bit of trash now and then is good for the severest reader. It provides the necessary roughage in the literary diet."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "It's going to be all right, sir, Harry said over and over again, more worried by Dumbledore's silence than he had been by his weakened voice. We're nearly there ... I can Apparate us both back ... don't worry ..."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "We are all someone's monster."
  },
  {
    "author": "Carol Shields,",
    "quote": "Open a book this minute and start reading. Don’t move until you’ve reached page fifty. Until you’ve buried your thoughts in print. Cover yourself with words. Wash yourself away. Dissolve."
  },
  {
    "author": "Pittacus Lore,",
    "quote": "When you have lost hope, you have lost everything. And when you think all is lost, when all is dire and bleak, there is always hope."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Never marry at all, Dorian. Men marry because they are tired, women, because they are curious: both are disappointed."
  },
  {
    "author": "J.R. Ward,",
    "quote": "I was dead until you found me, though I breathed. I was sightless, though I could see. And then you came...and I was awakened."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "The future depends on what you do today."
  },
  {
    "author": "Charles Bukowski,",
    "quote": "A love like that was a serious illness, an illness from which you never entirely recover."
  },
  {
    "author": "Simone de Beauvoir",
    "quote": "I am awfully greedy; I want everything from life. I want to be a woman and to be a man, to have many friends and to have loneliness, to work much and write good books, to travel and enjoy myself, to be selfish and to be unselfish… You see, it is difficult to get all which I want. And then when I do not succeed I get mad with anger."
  },
  {
    "author": "Ray Bradbury,",
    "quote": "We need not to be let alone. We need to be really bothered once in a while. How long is it since you were really bothered? About something important, about something real?"
  },
  {
    "author": "Charles Baudelaire",
    "quote": "Always be a poet, even in prose."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "The advantage of a bad memory is that one enjoys several times the same good things for the first time."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "You care so much you feel as though you will bleed to death with the pain of it."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Magnus, standing by the door, snapped his fingers impatiently. Move it along, teenagers. The only person who gets to canoodle in my bedroom is my magnificent self."
  },
  {
    "author": "Mitch Albom,",
    "quote": "When someone is in your heart, they're never truly gone. They can come back to you, even at unlikely times."
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "If, then, I were asked for the most important advice I could give, that which I considered to be the most useful to the men of our century, I should simply say: in the name of God, stop a moment, cease your work, look around you."
  },
  {
    "author": "Markus Zusak,",
    "quote": "A small but noteworthy note. I've seen so many young men over the years who think they're running at other young men. They are not. They are running at me."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Anybody can sympathise with the sufferings of a friend, but it requires a very fine nature to sympathise with a friend's success."
  },
  {
    "author": "J.R.R. Tolkien",
    "quote": "I sit beside the fire and think"
  },
  {
    "author": "Martin Luther King Jr.",
    "quote": "Intelligence plus character-that is the goal of true education."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "I hope that one day you will have the experience of doing something you do not understand for someone you love."
  },
  {
    "author": "Albert Einstein",
    "quote": "The best way to cheer yourself is to cheer somebody else up."
  },
  {
    "author": "Stephen Fry",
    "quote": "Books are no more threatened by Kindle than stairs by elevators."
  },
  {
    "author": "John Lennon",
    "quote": "I believe in God, but not as one thing, not as an old man in the sky. I believe that what people call God is something in all of us. I believe that what Jesus and Mohammed and Buddha and all the rest said was right. It's just that the translations have gone wrong."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Why are you worrying about YOU-KNOW-WHO, when you should be worrying about YOU-NO-POO? The constipation sensation that's gripping the nation!"
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Wanting to be someone else is a waste of the person you are."
  },
  {
    "author": "Michel de Montaigne",
    "quote": "The most certain sign of wisdom is cheerfulness."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "You might want to lie down, Magnus advised. I find that it helps when the crushing sense of horrible realization sets in."
  },
  {
    "author": "Reginald Vincent Holmes,",
    "quote": "The earth has its music for those who will listen"
  },
  {
    "author": "Charlotte Brontë,",
    "quote": "If all the world hated you and believed you wicked, while your own conscience approved of you and absolved you from guilt, you would not be without friends."
  },
  {
    "author": "Margaret Atwood,",
    "quote": "Male fantasies, male fantasies, is everything run by male fantasies? Up on a pedestal or down on your knees, it's all a male fantasy: that you're strong enough to take what they dish out, or else too weak to do anything about it. Even pretending you aren't catering to male fantasies is a male fantasy: pretending you're unseen, pretending you have a life of your own, that you can wash your feet and comb your hair unconscious of the ever-present watcher peering through the keyhole, peering through the keyhole in your own head, if nowhere else. You are a woman with a man inside watching a woman. You are your own voyeur."
  },
  {
    "author": "Neil deGrasse Tyson",
    "quote": "For me, I am driven by two main philosophies: know more today about the world than I knew yesterday and lessen the suffering of others. You'd be surprised how far that gets you."
  },
  {
    "author": "Ernest Hemingway,",
    "quote": "Every day is a new day. It is better to be lucky. But I would rather be exact. Then when luck comes you are ready."
  },
  {
    "author": "Jack Kerouac",
    "quote": "The only truth is music."
  },
  {
    "author": "Lucius Annaeus Seneca",
    "quote": "Sometimes even to live is an act of courage."
  },
  {
    "author": "Victor Hugo,",
    "quote": "The power of a glance has been so much abused in love stories, that it has come to be disbelieved in. Few people dare now to say that two beings have fallen in love because they have looked at each other. Yet it is in this way that love begins, and in this way only."
  },
  {
    "author": "C.S. Lewis",
    "quote": "He died not for men, but for each man. If each man had been the only man made, He would have done no less."
  },
  {
    "author": "Stephanie Lennox,",
    "quote": "I’ve been fighting to be who I am all my life. What’s the point of being who I am, if I can’t have the person who was worth all the fighting for?"
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "The things you used to own, now they own you."
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "If death meant just leaving the stage long enough to change costume and come back as a new character...Would you slow down? Or speed up?"
  },
  {
    "author": "Langston Hughes",
    "quote": "Let the rain kiss you. Let the rain beat upon your head with silver liquid drops. Let the rain sing you a lullaby."
  },
  {
    "author": "Shannon L. Alder",
    "quote": "Dignity"
  },
  {
    "author": "Francois Duc de la Rochefoucauld,",
    "quote": "Absence diminishes small loves and increases great ones, as the wind blows out the candle and fans the bonfire."
  },
  {
    "author": "Carl Sagan,",
    "quote": "Science is not only compatible with spirituality; it is a profound source of spirituality."
  },
  {
    "author": "Henry James",
    "quote": "She feels in italics and thinks in CAPITALS."
  },
  {
    "author": "Steve Maraboli,",
    "quote": "Incredible change happens in your life when you decide to take control of what you do have power over instead of craving control over what you don't."
  },
  {
    "author": "Moliere",
    "quote": "Trees that are slow to grow bear the best fruit."
  },
  {
    "author": "Louise Erdrich,",
    "quote": "When we are young, the words are scattered all around us. As they are assembled by experience, so also are we, sentence by sentence, until the story takes shape."
  },
  {
    "author": "John Keats,",
    "quote": "Heard melodies are sweet, but those unheard, are sweeter"
  },
  {
    "author": "Oscar Wilde",
    "quote": "A man's face is his autobiography. A woman's face is her work of fiction."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Silence, I discover, is something you can actually hear."
  },
  {
    "author": "Joss Whedon",
    "quote": "I write to give myself strength. I write to be the characters that I am not. I write to explore all the things I'm afraid of."
  },
  {
    "author": "Albert Camus",
    "quote": "Autumn is a second spring when every leaf is a flower."
  },
  {
    "author": "G.K. Chesterton",
    "quote": "Fairy tales do not tell children the dragons exist. Children already know that dragons exist. Fairy tales tell children the dragons can be killed."
  },
  {
    "author": "George Orwell,",
    "quote": "But if thought corrupts language, language can also corrupt thought."
  },
  {
    "author": "Bruce Lee",
    "quote": "I’m not in this world to live up to your expectations and you’re not in this world to live up to mine."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "...you know that a good, long session of weeping can often make you feel better, even if your circumstances have not changed one bit."
  },
  {
    "author": "C.S. Lewis",
    "quote": "The homemaker has the ultimate career. All other careers exist for one purpose only - and that is to support the ultimate career."
  },
  {
    "author": "Frank Zappa",
    "quote": "If you want to get laid, go to college. If you want an education, go to the library."
  },
  {
    "author": "Lorraine Hansberry",
    "quote": "The thing that makes you exceptional, if you are at all, is inevitably that which must also make you lonely."
  },
  {
    "author": "Ray Bradbury",
    "quote": "There is more than one way to burn a book. And the world is full of people running about with lit matches."
  },
  {
    "author": "George Carlin",
    "quote": "There are nights when the wolves are silent and only the moon howls."
  },
  {
    "author": "Mitch Albom,",
    "quote": "Have you ever lost someone you love and wanted one more conversation, one more chance to make up for the time when you thought they would be here forever? If so, then you know you can go your whole life collecting days, and none will outweigh the one you wish you had back."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "Mental pain is less dramatic than physical pain, but it is more common and also more hard to bear. The frequent attempt to conceal mental pain increases the burden: it is easier to say My tooth is aching than to say My heart is broken."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I know it's wrong - God, it's all kinds of wrong - but I just want to lie down with you and wake up with you, just once, just once ever in my life."
  },
  {
    "author": "Richelle Mead,",
    "quote": "You will lose what you value most, so treasure it while you can."
  },
  {
    "author": "Dan Brown,",
    "quote": "Men go to far greater lengths to avoid what they fear than to obtain what they desire."
  },
  {
    "author": "Nicole Krauss,",
    "quote": "there are two types of people in the world: those who prefer to be sad among others, and those who prefer to be sad alone."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Most men would rather deny a hard truth than face it."
  },
  {
    "author": "Steven Spielberg",
    "quote": "Only a generation of readers will spawn a generation of writers."
  },
  {
    "author": "Dr. Seuss,",
    "quote": "You’ll miss the best things if you keep your eyes shut."
  },
  {
    "author": "Voltaire",
    "quote": "The more I read, the more I acquire, the more certain I am that I know nothing."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "We do not need magic to transform our world. We carry all of the power we need inside ourselves already."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "If no one cares for you at all, do you even really exist?"
  },
  {
    "author": "Sean O'Casey",
    "quote": "Laughter is wine for the soul - laughter soft, or loud and deep, tinged through with seriousness - the hilarious declaration made by man that life is worth living."
  },
  {
    "author": "Rick Riordan,",
    "quote": "You deal with mythological stuff for a few years, you learn that paradises are usually places where you get killed."
  },
  {
    "author": "Douglas Adams,",
    "quote": "Nothing travels faster than the speed of light, with the possible exception of bad news, which obeys its own special laws."
  },
  {
    "author": "Maya Angelou",
    "quote": "You alone are enough. You have nothing to prove to anybody."
  },
  {
    "author": "Helen Keller,",
    "quote": "Life is either a daring adventure or nothing at all."
  },
  {
    "author": "Lauren Conrad",
    "quote": "Don't cry over someone who wouldn't cry over you."
  },
  {
    "author": "Colleen Hoover,",
    "quote": "I got schooled this year"
  },
  {
    "author": "Douglas Adams,",
    "quote": "He felt that his whole life was some kind of dream and he sometimes wondered whose it was and whether they were enjoying it."
  },
  {
    "author": "Ellen Bass",
    "quote": "to love life, to love it even"
  },
  {
    "author": "Sylvia Plath,",
    "quote": "I like people too much or not at all. I've got to go down deep, to fall into people, to really know them."
  },
  {
    "author": "Edith Wharton",
    "quote": "There are two ways of spreading light: to be the candle or the mirror that receives it."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "We can't be afraid of change. You may feel very secure in the pond that you are in, but if you never venture out of it, you will never know that there is such a thing as an ocean, a sea. Holding onto something that is good for you now, may be the very reason why you don't have something better."
  },
  {
    "author": "Becca Fitzpatrick,",
    "quote": "I don't go out with strangers, I said."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "All a girl really wants is for one guy to prove to her that they are not all the same."
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Stories you read when you're the right age never quite leave you. You may forget who wrote them or what the story was called. Sometimes you'll forget precisely what happened, but if a story touches you it will stay with you, haunting the places in your mind that you rarely ever visit."
  },
  {
    "author": "Stephen King",
    "quote": "Alone. Yes, that's the key word, the most awful word in the English tongue. Murder doesn't hold a candle to it and hell is only a poor synonym."
  },
  {
    "author": "Dr. Seuss",
    "quote": "If you never did you should. These things are fun and fun is good."
  },
  {
    "author": "Jean de La Fontaine,",
    "quote": "A person often meets his destiny on the road he took to avoid it."
  },
  {
    "author": "Pat  Monahan",
    "quote": "You can only be young once. But you can always be immature."
  },
  {
    "author": "Jean-Paul Sartre",
    "quote": "Do you think that I count the days? There is only one day left, always starting over: it is given to us at dawn and taken away from us at dusk."
  },
  {
    "author": "جبران خليل جبران",
    "quote": "لا تجالس أنصاف العشاق، ولا تصادق أنصاف الأصدقاء، لا تقرأ لأنصاف الموهوبين،لا تعش نصف حياة، ولا تمت نصف موت،لا تختر نصف حل، ولا تقف في منتصف الحقيقة، لا تحلم نصف حلم، ولا تتعلق بنصف أمل، إذا صمتّ.. فاصمت حتى النهاية، وإذا تكلمت.. فتكلّم حتى النهاية، لا تصمت كي تتكلم، ولا تتكلم كي تصمت."
  },
  {
    "author": "Johnny Depp",
    "quote": "If someone were to harm my family or a friend or somebody I love, I would eat them. I might end up in jail for 500 years, but I would eat them."
  },
  {
    "author": "Alexandre Dumas,",
    "quote": "All human wisdom is contained in these two words - Wait and Hope"
  },
  {
    "author": "William S. Burroughs",
    "quote": "A paranoid is someone who knows a little of what's going on."
  },
  {
    "author": "E.E. Cummings",
    "quote": "We do not believe in ourselves until someone reveals that deep inside us something is valuable, worth listening to, worthy of our trust, sacred to our touch. Once we believe in ourselves we can risk curiosity, wonder, spontaneous delight or any experience that reveals the human spirit."
  },
  {
    "author": "Henry Thomas Buckle",
    "quote": "Great minds discuss ideas. Average minds discuss events. Small minds discuss people."
  },
  {
    "author": "Lemony Snicket",
    "quote": "I will love you as a thief loves a gallery and as a crow loves a murder, as a cloud loves bats and as a range loves braes. I will love you as misfortune loves orphans, as fire loves innocence and as justice loves to sit and watch while everything goes wrong. I will love you as a battlefield loves young men and as peppermints love your allergies, and I will love you as the banana peel loves the shoe of a man who was just struck by a shingle falling off a house. I will love you as a volunteer fire department loves rushing into burning buildings and as burning buildings love to chase them back out, and as a parachute loves to leave a blimp and as a blimp operator loves to chase after it."
  },
  {
    "author": "Norman Vincent Peale",
    "quote": "Shoot for the moon. Even if you miss, you'll land among the stars."
  },
  {
    "author": "Steve Maraboli,",
    "quote": "I want to be in a relationship where you telling me you love me is just a ceremonious validation of what you already show me."
  },
  {
    "author": "Dr. Seuss",
    "quote": "Only you can control your future."
  },
  {
    "author": "V.E. Schwab,",
    "quote": "Books, she has found, are a way to live a thousand lives--or to find strength in a very long one."
  },
  {
    "author": "Walt Whitman",
    "quote": "Keep your face always toward the sunshine - and shadows will fall behind you."
  },
  {
    "author": "Charles bukowski",
    "quote": "there is a place in the heart that"
  },
  {
    "author": "Albert Einstein",
    "quote": "Whoever is careless with the truth in small matters cannot be trusted with important matters"
  },
  {
    "author": "Agatha Christie,",
    "quote": "The impossible could not have happened, therefore the impossible must be possible in spite of appearances."
  },
  {
    "author": "Franz Kafka,",
    "quote": "I cannot make you understand. I cannot make anyone understand what is happening inside me. I cannot even explain it to myself."
  },
  {
    "author": "R.A. Salvatore,",
    "quote": "It is better, I think, to grab at the stars than to sit flustered because you know you cannot reach them."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Fashion is a form of ugliness so intolerable that we have to alter it every six months."
  },
  {
    "author": "Taylor Jenkins Reid,",
    "quote": "I had absolutely no interest in being somebody else's muse."
  },
  {
    "author": "Robert Frost",
    "quote": "Freedom lies in being bold."
  },
  {
    "author": "Melissa Marr,",
    "quote": "Sometimes love means letting go when you want to hold on tighter."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "There are moments when troubles enter our lives and we can do nothing to avoid them."
  },
  {
    "author": "Eleanor Hodgman Porter",
    "quote": "Be glad. Be good. Be brave."
  },
  {
    "author": "Caroline Gordon",
    "quote": "A well-composed book is a magic carpet on which we are wafted to a world that we cannot enter in any other way."
  },
  {
    "author": "Ashleigh Brilliant",
    "quote": "My life has a superb cast, but I cannot figure out the plot."
  },
  {
    "author": "Roald Dahl,",
    "quote": "A person who has good thoughts cannot ever be ugly. You can have a wonky nose and a crooked mouth and a double chin and stick-out teeth, but if you have good thoughts they will shine out of your face like sunbeams and you will always look lovely."
  },
  {
    "author": "C.S. Lewis,",
    "quote": "It would seem that Our Lord finds our desires not too strong, but too weak. We are half-hearted creatures, fooling about with drink and sex and ambition when infinite joy is offered us, like an ignorant child who wants to go on making mud pies in a slum because he cannot imagine what is meant by the offer of a holiday at the sea. We are far too easily pleased."
  },
  {
    "author": "Washington Irving",
    "quote": "A mother is the truest friend we have, when trials heavy and sudden fall upon us; when adversity takes the place of prosperity; when friends desert us; when trouble thickens around us, still will she cling to us, and endeavor by her kind precepts and counsels to dissipate the clouds of darkness, and cause peace to return to our hearts."
  },
  {
    "author": "Friedrich Nietzsche",
    "quote": "Man is the cruelest animal."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "I am both happy and sad at the same time, and I'm still trying to figure out how that could be."
  },
  {
    "author": "Jane Yolen,",
    "quote": "Literature is a textually transmitted disease, normally contracted in childhood."
  },
  {
    "author": "Aristotle",
    "quote": "No great mind has ever existed without a touch of madness."
  },
  {
    "author": "Cormac McCarthy,",
    "quote": "Scars have the strange power to remind us that our past is real."
  },
  {
    "author": "Bram Stoker,",
    "quote": "We learn from failure, not from success!"
  },
  {
    "author": "George Orwell,",
    "quote": "If you want a picture of the future, imagine a boot stamping on a human face—for ever."
  },
  {
    "author": "Anne Sexton,",
    "quote": "Watch out for intellect,"
  },
  {
    "author": "Barack Obama",
    "quote": "The best way to not feel hopeless is to get up and do something. Don’t wait for good things to happen to you. If you go out and make some good things happen, you will fill the world with hope, you will fill yourself with hope."
  },
  {
    "author": "Anaïs Nin,",
    "quote": "I hate men who are afraid of women's strength."
  },
  {
    "author": "Fernando Pessoa",
    "quote": "The feelings that hurt most, the emotions that sting most, are those that are absurd - The longing for impossible things, precisely because they are impossible; nostalgia for what never was; the desire for what could have been; regret over not being someone else; dissatisfaction with the world’s existence. All these half-tones of the soul’s consciousness create in us a painful landscape, an eternal sunset of what we are."
  },
  {
    "author": "Katherine Anne Porter",
    "quote": "The past is never where you think you left it."
  },
  {
    "author": "Oscar Wilde",
    "quote": "Whenever people agree with me I always feel I must be wrong."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Dreams are always crushing when they don't come true. But it's the simple dreams that are often the most painful because they seem so personal, so reasonable, so attainable. You're always close enough to touch, but never quite close enough to hold and it's enough to break your heart."
  },
  {
    "author": "عباس محمود العقاد",
    "quote": "ليس هناك كتابا أقرأه و لا أستفيد منه شيئا جديدا ، فحتى الكتاب التافه أستفيد من قراءته ، أني تعلمت شيئا جديدا هو ما هي التفاهة ؟ و كيف يكتب الكتاب التافهون ؟ و فيم يفكرون ؟"
  },
  {
    "author": "F. Scott Fitzgerald,",
    "quote": "Life starts all over again when it gets crisp in the fall."
  },
  {
    "author": "Katharine Graham",
    "quote": "The longer I live, the more I observe that carrying around anger is the most debilitating to the person who bears it."
  },
  {
    "author": "Ray Bradbury,",
    "quote": "There must be something in books, something we can’t imagine, to make a woman stay in a burning house; there must be something there. You don’t stay for nothing."
  },
  {
    "author": "Isaac Asimov",
    "quote": "Anti-intellectualism has been a constant thread winding its way through our political and cultural life, nurtured by the false notion that democracy means that"
  },
  {
    "author": "Victor Hugo,",
    "quote": "It is nothing to die. It is frightful not to live."
  },
  {
    "author": "Viktor E. Frankl,",
    "quote": "Those who have a 'why' to live, can bear with almost any 'how'."
  },
  {
    "author": "Richelle Mead,",
    "quote": "I know how devastated you must be to miss me, but leave a message, and I'll try to ease your agony"
  },
  {
    "author": "Khaled Hosseini,",
    "quote": "Marriage can wait, education cannot."
  },
  {
    "author": "Stephenie Meyer,",
    "quote": "I decided as long as I'm going to hell, I might as well do it thoroughly."
  },
  {
    "author": "Seamus Heaney,",
    "quote": "If you have the words, there's always a chance that you'll find the way."
  },
  {
    "author": "Jeanette Winterson,",
    "quote": "You’ll get over it… It’s the clichés that cause the trouble. To lose someone you love is to alter your life for ever. You don’t get over it because ‘it is the person you loved. The pain stops, there are new people, but the gap never closes. How could it? The particularness of someone who mattered enough to grieve over is not made anodyne by death. This hole in my heart is in the shape of you and no-one else can fit it. Why would I want them to?"
  },
  {
    "author": "Eleanor Roosevelt",
    "quote": "Many people will walk in and out of your life, but only true friends will leave footprints in your heart"
  },
  {
    "author": "Harper Lee,",
    "quote": "Atticus said to Jem one day, I’d rather you shot at tin cans in the backyard, but I know you’ll go after birds. Shoot all the blue jays you want, if you can hit ‘em, but remember it’s a sin to kill a mockingbird. That was the only time I ever heard Atticus say it was a sin to do something, and I asked Miss Maudie about it. Your father’s right, she said. Mockingbirds don’t do one thing except make music for us to enjoy. They don’t eat up people’s gardens, don’t nest in corn cribs, they don’t do one thing but sing their hearts out for us. That’s why it’s a sin to kill a mockingbird."
  },
  {
    "author": "Abraham Lincoln",
    "quote": "When I do good, I feel good. When I do bad, I feel bad. That's my religion."
  },
  {
    "author": "Amy Tan,",
    "quote": "We dream to give ourselves hope. To stop dreaming - well, that’s like saying you can never change your fate."
  },
  {
    "author": "Mary Oliver",
    "quote": "Instructions for living a life."
  },
  {
    "author": "Laura Ingalls Wilder",
    "quote": "I am beginning to learn that it is the sweet, simple things of life which are the real ones after all."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Demon pox, oh demon pox"
  },
  {
    "author": "Lauren Oliver,",
    "quote": "I guess that's what saying good-bye is always like--like jumping off an edge. The worst part is making the choice to do it. Once you're in the air, there's nothing you can do but let go."
  },
  {
    "author": "Cormac McCarthy,",
    "quote": "You forget what you want to remember, and you remember what you want to forget."
  },
  {
    "author": "Gary Paulsen,",
    "quote": "If books could have more, give more, be more, show more, they would still need readers who bring to them sound and smell and light and all the rest that can’t be in books."
  },
  {
    "author": "Toni Morrison",
    "quote": "You think because he doesn't love you that you are worthless. You think that because he doesn't want you anymore that he is right -- that his judgement and opinion of you are correct. If he throws you out, then you are garbage. You think he belongs to you because you want to belong to him. Don't. It's a bad word, 'belong.' Especially when you put it with somebody you love. Love shouldn't be like that. Did you ever see the way the clouds love a mountain? They circle all around it; sometimes you can't even see the mountain for the clouds. But you know what? You go up top and what do you see? His head. The clouds never cover the head. His head pokes through, beacuse the clouds let him; they don't wrap him up. They let him keep his head up high, free, with nothing to hide him or bind him. You can't own a human being. You can't lose what you don't own. Suppose you did own him. Could you really love somebody who was absolutely nobody without you? You really want somebody like that? Somebody who falls apart when you walk out the door? You don't, do you? And neither does he. You're turning over your whole life to him. Your whole life, girl. And if it means so little to you that you can just give it away, hand it to him, then why should it mean any more to him? He can't value you more than you value yourself."
  },
  {
    "author": "Albert Einstein",
    "quote": "When you trip over love, it is easy to get up. But when you fall in love, it is impossible to stand again."
  },
  {
    "author": "William Shakespeare,",
    "quote": "The course of true love never did run smooth; But, either it was different in blood,"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "If you're texting Magnus to say 'I think u r kewl,' I'm going to kill you."
  },
  {
    "author": "Laurie Halse Anderson,",
    "quote": "In one aspect, yes, I believe in ghosts, but we create them. We haunt ourselves."
  },
  {
    "author": "Markus Zusak,",
    "quote": "Usually we walk around constantly believing ourselves. I'm okay we say. I'm alright. But sometimes the truth arrives on you and you can't get it off. That's when you realize that sometimes it isn't even an answer--it's a question. Even now, I wonder how much of my life is convinced."
  },
  {
    "author": "Katie McGarry,",
    "quote": "The worst type of crying wasn't the kind everyone could see--the wailing on street corners, the tearing at clothes. No, the worst kind happened when your soul wept and no matter what you did, there was no way to comfort it. A section withered and became a scar on the part of your soul that survived. For people like me and Echo, our souls contained more scar tissue than life."
  },
  {
    "author": "John Green,",
    "quote": "I’m on a roller coaster that only goes up, my friend."
  },
  {
    "author": "Rachel Carson",
    "quote": "The more clearly we can focus our attention on the wonders and realities of the universe about us, the less taste we shall have for destruction."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Stars, hide your fires; Let not light see my black and deep desires."
  },
  {
    "author": "Rick Riordan,",
    "quote": "You are okay? he asked. Not eaten by monsters?"
  },
  {
    "author": "Colleen Hoover,",
    "quote": "It stops here. With me and you. It ends with us."
  },
  {
    "author": "Napoleon Bonaparte",
    "quote": "Courage isn't having the strength to go on - it is going on when you don't have strength."
  },
  {
    "author": "Jane Austen,",
    "quote": "It isn't what we say or think that defines us, but what we do."
  },
  {
    "author": "Jack London",
    "quote": "You can't wait for inspiration. You have to go after it with a club."
  },
  {
    "author": "Will Rogers",
    "quote": "Never miss a good chance to shut up."
  },
  {
    "author": "Confucius",
    "quote": "He who knows all the answers has not been asked all the questions."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "A man is but the product of his thoughts. What he thinks, he becomes."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Well, she's not responding to my advances, he observed more brightly than he felt, so she must be dead."
  },
  {
    "author": "Taylor Swift",
    "quote": "This is a new year. A new beginning. And things will change."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I don't mind making jokes, but I don't want to look like one."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "God does not play dice with the universe; He plays an ineffable game of His own devising, which might be compared, from the perspective of any of the other players [i.e. everybody], to being involved in an obscure and complex variant of poker in a pitch-dark room, with blank cards, for infinite stakes, with a Dealer who won't tell you the rules, and who"
  },
  {
    "author": "Walt Disney",
    "quote": "All our dreams can come true, if we have the courage to pursue them."
  },
  {
    "author": "Geraldine Brooks,",
    "quote": "For to know a man's library is, in some measure, to know his mind."
  },
  {
    "author": "Markus Zusak,",
    "quote": "He was the crazy one who had painted himself black and defeated the world."
  },
  {
    "author": "Roy T. Bennett",
    "quote": "Do not set aside your happiness. Do not wait to be happy in the future. The best time to be happy is always now."
  },
  {
    "author": "R.J. Palacio,",
    "quote": "I think there should be a rule that everyone in the world should get a standing ovation at least once in their lives."
  },
  {
    "author": "T.S. Eliot,",
    "quote": "To do the useful thing, to say the courageous thing, to contemplate the beautiful thing: that is enough for one man's life."
  },
  {
    "author": "John Keats,",
    "quote": "Do you not see how necessary a world of pains and troubles is to school an intelligence and make it a soul?"
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "And then I am going to rattle the stars."
  },
  {
    "author": "Alan Moore,",
    "quote": "Behind this mask there is more than just flesh. Beneath this mask there is an idea... and ideas are bulletproof."
  },
  {
    "author": "Cheris Kramarae",
    "quote": "Feminism is the radical notion that women are human beings."
  },
  {
    "author": "Robert Frost",
    "quote": "The best way out is always through."
  },
  {
    "author": "Mark Twain",
    "quote": "Name the greatest of all inventors. Accident."
  },
  {
    "author": "Alan Alda",
    "quote": "Your assumptions are your windows on the world. Scrub them off every once in a while, or the light won't come in."
  },
  {
    "author": "Herman Melville,",
    "quote": "I know not all that may be coming, but be it what it will, I'll go to it laughing."
  },
  {
    "author": "Margaret Atwood,",
    "quote": "Another belief of mine: that everyone else my age is an adult, whereas I am merely in disguise."
  },
  {
    "author": "W.E.B. DuBois",
    "quote": "Children learn more from what you are than what you teach."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "Sex is part of nature. I go along with nature."
  },
  {
    "author": "Albert Einstein",
    "quote": "What is right is not always popular and what is popular is not always right."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "You could say sorry, suggested Harry bluntly."
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "The water hears and understands. The ice does not forgive."
  },
  {
    "author": "David Henry Hwang,",
    "quote": "I'm happy. Which often looks like crazy."
  },
  {
    "author": "Terry McMillan ,",
    "quote": "Too many of us are hung up on what we don't have, can't have, or won't ever have. We spend too much energy being down, when we could use that same energy – if not less of it – doing, or at least trying to do, some of the things we really want to do."
  },
  {
    "author": "Sylvia Plath,",
    "quote": "The trouble was, I had been inadequate all along, I simply hadn't thought about it."
  },
  {
    "author": "Philip José Farmer",
    "quote": "Imagination is like a muscle. I found out that the more I wrote, the bigger it got."
  },
  {
    "author": "John Green,",
    "quote": "Talking to a drunk person was like talking to an extremely happy, severely brain-damaged three-year-old."
  },
  {
    "author": "John Steinbeck,",
    "quote": "It's so much darker when a light goes out than it would have been if it had never shone."
  },
  {
    "author": "Mae West",
    "quote": "Good sex is like good bridge. If you don't have a good partner, you'd better have a good hand."
  },
  {
    "author": "Margaret Mitchell",
    "quote": "With enough courage, you can do without a reputation."
  },
  {
    "author": "Donald E. Westlake,",
    "quote": "Nobody gets everything in this life. You decide your priorities and you make your choices. I'd decided long ago that any cake I had would be eaten."
  },
  {
    "author": "Emily Brontë,",
    "quote": "Catherine Earnshaw, may you not rest as long as I am living. You said I killed you--haunt me then. The murdered do haunt their murderers. I believe--I know that ghosts have wandered the earth. Be with me always--take any form--drive me mad. Only do not leave me in this abyss, where I cannot find you! Oh, God! It is unutterable! I cannot live without my life! I cannot live without my soul!"
  },
  {
    "author": "Lemony Snicket,",
    "quote": "Well-read people are less likely to be evil."
  },
  {
    "author": "William Makepeace Thackeray",
    "quote": "Life is a mirror: if you frown at it, it frowns back; if you smile, it returns the greeting."
  },
  {
    "author": "Betty Smith,",
    "quote": "Look at everything always as though you were seeing it either for the first or last time: Thus is your time on earth filled with glory."
  },
  {
    "author": "Ernest Hemingway,",
    "quote": "All thinking men are atheists."
  },
  {
    "author": "Jennifer Niven,",
    "quote": "The thing I realize is, that it's not what you take, it's what you leave."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "How long was I asleep? she whispered. He didn't respond."
  },
  {
    "author": "Marcus Aurelius,",
    "quote": "Waste no more time arguing about what a good man should be. Be one."
  },
  {
    "author": "Gayle Forman,",
    "quote": "If you stay, I'll do whatever you want. I'll quit the band, go with you to New York. But if you need me to go away, I'll do that, too. I was talking to Liz and she said maybe coming back to your old life would be too painful, that maybe it'd be easier for you to erase us. And that would suck, but I'd do it. I can lose you like that if I don't lose you today. I'll let you go. If you stay."
  },
  {
    "author": "Victor Hugo,",
    "quote": "Love is like a tree: it grows by itself, roots itself deeply in our being and continues to flourish over a heart in ruin. The inexplicable fact is that the blinder it is, the more tenacious it is. It is never stronger than when it is completely unreasonable."
  },
  {
    "author": "Fyodor Dostoyevsky,",
    "quote": "I love mankind, he said, but I find to my amazement that the more I love mankind as a whole, the less I love man in particular."
  },
  {
    "author": "Anais Nin",
    "quote": "Luxury is not a necessity to me, but beautiful and good things are."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "Without you in my arms, I feel an emptiness in my soul. I find myself searching the crowds for your face - I know it's an impossibility, but I cannot help myself."
  },
  {
    "author": "Zig Ziglar,",
    "quote": "Of course motivation is not permanent. But then, neither is bathing; but it is something you should do on a regular basis."
  },
  {
    "author": "John Green,",
    "quote": "Gus: It tastes like..."
  },
  {
    "author": "Tennessee Williams,",
    "quote": "What is straight? A line can be straight, or a street, but the human heart, oh, no, it's curved like a road through mountains."
  },
  {
    "author": "David Levithan,",
    "quote": "If there's one thing I've learned, it's this: We all want everything to be okay. We don't even wish so much for fantastic or marvelous or outstanding. We will happily settle for okay, because most of the time, okay is enough."
  },
  {
    "author": "Elizabeth Barrett Browning",
    "quote": "How do I love thee? Let me count the ways."
  },
  {
    "author": "Charles M. Schulz",
    "quote": "Nothing takes the taste out of peanut butter quite like unrequited love."
  },
  {
    "author": "Aldous Huxley",
    "quote": "Maybe this world is another planet’s hell."
  },
  {
    "author": "Nora Roberts,",
    "quote": "Some things in life are out of your control. You can make it a party or a tragedy."
  },
  {
    "author": "Maya Angelou",
    "quote": "The desire to reach for the stars is ambitious. The desire to reach hearts is wise."
  },
  {
    "author": "Gore Vidal",
    "quote": "The unfed mind devours itself."
  },
  {
    "author": "Viktor E. Frankl,",
    "quote": "Don't aim at success. The more you aim at it and make it a target, the more you are going to miss it. For success, like happiness, cannot be pursued; it must ensue, and it only does so as the unintended side effect of one's personal dedication to a cause greater than oneself or as the by-product of one's surrender to a person other than oneself. Happiness must happen, and the same holds for success: you have to let it happen by not caring about it. I want you to listen to what your conscience commands you to do and go on to carry it out to the best of your knowledge. Then you will live to see that in the long-run—in the long-run, I say!—success will follow you precisely because you had forgotten to think about it"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Have you tried talking to her?"
  },
  {
    "author": "Oscar Wilde",
    "quote": "No good deed goes unpunished."
  },
  {
    "author": "Emily Dickinson",
    "quote": "If I read a book and it makes my whole body so cold no fire can ever warm me, I know that is poetry."
  },
  {
    "author": "Charles Bukowski",
    "quote": "There's a bluebird in my heart that wants to get out"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Will rolled up his sleeves. We'll probably have to knock down the door--"
  },
  {
    "author": "Albert Camus",
    "quote": "An intellectual? Yes. And never deny it. An intellectual is someone whose mind watches itself. I like this, because I am happy to be both halves, the watcher and the watched. Can they be brought together? This is a practical question. We must get down to it. I despise intelligence really means: I cannot bear my doubts."
  },
  {
    "author": "G.K. Chesterton",
    "quote": "Literature is a luxury; fiction is a necessity."
  },
  {
    "author": "Walt Disney",
    "quote": "The way to get started is to quit talking and begin doing."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "There are much worse games to play."
  },
  {
    "author": "Nathaniel Hawthorne,",
    "quote": "We dream in our waking moments, and walk in our sleep."
  },
  {
    "author": "James Burke",
    "quote": "When you read a book, you hold another's mind in your hands."
  },
  {
    "author": "Ralph Waldo Emerson,",
    "quote": "It is easy in the world to live after the world's opinion; it is easy in solitude to live after our own; but the great man is he who in the midst of the crowd keeps with perfect sweetness the independence of solitude."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "So light a fire! Harry choked. Yes...of course...but there's no wood! ..."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "Pity those who don't feel anything at all."
  },
  {
    "author": "Nadezhda Mandelstam,",
    "quote": "I decided it is better to scream. Silence is the real crime against humanity."
  },
  {
    "author": "Richard Matheson,",
    "quote": "That which you believe becomes your world."
  },
  {
    "author": "Becca Fitzpatrick,",
    "quote": "Being with you never felt wrong. It's the one thing I did right. You're the one thing I did right."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "District 12: Where you can starve to death in safety."
  },
  {
    "author": "Fyodor Dostoevsky",
    "quote": "The soul is healed by being with children."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Now that she had nothing to lose, she was free."
  },
  {
    "author": "Albert Camus,",
    "quote": "When I look at my life and its secret colours, I feel like bursting into tears."
  },
  {
    "author": "Taylor Swift",
    "quote": "I suffer from girlnextdooritis where the guy is friends with you and that's it."
  },
  {
    "author": "C. S. Lewis",
    "quote": "What draws people to be friends is that they see the same truth. They share it."
  },
  {
    "author": "Judith McNaught,",
    "quote": "There will be a few times in your life when all your instincts will tell you to do something, something that defies logic, upsets your plans, and may seem crazy to others. When that happens, you do it. Listen to your instincts and ignore everything else. Ignore logic, ignore the odds, ignore the complications, and just go for it."
  },
  {
    "author": "Mawlana Jalal-al-Din Rumi",
    "quote": "Lovers don't finally meet somewhere. They're in each other all along."
  },
  {
    "author": "George Orwell,",
    "quote": "We shall meet in the place where there is no darkness."
  },
  {
    "author": "Daphne du Maurier",
    "quote": "Women want love to be a novel. Men, a short story."
  },
  {
    "author": "Rick Riordan,",
    "quote": "God alert! Blackjack yelled. It's the wine dude!"
  },
  {
    "author": "Mark Twain",
    "quote": "You believe in a book that has talking animals, wizards, witches, demons, sticks turning into snakes, burning bushes, food falling from the sky, people walking on water, and all sorts of magical, absurd and primitive stories, and you say that we are the ones that need help?"
  },
  {
    "author": "Virginia Woolf",
    "quote": "When you consider things like the stars, our affairs don't seem to matter very much, do they?"
  },
  {
    "author": "Neil Gaiman,",
    "quote": "You get what anybody gets - you get a lifetime."
  },
  {
    "author": "Percy Bysshe Shelley",
    "quote": "The sunlight claps the earth, and the moonbeams kiss the sea: what are all these kissings worth, if thou kiss not me?"
  },
  {
    "author": "Terry Pratchett,",
    "quote": "Five exclamation marks, the sure sign of an insane mind."
  },
  {
    "author": "Paula Poundstone",
    "quote": "Adults are always asking little kids what they want to be when they grow up ’cause they’re looking for ideas."
  },
  {
    "author": "Gabriel García Márquez,",
    "quote": "He allowed himself to be swayed by his conviction that human beings are not born once and for all on the day their mothers give birth to them, but that life obliges them over and over again to give birth to themselves."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "The greatness of a nation and its moral progress can be judged by the way its animals are treated."
  },
  {
    "author": "Buddha Siddhartha Guatama Shakyamuni",
    "quote": "However many holy words you read, however many you speak, what good will they do you if you do not act on upon them?"
  },
  {
    "author": "Arthur Conan Doyle,",
    "quote": "There is nothing more deceptive than an obvious fact."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "The things we love destroy us every time, lad. Remember that."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "She was a genius of sadness, immersing herself in it, separating its numerous strands, appreciating its subtle nuances. She was a prism through which sadness could be divided into its infinite spectrum."
  },
  {
    "author": "Mother Teresa",
    "quote": "The most terrible poverty is loneliness, and the feeling of being unloved."
  },
  {
    "author": "George Orwell,",
    "quote": "It was a bright cold day in April, and the clocks were striking thirteen."
  },
  {
    "author": "Art Spiegelman,",
    "quote": "To die, it's easy. But you have to struggle for life."
  },
  {
    "author": "Alyson Noel,",
    "quote": "I guess by now I should know enough about loss to realize that you never really stop missing someone-you just learn to live around the huge gaping hole of their absence."
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "It is not the length of life, but the depth."
  },
  {
    "author": "John Irving,",
    "quote": "When someone you love dies, and you're not expecting it, you don't lose her all at once; you lose her in pieces over a long time—the way the mail stops coming, and her scent fades from the pillows and even from the clothes in her closet and drawers. Gradually, you accumulate the parts of her that are gone. Just when the day comes—when there's a particular missing part that overwhelms you with the feeling that she's gone, forever—there comes another day, and another specifically missing part."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "Death is so terribly final, while life is full of possibilities."
  },
  {
    "author": "Jonathan Safran Foer,",
    "quote": "Why do beautiful songs make you sad?' 'Because they aren't true.' 'Never?' 'Nothing is beautiful and true."
  },
  {
    "author": "Bei Dao",
    "quote": "In the world I am"
  },
  {
    "author": "Chuck Palahniuk,",
    "quote": "A girl calls and asks, Does it hurt very much to die?"
  },
  {
    "author": "Stephen King,",
    "quote": "A short story is a different thing altogether – a short story is like a quick kiss in the dark from a stranger."
  },
  {
    "author": "Judy Garland",
    "quote": "Always be a first rate version of yourself and not a second rate version of someone else."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Believe in your infinite potential. Your only limitations are those you set upon yourself."
  },
  {
    "author": "Groucho Marx",
    "quote": "Humor is reason gone mad."
  },
  {
    "author": "Anais Nin",
    "quote": "The role of a writer is not to say what we can all say, but what we are unable to say."
  },
  {
    "author": "Flannery O'Connor",
    "quote": "She looked at nice young men as if she could smell their stupidity."
  },
  {
    "author": "Ludwig van Beethoven",
    "quote": "Music is ... A higher revelation than all Wisdom & Philosophy"
  },
  {
    "author": "John Green,",
    "quote": "But I believe in true love, you know? I don't believe that everybody gets to keep their eyes or not get sick or whatever, but everybody should have true love, and it should last at least as long as your life does."
  },
  {
    "author": "Brandon Sanderson,",
    "quote": "The purpose of a storyteller is not to tell you how to think, but to give you questions to think upon."
  },
  {
    "author": "Mother Teresa",
    "quote": "Let no one ever come to you without leaving better and happier. Be the living expression of God's kindness: kindness in your face, kindness in your eyes, kindness in your smile."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Sometimes, the best way to help someone is just to be near them."
  },
  {
    "author": "Franz Kafka",
    "quote": "I write differently from what I speak, I speak differently from what I think, I think differently from the way I ought to think, and so it all proceeds into deepest darkness."
  },
  {
    "author": "J.R.R. Tolkien,",
    "quote": "There is nothing like looking, if you want to find something. You certainly usually find something, if you look, but it is not always quite the something you were after."
  },
  {
    "author": "Ayn Rand,",
    "quote": "Freedom (n.): To ask nothing. To expect nothing. To depend on nothing."
  },
  {
    "author": "Terry Pratchett,",
    "quote": "All right, said Susan. I'm not stupid. You're saying humans need..."
  },
  {
    "author": "Stephen R. Covey,",
    "quote": "But until a person can say deeply and honestly, I am what I am today because of the choices I made yesterday, that person cannot say, I choose otherwise."
  },
  {
    "author": "Charlotte Brontë ,",
    "quote": "Jane, be still; don't struggle so like a wild, frantic bird, that is rending its own plumage in its desperation."
  },
  {
    "author": "Anaïs Nin,",
    "quote": "You live like this, sheltered, in a delicate world, and you believe you are living. Then you read a book… or you take a trip… and you discover that you are not living, that you are hibernating. The symptoms of hibernating are easily detectable: first, restlessness. The second symptom (when hibernating becomes dangerous and might degenerate into death): absence of pleasure. That is all. It appears like an innocuous illness. Monotony, boredom, death. Millions live like this (or die like this) without knowing it. They work in offices. They drive a car. They picnic with their families. They raise children. And then some shock treatment takes place, a person, a book, a song, and it awakens them and saves them from death. Some never awaken."
  },
  {
    "author": "C.G. Jung",
    "quote": "Until you make the unconscious conscious, it will direct your life and you will call it fate."
  },
  {
    "author": "John Green,",
    "quote": "Sometimes you lose a battle. But mischief always wins the war"
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "When people say impossible, they usually mean improbable."
  },
  {
    "author": "Rainbow Rowell,",
    "quote": "I want everyone to meet you. You're my favorite person of all time."
  },
  {
    "author": "Jennifer Egan,",
    "quote": "I'm always happy, Sasha said. Sometimes I just forget."
  },
  {
    "author": "Veronica Roth,",
    "quote": "I feel like someone breathed new air into my lungs. I am not Abnegation. I am not Dauntless."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "There is no such thing as a broken family. Family is family, and is not determined by marriage certificates, divorce papers, and adoption documents. Families are made in the heart. The only time family becomes null is when those ties in the heart are cut. If you cut those ties, those people are not your family. If you make those ties, those people are your family. And if you hate those ties, those people will still be your family because whatever you hate will always be with you."
  },
  {
    "author": "Groucho Marx",
    "quote": "I never forget a face, but in your case I'll be glad to make an exception."
  },
  {
    "author": "Dalai Lama XIV",
    "quote": "My religion is very simple. My religion is kindness."
  },
  {
    "author": "John Green,",
    "quote": "When you go into the ER, one of the first things they ask you to do is rate your pain on a scale of one to ten, and from there they decide which drugs to use and how quickly to use them. I'd been asked this question hundreds of times over the years, and I remember once early on when I couldn't get my breath and it felt like my chest was on fire, flames licking the inside of my ribs fighting for a way to burn out of my body, my parents took me to the ER. nurse asked me about the pain, and I couldn't even speak, so I held up nine fingers."
  },
  {
    "author": "Umberto Eco,",
    "quote": "To survive, you must tell stories."
  },
  {
    "author": "Richelle Mead,",
    "quote": "What's up? I asked."
  },
  {
    "author": "Charles Baudelaire,",
    "quote": "One should always be drunk. That's all that matters...But with what? With wine, with poetry, or with virtue, as you chose. But get drunk."
  },
  {
    "author": "John Muir",
    "quote": "The mountains are calling and I must go."
  },
  {
    "author": "Plato",
    "quote": "Do not train a child to learn by force or harshness; but direct them to it by what amuses their minds, so that you may be better able to discover with accuracy the peculiar bent of the genius of each."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "You never know what life is like, until you have lived it."
  },
  {
    "author": "Lemony Snicket",
    "quote": "If you are a student you should always get a good nights sleep unless you have come to the good part of your book, and then you should stay up all night and let your schoolwork fall by the wayside, a phrase which means 'flunk'."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Unfortunately, the clock is ticking, the hours are going by. The past increases, the future recedes. Possibilities decreasing, regrets mounting."
  },
  {
    "author": "Philip Pullman",
    "quote": "We don’t need a list of rights and wrongs, tables of dos and don’ts: we need books, time, and silence."
  },
  {
    "author": "Albert Camus,",
    "quote": "Real generosity towards the future lies in giving all to the present."
  },
  {
    "author": "Pablo Neruda,",
    "quote": "I love you as certain dark things are loved, secretly, between the shadow and the soul."
  },
  {
    "author": "Doris Lessing,",
    "quote": "What's terrible is to pretend that second-rate is first-rate. To pretend that you don't need love when you do; or you like your work when you know quite well you're capable of better."
  },
  {
    "author": "Albert Dietrich,",
    "quote": "There are perhaps many causes worth dying for, but to me, certainly, there are none worth killing for."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "And Lot's wife, of course, was told not to look back where all those people and their homes had been. But she did look back, and I love her for that, because it was so human. So she was turned into a pillar of salt. So it goes."
  },
  {
    "author": "Dalai Lama XIV",
    "quote": "There is a saying in Tibetan, 'Tragedy should be utilized as a source of strength.'"
  },
  {
    "author": "Albert Camus",
    "quote": "Fiction is the lie through which we tell the truth."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "After a good dinner one can forgive anybody, even one's own relations."
  },
  {
    "author": "Katherine Mansfield",
    "quote": "The mind I love must have wild places."
  },
  {
    "author": "Gilles Deleuze,",
    "quote": "A concept is a brick. It can be used to build a courthouse of reason. Or it can be thrown through the window."
  },
  {
    "author": "Richelle Mead,",
    "quote": "Stop fighting me! he said, trying to pull on the arm he held."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "To give pleasure to a single heart by a single act is better than a thousand heads bowing in prayer."
  },
  {
    "author": "John W. Campbell Jr.",
    "quote": "History does not always repeat itself. Sometimes it just yells, 'Can't you remember anything I told you?' and lets fly with a club."
  },
  {
    "author": "William Shakespeare,",
    "quote": "Lord, what fools these mortals be!"
  },
  {
    "author": "William Shakespeare",
    "quote": "I like this place and could willingly waste my time in it."
  },
  {
    "author": "Fyodor Dostoyevsky,",
    "quote": "We sometimes encounter people, even perfect strangers, who begin to interest us at first sight, somehow suddenly, all at once, before a word has been spoken."
  },
  {
    "author": "Joseph Conrad,",
    "quote": "It's only those who do nothing that make no mistakes, I suppose."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "We are all born sexual creatures,thank God, but it's a pity so many people despise and crush this natural gift."
  },
  {
    "author": "Maya Angelou",
    "quote": "Ask for what you want and be prepared to get it!"
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Man often becomes what he believes himself to be. If I keep on saying to myself that I cannot do a certain thing, it is possible that I may end by really becoming incapable of doing it. On the contrary, if I have the belief that I can do it, I shall surely acquire the capacity to do it even if I may not have it at the beginning."
  },
  {
    "author": "Julie Kagawa,",
    "quote": "Oh, we're playing nice now? Shall we have tea first? Brew up a nice pot of kiss-my-ass?"
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "The only person you are destined to become is the person you decide to be."
  },
  {
    "author": "Mae West",
    "quote": "When I'm good, I'm very good, but when I'm bad, I'm better."
  },
  {
    "author": "David Nicholls,",
    "quote": "This is where it all begins. Everything starts here, today."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "Grown-ups never understand anything by themselves, and it is tiresome for children to be always and forever explaining things to them"
  },
  {
    "author": "Roberto Bolaño,",
    "quote": "Reading is like thinking, like praying, like talking to a friend, like expressing your ideas, like listening to other people's ideas, like listening to music, like looking at the view, like taking a walk on the beach."
  },
  {
    "author": "Marvin Bell",
    "quote": "Learn the rules, break the rules, make up new rules, break the new rules."
  },
  {
    "author": "Hunter S. Thompson",
    "quote": "So we shall let the reader answer this question for himself: who is the happier man, he who has braved the storm of life and lived or he who has stayed securely on shore and merely existed?"
  },
  {
    "author": "Mark Twain",
    "quote": "The easy confidence with which I know another man's religion is folly teaches me to suspect that my own is also."
  },
  {
    "author": "Thomas Pynchon",
    "quote": "Every weirdo in the world is on my wavelength."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Listen with curiosity. Speak with honesty. Act with integrity. The greatest problem with communication is we don’t listen to understand. We listen to reply. When we listen with curiosity, we don’t listen with the intent to reply. We listen for what’s behind the words."
  },
  {
    "author": "Elizabeth Barrett Browning",
    "quote": "You're something between a dream and a miracle."
  },
  {
    "author": "Maya Angelou",
    "quote": "If I am not good to myself, how can I expect anyone else to be good to me?"
  },
  {
    "author": "Mark A. Cooper,",
    "quote": "Life has no remote....get up and change it yourself!"
  },
  {
    "author": "George Washington",
    "quote": "It is better to offer no excuse than a bad one."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "Passion makes a person stop eating, sleeping, working, feeling at peace. A lot of people are frightened because, when it appears, it demolishes all the old things it finds in its path."
  },
  {
    "author": "Edward Abbey",
    "quote": "May your trails be crooked, winding, lonesome, dangerous, leading to the most amazing view."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Seventeen, eh! said Hagrid as he accepted a bucket-sized glass of wine from Fred."
  },
  {
    "author": "Confucius,",
    "quote": "The man who moves a mountain begins by carrying away small stones."
  },
  {
    "author": "Anais Nin",
    "quote": "Throw your dreams into space like a kite, and you do not know what it will bring back, a new life, a new friend, a new love, a new country."
  },
  {
    "author": "Pablo Picasso,",
    "quote": "Others have seen what is and asked why. I have seen what could be and asked why not."
  },
  {
    "author": "Dr. Seuss",
    "quote": "I'm afraid that sometimes you'll play lonely games too. Games you can't win 'cause you'll play against you."
  },
  {
    "author": "Douglas Coupland,",
    "quote": "And then I felt sad because I realized that once people are broken in certain ways, they can't ever be fixed, and this is something nobody ever tells you when you are young and it never fails to surprise you as you grow older as you see the people in your life break one by one. You wonder when your turn is going to be, or if it's already happened."
  },
  {
    "author": "Carl Gustav Jung",
    "quote": "I am not what happened to me, I am what I choose to become."
  },
  {
    "author": "Zora Neale Hurston",
    "quote": "Love makes your soul crawl out from its hiding place."
  },
  {
    "author": "John Green,",
    "quote": "I am going to take this bucket of water and pour it on the flames of hell, and then I am going to use this torch to burn down the gates of paradise so that people will not love God for want of heaven or fear of hell, but because He is God."
  },
  {
    "author": "Jonathan Kellerman",
    "quote": "Life is like a prism. What you see depends on how you turn the glass."
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "To lose balance sometimes for love is part of living a balanced"
  },
  {
    "author": "J.K. Rowling,",
    "quote": "Don't let the muggles get you down."
  },
  {
    "author": "Carlos Castaneda",
    "quote": "You have everything needed for the extravagant journey that is your life."
  },
  {
    "author": "Kiera Cass,",
    "quote": "I hope you find someone you can't live without.I really do. And I hope you never have to know what it's like to have to try and live without them."
  },
  {
    "author": "John Green,",
    "quote": "When things break, it's not the actual breaking that prevents them from getting back together again. It's because a little piece gets lost - the two remaining ends couldn't fit together even if they wanted to. The whole shape has changed."
  },
  {
    "author": "Kurt Vonnegut,",
    "quote": "Tiger got to hunt, bird got to fly;"
  },
  {
    "author": "J.K. Rowling,",
    "quote": "I'm going to keep going until I succeed — or die. Don't think I don't know how this might end. I've known it for years."
  },
  {
    "author": "Roy T. Bennett,",
    "quote": "Help others without any reason and give without the expectation of receiving anything in return."
  },
  {
    "author": "Jack Kerouac,",
    "quote": "What is that feeling when you're driving away from people and they recede on the plain till you see their specks dispersing? - it's the too-huge world vaulting us, and it's good-bye. But we lean forward to the next crazy venture beneath the skies."
  },
  {
    "author": "Rose Wilder Lane",
    "quote": "Happiness is something that comes into our lives through doors we don't even remember leaving open."
  },
  {
    "author": "Dean Koontz,",
    "quote": "Never leave a friend behind. Friends are all we have to get us through this life--and they are the only things from this world that we could hope to see in the next."
  },
  {
    "author": "Ellen DeGeneres",
    "quote": "My grandmother started walking five miles a day when she was sixty. She's ninety-seven now, and we don't know where the heck she is."
  },
  {
    "author": "Adolf Hitler",
    "quote": "If you win, you need not have to explain...If you lose, you should not be there to explain!"
  },
  {
    "author": "Robert Frost",
    "quote": "Poetry is what gets lost in translation."
  },
  {
    "author": "H.L. Mencken",
    "quote": "I know some who are constantly drunk on books as other men are drunk on whiskey."
  },
  {
    "author": "Jonathan Safran Foer",
    "quote": "I think and think and think, I‘ve thought myself out of happiness one million times, but never once into it."
  },
  {
    "author": "e.e. cummings",
    "quote": "Whenever you think or you believe or you know, you're a lot of other people: but the moment you feel, you're nobody-but-yourself."
  },
  {
    "author": "Friedrich Nietzsche,",
    "quote": "I am a forest, and a night of dark trees: but he who is not afraid of my darkness, will find banks full of roses under my cypresses."
  },
  {
    "author": "Doris Lessing,",
    "quote": "Ideally, what should be said to every child, repeatedly, throughout his or her school life is something like this: 'You are in the process of being indoctrinated. We have not yet evolved a system of education that is not a system of indoctrination. We are sorry, but it is the best we can do. What you are being taught here is an amalgam of current prejudice and the choices of this particular culture. The slightest look at history will show how impermanent these must be. You are being taught by people who have been able to accommodate themselves to a regime of thought laid down by their predecessors. It is a self-perpetuating system. Those of you who are more robust and individual than others will be encouraged to leave and find ways of educating yourself — educating your own judgements. Those that stay must remember, always, and all the time, that they are being moulded and patterned to fit into the narrow and particular needs of this particular society."
  },
  {
    "author": "Napoleon Hill,",
    "quote": "The starting point of all achievement is DESIRE. Keep this constantly in mind. Weak desire brings weak results, just as a small fire makes a small amount of heat."
  },
  {
    "author": "Emily Brontë,",
    "quote": "If he loved with all the powers of his puny being, he couldn't love as much in eighty years as I could in a day."
  },
  {
    "author": "Sarah J. Maas,",
    "quote": "Fire-breathing bitch-queen."
  },
  {
    "author": "Patrick Rothfuss,",
    "quote": "When we are children we seldom think of the future. This innocence leaves us free to enjoy ourselves as few adults can. The day we fret about the future is the day we leave our childhood behind."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I restore myself when I'm alone."
  },
  {
    "author": "Tahereh Mafi,",
    "quote": "Ignite, my love. Ignite."
  },
  {
    "author": "Steve Jobs",
    "quote": "Being the richest man in the cemetery doesn't matter to me. Going to bed at night saying we've done something wonderful... that's what matters to me."
  },
  {
    "author": "Gertrude Stein",
    "quote": "We are always the same age inside."
  },
  {
    "author": "Steve Maraboli,",
    "quote": "Happiness is not the absence of problems, it's the ability to deal with them."
  },
  {
    "author": "John Green,",
    "quote": "It is easy to forget how full the world is of people, full to bursting, and each of them imaginable and consistently misimagined."
  },
  {
    "author": "Albert Camus,",
    "quote": "I opened myself to the gentle indifference of the world."
  },
  {
    "author": "Tolstoy Leo",
    "quote": "If you want to be happy, be."
  },
  {
    "author": "Ken Kesey,",
    "quote": "Man, when you lose your laugh you lose your footing."
  },
  {
    "author": "Jojo Moyes,",
    "quote": "Push yourself. Don't Settle. Just live well. Just LIVE."
  },
  {
    "author": "Lemony Snicket,",
    "quote": "The sad truth is the truth is sad."
  },
  {
    "author": "Woody Allen",
    "quote": "Life doesn't imitate art, it imitates bad television."
  },
  {
    "author": "Sherman Alexie,",
    "quote": "If you let people into your life a little bit, they can be pretty damn amazing."
  },
  {
    "author": "Selma Lagerlöf",
    "quote": "Nothing on earth can make up for the loss of one who has loved you."
  },
  {
    "author": "J.D. Salinger,",
    "quote": "That's the thing about girls. Every time they do something pretty, even if they're not much to look at, or even if they're sort of stupid, you fall in love with them, and then you never know where the hell you are. Girls. Jesus Christ. They can drive you crazy. They really can."
  },
  {
    "author": "Colleen Hoover,",
    "quote": "Question everything. Your love, your religion, your passion. If you don't have questions, you'll never find answers."
  },
  {
    "author": "Sarah Dessen,",
    "quote": "Holding people away from you, and denying yourself love, that doesn't make you strong. if anything, it makes you weaker. Because you're doing it out of fear."
  },
  {
    "author": "Sherrilyn Kenyon,",
    "quote": "I don't suffer from my insanity -- I enjoy every minute of it."
  },
  {
    "author": "Hayley Williams",
    "quote": "Sometimes it takes a good fall to really know where you stand"
  },
  {
    "author": "Leo Tolstoy,",
    "quote": "Spring is the time of plans and projects."
  },
  {
    "author": "Charles Dickens",
    "quote": "No one is useless in this world who lightens the burdens of another."
  },
  {
    "author": "Rachel Caine,",
    "quote": "Damn, Claire. Warn a guy before you do a face-plant on the floor next time. I could have looked all heroic and caught you or something -Shane"
  },
  {
    "author": "Confucius",
    "quote": "Life is really simple, but we insist on making it complicated."
  },
  {
    "author": "Joseph Conrad,",
    "quote": "We live as we dream--alone...."
  },
  {
    "author": "Jennifer Niven,",
    "quote": "We do not remember days, we remember moments."
  },
  {
    "author": "Stephen Chbosky,",
    "quote": "I just want you to know that you’re very special… and the only reason I’m telling you is that I don’t know if anyone else ever has."
  },
  {
    "author": "Oscar Wilde,",
    "quote": "Morality is simply the attitude we adopt towards people we personally dislike."
  },
  {
    "author": "Veronica Roth,",
    "quote": "Can you be a girl for a few seconds?"
  },
  {
    "author": "Albert Einstein",
    "quote": "Peace cannot be kept by force; it can only be achieved by understanding."
  },
  {
    "author": "Charlotte Brontë,",
    "quote": "I am not an angel,' I asserted; 'and I will not be one till I die: I will be myself. Mr. Rochester, you must neither expect nor exact anything celestial of me - for you will not get it, any more than I shall get it of you: which I do not at all anticipate."
  },
  {
    "author": "Ray Bradbury",
    "quote": "If we listened to our intellect we'd never have a love affair. We'd never have a friendship. We'd never go in business because we'd be cynical: It's gonna go wrong. Or She's going to hurt me. Or,I've had a couple of bad love affairs, so therefore . . . Well, that's nonsense. You're going to miss life. You've got to jump off the cliff all the time and build your wings on the way down."
  },
  {
    "author": "Mary Ann Shaffer,",
    "quote": "I don't want to be married just to be married. I can't think of anything lonelier than spending the rest of my life with someone I can't talk to, or worse, someone I can't be silent with."
  },
  {
    "author": "Barbara Kingsolver,",
    "quote": "There is no point treating a depressed person as though she were just feeling sad, saying, 'There now, hang on, you'll get over it.' Sadness is more or less like a head cold- with patience, it passes. Depression is like cancer."
  },
  {
    "author": "Charles Bukowski",
    "quote": "Poetry is what happens when nothing else can."
  },
  {
    "author": "George Carlin",
    "quote": "If you try to fail, and succeed, which have you done?"
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "Dare to live the life you have dreamed for yourself. Go forward and make your dreams come true."
  },
  {
    "author": "Erin Morgenstern,",
    "quote": "You may tell a tale that takes up residence in someone's soul, becomes their blood and self and purpose. That tale will move them and drive them and who knows that they might do because of it, because of your words. That is your role, your gift."
  },
  {
    "author": "Jane Austen,",
    "quote": "Silly things do cease to be silly if they are done by sensible people in an impudent way."
  },
  {
    "author": "Virginia Woolf,",
    "quote": "As long as she thinks of a man, nobody objects to a woman thinking."
  },
  {
    "author": "C. S. Lewis",
    "quote": "I didn’t go to religion to make me happy. I always knew a bottle of Port would do that. If you want a religion to make you feel really comfortable, I certainly don’t recommend Christianity."
  },
  {
    "author": "George R.R. Martin,",
    "quote": "What is honor compared to a woman's love? What is duty against the feel of a newborn son in your arms . . . or the memory of a brother's smile? Wind and words. Wind and words. We are only human, and the gods have fashioned us for love. That is our great glory, and our great tragedy."
  },
  {
    "author": "Lewis Caroll,",
    "quote": "If everybody minded their own business, the world would go around a great deal faster than it does."
  },
  {
    "author": "Ben Okri",
    "quote": "The most authentic thing about us is our capacity to create, to overcome, to endure, to transform, to love and to be greater than our suffering."
  },
  {
    "author": "William Shakespeare",
    "quote": "My only love sprung from my only hate!"
  },
  {
    "author": "Paulo Coelho,",
    "quote": "This is what we call love. When you are loved, you can do anything in creation. When you are loved, there's no need at all to understand what's happening, because everything happens within you."
  },
  {
    "author": "Walter Tevis",
    "quote": "I feel free and strong. If I were not a reader of books I could not feel this way."
  },
  {
    "author": "Sarah Kay",
    "quote": "If I should have a daughter…Instead of Mom, she’s gonna call me Point B. Because that way, she knows that no matter what happens, at least she can always find her way to me. And I’m going to paint the solar system on the back of her hands so that she has to learn the entire universe before she can say Oh, I know that like the back of my hand."
  },
  {
    "author": "Brian Selznick,",
    "quote": "I address you all tonight for who you truly are: wizards, mermaids, travelers, adventurers, and magicians. You are the true dreamers."
  },
  {
    "author": "C. JoyBell C.",
    "quote": "The unhappiest people in this world, are those who care the most about what other people think."
  },
  {
    "author": "Gertrude Stein",
    "quote": "One must dare to be happy."
  },
  {
    "author": "Robert Heinlein,",
    "quote": "Never attempt to teach a pig to sing; it wastes your time and annoys the pig."
  },
  {
    "author": "Albert Einstein",
    "quote": "In the middle of difficulty lies opportunity"
  },
  {
    "author": "Leigh Bardugo,",
    "quote": "The Darkling slumped back in his chair. Fine, he said with a weary shrug. Make me your villain."
  },
  {
    "author": "Paulo Coelho,",
    "quote": "People are capable, at any time in their lives, of doing what they dream of."
  },
  {
    "author": "Marilyn Monroe",
    "quote": "I just want to be wonderful."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "I clench his hands to the point of pain. Stay with me."
  },
  {
    "author": "Fyodor Dostoyevsky,",
    "quote": "It takes something more than intelligence to act intelligently."
  },
  {
    "author": "L.M. Montgomery,",
    "quote": "True friends are always together in spirit."
  },
  {
    "author": "J.K. Rowling,",
    "quote": "You think the dead we loved ever truly leave us? You think that we don't recall them more clearly in times of great trouble?"
  },
  {
    "author": "Jarod Kintz,",
    "quote": "I find out a lot about myself by sleeping. Dreams, they are who I am when I’m too tired to be me."
  },
  {
    "author": "Christopher Moore,",
    "quote": "People, generally, suck."
  },
  {
    "author": "Tamora Pierce,",
    "quote": "Threats are the last resort of a man with no vocabulary."
  },
  {
    "author": "Erica Jong",
    "quote": "I have accepted fear as part of life – specifically the fear of change... I have gone ahead despite the pounding in the heart that says: turn back...."
  },
  {
    "author": "Steven Moffat",
    "quote": "Demons run when a good man goes to war"
  },
  {
    "author": "Neil Gaiman,",
    "quote": "Because,' she said, 'when you're scared but you still do it anyway,"
  },
  {
    "author": "Lewis Carroll",
    "quote": "One of the deep secrets of life is that all that is really worth the doing is what we do for others."
  },
  {
    "author": "E.E. Cummings,",
    "quote": "I will take the sun in my mouth"
  },
  {
    "author": "Ralph Waldo Emerson",
    "quote": "Whatever you do, you need courage. Whatever course you decide upon, there is always someone to tell you that you are wrong. There are always difficulties arising that tempt you to believe your critics are right. To map out a course of action and follow it to an end requires some of the same courage that a soldier needs. Peace has its victories, but it takes brave men and women to win them."
  },
  {
    "author": "Cassandra Clare,",
    "quote": "I don't care, Clary said. He'd do it for me. Tell me he wouldn't. If I were missing-"
  },
  {
    "author": "Suzanne Collins,",
    "quote": "It crosses my mind that Cinna's calm and normal demeanor masks a complete madman."
  },
  {
    "author": "أحلام مستغانمي,",
    "quote": "الحداد ليس في ما نرتديه بل في ما نراه . إنّه يكمن في نظرتنا"
  },
  {
    "author": "Samuel Beckett",
    "quote": "We are all born mad. Some remain so."
  },
  {
    "author": "Albert Einstein",
    "quote": "A question that sometimes drives me hazy: am I or are the others crazy?"
  },
  {
    "author": "Paulo Coelho",
    "quote": "None of us knows what might happen even the next minute, yet still we go forward. Because we trust. Because we have faith."
  },
  {
    "author": "Gabriel García Márquez",
    "quote": "sex is the consolation you have when you can't have love"
  },
  {
    "author": "Robert Frost",
    "quote": "Half the world is composed of people who have something to say and can't, and the other half who have nothing to say and keep on saying it."
  },
  {
    "author": "Tim O'Brien",
    "quote": "That's what fiction is for. It's for getting at the truth when the truth isn't sufficient for the truth."
  },
  {
    "author": "Mahatma Gandhi",
    "quote": "Each night, when I go to sleep, I die. And the next morning, when I wake up, I am reborn."
  },
  {
    "author": "James Lecesne",
    "quote": "This is how it works. I love the people in my life, and I do for my friends whatever they need me to do for them, again and again, as many times as is necessary. For example, in your case you always forgot who you are and how much you're loved. So what I do for you as your friend is remind you who you are and tell you how much I love you. And this isn't any kind of burden for me, because I love who you are very much. Every time I remind you, I get to remember with you, which is my pleasure."
  },
  {
    "author": "Suzanne Collins,",
    "quote": "If Peeta and I were both to die, or they thought we were....My fingers fumble with the pouch on my belt, freeing it. Peeta sees it and his hand clamps on my wrist. No, I won't let you. Trust me, I whisper. He holds my gaze for a long moment then lets go. I loosen the top of the pouch and pour a few spoonfuls of berries into his palm. Then I fill my own. On the count of three? Peeta leans down and kisses me once, very gently. The count of three, he says. We stand, our backs pressed together, our empty hands locked tight. Hold them out. I want everyone to see, he says. I spread out my fingers, and the dark berries glisten in the sun. I give Peeta's hand one last squeeze as a signal, as a good-bye, and we begin counting. One. Maybe I'm wrong. Two. Maybe they don't care if we both die. Three! It's too late to change my mind. I lift my hand to my mouth taking one last look at the world. The berries have just passed my lips when the trumpets begin to blare. The frantic voice of Claudius Templesmith shouts above them. Stop! Stop! Ladies and gentlemen, I am pleased to present the victors of the 74th Hunger Games, Katniss Everdeen and Peeta Mellark! I give you - the tributes of District 12!"
  },
  {
    "author": "Nora Roberts",
    "quote": "If you don't go after what you want, you'll never have it. If you don't ask, the answer is always no. If you don't step forward, you're always in the same place."
  },
  {
    "author": "Henry David Thoreau,",
    "quote": "The mass of men lead lives of quiet desperation. What is called resignation is confirmed desperation. From the desperate city you go into the desperate country, and have to console yourself with the bravery of minks and muskrats. A stereotyped but unconscious despair is concealed even under what are called the games and amusements of mankind. There is no play in them, for this comes after work. But it is a characteristic of wisdom not to do desperate things.."
  },
  {
    "author": "Becca Fitzpatrick,",
    "quote": "Hang on, did you just call me Angel? I asked."
  },
  {
    "author": "Albert Einstein",
    "quote": "Imagination is everything. It is the preview of life's coming attractions."
  },
  {
    "author": "Mother Teresa",
    "quote": "If we have no peace, it is because we have forgotten that we belong to each other."
  },
  {
    "author": "George Carlin",
    "quote": "I like it when a flower or a little tuft of grass grows through a crack in the concrete. It's so fuckin' heroic."
  },
  {
    "author": "Antoine de Saint-Exupéry,",
    "quote": "You - you alone will have the stars as no one else has them...In one of the stars I shall be living. In one of them I shall be laughing. And so it will be as if all the stars were laughing, when you look at the sky at night...You - only you - will have stars that can laugh."
  },
  {
    "author": "C. J. Cherryh",
    "quote": "Ignorance killed the cat; curiosity was framed!"
  },
  {
    "author": "Audrey Niffenegger,",
    "quote": "Love the world and yourself in it, move through it as though it offers no resistance, as though the world is your natural element."
  },
  {
    "author": "A.A. Milne,",
    "quote": "If the person you are talking to doesn't appear to be listening, be patient. It may simply be that he has a small piece of fluff in his ear."
  },
  {
    "author": "Chaim Potok,",
    "quote": "I've begun to realize that you can listen to silence and learn from it. It has a quality and a dimension all its own."
  },
  {
    "author": "Gena Showalter,",
    "quote": "I don't hate you.. I just don't like that you exist"
  },
  {
    "author": "Elizabeth Gilbert,",
    "quote": "Your emotions are the slaves to your thoughts, and you are the slave to your emotions."
  },
  {
    "author": "جلال الدين الرومي",
    "quote": "لا تجزع من جرحك، وإلا فكيف للنور أن يتسلل إلى باطنك؟"
  },
  {
    "author": "Alysha Speer",
    "quote": "Laugh, even when you feel too sick or too worn out or tired."
  },
  {
    "author": "Robin  Williams",
    "quote": "See, the problem is that God gives men a brain and a penis, and only enough blood to run one at a time."
  },
  {
    "author": "Haruki Murakami,",
    "quote": "Listen up - there's no war that will end all wars."
  },
  {
    "author": "Lois Lowry",
    "quote": "It is very risky. But each time a child opens a book, he pushes open the gate that separates him from Elsewhere."
  },
  {
    "author": "Nicholas Sparks,",
    "quote": "In times of grief and sorrow I will hold you and rock you and take your grief and make it my own. When you cry I cry and when you hurt I hurt. And together we will try to hold back the floods to tears and despair and make it through the potholed street of life"
  },
  {
    "author": "Cassandra Clare,",
    "quote": "Black hair and blue eyes are my favorite combination."
  },
  {
    "author": "John Banville,",
    "quote": "The past beats inside me like a second heart."
  },
  {
    "author": "A.A. Milne,",
    "quote": "I'm not lost for I know where I am. But however, where I am may be lost."
  },
  {
    "author": "Milan Kundera",
    "quote": "Dogs are our link to paradise. They don't know evil or jealousy or discontent. To sit with a dog on a hillside on a glorious afternoon is to be back in Eden, where doing nothing was not boring--it was peace."
  },
  {
    "author": "Bill Watterson,",
    "quote": "People think it must be fun to be a super genius, but they don't realize how hard it is to put up with all the idiots in the world."
  },
  {
    "author": "John Green,",
    "quote": "What else? She is so beautiful. You don’t get tired of looking at her. You never worry if she is smarter than you: You know she is. She is funny without ever being mean. I love her. I am so lucky to love her, Van Houten. You don’t get to choose if you get hurt in this world, old man, but you do have some say in who hurts you. I like my choices. I hope she likes hers."
  },
  {
    "author": "Edgar Allan Poe",
    "quote": "Sleep, those little slices of death — how I loathe them."
  },
  {
    "author": "Henry David Thoreau",
    "quote": "Dreams are the touchstones of our characters."
  },
  {
    "author": "Frank Kaiser",
    "quote": "Yes, we praise women over 40 for a multitude of reasons. Unfortunately, it's not reciprocal. For every stunning, smart, well-coiffed, hot woman over 40, there is a bald, paunchy relic in yellow pants making a fool of himself with some 22-year old waitress. Ladies, I apologize. For all those men who say, Why buy the cow when you can get the milk for free?, here's an update for you. Nowadays 80% of women are against marriage. Why? Because women realize it's not worth buying an entire pig just to get a little sausage!"
  }
];

export default quotes;
